import type { Icon } from 'ngxi'

export const jam500px: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M8.991 17.692c3.68 0 6.673-2.972 6.673-6.625S12.67 4.441 8.991 4.441a6.7 6.7 0 0 0-4.798 2.02v-5.34h9.178a.563.563 0 0 0 .564-.56a.56.56 0 0 0-.564-.561H3.628a.563.563 0 0 0-.564.56v7.453l-.007.136a.566.566 0 0 0 1.06.294a5.55 5.55 0 0 1 4.874-2.88c3.057 0 5.543 2.468 5.543 5.503s-2.486 5.504-5.543 5.504a5.56 5.56 0 0 1-2.844-.787v-4.716c0-1.558 1.276-2.825 2.844-2.825a2.837 2.837 0 0 1 2.844 2.825c0 1.557-1.275 2.824-2.844 2.824a2.8 2.8 0 0 1-1.095-.217a.566.566 0 0 0-.738.302a.56.56 0 0 0 .303.733c.486.201 1 .303 1.53.303c2.191 0 3.974-1.77 3.974-3.945c0-2.176-1.783-3.946-3.974-3.946c-2.19 0-3.973 1.77-3.973 3.946v3.832a5.46 5.46 0 0 1-1.37-2.366a.565.565 0 0 0-1.09.298c.795 2.862 3.44 4.861 6.433 4.861\"/><path d=\"M5.598 2.833a.56.56 0 0 0-.287.74c.127.283.46.41.745.285c1.77-.78 5.248-1.596 8.647 1.715a.565.565 0 0 0 .8-.008a.56.56 0 0 0-.009-.793c-4.02-3.915-8.26-2.66-9.896-1.939M15.695 16.13a.567.567 0 0 0-.797.056a7.85 7.85 0 0 1-5.907 2.674c-3.98 0-7.322-2.957-7.773-6.878a.564.564 0 0 0-.625-.493a.56.56 0 0 0-.497.62c.516 4.488 4.34 7.873 8.895 7.873a8.98 8.98 0 0 0 6.76-3.06a.56.56 0 0 0-.056-.791zm-8.141-3.704a.565.565 0 0 0 .799.006l.58-.568l.572.575a.565.565 0 0 0 .798.006a.56.56 0 0 0 .006-.793l-.572-.576l.559-.547a.56.56 0 0 0 .005-.793a.567.567 0 0 0-.798-.006l-.559.548l-.551-.555a.567.567 0 0 0-.799-.006a.56.56 0 0 0-.005.793l.55.555l-.579.568a.56.56 0 0 0-.006.793\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamAccessibility: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m5.9 10.016l-.324 3.087a1 1 0 1 1-1.989-.21L4.31 6.01H1a1 1 0 0 1 0-2.003h10a1 1 0 0 1 0 2.003H7.69l.723 6.885a1.001 1.001 0 1 1-1.99.209L6.1 10.016zm.1-6.01c-1.105 0-2-.897-2-2.003S4.895 0 6 0s2 .897 2 2.003a2 2 0 0 1-2 2.003\"/>",
  "width": 12,
  "height": 14,
  "viewBox": "0 0 12 14"
}

export const jamActivity: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7.116 10.749L6 1.948l-1.116 8.8H1c-.552 0-1-.437-1-.976a.99.99 0 0 1 1-.978h2.116l.9-7.086C4.15.636 5.15-.124 6.245.008c.91.11 1.626.81 1.739 1.7l.899 7.086h1.974L12 16.04l1.142-7.245H19c.552 0 1 .438 1 .978s-.448.977-1 .977h-4.142l-.881 5.587a1.98 1.98 0 0 1-1.672 1.634c-1.092.165-2.113-.567-2.282-1.634l-.88-5.587z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3 24 24"
}

export const jamAirbnb: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17.497 13.278c1.017 2.29.441 4.676-1.433 5.938c-.774.522-1.592.783-2.431.783c-.848 0-1.716-.266-2.583-.797c-.512-.314-.966-.72-1.405-1.112q-.21-.189-.422-.371a1 1 0 0 1-.171-.192q-.183.162-.353.318c-.432.392-.841.762-1.286 1.078c-1.643 1.167-3.276 1.38-4.856.635a4.446 4.446 0 0 1-2.3-5.5c.493-1.414 1.135-2.79 1.757-4.12l.02-.043c.883-1.89 1.806-3.797 2.698-5.641l.793-1.641c.34-.706.795-1.498 1.595-2.026c.823-.543 1.783-.717 2.703-.49c.937.233 1.735.86 2.248 1.764c.763 1.346 1.44 2.762 2.015 3.984a375 375 0 0 1 3.411 7.433M11.62 3.97l-.555-1.165c-.412-.869-1.167-1.392-2.02-1.4c-.873.004-1.65.512-2.09 1.394q-.199.397-.404.79c-.226.439-.46.892-.674 1.35c-1.5 3.224-2.883 6.218-4.227 9.152c-.396.863-.41 1.772-.043 2.627c.35.814.974 1.422 1.757 1.711c.324.12.66.179.999.179c.483 0 .971-.12 1.432-.36c.585-.304 1.097-.738 1.593-1.157c.216-.183.432-.366.653-.537c.579-.448.26-.959.136-1.158c-.572-.915-1.164-1.862-1.624-2.842c-.444-.948-.538-1.903-.278-2.837c.413-1.482 1.952-2.33 3.503-1.93c1.456.374 2.341 1.873 2.058 3.486c-.194 1.107-.66 2.178-1.51 3.475c-.055.082-.12.168-.186.255c-.24.317-.511.677-.451 1.064c.064.41.426.705.745.965q.108.088.206.172c.805.711 1.719 1.371 2.951 1.388h.026l.025-.003q.117-.015.235-.027c.19-.02.389-.04.589-.097a3.06 3.06 0 0 0 1.953-1.692c.37-.83.356-1.766-.038-2.634c-1.547-3.41-3.18-6.846-4.761-10.169m-1.162 7.32c.183-.907.054-1.46-.43-1.85q-.468-.372-.988-.373q-.384 0-.793.204c-.545.274-.78.748-.737 1.495c.076 1.313.747 2.383 1.504 3.483c.633-.89 1.221-1.854 1.444-2.96z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2 24 24"
}

export const jamAlarmClock: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 10h2a1 1 0 0 1 0 2h-3a1 1 0 0 1-1-1V6a1 1 0 1 1 2 0zm7.63-1.562a9 9 0 1 1-17.26 0a5 5 0 1 1 7.668-6.387a9 9 0 0 1 1.924 0a5 5 0 1 1 7.668 6.387m-.938-2.113a3 3 0 0 0-4.48-3.735a9.03 9.03 0 0 1 4.48 3.735M6.787 2.59a3 3 0 0 0-4.48 3.735a9.03 9.03 0 0 1 4.48-3.735M10 18a7 7 0 1 0 0-14a7 7 0 0 0 0 14\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamAlarmClockF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.962 2.05a5 5 0 1 1 7.668 6.387a9.01 9.01 0 0 0-7.668-6.386zM1.37 8.439a5 5 0 1 1 7.668-6.387A9.01 9.01 0 0 0 1.37 8.438zM10 18a7 7 0 1 1 0-14a7 7 0 0 1 0 14m1-8V6a1 1 0 0 0-2 0v5a1 1 0 0 0 1 1h3a1 1 0 0 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3 24 24"
}

export const jamAlert: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0-13a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V6a1 1 0 0 1 1-1m0 10a1 1 0 1 1 0-2a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamAlertF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20.393c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.478 10 10s-4.477 10-10 10m0-15a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m0 10a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1.5 24 24"
}

export const jamAlien: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 20c-4.5 0-9-6.03-9-11a9 9 0 1 1 18 0c0 4.97-4.5 11-9 11m0-2c3.14 0 7-4.869 7-9A7 7 0 0 0 2 9c0 4.131 3.86 9 7 9m-1.974-4.18c-.529.192-2.339-.579-2.905-2.136c-.567-1.557.347-3.319.853-3.503s2.339.578 2.905 2.135c.567 1.557-.324 3.31-.853 3.503zm3.948 0c-.529-.193-1.42-1.947-.853-3.504c.566-1.557 2.399-2.32 2.905-2.135c.506.184 1.42 1.946.853 3.503c-.566 1.557-2.376 2.328-2.905 2.135z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2 24 24"
}

export const jamAlienF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 20.858c-4.5 0-9-6.03-9-11a9 9 0 1 1 18 0c0 4.97-4.5 11-9 11m-1.974-6.181c.529-.192 1.42-1.946.853-3.503c-.566-1.557-2.399-2.32-2.905-2.135c-.506.184-1.42 1.946-.853 3.503c.566 1.557 2.376 2.327 2.905 2.135m3.948 0c.529.192 2.339-.578 2.905-2.135c.567-1.557-.347-3.319-.853-3.503s-2.339.578-2.905 2.135c-.567 1.557.324 3.31.853 3.503\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -1.5 24 24"
}

export const jamAlignCenter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h8a1 1 0 0 1 0 2H3a1 1 0 1 1 0-2m0 8h8a1 1 0 0 1 0 2H3a1 1 0 1 1 0-2M1 4h12a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -7 24 24"
}

export const jamAlignJustify: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 0h12a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2m0 8h12a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2m0-4h12a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -7 24 24"
}

export const jamAlignLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 0h6a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2m0 8h8a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2m0-4h12a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -7 24 24"
}

export const jamAlignRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 0h6a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2M5 8h8a1 1 0 0 1 0 2H5a1 1 0 1 1 0-2M1 4h12a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -7 24 24"
}

export const jamAmazon: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M11.829 4.741c-.484.038-1.043.075-1.601.15c-.856.111-1.712.261-2.42.596C6.432 6.047 5.5 7.239 5.5 8.993c0 2.2 1.415 3.317 3.202 3.317c.596 0 1.08-.073 1.526-.185c.708-.224 1.303-.634 2.01-1.38c.41.56.52.821 1.229 1.417c.186.075.372.075.52-.037a67 67 0 0 0 1.64-1.417c.185-.15.147-.373.036-.56c-.41-.522-.819-.97-.819-1.975V4.816c0-1.418.11-2.722-.93-3.69C13.057.34 11.716.042 10.675.042h-.447C8.329.155 6.319.975 5.872 3.324c-.074.298.15.41.299.449l2.084.26c.223-.038.334-.224.371-.41c.187-.82.857-1.23 1.602-1.305h.15c.445 0 .929.187 1.19.558c.297.448.26 1.045.26 1.567zm0 2.164c0 .858.036 1.529-.41 2.273c-.26.522-.707.858-1.191.97c-.074 0-.185.038-.298.038c-.818 0-1.303-.633-1.303-1.566c0-1.193.708-1.753 1.6-2.014c.485-.112 1.044-.15 1.602-.15zm6.857 8.86c.91-.77 1.294-2.167 1.314-2.897v-.122a.66.66 0 0 0-.08-.344c-.182-.222-1.518-.426-2.67-.081a3.2 3.2 0 0 0-.87.425c-.202.143-.162.323.04.304c.223-.041.506-.06.83-.102c.708-.06 1.537-.08 1.74.183c.281.343-.324 1.843-.588 2.492c-.08.203.101.285.284.142\"/><path d=\"M.1 12.868c2.609 2.37 6.047 3.789 9.89 3.789c2.386 0 5.136-.67 7.26-1.945c.284-.163.566-.346.828-.548c.364-.262.041-.669-.323-.507c-.161.06-.344.143-.505.203a19.5 19.5 0 0 1-7.038 1.338c-3.6 0-7.078-.993-9.89-2.634c-.263-.141-.445.122-.222.304\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3.5 24 24"
}

export const jamAnchor: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16.93 11.998A1 1 0 0 1 17 10h2a1 1 0 0 1 0 2h-.055a9.001 9.001 0 0 1-17.89 0H1a1 1 0 0 1 0-2h2a1 1 0 0 1 .07 1.998A7.005 7.005 0 0 0 9 17.929V7.874A4.002 4.002 0 0 1 10 0a4 4 0 0 1 1 7.874v10.055a7.005 7.005 0 0 0 5.93-5.931M10 6a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamAndroid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1.247 6.51h-.051c-.656 0-1.19.537-1.19 1.19v5.183c0 .656.534 1.19 1.19 1.19h.052c.655 0 1.19-.535 1.19-1.19V7.7a1.195 1.195 0 0 0-1.191-1.19m1.76 8.373c0 .602.492 1.092 1.094 1.092h1.17v2.8c0 .657.535 1.191 1.19 1.191h.05c.657 0 1.192-.535 1.192-1.192v-2.799h1.634v2.8c0 .657.538 1.191 1.192 1.191h.05c.657 0 1.191-.535 1.191-1.192v-2.799h1.17c.601 0 1.093-.49 1.093-1.092V6.701H3.007zm8.259-13.145l.929-1.433a.197.197 0 1 0-.33-.215l-.963 1.483a6.3 6.3 0 0 0-2.38-.462a6.3 6.3 0 0 0-2.382.462L5.179.09a.197.197 0 0 0-.275-.058a.197.197 0 0 0-.058.273l.93 1.433C4.1 2.56 2.97 4.107 2.97 5.882q0 .164.016.323h11.07a4 4 0 0 0 .014-.323c0-1.775-1.13-3.322-2.805-4.144zM5.955 4.305a.532.532 0 1 1-.002-1.064a.532.532 0 0 1 .002 1.064m5.132 0a.532.532 0 1 1-.003-1.064a.532.532 0 0 1 .003 1.064m4.758 2.205h-.05c-.655 0-1.191.537-1.191 1.19v5.183c0 .656.537 1.19 1.191 1.19h.05c.657 0 1.191-.535 1.191-1.19V7.7c0-.654-.535-1.19-1.191-1.19\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2 24 24"
}

export const jamAndroidCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M6.39 8.248h-.026a.6.6 0 0 0-.596.596v2.594c0 .329.267.596.596.596h.026a.6.6 0 0 0 .596-.596V8.844a.6.6 0 0 0-.597-.596zm.88 4.192c0 .3.247.546.548.546h.586v1.402c0 .329.268.596.596.596h.025a.6.6 0 0 0 .597-.596v-1.402h.818v1.402c0 .329.27.596.596.596h.026a.6.6 0 0 0 .596-.596v-1.402h.586c.3 0 .547-.245.547-.547V8.343H7.27zm4.136-6.581l.465-.718a.099.099 0 1 0-.166-.108l-.482.743a3.1 3.1 0 0 0-1.192-.232c-.427 0-.83.084-1.192.232l-.481-.743a.1.1 0 0 0-.137-.029a.1.1 0 0 0-.03.137l.466.718c-.839.41-1.405 1.185-1.405 2.074q0 .082.009.162h5.541q.008-.08.008-.162c0-.889-.566-1.663-1.404-2.074m-2.66 1.284a.266.266 0 1 1 0-.532a.266.266 0 0 1 0 .532m2.57 0a.266.266 0 1 1-.001-.532a.266.266 0 0 1 0 .532zm2.382 1.105h-.025a.6.6 0 0 0-.597.596v2.594c0 .329.27.596.597.596h.025a.597.597 0 0 0 .596-.596V8.844a.6.6 0 0 0-.596-.596\"/><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamAndroidSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M6.39 8.248h-.026a.6.6 0 0 0-.596.596v2.594c0 .329.267.596.596.596h.026a.6.6 0 0 0 .596-.596V8.844a.6.6 0 0 0-.597-.596zm.88 4.192c0 .3.247.546.548.546h.586v1.402c0 .329.268.596.596.596h.025a.6.6 0 0 0 .597-.596v-1.402h.818v1.402c0 .329.27.596.596.596h.026a.6.6 0 0 0 .596-.596v-1.402h.586c.3 0 .547-.245.547-.547V8.343H7.27zm4.136-6.581l.465-.718a.099.099 0 1 0-.166-.108l-.482.743a3.1 3.1 0 0 0-1.192-.232c-.427 0-.83.084-1.192.232l-.481-.743a.1.1 0 0 0-.137-.029a.1.1 0 0 0-.03.137l.466.718c-.839.41-1.405 1.185-1.405 2.074q0 .082.009.162h5.541q.008-.08.008-.162c0-.889-.566-1.663-1.404-2.074m-2.66 1.284a.266.266 0 1 1 0-.532a.266.266 0 0 1 0 .532m2.57 0a.266.266 0 1 1-.001-.532a.266.266 0 0 1 0 .532zm2.382 1.105h-.025a.6.6 0 0 0-.597.596v2.594c0 .329.27.596.597.596h.025a.597.597 0 0 0 .596-.596V8.844a.6.6 0 0 0-.596-.596\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamAperture: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m8.164 11.107l1.817 1.049l1.87-1.08V9.01L9.96 7.92L8.164 9.042zm-2-1.155V2.978a8.02 8.02 0 0 0-3.839 4.758zm-4.163-.094L2 10a7.97 7.97 0 0 0 2.19 5.499l3.79-2.189zm6.163-3.174l5.808-3.63A7.96 7.96 0 0 0 10 2q-.95.002-1.836.212zm7.503-2.33l-3.786 2.365l6.115 3.531a7.98 7.98 0 0 0-2.329-5.897zm-1.816 5.812v6.848a8.02 8.02 0 0 0 3.796-4.656zm-7.993 6.68A7.96 7.96 0 0 0 10 18c.637 0 1.257-.074 1.85-.215v-4.4l-5.992 3.46zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamApple: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.623 10.627c-.025-2.533 2.066-3.748 2.159-3.808c-1.175-1.72-3.005-1.955-3.657-1.982c-1.557-.158-3.039.917-3.83.917c-.788 0-2.008-.894-3.3-.87C3.299 4.909 1.734 5.87.86 7.39c-1.764 3.06-.452 7.595 1.267 10.077c.84 1.215 1.842 2.58 3.157 2.53c1.266-.05 1.745-.819 3.276-.819s1.962.82 3.302.795c1.363-.026 2.226-1.239 3.06-2.457c.965-1.41 1.362-2.775 1.386-2.845c-.03-.013-2.658-1.02-2.684-4.045zm-2.518-7.433c.698-.847 1.169-2.022 1.04-3.194C11.14.04 9.921.67 9.2 1.515c-.647.75-1.214 1.945-1.062 3.094c1.122.088 2.268-.57 2.967-1.415\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3.5 -2 24 24"
}

export const jamAppleCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M12.8 10.313c-.012-1.266 1.034-1.873 1.08-1.904c-.587-.86-1.502-.977-1.828-.99c-.779-.08-1.52.458-1.915.458c-.394 0-1.004-.447-1.65-.435c-.849.013-1.631.493-2.068 1.254c-.882 1.53-.226 3.797.633 5.038c.42.607.921 1.29 1.579 1.265c.633-.025.872-.41 1.638-.41s.98.41 1.65.398c.682-.013 1.114-.62 1.531-1.229c.482-.704.681-1.387.693-1.422c-.015-.007-1.33-.51-1.342-2.023zm-1.258-3.716c.349-.424.584-1.011.52-1.597c-.503.02-1.112.335-1.473.757c-.323.375-.607.973-.53 1.548c.56.043 1.133-.286 1.483-.708\"/><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamAppleSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M12.8 10.313c-.012-1.266 1.034-1.873 1.08-1.904c-.587-.86-1.502-.977-1.828-.99c-.779-.08-1.52.458-1.915.458c-.394 0-1.004-.447-1.65-.435c-.849.013-1.631.493-2.068 1.254c-.882 1.53-.226 3.797.633 5.038c.42.607.921 1.29 1.579 1.265c.633-.025.872-.41 1.638-.41s.98.41 1.65.398c.682-.013 1.114-.62 1.531-1.229c.482-.704.681-1.387.693-1.422c-.015-.007-1.33-.51-1.342-2.023zm-1.258-3.716c.349-.424.584-1.011.52-1.597c-.503.02-1.112.335-1.473.757c-.323.375-.607.973-.53 1.548c.56.043 1.133-.286 1.483-.708\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArchive: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 5h16V2H2zm16 2v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1zM4 18h12V7H4zm4-4h4a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArchiveF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1zm1 2v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7zM8 14a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowCircleDown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-1-6.414V6a1 1 0 1 1 2 0v5.586l2.536-2.536a1 1 0 0 1 1.414 1.414l-4.243 4.243a.997.997 0 0 1-1.414 0L5.05 10.464A1 1 0 0 1 6.464 9.05z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowCircleDownF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.293 14.707a.997.997 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414L11 11.586V6a1 1 0 0 0-2 0v5.586L6.464 9.05a1 1 0 1 0-1.414 1.414zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowCircleDownLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-1.828-7.586l3.95-3.95a1 1 0 0 1 1.414 1.415l-3.95 3.95h3.586a1 1 0 0 1 0 2h-6a.997.997 0 0 1-1-1v-6a1 1 0 1 1 2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowCircleDownLeftF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6.172 12.828a.997.997 0 0 0 1 1h6a1 1 0 1 0 0-2H9.586l3.95-3.95a1 1 0 1 0-1.415-1.414l-3.95 3.95V6.828a1 1 0 1 0-2 0zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowCircleDownRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m.414-6.172l-3.95-3.95A1 1 0 0 1 7.88 6.465l3.95 3.95V6.828a1 1 0 0 1 2 0v6a.997.997 0 0 1-1 1h-6a1 1 0 1 1 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowCircleDownRightF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12.828 13.828a.997.997 0 0 0 1-1v-6a1 1 0 1 0-2 0v3.586l-3.95-3.95A1 1 0 0 0 6.465 7.88l3.95 3.95H6.828a1 1 0 0 0 0 2h6zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowCircleLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16M8.414 9H14a1 1 0 0 1 0 2H8.414l2.536 2.536a1 1 0 0 1-1.414 1.414l-4.243-4.243a.997.997 0 0 1 0-1.414L9.536 5.05a1 1 0 0 1 1.414 1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowCircleLeftF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5.293 9.293a.997.997 0 0 0 0 1.414l4.243 4.243a1 1 0 1 0 1.414-1.414L8.414 11H14a1 1 0 0 0 0-2H8.414l2.536-2.536A1 1 0 1 0 9.536 5.05zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowCircleRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m1.586-7H6a1 1 0 0 1 0-2h5.586L9.05 6.464a1 1 0 1 1 1.414-1.414l4.243 4.243a.997.997 0 0 1 0 1.414l-4.243 4.243a1 1 0 1 1-1.414-1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowCircleRightF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14.707 10.707a.997.997 0 0 0 0-1.414L10.464 5.05A1 1 0 0 0 9.05 6.464L11.586 9H6a1 1 0 1 0 0 2h5.586L9.05 13.536a1 1 0 0 0 1.414 1.414zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowCircleUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 8.414V14a1 1 0 0 1-2 0V8.414L6.464 10.95A1 1 0 1 1 5.05 9.536l4.243-4.243a.997.997 0 0 1 1.414 0l4.243 4.243a1 1 0 1 1-1.414 1.414zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowCircleUpF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.707 5.293a.997.997 0 0 0-1.414 0L5.05 9.536a1 1 0 0 0 1.414 1.414L9 8.414V14a1 1 0 0 0 2 0V8.414l2.536 2.536a1 1 0 0 0 1.414-1.414zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowCircleUpLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-.414-9.828l3.95 3.95a1 1 0 0 1-1.415 1.414l-3.95-3.95v3.586a1 1 0 0 1-2 0v-6a.997.997 0 0 1 1-1h6a1 1 0 0 1 0 2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowCircleUpLeftF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7.172 6.172a.997.997 0 0 0-1 1v6a1 1 0 0 0 2 0V9.586l3.95 3.95a1 1 0 0 0 1.414-1.415l-3.95-3.95h3.586a1 1 0 0 0 0-2zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowCircleUpRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m1.828-8.414l-3.95 3.95a1 1 0 1 1-1.414-1.415l3.95-3.95H6.828a1 1 0 1 1 0-2h6a.997.997 0 0 1 1 1v6a1 1 0 1 1-2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowCircleUpRightF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.828 7.172a.997.997 0 0 0-1-1h-6a1 1 0 1 0 0 2h3.586l-3.95 3.95a1 1 0 0 0 1.415 1.414l3.95-3.95v3.586a1 1 0 0 0 2 0v-6zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowDown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m8 11.243l3.95-3.95a1 1 0 1 1 1.414 1.414l-5.657 5.657a.997.997 0 0 1-1.414 0L.636 8.707A1 1 0 1 1 2.05 7.293L6 11.243V1.657a1 1 0 1 1 2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -4.5 24 24"
}

export const jamArrowDownLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.828 8.9h5.586a1 1 0 0 1 0 2h-8a.997.997 0 0 1-1-1v-8a1 1 0 1 1 2 0v5.585L9.192.707a1 1 0 1 1 1.415 1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6.5 -6.5 24 24"
}

export const jamArrowDownRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8.9 7.485V1.9a1 1 0 0 1 2 0v8a.997.997 0 0 1-1 1h-8a1 1 0 1 1 0-2h5.585L.707 2.121A1 1 0 0 1 2.121.707z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6.5 -6.5 24 24"
}

export const jamArrowLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m3.414 7.657l3.95 3.95A1 1 0 0 1 5.95 13.02L.293 7.364a.997.997 0 0 1 0-1.414L5.95.293a1 1 0 1 1 1.414 1.414l-3.95 3.95H13a1 1 0 0 1 0 2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -5 24 24"
}

export const jamArrowRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m10.586 5.657l-3.95-3.95A1 1 0 0 1 8.05.293l5.657 5.657a.997.997 0 0 1 0 1.414L8.05 13.021a1 1 0 1 1-1.414-1.414l3.95-3.95H1a1 1 0 1 1 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -5 24 24"
}

export const jamArrowSquareDown: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/><path d=\"M9 11.586V6a1 1 0 1 1 2 0v5.586l2.536-2.536a1 1 0 0 1 1.414 1.414l-4.243 4.243a.997.997 0 0 1-1.414 0L5.05 10.464A1 1 0 1 1 6.464 9.05z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowSquareDownF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.293 14.707a.997.997 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414L11 11.586V6a1 1 0 0 0-2 0v5.586L6.464 9.05a1 1 0 1 0-1.414 1.414zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowSquareDownLeft: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/><path d=\"m8.172 10.414l3.95-3.95a1 1 0 1 1 1.414 1.415l-3.95 3.95h3.586a1 1 0 0 1 0 2h-6a.997.997 0 0 1-1-1v-6a1 1 0 1 1 2 0z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowSquareDownLeftF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6.172 12.828a.997.997 0 0 0 1 1h6a1 1 0 1 0 0-2H9.586l3.95-3.95a1 1 0 1 0-1.415-1.414l-3.95 3.95V6.828a1 1 0 1 0-2 0zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowSquareDownRight: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/><path d=\"m10.414 11.828l-3.95-3.95A1 1 0 1 1 7.88 6.465l3.95 3.95V6.828a1 1 0 0 1 2 0v6a.997.997 0 0 1-1 1h-6a1 1 0 1 1 0-2z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowSquareDownRightF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12.828 13.828a.997.997 0 0 0 1-1v-6a1 1 0 1 0-2 0v3.586l-3.95-3.95A1 1 0 0 0 6.465 7.88l3.95 3.95H6.828a1 1 0 0 0 0 2h6zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowSquareLeft: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/><path d=\"M8.414 9H14a1 1 0 1 1 0 2H8.414l2.536 2.536a1 1 0 0 1-1.414 1.414l-4.243-4.243a.997.997 0 0 1 0-1.414L9.536 5.05a1 1 0 1 1 1.414 1.414z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowSquareLeftF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5.293 9.293a.997.997 0 0 0 0 1.414l4.243 4.243a1 1 0 1 0 1.414-1.414L8.414 11H14a1 1 0 0 0 0-2H8.414l2.536-2.536A1 1 0 1 0 9.536 5.05zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowSquareRight: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/><path d=\"M11.586 11H6a1 1 0 1 1 0-2h5.586L9.05 6.464a1 1 0 0 1 1.414-1.414l4.243 4.243a.997.997 0 0 1 0 1.414l-4.243 4.243a1 1 0 1 1-1.414-1.414z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowSquareRightF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14.707 10.707a.997.997 0 0 0 0-1.414L10.464 5.05A1 1 0 0 0 9.05 6.464L11.586 9H6a1 1 0 1 0 0 2h5.586L9.05 13.536a1 1 0 0 0 1.414 1.414zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowSquareUp: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/><path d=\"M11 8.414V14a1 1 0 0 1-2 0V8.414L6.464 10.95A1 1 0 1 1 5.05 9.536l4.243-4.243a.997.997 0 0 1 1.414 0l4.243 4.243a1 1 0 1 1-1.414 1.414z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowSquareUpF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.707 5.293a.997.997 0 0 0-1.414 0L5.05 9.536a1 1 0 0 0 1.414 1.414L9 8.414V14a1 1 0 0 0 2 0V8.414l2.536 2.536a1 1 0 0 0 1.414-1.414zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowSquareUpLeft: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/><path d=\"m9.586 8.172l3.95 3.95a1 1 0 1 1-1.415 1.414l-3.95-3.95v3.586a1 1 0 0 1-2 0v-6a.997.997 0 0 1 1-1h6a1 1 0 1 1 0 2z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowSquareUpLeftF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7.172 6.172a.997.997 0 0 0-1 1v6a1 1 0 0 0 2 0V9.586l3.95 3.95a1 1 0 0 0 1.414-1.415l-3.95-3.95h3.586a1 1 0 0 0 0-2zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowSquareUpRight: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/><path d=\"m11.828 9.586l-3.95 3.95a1 1 0 1 1-1.414-1.415l3.95-3.95H6.828a1 1 0 0 1 0-2h6a.997.997 0 0 1 1 1v6a1 1 0 1 1-2 0z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowSquareUpRightF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.828 7.172a.997.997 0 0 0-1-1h-6a1 1 0 1 0 0 2h3.586l-3.95 3.95a1 1 0 0 0 1.415 1.414l3.95-3.95v3.586a1 1 0 0 0 2 0v-6zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m6 4.071l-3.95 3.95A1 1 0 0 1 .636 6.607L6.293.95a.997.997 0 0 1 1.414 0l5.657 5.657A1 1 0 0 1 11.95 8.02L8 4.07v9.586a1 1 0 1 1-2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -4.5 24 24"
}

export const jamArrowUpLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2.757 3.828v5.586a1 1 0 0 1-2 0v-8a.997.997 0 0 1 1-1h8a1 1 0 1 1 0 2H4.172l6.778 6.778a1 1 0 1 1-1.414 1.415z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -6.5 24 24"
}

export const jamArrowUpRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7.828 2.414H2.243a1 1 0 1 1 0-2h8a.997.997 0 0 1 1 1v8a1 1 0 0 1-2 0V3.828l-6.779 6.779A1 1 0 0 1 1.05 9.192z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -6.5 24 24"
}

export const jamArrowsCorners: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 0h6a1 1 0 1 1 0 2H3.414L18 16.586V13a1 1 0 0 1 2 0v6a1 1 0 0 1-1 1h-6a1 1 0 0 1 0-2h3.586L2 3.414V7a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowsFullscreen: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19 0a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0V3.414L11.414 10L18 16.586V13a1 1 0 0 1 2 0v6a1 1 0 0 1-1 1h-6a1 1 0 0 1 0-2h3.586L10 11.414L3.414 18H7a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1v-6a1 1 0 0 1 2 0v3.586L8.586 10L2 3.414V7a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H3.414L10 8.586L16.586 2H13a1 1 0 0 1 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamArrowsH: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.423 4.996h13.154L14.04 2.46a1 1 0 1 1 1.415-1.414l4.242 4.243a1 1 0 0 1 0 1.414l-4.242 4.242a1 1 0 0 1-1.415-1.414l2.536-2.535H3.423L5.96 9.53a1 1 0 1 1-1.415 1.414L.302 6.703a.997.997 0 0 1 0-1.414l4.242-4.243A1 1 0 1 1 5.96 2.46z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6 24 24"
}

export const jamArrowsV: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 16.573V3.419L2.464 5.954A1 1 0 0 1 1.05 4.54L5.293.297a1 1 0 0 1 1.414 0L10.95 4.54a1 1 0 1 1-1.414 1.414L7 3.42v13.154l2.536-2.536a1 1 0 1 1 1.414 1.414l-4.243 4.243a.997.997 0 0 1-1.414 0L1.05 15.451a1 1 0 1 1 1.414-1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -2 24 24"
}

export const jamAttachment: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18.433 5.359a.933.933 0 0 1 1.357 0c.375.39.375 1.022 0 1.412L8.26 18.78a4.663 4.663 0 0 1-6.783 0c-1.873-1.95-1.873-5.113 0-7.064L11.65 1.12a2.8 2.8 0 0 1 4.07 0c1.124 1.17 1.124 3.068 0 4.239L6.902 14.54a.933.933 0 0 1-1.356 0a1.03 1.03 0 0 1 0-1.412l8.818-9.183a1.03 1.03 0 0 0 0-1.413a.933.933 0 0 0-1.357 0L2.832 13.13c-1.123 1.17-1.123 3.068 0 4.238a2.8 2.8 0 0 0 4.07 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1.5 -1.5 24 24"
}

export const jamBackgroundColor: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m7.543 8l.506 1.386c.17.466.734.722 1.26.57c.525-.15.813-.651.643-1.117l-2.05-5.61c-.197-.542-.675-.967-1.285-1.142c-1.05-.302-2.179.209-2.52 1.141L2.05 8.838c-.17.467.118.967.643 1.119c.525.15 1.09-.105 1.26-.571L4.458 8zm-.73-2H5.188L6 3.776zM2 0h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -6 24 24"
}

export const jamBackpack: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 13v5h8v-5zm10-.764V18a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-5.764c-.614-.55-1-1.348-1-2.236V7a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v3c0 .888-.386 1.687-1 2.236M3 6a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm5 5H6v-1a1 1 0 1 1 2 0zm0 2v1a1 1 0 0 1-2 0v-1zM3.5 0A1.5 1.5 0 0 1 5 1.5v3a1.5 1.5 0 0 1-3 0v-3A1.5 1.5 0 0 1 3.5 0m7 0A1.5 1.5 0 0 1 12 1.5v3a1.5 1.5 0 0 1-3 0v-3A1.5 1.5 0 0 1 10.5 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamBackpackF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 14a1 1 0 0 0 2 0h3c.729 0 1.412-.195 2-.535V18a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-4.535c.588.34 1.271.535 2 .535zm2-1v-3a1 1 0 1 0-2 0v3H3a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3zM5 3H3q-.519.002-1 .126V1.5a1.5 1.5 0 0 1 3 0zm7 .126A4 4 0 0 0 11 3H9V1.5a1.5 1.5 0 0 1 3 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamBackward: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16.51.69a1.966 1.966 0 0 1 2.814-.182c.43.386.676.942.676 1.526v13.932C20 17.089 19.107 18 18.006 18a1.98 1.98 0 0 1-1.496-.69l-6.012-6.966a2.065 2.065 0 0 1 0-2.688zm1.496 15.276V2.034L11.994 9zM6.51.69A1.966 1.966 0 0 1 9.324.508c.43.386.676.942.676 1.526v13.932C10 17.089 9.107 18 8.006 18a1.98 1.98 0 0 1-1.496-.69L.498 10.344a2.065 2.065 0 0 1 0-2.688zm1.496 15.276V2.034L1.994 9z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3 24 24"
}

export const jamBackwardCircle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m.973-11.246l1.956-1.398c.905-.646 2.13-.389 2.737.576c.218.346.334.753.334 1.17v5.796c0 1.16-.883 2.102-1.972 2.102a1.9 1.9 0 0 1-1.099-.356l-1.956-1.398C10.818 14.24 10.006 15 9.028 15a1.9 1.9 0 0 1-1.099-.356l-4.055-2.898c-.905-.647-1.146-1.952-.54-2.917c.143-.227.327-.422.54-.575L7.93 5.356c.905-.646 2.13-.389 2.737.576c.157.249.26.53.307.822zm-1.945 6.144V7.102L4.973 10zm5 0V7.102l-3.02 2.159l-.004 1.476z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamBackwardCircleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.973 6.754a2.2 2.2 0 0 0-.307-.822c-.607-.965-1.832-1.222-2.737-.576L3.874 8.254a2 2 0 0 0-.54.575c-.606.965-.365 2.27.54 2.917l4.055 2.898A1.9 1.9 0 0 0 9.028 15c.978 0 1.79-.759 1.945-1.754l1.956 1.398a1.9 1.9 0 0 0 1.099.356C15.117 15 16 14.059 16 12.898V7.102c0-.417-.116-.824-.334-1.17c-.607-.965-1.832-1.222-2.737-.576zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m4.028-7.102l-3.024-2.161l.003-1.476l3.02-2.159v5.796zm-5 0L4.973 10l4.055-2.898z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamBackwardSquare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm6.973 4.754l1.956-1.398c.905-.646 2.13-.389 2.737.576c.218.346.334.753.334 1.17v5.796c0 1.16-.883 2.102-1.972 2.102a1.9 1.9 0 0 1-1.099-.356l-1.956-1.398C10.818 14.24 10.006 15 9.028 15a1.9 1.9 0 0 1-1.099-.356l-4.055-2.898c-.905-.647-1.146-1.952-.54-2.917c.143-.227.327-.422.54-.575L7.93 5.356c.905-.646 2.13-.389 2.737.576c.157.249.26.53.307.822zm-1.945 6.144V7.102L4.973 10zm5 0V7.102l-3.02 2.159l-.004 1.476z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamBackwardSquareF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.973 6.754a2.2 2.2 0 0 0-.307-.822c-.607-.965-1.832-1.222-2.737-.576L3.874 8.254a2 2 0 0 0-.54.575c-.606.965-.365 2.27.54 2.917l4.055 2.898A1.9 1.9 0 0 0 9.028 15c.978 0 1.79-.759 1.945-1.754l1.956 1.398a1.9 1.9 0 0 0 1.099.356C15.117 15 16 14.059 16 12.898V7.102c0-.417-.116-.824-.334-1.17c-.607-.965-1.832-1.222-2.737-.576zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m10.052 7.114v5.795l-3.02-2.158l-.004-1.476zm-4.97 0v5.795l-4.054-2.897z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamBaidu: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4.503 7.382c.114 1.681-.774 3.115-1.986 3.202c-1.21.087-2.285-1.205-2.4-2.887s.774-3.115 1.985-3.202s2.286 1.205 2.4 2.887zm8.34-6.97c-1.176-.308-2.458.767-2.862 2.4c-.406 1.633.219 3.207 1.395 3.515c1.177.308 2.46-.767 2.864-2.4C14.767 1.8 13.126.485 12.844.412zm2.76 5.506c-1.238.018-2.22 1.226-2.193 3.096s1.05 2.722 2.29 2.703c1.236-.019 2.22-.901 2.192-2.772c-.036-2.434-1.993-3.032-2.29-3.027zM6.635 0C5.458 0 4.503 1.354 4.503 3.023s.955 3.023 2.132 3.023s2.133-1.353 2.133-3.023S7.813 0 6.635 0m-.272 9.389c-.68 1.002-1.452 1.98-2.95 3.262c-1.497 1.282-2.132 2.167-2.132 3.472c0 1.304.726 3.471 2.79 3.471s3.063-.466 4.697-.466s2.723.652 4.787.652s2.926-2.003 2.926-3.308s-.358-2.043-2.012-3.532c-1.06-.955-1.958-1.733-3.365-3.737c-.695-.99-1.497-1.118-2.336-1.118c-.84 0-1.724.302-2.405 1.304\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2 24 24"
}

export const jamBaiduCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M7.731 8.74c.058.85-.39 1.575-1.003 1.619s-1.156-.61-1.214-1.46s.391-1.575 1.004-1.619c.612-.044 1.156.61 1.213 1.46m4.217-3.524c-.595-.156-1.243.388-1.447 1.213c-.206.826.11 1.622.705 1.777c.595.156 1.244-.387 1.448-1.213c.267-1.075-.563-1.74-.706-1.777M13.343 8c-.626.01-1.122.62-1.108 1.566c.013.945.53 1.376 1.157 1.367c.625-.01 1.122-.456 1.109-1.402c-.019-1.23-1.008-1.533-1.158-1.53zM8.81 5.008c-.596 0-1.078.684-1.078 1.528s.482 1.528 1.078 1.528c.595 0 1.078-.684 1.078-1.528S9.405 5.008 8.81 5.008m-.138 4.746c-.344.507-.734 1.002-1.491 1.65s-1.078 1.095-1.078 1.755s.367 1.755 1.41 1.755c1.044 0 1.549-.236 2.375-.236c.825 0 1.376.33 2.42.33c1.043 0 1.48-1.013 1.48-1.673s-.182-1.033-1.018-1.785c-.536-.483-.99-.877-1.701-1.89c-.352-.5-.757-.565-1.181-.565s-.872.153-1.216.66z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamBaiduSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M7.731 8.74c.058.85-.39 1.575-1.003 1.619s-1.156-.61-1.214-1.46s.391-1.575 1.004-1.619c.612-.044 1.156.61 1.213 1.46m4.217-3.524c-.595-.156-1.243.388-1.447 1.213c-.206.826.11 1.622.705 1.777c.595.156 1.244-.387 1.448-1.213c.267-1.075-.563-1.74-.706-1.777M13.343 8c-.626.01-1.122.62-1.108 1.566c.013.945.53 1.376 1.157 1.367c.625-.01 1.122-.456 1.109-1.402c-.019-1.23-1.008-1.533-1.158-1.53zM8.81 5.008c-.596 0-1.078.684-1.078 1.528s.482 1.528 1.078 1.528c.595 0 1.078-.684 1.078-1.528S9.405 5.008 8.81 5.008m-.138 4.746c-.344.507-.734 1.002-1.491 1.65s-1.078 1.095-1.078 1.755s.367 1.755 1.41 1.755c1.044 0 1.549-.236 2.375-.236c.825 0 1.376.33 2.42.33c1.043 0 1.48-1.013 1.48-1.673s-.182-1.033-1.018-1.785c-.536-.483-.99-.877-1.701-1.89c-.352-.5-.757-.565-1.181-.565s-.872.153-1.216.66z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamBandage: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18.697 1.445a4.69 4.69 0 0 1 0 6.635L8.08 18.697a4.692 4.692 0 0 1-6.635-6.635L12.062 1.445a4.69 4.69 0 0 1 6.635 0M17.37 2.772a2.815 2.815 0 0 0-3.981 0L2.772 13.39a2.815 2.815 0 1 0 3.981 3.98L17.37 6.754a2.813 2.813 0 0 0 0-3.98zm-5.972 4.645l1.327 1.327a.94.94 0 0 1 0 1.327l-2.654 2.654a.94.94 0 0 1-1.327 0l-1.327-1.327a.94.94 0 0 1 0-1.327l2.654-2.654a.94.94 0 0 1 1.327 0m.664-.664a.938.938 0 1 1 1.327-1.327a.938.938 0 0 1-1.327 1.327M5.426 13.39a.938.938 0 1 1 1.327-1.327a.938.938 0 0 1-1.327 1.327m9.953-7.3a.938.938 0 1 1 1.327-1.326a.938.938 0 0 1-1.327 1.327zM4.763 16.707A.938.938 0 1 1 6.09 15.38a.938.938 0 0 1-1.327 1.327\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1.5 -1.5 24 24"
}

export const jamBandageF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19.92 1.536a5 5 0 0 1 0 7.07L8.607 19.92a5 5 0 1 1-7.071-7.07L12.849 1.535a5 5 0 0 1 7.071 0zm-7.778 6.363a1 1 0 0 0-1.414 0l-2.829 2.829a1 1 0 0 0 0 1.414l1.415 1.414a1 1 0 0 0 1.414 0l2.828-2.828a1 1 0 0 0 0-1.414zm.707-.707a1 1 0 1 0 1.414-1.414a1 1 0 0 0-1.414 1.414m-7.07 7.071a1 1 0 1 0 1.413-1.414a1 1 0 0 0-1.414 1.414zm10.606-7.778a1 1 0 1 0 1.414-1.414a1 1 0 0 0-1.414 1.414M5.07 17.8a1 1 0 1 0 1.414-1.414A1 1 0 0 0 5.07 17.8\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1 -1 24 24"
}

export const jamBarChart: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 0a1 1 0 0 1 1 1v14a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1m12 4a1 1 0 0 1 1 1v10a1 1 0 0 1-2 0V5a1 1 0 0 1 1-1M7 8a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -4 24 24"
}

export const jamBaseball: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.05 11H13a1 1 0 0 1 0-2h.05a9.95 9.95 0 0 1 2.065-5.151A7.97 7.97 0 0 0 10 2a7.97 7.97 0 0 0-5.115 1.849A9.95 9.95 0 0 1 6.95 9H7a1 1 0 1 1 0 2h-.05a9.95 9.95 0 0 1-2.065 5.151A7.97 7.97 0 0 0 10 18a7.97 7.97 0 0 0 5.115-1.849A9.95 9.95 0 0 1 13.05 11m2.012-1.998a1 1 0 0 1 0 1.996a7.96 7.96 0 0 0 1.438 3.668A7.97 7.97 0 0 0 18 10c0-1.71-.538-3.329-1.5-4.666a7.96 7.96 0 0 0-1.438 3.668M4.938 10.998a1 1 0 0 1 0-1.996A7.96 7.96 0 0 0 3.5 5.334A7.97 7.97 0 0 0 2 10c0 1.71.538 3.329 1.5 4.666a7.96 7.96 0 0 0 1.438-3.668M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamBasketball: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 17.938a7.97 7.97 0 0 0 4.115-1.787A9.95 9.95 0 0 1 13.05 11H11zm-2 0V11H6.95a9.95 9.95 0 0 1-2.065 5.151A7.97 7.97 0 0 0 9 17.938M6.95 9H9V2.062a7.97 7.97 0 0 0-4.115 1.787A9.95 9.95 0 0 1 6.95 9M11 2.062V9h2.05a9.95 9.95 0 0 1 2.065-5.151A7.97 7.97 0 0 0 11 2.062M4.938 11H2.062A7.96 7.96 0 0 0 3.5 14.666A7.96 7.96 0 0 0 4.938 11M2.062 9h2.876A7.96 7.96 0 0 0 3.5 5.334A7.96 7.96 0 0 0 2.062 9m13 0h2.876A7.96 7.96 0 0 0 16.5 5.334A7.96 7.96 0 0 0 15.062 9m2.876 2h-2.876a7.96 7.96 0 0 0 1.438 3.666A7.96 7.96 0 0 0 17.938 11M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamBathtub: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8.487 2.04A3 3 0 0 1 11 5v2H5V5c0-1.039.528-1.955 1.33-2.493A2 2 0 0 0 3 4v6h16a1 1 0 0 1 0 2v1a6 6 0 0 1-4 5.659V19a1 1 0 0 1-2 0H7a1 1 0 0 1-2 0v-.341A6 6 0 0 1 1 13v-1a1 1 0 0 1 0-2V4a4 4 0 0 1 7.487-1.96M17 12H3v1a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4zM8 4a1 1 0 0 0-1 1h2a1 1 0 0 0-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamBathtubF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8.487 2.897A3 3 0 0 1 11 5.857v2H5v-2c0-1.038.528-1.954 1.33-2.492A2 2 0 0 0 3 4.858v6h16a1 1 0 0 1 0 2v1a6 6 0 0 1-4 5.658V20a1 1 0 1 1-2 0v-.142H7V20a1 1 0 1 1-2 0v-.484a6 6 0 0 1-4-5.658v-1a1 1 0 0 1 0-2v-6a4 4 0 0 1 7.487-1.96z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1.5 24 24"
}

export const jamBattery: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19 3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h15a2 2 0 0 1 2 2zm-2 1.5V2H2v8h15z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6 24 24"
}

export const jamBatteryCharging: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 2v8h15V2zm17 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h15a2 2 0 0 1 2 2zm-5.212 3.358a1 1 0 0 1-1.281.597l-3.76-1.368a1 1 0 0 1 .685-1.88l3.759 1.369a1 1 0 0 1 .597 1.282M10.03 7.989a1 1 0 0 1-1.282.598L4.989 7.22a1 1 0 0 1 .684-1.88l3.759 1.369a1 1 0 0 1 .598 1.281zm.06-3.342v3a1 1 0 1 1-2 0v-3a1 1 0 1 1 2 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6 24 24"
}

export const jamBatteryChargingF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19 3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h15a2 2 0 0 1 2 2zm-8.775 5.11q.365-.245.408-.738V5.72l2.432.898a1 1 0 0 0 1.285-.591c.191-.518-.121-1.066-.639-1.258A381 381 0 0 1 9.946 3.41c-.441-.163-.755-.005-1.03.204q-.273.21-.326.806l.043 1.49l-2.428-.877a1 1 0 1 0-.68 1.881q2.484.909 3.77 1.377c.34.124.566.06.93-.183z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6 24 24"
}

export const jamBatteryF: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M2 0h15a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2\"/><path d=\"M18.5 3h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-.5A1.5 1.5 0 0 1 17 7.5v-3A1.5 1.5 0 0 1 18.5 3\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6 24 24"
}

export const jamBatteryHalf: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 2v8h15V2zm17 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h15a2 2 0 0 1 2 2zM9 2h2v8H9z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6 24 24"
}

export const jamBatteryHalfF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 2v8h7V2zm9 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h15a2 2 0 0 1 2 2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6 24 24"
}

export const jamBatteryOneQuarter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 2v8h15V2zm17 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h15a2 2 0 0 1 2 2zM6 2h2v8H6z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6 24 24"
}

export const jamBatteryOneQuarterF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 2v8h9V2zm11 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h15a2 2 0 0 1 2 2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6 24 24"
}

export const jamBatteryThreeQuarters: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 2v8h15V2zm17 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h15a2 2 0 0 1 2 2zm-8-1h2v8h-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6 24 24"
}

export const jamBatteryThreeQuartersF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13 2v8h4V2zm6 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h15a2 2 0 0 1 2 2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6 24 24"
}

export const jamBeatport: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M16.667 7.63c0-4.207-3.178-7.63-7.084-7.63S2.5 3.423 2.5 7.63c0 1.947.682 3.801 1.92 5.222c.167.19.444.199.62.02l.764-.774a.5.5 0 0 0 .02-.667a5.77 5.77 0 0 1-1.396-3.8c0-3.063 2.312-5.554 5.155-5.554s5.156 2.491 5.156 5.554a5.77 5.77 0 0 1-1.397 3.8l.001.001a.5.5 0 0 0 .021.666l.764.773c.176.18.454.17.62-.02c1.237-1.42 1.919-3.274 1.919-5.22M20 7.65c0-1.02-.158-2.026-.47-2.99v-.003l-.002-.003a.483.483 0 0 0-.597-.3l-1.094.329a.46.46 0 0 0-.315.58h-.001a7.75 7.75 0 0 1-.789 6.467h.001a.455.455 0 0 0 .167.634l.981.57c.227.132.52.06.657-.159A9.74 9.74 0 0 0 20 7.649\"/><path d=\"M3.268 11.732a7.76 7.76 0 0 1-.788-6.468a.46.46 0 0 0-.315-.58l-1.093-.33a.48.48 0 0 0-.598.301H.472a9.72 9.72 0 0 0 .99 8.123h.002a.49.49 0 0 0 .655.156l.982-.57a.455.455 0 0 0 .167-.631z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -5.5 24 24"
}

export const jamBeatportCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M13.462 10.58c0-2.103-1.588-3.814-3.541-3.814s-3.542 1.711-3.542 3.815c0 .973.34 1.9.96 2.61c.083.095.222.1.31.01l.382-.387a.25.25 0 0 0 .01-.333a2.9 2.9 0 0 1-.698-1.9c0-1.531 1.156-2.777 2.578-2.777s2.577 1.246 2.577 2.777c0 .708-.248 1.383-.698 1.9a.25.25 0 0 0 .011.333l.382.387c.088.09.227.085.31-.01c.619-.71.96-1.637.96-2.61m1.666.009c0-.51-.079-1.012-.235-1.495v-.003a.24.24 0 0 0-.3-.15l-.546.165a.23.23 0 0 0-.158.29a3.88 3.88 0 0 1-.395 3.233v.001a.23.23 0 0 0 .084.317l.49.285c.114.065.26.03.33-.08c.477-.773.73-1.66.73-2.563\"/><path d=\"M6.763 12.632a3.88 3.88 0 0 1-.394-3.234a.23.23 0 0 0-.157-.29l-.547-.165a.24.24 0 0 0-.3.15a4.86 4.86 0 0 0 .495 4.062a.244.244 0 0 0 .329.078l.49-.285a.23.23 0 0 0 .084-.316\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamBeatportSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M13.462 10.58c0-2.103-1.588-3.814-3.541-3.814s-3.542 1.711-3.542 3.815c0 .973.34 1.9.96 2.61c.083.095.222.1.31.01l.382-.387a.25.25 0 0 0 .01-.333a2.9 2.9 0 0 1-.698-1.9c0-1.531 1.156-2.777 2.578-2.777s2.577 1.246 2.577 2.777c0 .708-.248 1.383-.698 1.9a.25.25 0 0 0 .011.333l.382.387c.088.09.227.085.31-.01c.619-.71.96-1.637.96-2.61m1.666.009c0-.51-.079-1.012-.235-1.495v-.003a.24.24 0 0 0-.3-.15l-.546.165a.23.23 0 0 0-.158.29a3.88 3.88 0 0 1-.395 3.233v.001a.23.23 0 0 0 .084.317l.49.285c.114.065.26.03.33-.08c.477-.773.73-1.66.73-2.563\"/><path d=\"M6.763 12.632a3.88 3.88 0 0 1-.394-3.234a.23.23 0 0 0-.157-.29l-.547-.165a.24.24 0 0 0-.3.15a4.86 4.86 0 0 0 .495 4.062a.244.244 0 0 0 .329.078l.49-.285a.23.23 0 0 0 .084-.316\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamBeer: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 6v9a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6zm10 0h1a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3h-1a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2m0 2v5h1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zM4 8a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1m4 0a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1M6.5 0A4.5 4.5 0 0 1 11 4.5v1.509H0V4.5a3.5 3.5 0 0 1 3.667-3.496A4.48 4.48 0 0 1 6.5 0M2 4h7a2 2 0 0 0-2-2H6a2 2 0 0 0-1.75 1.031A1 1 0 0 0 4 3H3a1 1 0 0 0-1 1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -3 24 24"
}

export const jamBeerF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 15a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V6h13a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3zM.035 4a3.5 3.5 0 0 1 3.632-2.996A4.5 4.5 0 0 1 10.973 4zM4 8a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m4 0a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m4 0v5h1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -3 24 24"
}

export const jamBehance: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18.025 1.769h-5.001V.527h5.001zm-8.33 5.094q.483.75.483 1.819q.001 1.106-.551 1.982a3.4 3.4 0 0 1-.879.975a3.4 3.4 0 0 1-1.402.624a8.7 8.7 0 0 1-1.753.167H0V.011h5.998C7.509.036 8.58.474 9.214 1.334q.569.792.568 1.897q.001 1.137-.574 1.828q-.32.388-.945.707q.948.345 1.431 1.097zm-6.83-1.955h2.627q.81 0 1.313-.308q.504-.308.504-1.092q0-.868-.667-1.146q-.575-.193-1.466-.194H2.864v2.74zm4.697 3.597c0-.645-.264-1.091-.79-1.33q-.443-.205-1.242-.211H2.864v3.31H5.49q.807.001 1.257-.218q.815-.405.816-1.551zm12.318-2.02q.092.61.077 1.766H13.48q.053 1.34.93 1.877q.53.335 1.282.334q.793.002 1.29-.409q.271-.219.478-.61h2.374q-.092.792-.861 1.608q-1.194 1.298-3.346 1.299q-1.775 0-3.134-1.095q-1.355-1.097-1.356-3.564q0-2.314 1.224-3.546c.82-.824 1.878-1.234 3.182-1.234q1.16 0 2.092.416q.93.416 1.536 1.317q.546.794.71 1.84zm-2.337.231q-.065-.927-.621-1.406q-.554-.48-1.379-.481q-.897.002-1.387.51q-.495.505-.62 1.377z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -5.5 24 24"
}

export const jamBehanceCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M14.03 7.88h-2.505v-.622h2.506v.623zm-4.173 2.553q.243.375.242.911q.002.554-.276.993a1.72 1.72 0 0 1-1.142.801a4.3 4.3 0 0 1-.879.084H5V7h3.005q1.136.017 1.611.663q.285.396.285.95q0 .57-.288.916q-.16.195-.473.354q.475.173.717.55m-3.422-.98h1.317q.405 0 .657-.154q.253-.154.253-.547q0-.435-.334-.574a2.4 2.4 0 0 0-.735-.098H6.435zm2.354 1.802q0-.485-.396-.666q-.223-.102-.622-.106H6.435v1.658H7.75q.405.001.63-.109q.409-.202.409-.777m6.171-1.012q.046.306.039.885h-3.245q.026.672.466.94q.264.169.642.168q.397.001.647-.205a1 1 0 0 0 .239-.306h1.19q-.047.397-.432.806q-.6.65-1.677.65a2.43 2.43 0 0 1-1.57-.548q-.679-.548-.68-1.785q0-1.16.614-1.777q.615-.619 1.595-.618q.58 0 1.048.208q.466.21.769.66q.274.398.355.922m-1.17.116q-.033-.465-.312-.704a1.02 1.02 0 0 0-.69-.242q-.45.001-.696.256q-.247.255-.31.69z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamBehanceSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M14.03 7.88h-2.505v-.622h2.506v.623zm-4.173 2.553q.243.375.242.911q.002.554-.276.993a1.72 1.72 0 0 1-1.142.801a4.3 4.3 0 0 1-.879.084H5V7h3.005q1.136.017 1.611.663q.285.396.285.95q0 .57-.288.916q-.16.195-.473.354q.475.173.717.55m-3.422-.98h1.317q.405 0 .657-.154q.253-.154.253-.547q0-.435-.334-.574a2.4 2.4 0 0 0-.735-.098H6.435zm2.354 1.802q0-.485-.396-.666q-.223-.102-.622-.106H6.435v1.658H7.75q.405.001.63-.109q.409-.202.409-.777m6.171-1.012q.046.306.039.885h-3.245q.026.672.466.94q.264.169.642.168q.397.001.647-.205a1 1 0 0 0 .239-.306h1.19q-.047.397-.432.806q-.6.65-1.677.65a2.43 2.43 0 0 1-1.57-.548q-.679-.548-.68-1.785q0-1.16.614-1.777q.615-.619 1.595-.618q.58 0 1.048.208q.466.21.769.66q.274.398.355.922m-1.17.116q-.033-.465-.312-.704a1.02 1.02 0 0 0-.69-.242q-.45.001-.696.256q-.247.255-.31.69z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamBell: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.666 11.782L13 11.186V6a4 4 0 1 0-8 0v5.186l-.666.596A7 7 0 0 0 2.29 15h13.42a7 7 0 0 0-2.044-3.218M12 17a3 3 0 0 1-6 0H0a8.98 8.98 0 0 1 3-6.708V6a6 6 0 1 1 12 0v4.292A8.98 8.98 0 0 1 18 17zm-3 1a1 1 0 0 0 1-1H8a1 1 0 0 0 1 1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2 24 24"
}

export const jamBellF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 17H0a8.98 8.98 0 0 1 3-6.708V6a6 6 0 1 1 12 0v4.292A8.98 8.98 0 0 1 18 17M6.17 18h5.66a3.001 3.001 0 0 1-5.66 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2 24 24"
}

export const jamBellOff: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13 18a3 3 0 0 1-6 0H4.657l2-2H16.71a7 7 0 0 0-2.044-3.218L14 12.186v-3.53l1.99-1.99Q16 6.832 16 7v4.292A8.98 8.98 0 0 1 19 18zM1.295 15.705A9 9 0 0 1 4 11.292V7a6 6 0 0 1 10.243-4.243l-1.415 1.415A4 4 0 0 0 6 7v4zM10 19a1 1 0 0 0 1-1H9a1 1 0 0 0 1 1M19.092.707a1 1 0 0 1 0 1.414l-16.97 16.97a1 1 0 1 1-1.415-1.413L17.677.708a1 1 0 0 1 1.415 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1.5 24 24"
}

export const jamBellOffF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1.295 15.705A9 9 0 0 1 4 11.292V7a6 6 0 0 1 10.243-4.243zm14.696-9.039Q16 6.832 16 7v4.292A8.98 8.98 0 0 1 19 18H4.657zM12.829 19a3.001 3.001 0 0 1-5.658 0zM19.092.707a1 1 0 0 1 0 1.414l-16.97 16.97a1 1 0 1 1-1.415-1.413L17.677.708a1 1 0 0 1 1.415 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1.5 24 24"
}

export const jamBing: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15.973 8.57a.48.48 0 0 0-.317-.434L6.273 5.23c-.175-.054-.255.039-.178.206L7.84 9.269c.077.168.276.367.442.443l2.394 1.096c.166.076.17.209.008.295L.47 16.535c-.161.086-.182.056-.046-.067l3.924-3.534a.86.86 0 0 0 .248-.558L4.6 1.664a.48.48 0 0 0-.318-.435L.355.014C.18-.04.037.067.037.252v16.25c0 .185.122.423.272.529l3.99 2.827c.15.106.4.115.557.02l10.832-6.523a.66.66 0 0 0 .286-.507V8.57z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamBingCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M13.99 9.297a.24.24 0 0 0-.159-.218L9.127 7.623c-.088-.027-.128.02-.09.103l.876 1.922a.52.52 0 0 0 .221.222l1.2.55c.084.037.086.104.005.147l-5.122 2.724c-.08.043-.091.028-.023-.034l1.968-1.772a.43.43 0 0 0 .124-.28l.001-5.37a.24.24 0 0 0-.159-.219L6.16 5.007c-.088-.027-.16.027-.16.12v8.148c0 .092.061.211.136.264l2.001 1.418c.075.053.2.058.28.01l5.43-3.27a.33.33 0 0 0 .144-.255z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamBingSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M13.99 9.297a.24.24 0 0 0-.159-.218L9.127 7.623c-.088-.027-.128.02-.09.103l.876 1.922a.52.52 0 0 0 .221.222l1.2.55c.084.037.086.104.005.147l-5.122 2.724c-.08.043-.091.028-.023-.034l1.968-1.772a.43.43 0 0 0 .124-.28l.001-5.37a.24.24 0 0 0-.159-.219L6.16 5.007c-.088-.027-.16.027-.16.12v8.148c0 .092.061.211.136.264l2.001 1.418c.075.053.2.058.28.01l5.43-3.27a.33.33 0 0 0 .144-.255z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamBirthdayCake: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 18.262V20h16v-1.728l-3.106.753l-4.86-1.004l-4.977 1.004zM2 16.2l3.104.775l4.936-.996l4.819.996L18 16.214V15a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1zM13 12h4a3 3 0 0 1 3 3v7H0v-7a3 3 0 0 1 3-3h4V9h6zm-2 0v-1H9v1zm-1-3.6a3 3 0 0 1-3-3Q7 3.742 10 0q3 3.742 3 5.4a3 3 0 0 1-3 3m-.002-1.981c.552 0 1-.48 1-1.072q0-.591-1-1.928q-1 1.337-1 1.928c0 .592.448 1.072 1 1.072\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1 24 24"
}

export const jamBirthdayCakeF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m20 15.693l-5.141 1.282l-4.82-.996l-4.935.996L0 15.687V15a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3zm0 2.063V22H0v-4.25l5.057 1.275l4.978-1.004l4.859 1.004zM7 9h6v2H7zm3-.6a3 3 0 0 1-3-3Q7 3.742 10 0q3 3.742 3 5.4a3 3 0 0 1-3 3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1 24 24"
}

export const jamBlogger: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.593 19.96c3.48 0 6.307-2.836 6.327-6.297l.039-5.095l-.059-.278l-.167-.348l-.283-.22c-.367-.287-2.228.02-2.729-.435c-.355-.324-.41-.91-.518-1.706c-.2-1.54-.326-1.62-.568-2.142C14.76 1.585 12.382.193 10.75 0H6.325C2.845 0 0 2.839 0 6.307v7.356c0 3.461 2.845 6.296 6.325 6.296h7.268zM6.406 5.151h3.507c.67 0 1.212.544 1.212 1.205c0 .657-.542 1.206-1.212 1.206H6.406c-.67 0-1.21-.549-1.21-1.206c0-.661.54-1.205 1.21-1.205m-1.21 8.418c0-.66.54-1.2 1.21-1.2h7.127c.665 0 1.205.54 1.205 1.2c0 .652-.54 1.2-1.205 1.2H6.406a1.21 1.21 0 0 1-1.21-1.2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamBloggerCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M11.81 15c1.744 0 3.16-1.42 3.17-3.154L15 9.293l-.03-.14l-.083-.174l-.142-.11c-.184-.144-1.116.01-1.367-.218c-.178-.163-.206-.456-.26-.855c-.1-.771-.163-.811-.284-1.073c-.44-.929-1.63-1.627-2.448-1.723H8.169A3.174 3.174 0 0 0 5 8.16v3.686C5 13.58 6.426 15 8.17 15zm-3.6-7.419h1.757c.335 0 .607.273.607.604s-.272.604-.607.604H8.21a.61.61 0 0 1-.607-.604c0-.331.271-.604.607-.604M7.603 11.8c0-.33.271-.601.607-.601h3.57c.333 0 .604.27.604.601c0 .327-.27.601-.604.601H8.21a.607.607 0 0 1-.607-.601\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamBloggerSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M11.81 15c1.744 0 3.16-1.42 3.17-3.154L15 9.293l-.03-.14l-.083-.174l-.142-.11c-.184-.144-1.116.01-1.367-.218c-.178-.163-.206-.456-.26-.855c-.1-.771-.163-.811-.284-1.073c-.44-.929-1.63-1.627-2.448-1.723H8.169A3.174 3.174 0 0 0 5 8.16v3.686C5 13.58 6.426 15 8.17 15zm-3.6-7.419h1.757c.335 0 .607.273.607.604s-.272.604-.607.604H8.21a.61.61 0 0 1-.607-.604c0-.331.271-.604.607-.604M7.603 11.8c0-.33.271-.601.607-.601h3.57c.333 0 .604.27.604.601c0 .327-.27.601-.604.601H8.21a.607.607 0 0 1-.607-.601\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamBluetooth: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m7.414 10l4.294 4.294A1 1 0 0 1 12 15q0 .403-.35.76l-4.947 3.958q-.555.447-1.105.19T5 19.006v-6.592l-3.293 3.293a1 1 0 1 1-1.414-1.414L4.586 10L.293 5.707a1 1 0 1 1 1.414-1.414L5 7.586v-6.56C5 .448 5.448 0 6 0a1 1 0 0 1 .602.201l4.91 3.928c.293.187.488.506.488.871c0 .33-.16.623-.407.805zM7 16.92l2.503-2.003L7 12.414v4.505zM9.503 5.082L7 3.08v4.505z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -2 24 24"
}

export const jamBold: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 5.455v2.727h1.5c.828 0 1.5-.61 1.5-1.364c0-.753-.672-1.363-1.5-1.363zm3.514-1.24C6.413 4.793 7 5.744 7 6.819C7 8.575 5.433 10 3.5 10H0V.91C0 .406.448 0 1 0h2c1.657 0 3 1.221 3 2.727c0 .55-.179 1.06-.486 1.489zM2 1.819v1.818h1c.552 0 1-.407 1-.909s-.448-.909-1-.909z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-8.5 -7 24 24"
}

export const jamBook: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 18v2H3v-2H0V0h11a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3zM3 2H2v14h1zm2 0v14h6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm1 2h5v2H6zm0 3h5v2H6z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamBookF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 18V1H3v17H0V0h11a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3zM6 4v2h5V4zm0 3v2h5V7zM3 18h2v2H3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamBookmark: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 2a1 1 0 0 0-1 1v15l2.978-2.717a3 3 0 0 1 4.044 0L12 18V3a1 1 0 0 0-1-1zm0-2h8a3 3 0 0 1 3 3v15a2 2 0 0 1-3.348 1.477L7.674 16.76a1 1 0 0 0-1.348 0l-2.978 2.717A2 2 0 0 1 0 18V3a3 3 0 0 1 3-3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamBookmarkF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h8a3 3 0 0 1 3 3v15a2 2 0 0 1-3.348 1.477L7.674 16.76a1 1 0 0 0-1.348 0l-2.978 2.717A2 2 0 0 1 0 18V3a3 3 0 0 1 3-3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamBookmarkMinus: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 2a1 1 0 0 0-1 1v15l2.978-2.717a3 3 0 0 1 4.044 0L12 18V3a1 1 0 0 0-1-1zm0-2h8a3 3 0 0 1 3 3v15a2 2 0 0 1-3.348 1.477L7.674 16.76a1 1 0 0 0-1.348 0l-2.978 2.717A2 2 0 0 1 0 18V3a3 3 0 0 1 3-3m1 8h6a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamBookmarkMinusF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 .858h8a3 3 0 0 1 3 3v15a2 2 0 0 1-3.348 1.477l-2.978-2.717a1 1 0 0 0-1.348 0l-2.978 2.717A2 2 0 0 1 0 18.858v-15a3 3 0 0 1 3-3m1 8a1 1 0 1 0 0 2h6a1 1 0 0 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -1.5 24 24"
}

export const jamBookmarkPlus: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 2a1 1 0 0 0-1 1v15l2.978-2.717a3 3 0 0 1 4.044 0L12 18V3a1 1 0 0 0-1-1zm0-2h8a3 3 0 0 1 3 3v15a2 2 0 0 1-3.348 1.477L7.674 16.76a1 1 0 0 0-1.348 0l-2.978 2.717A2 2 0 0 1 0 18V3a3 3 0 0 1 3-3m5 8h2a1 1 0 0 1 0 2H8v2a1 1 0 0 1-2 0v-2H4a1 1 0 1 1 0-2h2V6a1 1 0 1 1 2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamBookmarkPlusF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 8.858v-2a1 1 0 1 0-2 0v2H4a1 1 0 1 0 0 2h2v2a1 1 0 0 0 2 0v-2h2a1 1 0 0 0 0-2zm-5-8h8a3 3 0 0 1 3 3v15a2 2 0 0 1-3.348 1.477l-2.978-2.717a1 1 0 0 0-1.348 0l-2.978 2.717A2 2 0 0 1 0 18.858v-15a3 3 0 0 1 3-3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -1.5 24 24"
}

export const jamBookmarkRemove: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 2a1 1 0 0 0-1 1v15l2.978-2.717a3 3 0 0 1 4.044 0L12 18V3a1 1 0 0 0-1-1zm0-2h8a3 3 0 0 1 3 3v15a2 2 0 0 1-3.348 1.477L7.674 16.76a1 1 0 0 0-1.348 0l-2.978 2.717A2 2 0 0 1 0 18V3a3 3 0 0 1 3-3m5.414 9l1.414 1.414a1 1 0 1 1-1.414 1.414L7 10.414l-1.414 1.414a1 1 0 0 1-1.414-1.414L5.586 9L4.172 7.586a1 1 0 1 1 1.414-1.414L7 7.586l1.414-1.414a1 1 0 1 1 1.414 1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamBookmarkRemoveF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m8.414 9.858l1.414-1.414a1 1 0 0 0-1.414-1.415L7 8.444L5.586 7.029a1 1 0 1 0-1.414 1.415l1.414 1.414l-1.414 1.414a1 1 0 1 0 1.414 1.414L7 11.272l1.414 1.414a1 1 0 0 0 1.414-1.414zM3 .858h8a3 3 0 0 1 3 3v15a2 2 0 0 1-3.348 1.477l-2.978-2.717a1 1 0 0 0-1.348 0l-2.978 2.717A2 2 0 0 1 0 18.858v-15a3 3 0 0 1 3-3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -1.5 24 24"
}

export const jamBottle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.975 9H10v9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V9h.025a4 4 0 0 1 .902-2.113l1.11-1.33A2 2 0 0 0 2.5 4.275V1a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3.276a2 2 0 0 0 .464 1.28l1.109 1.331A4 4 0 0 1 9.975 9M7.949 9a2 2 0 0 0-.413-.832L6.427 6.837A4 4 0 0 1 5.5 4.276V2h-1v2.276a4 4 0 0 1-.927 2.56l-1.11 1.332A2 2 0 0 0 2.052 9zM8 16H2v2h6zm-6-5v3h6v-3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7 -2 24 24"
}

export const jamBottleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.975 9H.025a4 4 0 0 1 .902-2.113l1.11-1.33A2 2 0 0 0 2.5 4.275V1a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3.276a2 2 0 0 0 .464 1.28l1.109 1.331A4 4 0 0 1 9.975 9M10 16v2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2zm-8-5h6v3H2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7 -2 24 24"
}

export const jamBox: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm10.874 5a4.002 4.002 0 0 1-7.748 0H2V5h16v2zm-2.142 0H8.268a2 2 0 0 0 3.464 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamBoxF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M20 5H0V3a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3zm0 2v6a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V7h6.126a4.002 4.002 0 0 0 7.748 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamBranch: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 18a1 1 0 1 0 0-2a1 1 0 0 0 0 2m1-7.002v3.173a3.001 3.001 0 1 1-2 0V5.829a3.001 3.001 0 1 1 2 0v2.34c.312-.11.647-.17.997-.171l6.037-.006a1 1 0 0 0 .999-1V5.84A3.001 3.001 0 0 1 13 0a3 3 0 0 1 1.033 5.817v1.175a3 3 0 0 1-2.997 3l-6.037.006a1 1 0 0 0-.999 1M3 4a1 1 0 1 0 0-2a1 1 0 0 0 0 2m10 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamBranchF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 11.856v3.173a3.001 3.001 0 1 1-2 0V6.687a3.001 3.001 0 1 1 2 0v2.34c.312-.11.647-.17.997-.171l6.037-.006a1 1 0 0 0 .999-1V6.699A3.001 3.001 0 0 1 13 .858a3 3 0 0 1 1.033 5.817V7.85a3 3 0 0 1-2.997 3l-6.037.006a1 1 0 0 0-.999 1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -1.5 24 24"
}

export const jamBrightness: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 18q.168 0 0-16a8 8 0 1 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamBrightnessDown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 10a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0 2a4 4 0 1 1 0-8a4 4 0 0 1 0 8m6-5h1a1 1 0 0 1 0 2h-1a1 1 0 0 1 0-2m-6 6a1 1 0 0 1 1 1v1a1 1 0 0 1-2 0v-1a1 1 0 0 1 1-1M8 0a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1M1 7h1a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2m11.95 4.536l.707.707a1 1 0 1 1-1.414 1.414l-.707-.707a1 1 0 0 1 1.414-1.414m-8.486 0a1 1 0 0 1 0 1.414l-.707.707a1 1 0 0 1-1.414-1.414l.707-.707a1 1 0 0 1 1.414 0m9.193-9.193a1 1 0 0 1 0 1.414l-.707.707a1 1 0 0 1-1.414-1.414l.707-.707a1 1 0 0 1 1.414 0m-9.9 0l.707.707A1 1 0 1 1 3.05 4.464l-.707-.707a1 1 0 0 1 1.414-1.414\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -4 24 24"
}

export const jamBrightnessDownF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 12.858a4 4 0 1 1 0-8a4 4 0 0 1 0 8m6-5h1a1 1 0 0 1 0 2h-1a1 1 0 0 1 0-2m-6 6a1 1 0 0 1 1 1v1a1 1 0 0 1-2 0v-1a1 1 0 0 1 1-1m0-13a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1m-7 7h1a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2m11.95 4.535l.707.708a1 1 0 1 1-1.414 1.414l-.707-.707a1 1 0 0 1 1.414-1.415m-8.486 0a1 1 0 0 1 0 1.415l-.707.707A1 1 0 0 1 2.343 13.1l.707-.708a1 1 0 0 1 1.414 0zm9.193-9.192a1 1 0 0 1 0 1.414l-.707.707a1 1 0 0 1-1.414-1.414l.707-.707a1 1 0 0 1 1.414 0m-9.9 0l.707.707A1 1 0 1 1 3.05 5.322l-.707-.707a1 1 0 0 1 1.414-1.414\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -3.5 24 24"
}

export const jamBrightnessUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0 2a4 4 0 1 1 0-8a4 4 0 0 1 0 8m6-5h3a1 1 0 0 1 0 2h-3a1 1 0 0 1 0-2m-6 6a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0v-3a1 1 0 0 1 1-1m0-15a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1M1 9h3a1 1 0 1 1 0 2H1a1 1 0 0 1 0-2m13.95 4.536l2.121 2.12a1 1 0 0 1-1.414 1.415l-2.121-2.121a1 1 0 0 1 1.414-1.414m-8.486 0a1 1 0 0 1 0 1.414l-2.12 2.121a1 1 0 1 1-1.415-1.414l2.121-2.121a1 1 0 0 1 1.414 0M17.071 2.929a1 1 0 0 1 0 1.414L14.95 6.464a1 1 0 0 1-1.414-1.414l2.12-2.121a1 1 0 0 1 1.415 0m-12.728 0L6.464 5.05A1 1 0 1 1 5.05 6.464l-2.12-2.12a1 1 0 0 1 1.414-1.415z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamBrightnessUpF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 14.858a4 4 0 1 1 0-8a4 4 0 0 1 0 8m6-5h3a1 1 0 0 1 0 2h-3a1 1 0 0 1 0-2m-6 6a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0v-3a1 1 0 0 1 1-1m0-15a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0v-3a1 1 0 0 1 1-1m-9 9h3a1 1 0 1 1 0 2H1a1 1 0 0 1 0-2m13.95 4.535l2.121 2.122a1 1 0 0 1-1.414 1.414l-2.121-2.121a1 1 0 0 1 1.414-1.415m-8.486 0a1 1 0 0 1 0 1.415l-2.12 2.12a1 1 0 1 1-1.415-1.413l2.121-2.122a1 1 0 0 1 1.414 0M17.071 3.787a1 1 0 0 1 0 1.414L14.95 7.322a1 1 0 0 1-1.414-1.414l2.12-2.121a1 1 0 0 1 1.415 0m-12.728 0l2.121 2.121A1 1 0 1 1 5.05 7.322L2.93 5.201a1 1 0 0 1 1.414-1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1.5 24 24"
}

export const jamBrowse: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 4v10h16V4zm1-1a1 1 0 1 0 0-2a1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2M2 0h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2\"/>",
  "width": 20,
  "height": 16,
  "viewBox": "0 0 20 16"
}

export const jamBrush: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6.816 11.556c-1.008.464-1.69 1.003-2.084 1.598a52 52 0 0 0-1.115 1.756c1.124.244 1.969.127 2.578-.281c.852-.57 1.408-1.221 1.717-1.977zm1.395-1.433l1.02 1.02c.742-.382 1.489-.987 2.234-1.832c1.139-1.29 3.061-3.588 5.757-6.88a.211.211 0 0 0-.297-.296c-3.286 2.693-5.583 4.615-6.881 5.758c-.849.746-1.454 1.491-1.833 2.23m-.903 6.168q-2.423 1.622-6.63-.298a58 58 0 0 1 2.387-3.945q.983-1.48 3.17-2.422q.728-1.688 2.487-3.236q1.98-1.743 6.936-5.803a2.21 2.21 0 0 1 3.111 3.111q-4.065 4.965-5.804 6.935q-1.467 1.662-3.067 2.408q-.645 1.946-2.59 3.249z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3 24 24"
}

export const jamBrushF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m5.36 11.116l2.68 2.681q-.75.974-1.864 1.832q-2.238 1.725-5.318.885a83 83 0 0 1 2.603-3.6q.733-.955 1.898-1.798zm1.489-1.338q.826-1.184 2.154-2.406q1.9-1.748 6.602-5.877c.834-.733 1.86-.9 2.375-.385c.514.514.348 1.542-.384 2.376q-4.135 4.71-5.878 6.601q-1.22 1.324-2.407 2.153z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2.5 -3.5 24 24"
}

export const jamBug: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 9a1 1 0 0 0-1 1v4a4 4 0 1 0 8 0v-4a1 1 0 0 0-1-1zm8.236-1h1.647V5a1 1 0 1 1 2 0v3a2 2 0 0 1-2 2H16v1h3a1 1 0 0 1 0 2h-3v1h.883a2 2 0 0 1 2 2v3a1 1 0 0 1-2 0v-3h-1.224A6.002 6.002 0 0 1 4.34 16H3v3a1 1 0 0 1-2 0v-3a2 2 0 0 1 2-2h1v-1H1a1 1 0 0 1 0-2h3v-1H3a2 2 0 0 1-2-2V5a1 1 0 1 1 2 0v3h1.764A3 3 0 0 1 6 7.17V5a2 2 0 0 1 2-2h.737c-.343-.598-.988-1-1.726-1H5a1 1 0 1 1 0-2h2.01A3.98 3.98 0 0 1 10 1.348A3.98 3.98 0 0 1 12.99 0H15a1 1 0 0 1 0 2h-2.01c-.74 0-1.384.402-1.727 1H12a2 2 0 0 1 2 2v2.17a3 3 0 0 1 1.236.83M8 7h4V5H8z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamBugF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15.236 8h1.647V5a1 1 0 1 1 2 0v3a2 2 0 0 1-2 2H16v1h3a1 1 0 0 1 0 2h-3v1h.883a2 2 0 0 1 2 2v3a1 1 0 0 1-2 0v-3h-1.224A6.01 6.01 0 0 1 11 19.917V13a1 1 0 0 0-2 0v6.917A6.01 6.01 0 0 1 4.341 16H3v3a1 1 0 0 1-2 0v-3a2 2 0 0 1 2-2h1v-1H1a1 1 0 0 1 0-2h3v-1H3a2 2 0 0 1-2-2V5a1 1 0 1 1 2 0v3h1.764A3 3 0 0 1 6 7.17V5a2 2 0 0 1 2-2h.737c-.343-.598-.988-1-1.726-1H5a1 1 0 1 1 0-2h2.01A3.98 3.98 0 0 1 10 1.348A3.98 3.98 0 0 1 12.99 0H15a1 1 0 0 1 0 2h-2.01c-.74 0-1.384.402-1.727 1H12a2 2 0 0 1 2 2v2.17a3 3 0 0 1 1.236.83\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamBuilding: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h7a3 3 0 0 1 3 3v17H0V3a3 3 0 0 1 3-3M2 18h9V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1zM4 4h1a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2m0 3h1a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2m0 3h1a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2m0 3h1a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2m4-9h1a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2m0 3h1a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2m0 3h1a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2m0 3h1a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2m-3 3h3a1 1 0 0 1 1 1v1H4v-1a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5.5 -2 24 24"
}

export const jamBuildingF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 20v-3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v3H0V3a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v17zM4 4a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 3a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 3a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm0 3a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm4-9a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 3a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 3a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm0 3a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5.5 -2 24 24"
}

export const jamBus: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 17H5v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-2.535A4 4 0 0 1 0 13V4a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v9c0 1.48-.804 2.773-2 3.465V19a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zm3-8V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v5zm0 2H2v2a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM4 3a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1m0 11a1 1 0 1 1 0-2a1 1 0 0 1 0 2m8 0a1 1 0 1 1 0-2a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamBusF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 2a2 2 0 0 0-2 2v5l12-.037V4a2 2 0 0 0-2-2zm7 15H5v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-2.535A4 4 0 0 1 0 13V4a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v9c0 1.48-.804 2.773-2 3.465V19a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zm-7-3a1 1 0 1 0 0-2a1 1 0 0 0 0 2m8 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2M4 3a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamCactus: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M20 6.5V14h-6v6H6v-4H0V8.5a2.5 2.5 0 0 1 5 0V11h1V4a4 4 0 0 1 7.988-.314V9H15V6.5a2.5 2.5 0 1 1 5 0M8 18h4v-6h6V6.5a.5.5 0 1 0-1 0V11h-5V4a2 2 0 1 0-4 0v9H3V8.5a.5.5 0 0 0-1 0V14h6zm2-9a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1m0-5a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0V5a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamCactusF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 16H0V8.5a2.5 2.5 0 0 1 5 0V11h1V4a4 4 0 1 1 8 0v5h1V6.5a2.5 2.5 0 1 1 5 0V14h-6v6H6zm4-7a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1m0-5a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamCalculator: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h7a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm1 2h5a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1m0 5h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1m4 0h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1m0 4h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1m-4 0h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4.5 -2 24 24"
}

export const jamCalendar: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 7V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v2zm0 2H2v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1zm-2-7h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h8V1a1 1 0 0 1 2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3 24 24"
}

export const jamCalendarAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0zM3 8h2v2H3zm0 4h2v2H3zm12 0h2v2h-2zm0-4h2v2h-2zM7 8h2v2H7zm4 0h2v2h-2zm0 4h2v2h-2zm-4 0h2v2H7z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3 24 24"
}

export const jamCalendarAltF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3v2a2 2 0 1 0 4 0V2h1v2a2 2 0 1 0 4 0V2h1v2a2 2 0 1 0 4 0zM3 8v2h2V8zm0 4v2h2v-2zm12 0v2h2v-2zm0-4v2h2V8zM7 8v2h2V8zm4 0v2h2V8zm0 4v2h2v-2zm-4 0v2h2v-2zM5 0a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1m10 0a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1m-5 0a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3 24 24"
}

export const jamCalendarF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 3v2a2 2 0 1 0 4 0V3h6v2a2 2 0 1 0 4 0V3a3 3 0 0 1 3 3v2H0V6a3 3 0 0 1 3-3m17 7v6a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-6zM15 0a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1M5 0a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2.5 24 24"
}

export const jamCamera: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5.676 5H4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1.676l-.387-1.501A2 2 0 0 0 12 2H8a2 2 0 0 0-1.937 1.499zm-1.55-2C4.57 1.275 6.136 0 8 0h4a4 4 0 0 1 3.874 3H16a4 4 0 0 1 4 4v5a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4zM10 13a4 4 0 1 1 0-8a4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4a2 2 0 0 0 0 4m6-3a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamCameraAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 12V6a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4H2v-2zM6 0h8a6 6 0 0 1 6 6v8a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6m0 15h8a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m4-4a4 4 0 1 1 0-8a4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4a2 2 0 0 0 0 4m6 2a1 1 0 1 1 0-2a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamCameraAltF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M20 12H0V6a6 6 0 0 1 6-6h8a6 6 0 0 1 6 6zm0 2a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6zM6 15a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2zm4-4a4 4 0 1 0 0-8a4 4 0 0 0 0 8m6 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2m-6-2a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamCameraF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4.126 3C4.57 1.275 6.136 0 8 0h4a4 4 0 0 1 3.874 3H16a4 4 0 0 1 4 4v5a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4zM10 13a4 4 0 1 0 0-8a4 4 0 0 0 0 8m6-5a1 1 0 1 0 0-2a1 1 0 0 0 0 2m-6 3a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamCandle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 11v6h2v-6zm4 6h5a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2h5V9h6zM2 19v1h16v-1zm8-10.6a3 3 0 0 1-3-3Q7 3.742 10 0q3 3.742 3 5.4a3 3 0 0 1-3 3m0-1.952c.552 0 1-.48 1-1c0-.466-.333-1.109-1-2c-.667.891-1 1.534-1 2c0 .52.448 1 1 1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1 24 24"
}

export const jamCandleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 9h6v6H7zm-5 8h16a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2m8-8.6a3 3 0 0 1-3-3Q7 3.742 10 0q3 3.742 3 5.4a3 3 0 0 1-3 3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1 24 24"
}

export const jamCapsule: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 9V5a3 3 0 1 0-6 0v4zm0 2H2v4a3 3 0 0 0 6 0zM5 0a5 5 0 0 1 5 5v10a5 5 0 0 1-10 0V5a5 5 0 0 1 5-5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7 -2 24 24"
}

export const jamCapsuleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 9.858H0v-4a5 5 0 1 1 10 0zm0 2v4a5 5 0 0 1-10 0v-4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7 -1.5 24 24"
}

export const jamCar: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14 17H6v1.5A1.5 1.5 0 0 1 4.5 20h-1A1.5 1.5 0 0 1 2 18.5v-1.67A3 3 0 0 1 0 14v-3c0-.62.188-1.196.51-1.674l1.086-6.8A3 3 0 0 1 4.56 0h10.88a3 3 0 0 1 2.96 2.527l1.083 6.79c.326.48.516 1.06.516 1.683v3a3 3 0 0 1-2 2.83v1.67a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5zM3 15h14a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1m14.25-6.99l-.824-5.168A1 1 0 0 0 15.44 2H4.559a1 1 0 0 0-.988.842l-.825 5.169A3 3 0 0 1 3 8h14q.127 0 .25.01M15.5 12a.5.5 0 1 0 0 1a.5.5 0 0 0 0-1m0 2a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m-11-2a.5.5 0 1 0 0 1a.5.5 0 0 0 0-1m0 2a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m.704-10.906a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamCarF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14 17H6v1.5A1.5 1.5 0 0 1 4.5 20h-1A1.5 1.5 0 0 1 2 18.5v-1.67A3 3 0 0 1 0 14v-3c0-.62.188-1.196.51-1.674l1.086-6.8A3 3 0 0 1 4.56 0h10.88a3 3 0 0 1 2.96 2.527l1.083 6.79c.326.48.516 1.06.516 1.683v3a3 3 0 0 1-2 2.83v1.67a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5zm3.25-8.99l-.824-5.168A1 1 0 0 0 15.44 2H4.559a1 1 0 0 0-.988.842l-.825 5.169A3 3 0 0 1 3 8h14q.127 0 .25.01M15.5 14a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m-11 0a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m.704-10.906a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamCastle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 8v9h6V8zm8 11H0v-7a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2h2V8a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2h2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zM8 17v-3H4v-2H2v5zM8 2v4h10V2h-2v2h-6V2zm5 11a2 2 0 0 1 2 2v3h-4v-3a2 2 0 0 1 2-2m-1-4h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2.5 24 24"
}

export const jamCastleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 8v11h-3v-4a2 2 0 1 0-4 0v4H0v-8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h2V8a2 2 0 0 1-2-2V1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h2V1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v5a2 2 0 0 1-2 2m-6 1a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2.5 24 24"
}

export const jamCharacter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 14v-2.108c1.984-.504 3.501-2.476 3.501-4.882c0-2.797-2.049-5.007-4.5-5.007s-4.5 2.21-4.5 5.007c0 2.405 1.516 4.376 3.499 4.881V14H1a1 1 0 0 1 0-2.003h1.434C1.241 10.727.501 8.961.501 7.01c0-3.872 2.91-7.01 6.5-7.01s6.5 3.138 6.5 7.01c0 1.951-.74 3.716-1.933 4.987H13A1 1 0 0 1 13 14z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const jamCheck: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5.486 9.73a1 1 0 0 1-.707-.292L.537 5.195A1 1 0 1 1 1.95 3.78l3.535 3.535L11.85.952a1 1 0 0 1 1.415 1.414L6.193 9.438a1 1 0 0 1-.707.292\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -7 24 24"
}

export const jamChevronCircleDown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0-6.172l3.536-3.535a1 1 0 0 1 1.414 1.414l-4.243 4.243a1 1 0 0 1-1.414 0L5.05 9.707a1 1 0 0 1 1.414-1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronCircleDownF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 11.828L6.464 8.293A1 1 0 0 0 5.05 9.707l4.243 4.243a.997.997 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronCircleDownLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-1-7h5a1 1 0 0 1 0 2H8a1 1 0 0 1-1-1V6a1 1 0 1 1 2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronCircleDownLeftF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 11V6a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1h6a1 1 0 0 0 0-2zm1 9C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronCircleDownRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m1-7V6a1 1 0 0 1 2 0v6a1 1 0 0 1-1 1H6a1 1 0 0 1 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronCircleDownRightF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 11H6a1 1 0 0 0 0 2h6a1 1 0 0 0 1-1V6a1 1 0 0 0-2 0zm-1 9C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronCircleLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-1.828-8l3.535 3.536a1 1 0 0 1-1.414 1.414L6.05 10.707a1 1 0 0 1 0-1.414l4.243-4.243a1 1 0 0 1 1.414 1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronCircleLeftF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m8.172 10l3.535-3.536a1 1 0 1 0-1.414-1.414L6.05 9.293a1 1 0 0 0 0 1.414l4.243 4.243a1 1 0 0 0 1.414-1.414zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronCircleRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m1.828-8L8.293 6.464A1 1 0 0 1 9.707 5.05l4.243 4.243a1 1 0 0 1 0 1.414L9.707 14.95a1 1 0 1 1-1.414-1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronCircleRightF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m11.828 10l-3.535 3.536a1 1 0 0 0 1.414 1.414l4.243-4.243a1 1 0 0 0 0-1.414L9.707 5.05a1 1 0 0 0-1.414 1.414zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronCircleUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0-8.828l-3.536 3.535a1 1 0 1 1-1.414-1.414L9.293 7.05a1 1 0 0 1 1.414 0l4.243 4.243a1 1 0 0 1-1.414 1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronCircleUpF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m10 9.172l3.536 3.535a1 1 0 0 0 1.414-1.414L10.707 7.05a1 1 0 0 0-1.414 0L5.05 11.293a1 1 0 0 0 1.414 1.414zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronCircleUpLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16M9 9v5a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronCircleUpLeftF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 9h5a1 1 0 0 0 0-2H8a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0zm1 11C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronCircleUpRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m1-9H6a1 1 0 1 1 0-2h6a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronCircleUpRightF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 9v5a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1H6a1 1 0 1 0 0 2zm-1 11C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronDown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -8 24 24"
}

export const jamChevronDownLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 8h7a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7 -7 24 24"
}

export const jamChevronDownRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 8V1a1 1 0 1 1 2 0v8a1 1 0 0 1-1 1H1a1 1 0 1 1 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7 -7 24 24"
}

export const jamChevronLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m2.757 7l4.95 4.95a1 1 0 1 1-1.414 1.414L.636 7.707a1 1 0 0 1 0-1.414L6.293.636A1 1 0 0 1 7.707 2.05z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-8 -5 24 24"
}

export const jamChevronRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m5.314 7.071l-4.95-4.95A1 1 0 0 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-8 -5 24 24"
}

export const jamChevronSquareDown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm6 9.828l3.536-3.535a1 1 0 0 1 1.414 1.414l-4.243 4.243a1 1 0 0 1-1.414 0L5.05 9.707a1 1 0 0 1 1.414-1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronSquareDownF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 11.828L6.464 8.293A1 1 0 0 0 5.05 9.707l4.243 4.243a.997.997 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronSquareDownLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm5 9h5a1 1 0 0 1 0 2H8a1 1 0 0 1-1-1V6a1 1 0 1 1 2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronSquareDownLeftF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 11V6a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1h6a1 1 0 0 0 0-2zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronSquareDownRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm7 9V6a1 1 0 0 1 2 0v6a1 1 0 0 1-1 1H6a1 1 0 0 1 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronSquareDownRightF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 11H6a1 1 0 0 0 0 2h6a1 1 0 0 0 1-1V6a1 1 0 0 0-2 0zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronSquareLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm4.172 8l3.535 3.536a1 1 0 0 1-1.414 1.414L6.05 10.707a1 1 0 0 1 0-1.414l4.243-4.243a1 1 0 0 1 1.414 1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronSquareLeftF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m8.172 10l3.535-3.536a1 1 0 1 0-1.414-1.414L6.05 9.293a1 1 0 0 0 0 1.414l4.243 4.243a1 1 0 0 0 1.414-1.414zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronSquareRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm7.828 8L8.293 6.464A1 1 0 0 1 9.707 5.05l4.243 4.243a1 1 0 0 1 0 1.414L9.707 14.95a1 1 0 1 1-1.414-1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronSquareRightF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m11.828 10l-3.535 3.536a1 1 0 0 0 1.414 1.414l4.243-4.243a1 1 0 0 0 0-1.414L9.707 5.05a1 1 0 0 0-1.414 1.414zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronSquareUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm6 7.172l-3.536 3.535a1 1 0 1 1-1.414-1.414L9.293 7.05a1 1 0 0 1 1.414 0l4.243 4.243a1 1 0 0 1-1.414 1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronSquareUpF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m10 9.172l3.536 3.535a1 1 0 0 0 1.414-1.414L10.707 7.05a1 1 0 0 0-1.414 0L5.05 11.293a1 1 0 0 0 1.414 1.414zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronSquareUpLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm5 7v5a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronSquareUpLeftF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 9h5a1 1 0 0 0 0-2H8a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronSquareUpRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm7 7H6a1 1 0 1 1 0-2h6a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronSquareUpRightF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 9v5a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1H6a1 1 0 1 0 0 2zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -7.5 24 24"
}

export const jamChevronUpLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 2v7a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7 -7 24 24"
}

export const jamChevronUpRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 2H1a1 1 0 1 1 0-2h8a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7 -7 24 24"
}

export const jamChevronsCircleDown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0-5.29l2.121-2.12a1 1 0 0 1 1.415 1.414l-2.829 2.828a1 1 0 0 1-1.414 0l-2.829-2.828a1 1 0 1 1 1.415-1.415zm0-5l2.121-2.12a1 1 0 0 1 1.415 1.414l-2.829 2.828a1 1 0 0 1-1.414 0L6.464 7.004A1 1 0 1 1 7.88 5.589L10 7.711z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsCircleDownF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m.009-7.377l-2.122-2.12a1 1 0 0 0-1.414 1.413l2.828 2.829a1 1 0 0 0 1.415 0l2.828-2.829a1 1 0 1 0-1.414-1.414zm0-5l-2.122-2.12a1 1 0 0 0-1.414 1.413l2.828 2.829a1 1 0 0 0 1.415 0l2.828-2.829a1 1 0 1 0-1.414-1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsCircleDownLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-2-6h3a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1V9a1 1 0 1 1 2 0zm3-3h3a1 1 0 0 1 0 2h-4a1 1 0 0 1-1-1V6a1 1 0 1 1 2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsCircleDownLeftF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 9V6a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1h4a1 1 0 0 0 0-2zm-3 3V9a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1h4a1 1 0 0 0 0-2zm2 8C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsCircleDownRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m2-6V9a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1H9a1 1 0 0 1 0-2zM9 9V6a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1H6a1 1 0 0 1 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsCircleDownRightF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 9H6a1 1 0 1 0 0 2h4a1 1 0 0 0 1-1V6a1 1 0 0 0-2 0zm3 3H9a1 1 0 0 0 0 2h4a1 1 0 0 0 1-1V9a1 1 0 0 0-2 0zm-2 8C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsCircleLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-3.172-8l2.122 2.121a1 1 0 0 1-1.414 1.415l-2.829-2.829a1 1 0 0 1 0-1.414l2.829-2.829A1 1 0 1 1 8.95 7.88zm4.99 0l2.121 2.121a1 1 0 0 1-1.414 1.415l-2.828-2.829a1 1 0 0 1 0-1.414l2.828-2.829A1 1 0 0 1 13.94 7.88z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsCircleLeftF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m11.818 10l2.121-2.121a1 1 0 1 0-1.414-1.415L9.697 9.293a1 1 0 0 0 0 1.414l2.828 2.829a1 1 0 0 0 1.414-1.415zm-4.99 0L8.95 7.879a1 1 0 0 0-1.414-1.415L4.707 9.293a1 1 0 0 0 0 1.414l2.829 2.829A1 1 0 1 0 8.95 12.12zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsCircleRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m2.818-8l-2.121-2.121a1 1 0 0 1 1.414-1.415l2.828 2.829a1 1 0 0 1 0 1.414l-2.828 2.829a1 1 0 1 1-1.414-1.415zm-4.99 0l-2.12-2.121A1 1 0 0 1 7.12 6.464l2.83 2.829a1 1 0 0 1 0 1.414l-2.83 2.829a1 1 0 1 1-1.414-1.415z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsCircleRightF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m3.175-9.976l-2.122 2.121a1 1 0 0 0 1.414 1.414l2.829-2.828a1 1 0 0 0 0-1.414l-2.829-2.829a1 1 0 1 0-1.414 1.415zm-4.99 0l-2.121 2.121a1 1 0 0 0 1.414 1.414l2.828-2.828a1 1 0 0 0 0-1.414L7.478 6.488a1 1 0 0 0-1.414 1.415z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsCircleUp: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M10 7.382L7.879 9.503A1 1 0 1 1 6.464 8.09l2.829-2.828a1 1 0 0 1 1.414 0l2.829 2.828a1 1 0 0 1-1.415 1.414L10 7.383z\"/><path d=\"m10 12.382l-2.121 2.121a1 1 0 1 1-1.415-1.414l2.829-2.828a1 1 0 0 1 1.414 0l2.829 2.828a1 1 0 0 1-1.415 1.414z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsCircleUpF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m10 12.382l2.121 2.121a1 1 0 0 0 1.415-1.414l-2.829-2.828a1 1 0 0 0-1.414 0l-2.829 2.828a1 1 0 0 0 1.415 1.414zm0-5l2.121 2.121a1 1 0 0 0 1.415-1.414l-2.829-2.828a1 1 0 0 0-1.414 0L6.464 8.089A1 1 0 1 0 7.88 9.503L10 7.383zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsCircleUpLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16M8 8v3a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2zm3 3v3a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsCircleUpLeftF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 11h3a1 1 0 0 0 0-2h-4a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0zM8 8h3a1 1 0 0 0 0-2H7a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0zm2 12C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsCircleUpRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m2-10H9a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0zm-3 3H6a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsCircleUpRightF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 11v3a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1H6a1 1 0 1 0 0 2zm3-3v3a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1H9a1 1 0 1 0 0 2zm-2 12C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsDown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364zm0 6l4.95-4.95a1 1 0 1 1 1.414 1.414l-5.657 5.657a1 1 0 0 1-1.414 0L.707 7.778a1 1 0 1 1 1.414-1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -5 24 24"
}

export const jamChevronsDownLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 12h7a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1V5a1 1 0 1 1 2 0zm4-4h7a1 1 0 0 1 0 2H5a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -5 24 24"
}

export const jamChevronsDownRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 8V1a1 1 0 1 1 2 0v8a1 1 0 0 1-1 1H1a1 1 0 1 1 0-2zm4 4V5a1 1 0 0 1 2 0v8a1 1 0 0 1-1 1H5a1 1 0 0 1 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -5 24 24"
}

export const jamChevronsLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m8.828 7.071l4.95 4.95a1 1 0 1 1-1.414 1.414L6.707 7.778a1 1 0 0 1 0-1.414L12.364.707a1 1 0 0 1 1.414 1.414zm-6 0l4.95 4.95a1 1 0 1 1-1.414 1.414L.707 7.778a1 1 0 0 1 0-1.414L6.364.707a1 1 0 1 1 1.414 1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4.5 -5 24 24"
}

export const jamChevronsRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m11.314 7.071l-4.95-4.95A1 1 0 0 1 7.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414zm-6 0l-4.95-4.95A1 1 0 1 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -5 24 24"
}

export const jamChevronsSquareDown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm6 10.958l2.121-2.121a1 1 0 0 1 1.415 1.414l-2.829 2.828a1 1 0 0 1-1.414 0l-2.829-2.828a1 1 0 0 1 1.415-1.414zm0-5l2.121-2.121a1 1 0 0 1 1.415 1.414l-2.829 2.828a1 1 0 0 1-1.414 0L6.464 7.251A1 1 0 1 1 7.88 5.837L10 7.957z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsSquareDownF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m5.998 12.612l-2.122-2.121a1 1 0 1 0-1.414 1.414l2.829 2.828a1 1 0 0 0 1.414 0l2.828-2.828a1 1 0 0 0-1.414-1.414zm0-5L7.876 5.491a1 1 0 1 0-1.414 1.414l2.829 2.828a1 1 0 0 0 1.414 0l2.828-2.828A1 1 0 0 0 12.12 5.49z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsSquareDownLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm4 10h3a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1V9a1 1 0 1 1 2 0zm3-3h3a1 1 0 0 1 0 2h-4a1 1 0 0 1-1-1V6a1 1 0 1 1 2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsSquareDownLeftF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 9V6a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1h4a1 1 0 0 0 0-2zm-3 3V9a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1h4a1 1 0 0 0 0-2zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsSquareDownRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm8 10V9a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1H9a1 1 0 0 1 0-2zM9 9V6a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1H6a1 1 0 0 1 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsSquareDownRightF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 9H6a1 1 0 1 0 0 2h4a1 1 0 0 0 1-1V6a1 1 0 0 0-2 0zm3 3H9a1 1 0 0 0 0 2h4a1 1 0 0 0 1-1V9a1 1 0 0 0-2 0zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsSquareLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm2.828 8l2.122 2.121a1 1 0 0 1-1.414 1.415l-2.829-2.829a1 1 0 0 1 0-1.414l2.829-2.829A1 1 0 1 1 8.95 7.88zm4.99 0l2.121 2.121a1 1 0 0 1-1.414 1.415l-2.828-2.829a1 1 0 0 1 0-1.414l2.828-2.829A1 1 0 0 1 13.94 7.88z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsSquareLeftF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m11.818 10l2.121-2.121a1 1 0 1 0-1.414-1.415L9.697 9.293a1 1 0 0 0 0 1.414l2.828 2.829a1 1 0 0 0 1.414-1.415zm-4.99 0L8.95 7.879a1 1 0 0 0-1.414-1.415L4.707 9.293a1 1 0 0 0 0 1.414l2.829 2.829A1 1 0 1 0 8.95 12.12zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsSquareRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm8.818 8l-2.121-2.121a1 1 0 0 1 1.414-1.415l2.828 2.829a1 1 0 0 1 0 1.414l-2.828 2.829a1 1 0 1 1-1.414-1.415zm-4.99 0l-2.12-2.121A1 1 0 0 1 7.12 6.464l2.83 2.829a1 1 0 0 1 0 1.414l-2.83 2.829a1 1 0 1 1-1.414-1.415z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsSquareRightF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m9.212 10.021l-2.121 2.122a1 1 0 0 0 1.414 1.414l2.828-2.829a1 1 0 0 0 0-1.414l-2.828-2.828A1 1 0 1 0 11.09 7.9l2.12 2.121zm-4.99 0l-2.12 2.122a1 1 0 0 0 1.413 1.414l2.829-2.829a1 1 0 0 0 0-1.414L7.515 6.486A1 1 0 0 0 6.101 7.9z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsSquareUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm6 5.382L7.879 9.503A1 1 0 0 1 6.464 8.09l2.829-2.828a1 1 0 0 1 1.414 0l2.829 2.828a1 1 0 1 1-1.415 1.414L10 7.383zm0 5l-2.121 2.121a1 1 0 1 1-1.415-1.414l2.829-2.828a1 1 0 0 1 1.414 0l2.829 2.828a1 1 0 0 1-1.415 1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsSquareUpF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m10 12.382l2.121 2.121a1 1 0 0 0 1.415-1.414l-2.829-2.828a1 1 0 0 0-1.414 0l-2.829 2.828a1 1 0 0 0 1.415 1.414zm0-5l2.121 2.121a1 1 0 0 0 1.415-1.414l-2.829-2.828a1 1 0 0 0-1.414 0L6.464 8.089A1 1 0 1 0 7.88 9.503L10 7.383zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsSquareUpLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm4 6v3a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2zm3 3v3a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsSquareUpLeftF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 11h3a1 1 0 0 0 0-2h-4a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0zM8 8h3a1 1 0 0 0 0-2H7a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsSquareUpRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm8 6H9a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0zm-3 3H6a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsSquareUpRightF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 11v3a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1H6a1 1 0 1 0 0 2zm3-3v3a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1H9a1 1 0 1 0 0 2zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamChevronsUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414zm0 6l-4.95 4.95a1 1 0 1 1-1.414-1.414l5.657-5.657a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -4.5 24 24"
}

export const jamChevronsUpLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 2v7a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2zm4 4v7a1 1 0 0 1-2 0V5a1 1 0 0 1 1-1h8a1 1 0 0 1 0 2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -5 24 24"
}

export const jamChevronsUpRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 2H5a1 1 0 1 1 0-2h8a1 1 0 0 1 1 1v8a1 1 0 0 1-2 0zM8 6H1a1 1 0 1 1 0-2h8a1 1 0 0 1 1 1v8a1 1 0 0 1-2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -5 24 24"
}

export const jamChronometer: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 11h2a1 1 0 0 1 0 2H8a.997.997 0 0 1-1-1V8a1 1 0 1 1 2 0zM1.869 6.861a1.5 1.5 0 1 1 2.077-1.76a8 8 0 0 1 1.126-.548A2.5 2.5 0 0 1 6.5 0h3a2.5 2.5 0 0 1 1.428 4.553q.586.231 1.126.548a1.5 1.5 0 1 1 2.077 1.76a8 8 0 1 1-12.263 0zM8 18A6 6 0 1 0 8 6a6 6 0 0 0 0 12M6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamChronometerF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 11V8a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1h3a1 1 0 0 0 0-2zm-1 7A6 6 0 1 1 7 6a6 6 0 0 1 0 12M9.928 4.553A8 8 0 0 0 7 4a8 8 0 0 0-2.928.553A2.5 2.5 0 0 1 5.5 0h3a2.5 2.5 0 0 1 1.428 4.553M5.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm5.554 3.101a1.5 1.5 0 1 1 2.077 1.76a8 8 0 0 0-2.077-1.76M.869 6.861a1.5 1.5 0 1 1 2.077-1.76A8 8 0 0 0 .87 6.861z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -3 24 24"
}

export const jamCircle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamCircleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20.565c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1.5 24 24"
}

export const jamClearFormat: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6.326 2L3.95 9.309a1 1 0 1 1-1.902-.618L4.223 2H1a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2zm3.33 6.243l.708.707a1 1 0 1 1-1.414 1.414l-.707-.707l-.707.707A1 1 0 0 1 6.12 8.95l.707-.707l-.707-.707A1 1 0 0 1 7.536 6.12l.707.707l.707-.707a1 1 0 1 1 1.414 1.415z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6.5 -6.5 24 24"
}

export const jamClipboard: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 2v2h4V2zm6 0h1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2m0 2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2H2v14h10V4zM4 8h6a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2m0 5h6a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamClipboardF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 2v2H5V2H3a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2zM5 6h4a2 2 0 0 0 2-2V2h1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h1v2a2 2 0 0 0 2 2M4 8a1 1 0 1 0 0 2h6a1 1 0 0 0 0-2zm0 5a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamClock: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 9h4a1 1 0 0 1 0 2h-5a1 1 0 0 1-1-1V4a1 1 0 1 1 2 0zm-1 11C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamClockF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 9V4a1 1 0 0 0-2 0v6a1 1 0 0 0 1 1h5a1 1 0 0 0 0-2zm-1 11C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamClose: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485L2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535l3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -6 24 24"
}

export const jamCloseCircle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m11.414 10l2.829 2.828a1 1 0 0 1-1.415 1.415L10 11.414l-2.828 2.829a1 1 0 1 1-1.415-1.415L8.586 10L5.757 7.172a1 1 0 0 1 1.415-1.415L10 8.586l2.828-2.829a1 1 0 0 1 1.415 1.415zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamCloseCircleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m11.414 10l2.829-2.828a1 1 0 1 0-1.415-1.415L10 8.586L7.172 5.757a1 1 0 0 0-1.415 1.415L8.586 10l-2.829 2.828a1 1 0 0 0 1.415 1.415L10 11.414l2.828 2.829a1 1 0 0 0 1.415-1.415zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamCloseRectangle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm7.414 8l2.829 2.828a1 1 0 0 1-1.415 1.415L10 11.414l-2.828 2.829a1 1 0 1 1-1.415-1.415L8.586 10L5.757 7.172a1 1 0 0 1 1.415-1.415L10 8.586l2.828-2.829a1 1 0 0 1 1.415 1.415z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamCloseRectangleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m11.414 10l2.829-2.828a1 1 0 1 0-1.415-1.415L10 8.586L7.172 5.757a1 1 0 0 0-1.415 1.415L8.586 10l-2.829 2.828a1 1 0 0 0 1.415 1.415L10 11.414l2.828 2.829a1 1 0 0 0 1.415-1.415zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamCloud: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 14a5 5 0 1 1 1.561-9.751A7.002 7.002 0 0 1 20 7a7 7 0 0 1-7 7zm0-2h8a5 5 0 1 0-4.6-6.965l-.72 1.686l-1.742-.572A3 3 0 1 0 5 12\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -5 24 24"
}

export const jamCloudF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13 0a7 7 0 0 1 0 14H5a5 5 0 1 1 1.561-9.751A7 7 0 0 1 13 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -5 24 24"
}

export const jamCloudRain: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 14a5 5 0 1 1 1.561-9.751A7.002 7.002 0 0 1 20 7a7 7 0 0 1-7 7zm0-2h8a5 5 0 1 0-4.6-6.965l-.72 1.686l-1.742-.572A3 3 0 1 0 5 12m1 3a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m4 0a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0v-3a1 1 0 0 1 1-1m4 0a1 1 0 0 1 1 1v1a1 1 0 0 1-2 0v-1a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamCloudRainF: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M13 0a7 7 0 0 1 0 14H5a5 5 0 1 1 1.561-9.751A7 7 0 0 1 13 0\"/><rect width=\"2\" height=\"4\" x=\"5\" y=\"15\" rx=\"1\"/><rect width=\"2\" height=\"5\" x=\"9\" y=\"15\" rx=\"1\"/><rect width=\"2\" height=\"3\" x=\"13\" y=\"15\" rx=\"1\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamCloudSnow: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 14a5 5 0 1 1 1.561-9.751A7.002 7.002 0 0 1 20 7a7 7 0 0 1-7 7zm0-2h8a5 5 0 1 0-4.6-6.965l-.72 1.686l-1.742-.572A3 3 0 1 0 5 12m1 3a1 1 0 1 1 0 2a1 1 0 0 1 0-2m4 3a1 1 0 1 1 0 2a1 1 0 0 1 0-2m4-2a1 1 0 1 1 0 2a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamCloudSnowF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13 0a7 7 0 0 1 0 14H5a5 5 0 1 1 1.561-9.751A7 7 0 0 1 13 0M6 15a1 1 0 1 1 0 2a1 1 0 0 1 0-2m4 3a1 1 0 1 1 0 2a1 1 0 0 1 0-2m4-2a1 1 0 1 1 0 2a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamCloudThunder: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13 14a1 1 0 0 1 0-2a5 5 0 1 0-4.6-6.965l-.72 1.686l-1.742-.572A3 3 0 1 0 5 12h2a1 1 0 0 1 0 2H5a5 5 0 1 1 1.561-9.751A7.002 7.002 0 0 1 20 7a7 7 0 0 1-7 7m-2.29-2.936c.519.198.787.801.598 1.346L9.94 16.36c-.19.545-.763.826-1.282.627s-.786-.801-.597-1.346l1.368-3.95c.188-.545.762-.826 1.281-.627m1.632 3.949c.519.198.786.801.597 1.346l-1.368 3.95c-.188.545-.762.826-1.281.627s-.787-.801-.598-1.346l1.368-3.95c.19-.545.763-.826 1.282-.627M9 14.949h3c.552 0 1 .47 1 1.051c0 .58-.448 1.05-1 1.05H9c-.552 0-1-.47-1-1.05s.448-1.05 1-1.05z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1.5 24 24"
}

export const jamCloudThunderF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m11.774 14l.502-1.378a2 2 0 1 0-3.759-1.368l-.684 1.88A2 2 0 0 0 7.72 14H5a5 5 0 1 1 1.561-9.751A7.002 7.002 0 0 1 20 7a7 7 0 0 1-7 7zm-1.064-2.936c.519.198.787.801.598 1.346L9.94 16.36c-.19.545-.763.826-1.282.627s-.786-.801-.597-1.346l1.368-3.95c.188-.545.762-.826 1.281-.627m1.632 3.949c.519.198.786.801.597 1.346l-1.368 3.95c-.188.545-.762.826-1.281.627s-.787-.801-.598-1.346l1.368-3.95c.19-.545.763-.826 1.282-.627M9 14.949h3c.552 0 1 .47 1 1.051c0 .58-.448 1.05-1 1.05H9c-.552 0-1-.47-1-1.05s.448-1.05 1-1.05z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1.5 24 24"
}

export const jamCode: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12.736.064c.52.2.787.805.598 1.353L8.546 15.305c-.19.548-.763.83-1.282.631c-.52-.2-.787-.805-.598-1.353L11.454.695c.19-.548.763-.83 1.282-.631M2.414 8.256L5.95 11.99c.39.412.39 1.08 0 1.492a.963.963 0 0 1-1.414 0L.293 9.003a1.1 1.1 0 0 1 0-1.493l4.243-4.48a.963.963 0 0 1 1.414 0a1.1 1.1 0 0 1 0 1.494zm15.172 0L14.05 4.524a1.1 1.1 0 0 1 0-1.493a.963.963 0 0 1 1.414 0l4.243 4.479c.39.412.39 1.08 0 1.493l-4.243 4.478a.963.963 0 0 1-1.414 0a1.1 1.1 0 0 1 0-1.492z\"/>",
  "width": 20,
  "height": 16,
  "viewBox": "0 0 20 16"
}

export const jamCodeSample: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m5.243 6.657l-4.95-4.95A1 1 0 1 1 1.707.293L7.364 5.95a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 1 1-1.414-1.414zM9 11h8a1 1 0 0 1 0 2H9a1 1 0 0 1 0-2\"/>",
  "width": 18,
  "height": 14,
  "viewBox": "0 0 18 14"
}

export const jamCodepen: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.549.26a1.56 1.56 0 0 0-1.756.02L.928 5.76c-.42.292-.67.77-.67 1.282v5.903c0 .525.264 1.014.702 1.303l7.994 5.285a1.56 1.56 0 0 0 1.723 0l8.153-5.386c.438-.29.701-.78.701-1.304v-5.8c0-.524-.263-1.013-.7-1.303zm6.09 6.393l-3.014 2.023l-2.826-2.055l-.018-4.042l5.857 4.074zm-7.902-4.07V6.54L5.84 8.564L2.953 6.627zM2.16 8.576l1.87 1.253l-1.87 1.308zm6.625 8.433L2.954 13.1l2.913-2.037l2.92 1.958v3.99zM7.68 9.796l1.888-1.32l2.2 1.445l-1.95 1.31zm3.167 7.213v-3.99l2.79-1.87l3.003 1.975zm6.625-5.805l-1.98-1.3l1.98-1.329z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamCodepenCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M10.402 5.131a.79.79 0 0 0-.887.01L5.54 7.91a.79.79 0 0 0-.339.648v2.982a.79.79 0 0 0 .355.659l4.039 2.67a.79.79 0 0 0 .87 0l4.12-2.722a.79.79 0 0 0 .354-.658v-2.93a.79.79 0 0 0-.354-.66l-4.184-2.768zm3.077 3.23l-1.523 1.023l-1.428-1.038l-.009-2.043zM9.486 6.306v1.999L8.023 9.327l-1.46-.979zM6.164 9.333l.944.633l-.944.661zm3.347 4.261l-2.947-1.976l1.472-1.029l1.475.99zm-.56-3.644l.955-.667l1.11.73l-.984.662zm1.601 3.644v-2.016l1.41-.944l1.517.997zm3.347-2.933l-1-.657l1-.671z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamCodepenSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10.402 5.131a.79.79 0 0 0-.887.01L5.54 7.91a.79.79 0 0 0-.339.648v2.982a.79.79 0 0 0 .355.659l4.039 2.67a.79.79 0 0 0 .87 0l4.12-2.722a.79.79 0 0 0 .354-.658v-2.93a.79.79 0 0 0-.354-.66l-4.184-2.768zm3.077 3.23l-1.523 1.023l-1.428-1.038l-.009-2.043zM9.486 6.306v1.999L8.023 9.327l-1.46-.979zM6.164 9.333l.944.633l-.944.661zm3.347 4.261l-2.947-1.976l1.472-1.029l1.475.99zm-.56-3.644l.955-.667l1.11.73l-.984.662zm1.601 3.644v-2.016l1.41-.944l1.517.997zm3.347-2.933l-1-.657l1-.671z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamCoffee: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1.232 4.976A1.5 1.5 0 0 1 1.5 2H2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2h.5a1.5 1.5 0 0 1 .268 2.976l-.448 3.805a2 2 0 0 1 .399 1.467l-.5 4a2 2 0 0 1-.693 1.279l-.422 3.59a1 1 0 0 1-.993.883H3.889a1 1 0 0 1-.993-.883l-.422-3.59a2 2 0 0 1-.693-1.279l-.5-4a2 2 0 0 1 .4-1.467zM3.25 5l.353 3h6.796l.353-3zm.517 9h6.468l.5-4H3.266zm.777 2l.235 2h4.444l.235-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamCoffeeCup: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 4a6 6 0 1 0 12 0V2H2zm14-4h1a3 3 0 0 1 0 6h-1.252A8 8 0 0 1 0 4V0zm0 4h1a1 1 0 0 0 0-2h-1z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6 24 24"
}

export const jamCoffeeCupF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0h17a3 3 0 0 1 0 6h-1.252A8 8 0 0 1 0 4zm16 4h1a1 1 0 0 0 0-2h-1z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6 24 24"
}

export const jamCog: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M20 8.163A2.1 2.1 0 0 0 18.926 10c0 .789.433 1.476 1.074 1.837l-.717 2.406a2.105 2.105 0 0 0-2.218 3.058l-2.062 1.602A2.104 2.104 0 0 0 11.633 20l-3.29-.008a2.104 2.104 0 0 0-3.362-1.094l-2.06-1.615A2.105 2.105 0 0 0 .715 14.24L0 11.825A2.1 2.1 0 0 0 1.051 10C1.051 9.22.63 8.54 0 8.175L.715 5.76a2.105 2.105 0 0 0 2.207-3.043L4.98 1.102A2.104 2.104 0 0 0 8.342.008L11.634 0a2.104 2.104 0 0 0 3.37 1.097l2.06 1.603a2.105 2.105 0 0 0 2.218 3.058zM14.823 3.68q0-.094.005-.188l-.08-.062a4.1 4.1 0 0 1-4.308-1.428l-.904.002a4.1 4.1 0 0 1-4.29 1.43l-.095.076A4.11 4.11 0 0 1 2.279 7.6a4.1 4.1 0 0 1 .772 2.399c0 .882-.28 1.715-.772 2.4a4.11 4.11 0 0 1 2.872 4.09l.096.075a4.1 4.1 0 0 1 4.289 1.43l.904.002a4.1 4.1 0 0 1 4.307-1.428l.08-.062A4.11 4.11 0 0 1 17.7 12.4a4.1 4.1 0 0 1-.773-2.4c0-.882.281-1.716.773-2.4a4.11 4.11 0 0 1-2.876-3.919zM10 14a4 4 0 1 1 0-8a4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamCogF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M20 8.163A2.1 2.1 0 0 0 18.926 10c0 .789.433 1.476 1.074 1.837l-.717 2.406a2.105 2.105 0 0 0-2.218 3.058l-2.062 1.602A2.104 2.104 0 0 0 11.633 20l-3.29-.008a2.104 2.104 0 0 0-3.362-1.094l-2.06-1.615A2.105 2.105 0 0 0 .715 14.24L0 11.825A2.1 2.1 0 0 0 1.051 10C1.051 9.22.63 8.54 0 8.175L.715 5.76a2.105 2.105 0 0 0 2.207-3.043L4.98 1.102A2.104 2.104 0 0 0 8.342.008L11.634 0a2.104 2.104 0 0 0 3.37 1.097l2.06 1.603a2.105 2.105 0 0 0 2.218 3.058zM10 14a4 4 0 1 0 0-8a4 4 0 0 0 0 8\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamCogs: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.815 3.094a3.47 3.47 0 0 1-2.78-1.09l-.084-.001a3.47 3.47 0 0 1-2.781 1.09a3.48 3.48 0 0 1-1.727 2.51a3.47 3.47 0 0 1 0 2.794a3.48 3.48 0 0 1 1.727 2.51a3.47 3.47 0 0 1 2.78 1.09h.084a3.47 3.47 0 0 1 2.78-1.09a3.48 3.48 0 0 1 1.727-2.51a3.47 3.47 0 0 1 0-2.794a3.48 3.48 0 0 1-1.726-2.51zM14 5.714a1.474 1.474 0 0 0 0 2.572l-.502 1.684a1.473 1.473 0 0 0-1.553 2.14l-1.443 1.122A1.473 1.473 0 0 0 8.143 14l-2.304-.006a1.473 1.473 0 0 0-2.352-.765l-1.442-1.131A1.473 1.473 0 0 0 .5 9.968L0 8.278a1.474 1.474 0 0 0 0-2.555l.5-1.69a1.473 1.473 0 0 0 1.545-2.13L3.487.77A1.473 1.473 0 0 0 5.84.005L8.143 0a1.473 1.473 0 0 0 2.358.768l1.444 1.122a1.473 1.473 0 0 0 1.553 2.14zm-5.812 9.198a8 8 0 0 0 2.342-.73a4 4 0 0 1-.087.215a3.48 3.48 0 0 1 1.727 2.51a3.47 3.47 0 0 1 2.78 1.09h.084a3.47 3.47 0 0 1 2.78-1.09a3.48 3.48 0 0 1 1.727-2.51a3.47 3.47 0 0 1 0-2.794a3.48 3.48 0 0 1-1.726-2.51a3.47 3.47 0 0 1-2.78-1.09h-.084l-.015.016a8 8 0 0 0 .002-2.016L16.144 6a1.473 1.473 0 0 0 2.358.768l1.444 1.122a1.473 1.473 0 0 0 1.553 2.14L22 11.714a1.474 1.474 0 0 0 0 2.572l-.502 1.684a1.473 1.473 0 0 0-1.553 2.14l-1.443 1.122a1.473 1.473 0 0 0-2.359.768l-2.304-.006a1.473 1.473 0 0 0-2.352-.765l-1.442-1.131a1.473 1.473 0 0 0-1.545-2.13zM7 10a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0-2a1 1 0 1 0 0-2a1 1 0 0 0 0 2m8 8a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0-2a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1 -2 24 24"
}

export const jamCogsF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14 5.714a1.474 1.474 0 0 0 0 2.572l-.502 1.684a1.473 1.473 0 0 0-1.553 2.14l-1.443 1.122A1.473 1.473 0 0 0 8.143 14l-2.304-.006a1.473 1.473 0 0 0-2.352-.765l-1.442-1.131A1.473 1.473 0 0 0 .5 9.968L0 8.278a1.474 1.474 0 0 0 0-2.555l.5-1.69a1.473 1.473 0 0 0 1.545-2.13L3.487.77A1.473 1.473 0 0 0 5.84.005L8.143 0a1.473 1.473 0 0 0 2.358.768l1.444 1.122a1.473 1.473 0 0 0 1.553 2.14zM7 10a3 3 0 1 0 0-6a3 3 0 0 0 0 6m7.393.061a8 8 0 0 0 .545-4.058L16.144 6a1.473 1.473 0 0 0 2.358.768l1.444 1.122a1.473 1.473 0 0 0 1.553 2.14L22 11.714a1.474 1.474 0 0 0 0 2.572l-.502 1.684a1.473 1.473 0 0 0-1.553 2.14l-1.443 1.122a1.473 1.473 0 0 0-2.359.768l-2.304-.006a1.473 1.473 0 0 0-2.352-.765l-1.442-1.131a1.473 1.473 0 0 0-1.545-2.13l-.312-1.056a7.96 7.96 0 0 0 3.821-1.674a3 3 0 1 0 2.384-3.177\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1 -2 24 24"
}

export const jamCoin: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 13v-2a3 3 0 1 1 0-6V4a1 1 0 1 1 2 0v1h.022A2.98 2.98 0 0 1 14 7.978a1 1 0 0 1-2 0A.98.98 0 0 0 11.022 7H11v2a3 3 0 0 1 0 6v1a1 1 0 0 1-2 0v-1h-.051A2.95 2.95 0 0 1 6 12.051a1 1 0 1 1 2 0a.95.95 0 0 0 .949.949zm2 0a1 1 0 0 0 0-2zM9 7a1 1 0 1 0 0 2zm1 13C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamCoinF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 13.858h-.051A.95.95 0 0 1 8 12.909a1 1 0 1 0-2 0a2.95 2.95 0 0 0 2.949 2.949H9v1a1 1 0 0 0 2 0v-1a3 3 0 0 0 0-6v-2h.022c.54 0 .978.438.978.978a1 1 0 0 0 2 0a2.98 2.98 0 0 0-2.978-2.978H11v-1a1 1 0 0 0-2 0v1a3 3 0 1 0 0 6zm2 0v-2a1 1 0 0 1 0 2m-2-6v2a1 1 0 1 1 0-2m1 13c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1.5 24 24"
}

export const jamColor: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6.327 6.99H2.672l-.477 1.306c-.191.524-.826.812-1.417.642c-.59-.17-.915-.734-.723-1.258l2.304-6.312C2.743.32 4.011-.256 5.193.084C5.88.282 6.418.76 6.64 1.368L8.945 7.68c.191.524-.133 1.088-.724 1.258c-.59.17-1.225-.118-1.417-.642l-.477-1.307zm-.729-1.998L4.5 1.984L3.4 4.992h2.197zM10 4a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -7.5 24 24"
}

export const jamCompass: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11.932 9.482a2.003 2.003 0 0 1-2.45 2.45L6.464 14.95a1 1 0 1 1-1.414-1.414l3.018-3.018a2.003 2.003 0 0 1 2.45-2.45l3.018-3.018a1 1 0 0 1 1.414 1.414zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamCompassF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m11.932 9.482l3.018-3.018a1 1 0 1 0-1.414-1.414l-3.018 3.018a2.003 2.003 0 0 0-2.45 2.45L5.05 13.536a1 1 0 0 0 1.414 1.414l3.018-3.018a2.003 2.003 0 0 0 2.45-2.45M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamComputer: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 13v1h3V2H2v9h1v2zM1 0h5a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1m9 3h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v6h8V5zm2 9h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamComputerAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 14h18a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2M2 0h16a2 2 0 0 1 2 2v10a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V2a2 2 0 0 1 2-2m16 11V2H2v9z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamComputerAltF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 14h18a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2M2 0h16a2 2 0 0 1 2 2v10a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V2a2 2 0 0 1 2-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamComputerF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 .565h5a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-14a1 1 0 0 1 1-1m0 11v2h2v-2zm9-8h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2m2 11h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3.5 24 24"
}

export const jamCreditCard: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 4V2H2v2zm0 3H2v5h16zM2 0h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 9h1a1 1 0 1 1 0 2H4a1 1 0 0 1 0-2m5 0h5a1 1 0 0 1 0 2H9a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -5 24 24"
}

export const jamCreditCardF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M20 4H0V2a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2zm0 3v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7zM4 9a1 1 0 1 0 0 2h1a1 1 0 0 0 0-2zm5 0a1 1 0 1 0 0 2h5a1 1 0 0 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -5 24 24"
}

export const jamCrop: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15 17H7a4 4 0 0 1-4-4V5H1a1 1 0 1 1 0-2h2v-4v2a1 1 0 1 1 2 0v2h8a4 4 0 0 1 4 4v8h2a1 1 0 0 1 0 2h-2v4v-2a1 1 0 0 1-2 0zm0-2V7a2 2 0 0 0-2-2H5v8a2 2 0 0 0 2 2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamCrown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2.776 5.106L3.648 11h12.736l.867-5.98l-3.493 3.02l-3.755-4.827l-3.909 4.811zm10.038-1.537l-.078.067l.141.014l1.167 1.499l1.437-1.242l.14.014l-.062-.082l2.413-2.086a1 1 0 0 1 1.643.9L18.115 13H1.922L.399 2.7a1 1 0 0 1 1.65-.898L4.35 3.827l-.05.06l.109-.008l1.444 1.27l1.212-1.493l.109-.009l-.06-.052L9.245.976a1 1 0 0 1 1.565.017zM2 14h16v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamCrownF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2.049 1.802L5.854 5.15L9.244.976a1 1 0 0 1 1.565.017l3.235 4.156l3.928-3.396a1 1 0 0 1 1.643.9L18.115 13H1.922L.399 2.7a1 1 0 0 1 1.65-.898M2 14h16v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamCutlery: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m3.303 16.738l8.066-8.065l.894.05c1.065.061 2.369-.485 3.415-1.53c1.636-1.637 1.934-3.723 1.06-4.597c-.873-.873-2.96-.575-4.596 1.06c-1.046 1.047-1.592 2.35-1.531 3.416l.05.894l-8.065 8.065a.5.5 0 0 0 .707.707m1.415 1.415a2.5 2.5 0 0 1-3.536-3.536l7.432-7.432c-.092-1.614.643-3.471 2.114-4.942c2.343-2.344 5.667-2.818 7.425-1.061c1.757 1.757 1.282 5.081-1.061 7.425c-1.471 1.47-3.329 2.205-4.943 2.114z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2.5 24 24"
}

export const jamCutleryF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m11.955 10.5l-8.298 8.3a2 2 0 1 1-2.829-2.828l8.299-8.299c-.173-1.518.515-3.343 1.954-4.783C13.23.741 16.237.266 17.8 1.83c1.562 1.562 1.087 4.57-1.06 6.717c-1.44 1.44-3.266 2.128-4.784 1.955z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2.5 -2 24 24"
}

export const jamCutter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m11.37 15.226l.023-.027l-4.617-3.832l-.002.003zm-1.286 1.533l-2.58 3.074l-7.158-.803l5.142-6.128zM7.02 14.187L4.722 12.26L13.72 1.534a4 4 0 0 1 6.128 5.143L10.85 17.4l-2.298-1.928l-1.928 2.298l-2.175-.52l2.571-3.064zm.52-2.174l3.064 2.57l7.713-9.192a2 2 0 0 0-3.064-2.571zm9.245-7.907a1 1 0 0 1 .123 1.408l-.642.766a1 1 0 1 1-1.533-1.285l.643-.766a1 1 0 0 1 1.41-.123z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1.5 -2 24 24"
}

export const jamCutterF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m9.684 17.995l-1.928 2.298L.588 19.5l4.5-5.362zm2.052-.89l-6.129-5.142l8.356-9.958a4 4 0 0 1 6.129 5.142l-8.356 9.959zm5.916-12.62a1 1 0 0 0-1.409.124l-.643.766a1 1 0 0 0 1.532 1.286l.643-.766a1 1 0 0 0-.123-1.41\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1.5 -1.5 24 24"
}

export const jamDashboard: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.832 14A10 10 0 0 1 0 10C0 4.477 4.477 0 10 0s10 4.477 10 10a10 10 0 0 1-.832 4zm16.916-2a8 8 0 1 0-15.497 0zM10 5a1 1 0 1 1 0-2a1 1 0 0 1 0 2M5 9a1 1 0 1 1 0-2a1 1 0 0 1 0 2m10 0a1 1 0 1 1 0-2a1 1 0 0 1 0 2m-5-3a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -5 24 24"
}

export const jamDashboardF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.832 14.565a10 10 0 0 1-.832-4c0-5.523 4.477-10 10-10s10 4.477 10 10a10 10 0 0 1-.832 4zm9.168-9a1 1 0 1 0 0-2a1 1 0 0 0 0 2m-5 4a1 1 0 1 0 0-2a1 1 0 0 0 0 2m10 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2m-5-3a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4.5 24 24"
}

export const jamDatabase: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 12a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1zm0-2a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3m0-8a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm2 4a1 1 0 1 1 0-2a1 1 0 0 1 0 2m3 0a1 1 0 1 1 0-2a1 1 0 0 1 0 2m0 10a1 1 0 1 1 0-2a1 1 0 0 1 0 2m-3 0a1 1 0 1 1 0-2a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamDatabaseF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 10a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3m5 6a1 1 0 1 0 0-2a1 1 0 0 0 0 2m-3 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2M5 6a1 1 0 1 0 0-2a1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamDeezer: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 9.786h3.64v1.062H0zm0-1.381h3.64v1.062H0zm0-1.38h3.64v1.062H0zm0-1.38h3.64v1.062H0zm0-1.381h3.64v1.062H0zm4.082 5.522h3.641v1.062H4.082zm0-1.381h3.641v1.062H4.082zm0-1.38h3.641v1.062H4.082zm4.082 2.761h3.641v1.062H8.164zm0-1.381h3.641v1.062H8.164zm0-1.38h3.641v1.062H8.164zm0-1.38h3.641v1.062H8.164zm0-1.381h3.641v1.062H8.164zm0-1.38h3.641v1.062H8.164zm0-1.381h3.641v1.062H8.164zm4.082 8.283h3.641v1.062h-3.641zm0-1.381h3.641v1.062h-3.641zm0-1.38h3.641v1.062h-3.641zm0-1.38h3.641v1.062h-3.641zm0-1.381h3.641v1.062h-3.641zm4.082 5.522h3.641v1.062h-3.641zm0-1.381h3.641v1.062h-3.641zm0-1.38h3.641v1.062h-3.641zm0-1.38h3.641v1.062h-3.641zm0-1.381h3.641v1.062h-3.641zm0-1.38h3.641v1.062h-3.641zm0-1.381h3.641v1.062h-3.641zm0-1.381h3.641v1.062h-3.641z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6.5 24 24"
}

export const jamDeezerCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M5 12.111h1.82v1H5z\"/><path d=\"M5 11.421h1.82v1H5z\"/><path d=\"M5 10.731h1.82v1H5z\"/><path d=\"M5 10.041h1.82v1H5z\"/><path d=\"M5 9.351h1.82v1H5zm2.041 2.76h1.82v1h-1.82z\"/><path d=\"M7.041 11.421h1.82v1h-1.82z\"/><path d=\"M7.041 10.731h1.82v1h-1.82zm2.041 1.38h1.82v1h-1.82z\"/><path d=\"M9.082 11.421h1.82v1h-1.82z\"/><path d=\"M9.082 10.731h1.82v1h-1.82z\"/><path d=\"M9.082 10.041h1.82v1h-1.82z\"/><path d=\"M9.082 9.351h1.82v1h-1.82z\"/><path d=\"M9.082 8.66h1.82v1h-1.82z\"/><path d=\"M9.082 7.97h1.82v1h-1.82zm2.041 4.141h1.821v1h-1.821z\"/><path d=\"M11.123 11.421h1.821v1h-1.821z\"/><path d=\"M11.123 10.731h1.821v1h-1.821z\"/><path d=\"M11.123 10.041h1.821v1h-1.821z\"/><path d=\"M11.123 9.351h1.821v1h-1.821zm2.041 2.76h1.82v1h-1.82z\"/><path d=\"M13.164 11.421h1.82v1h-1.82z\"/><path d=\"M13.164 10.731h1.82v1h-1.82z\"/><path d=\"M13.164 10.041h1.82v1h-1.82z\"/><path d=\"M13.164 9.35h1.82v1h-1.82z\"/><path d=\"M13.164 8.66h1.82v1h-1.82z\"/><path d=\"M13.164 7.97h1.82v1h-1.82z\"/><path d=\"M13.164 7.28h1.82v1h-1.82z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamDeezerSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M5 12.111h1.82v1H5z\"/><path d=\"M5 11.421h1.82v1H5z\"/><path d=\"M5 10.731h1.82v1H5z\"/><path d=\"M5 10.041h1.82v1H5z\"/><path d=\"M5 9.351h1.82v1H5zm2.041 2.76h1.82v1h-1.82z\"/><path d=\"M7.041 11.421h1.82v1h-1.82z\"/><path d=\"M7.041 10.731h1.82v1h-1.82zm2.041 1.38h1.82v1h-1.82z\"/><path d=\"M9.082 11.421h1.82v1h-1.82z\"/><path d=\"M9.082 10.731h1.82v1h-1.82z\"/><path d=\"M9.082 10.041h1.82v1h-1.82z\"/><path d=\"M9.082 9.351h1.82v1h-1.82z\"/><path d=\"M9.082 8.66h1.82v1h-1.82z\"/><path d=\"M9.082 7.97h1.82v1h-1.82zm2.041 4.141h1.821v1h-1.821z\"/><path d=\"M11.123 11.421h1.821v1h-1.821z\"/><path d=\"M11.123 10.731h1.821v1h-1.821z\"/><path d=\"M11.123 10.041h1.821v1h-1.821z\"/><path d=\"M11.123 9.351h1.821v1h-1.821zm2.041 2.76h1.82v1h-1.82z\"/><path d=\"M13.164 11.421h1.82v1h-1.82z\"/><path d=\"M13.164 10.731h1.82v1h-1.82z\"/><path d=\"M13.164 10.041h1.82v1h-1.82z\"/><path d=\"M13.164 9.35h1.82v1h-1.82z\"/><path d=\"M13.164 8.66h1.82v1h-1.82z\"/><path d=\"M13.164 7.97h1.82v1h-1.82z\"/><path d=\"M13.164 7.28h1.82v1h-1.82z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamDelete: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7.828 0H18a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7.828a2 2 0 0 1-1.414-.586L.707 7.707a1 1 0 0 1 0-1.414L6.414.586A2 2 0 0 1 7.828 0m0 12H18V2H7.828l-5 5zm6.586-5l1.414 1.414a1 1 0 0 1-1.414 1.414L13 8.414l-1.414 1.414a1 1 0 1 1-1.414-1.414L11.586 7l-1.414-1.414a1 1 0 1 1 1.414-1.414L13 5.586l1.414-1.414a1 1 0 1 1 1.414 1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -5 24 24"
}

export const jamDeleteF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m14.414 7l1.414-1.414a1 1 0 0 0-1.414-1.414L13 5.586l-1.414-1.414a1 1 0 1 0-1.414 1.414L11.586 7l-1.414 1.414a1 1 0 1 0 1.414 1.414L13 8.414l1.414 1.414a1 1 0 1 0 1.414-1.414zM7.828 0H18a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7.828a2 2 0 0 1-1.414-.586L.707 7.707a1 1 0 0 1 0-1.414L6.414.586A2 2 0 0 1 7.828 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -5 24 24"
}

export const jamDeviantart: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12.985 0H8.846L7.141 3.211a1.2 1.2 0 0 1-1.066.631H.033v5.1h3.27c.362 0 .596.373.43.686l-3.7 6.967v3.375h4.131l1.706-3.21a1.2 1.2 0 0 1 1.066-.632h6.049v-5.1H9.707a.47.47 0 0 1-.43-.686l3.708-6.98z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5.5 -2 24 24"
}

export const jamDeviantartCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M13.254 5.01h-2.072l-.854 1.608a.6.6 0 0 1-.534.317H6.77v2.553h1.637c.182 0 .299.187.215.344L6.77 13.32v1.69h2.069l.853-1.607a.6.6 0 0 1 .534-.316h3.03v-2.554h-1.642a.236.236 0 0 1-.215-.344l1.856-3.495V5.011z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamDeviantartSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M13.254 5.01h-2.072l-.854 1.608a.6.6 0 0 1-.534.317H6.77v2.553h1.637c.182 0 .299.187.215.344L6.77 13.32v1.69h2.069l.853-1.607a.6.6 0 0 1 .534-.316h3.03v-2.554h-1.642a.236.236 0 0 1-.215-.344l1.856-3.495V5.011z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamDice: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16 0a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm0 2H4a2 2 0 0 0-1.995 1.85L2 4v12a2 2 0 0 0 1.85 1.995L4 18h12a2 2 0 0 0 1.995-1.85L18 16V4a2 2 0 0 0-1.85-1.995zm-1 11a2 2 0 1 1 0 4a2 2 0 0 1 0-4m-5-5a2 2 0 1 1 0 4a2 2 0 0 1 0-4M5 3a2 2 0 1 1 0 4a2 2 0 0 1 0-4\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const jamDiceF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16 0a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm-1 13a2 2 0 1 0 0 4a2 2 0 0 0 0-4m-5-5a2 2 0 1 0 0 4a2 2 0 0 0 0-4M5 3a2 2 0 1 0 0 4a2 2 0 0 0 0-4\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const jamDices: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 0a3 3 0 0 1 3 3v3h3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3v-3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm6 8H9a1 1 0 0 0-.993.883L8 9v8a1 1 0 0 0 .883.993L9 18h8a1 1 0 0 0 .993-.883L18 17V9a1 1 0 0 0-.883-.993zm-7 7a1 1 0 1 1 0 2a1 1 0 0 1 0-2m6 0a1 1 0 1 1 0 2a1 1 0 0 1 0-2m-3-3a1 1 0 1 1 0 2a1 1 0 0 1 0-2m-1.883-9.993L11 2H3a1 1 0 0 0-.993.883L2 3v8a1 1 0 0 0 .883.993L3 12h3V9a3 3 0 0 1 3-3h3V3a1 1 0 0 0-.883-.993M10 9a1 1 0 1 1 0 2a1 1 0 0 1 0-2m6 0a1 1 0 1 1 0 2a1 1 0 0 1 0-2M4.513 8.993a1 1 0 1 1 0 2a1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2a1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2a1 1 0 0 1 0-2m5 0a1 1 0 1 1 0 2a1 1 0 0 1 0-2\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const jamDicesF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 0a3 3 0 0 1 3 3v3h3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3v-3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm-1 15a1 1 0 1 0 0 2a1 1 0 0 0 0-2m6 0a1 1 0 1 0 0 2a1 1 0 0 0 0-2m-3-3a1 1 0 1 0 0 2a1 1 0 0 0 0-2m-3-3a1 1 0 1 0 0 2a1 1 0 0 0 0-2m6 0a1 1 0 1 0 0 2a1 1 0 0 0 0-2M4.513 8.993a1 1 0 1 0 0 2a1 1 0 0 0 0-2m0-3a1 1 0 1 0 0 2a1 1 0 0 0 0-2m0-3a1 1 0 1 0 0 2a1 1 0 0 0 0-2m5 0a1 1 0 1 0 0 2a1 1 0 0 0 0-2\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const jamDifferenciation: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 .674a7 7 0 1 1 0 12.653A7 7 0 1 1 10 .673ZM10 3a5 5 0 0 0-2 4c0 1.636.786 3.088 2 4a5 5 0 0 0 2-4a5 5 0 0 0-2-4\"/>",
  "width": 20,
  "height": 14,
  "viewBox": "0 0 20 14"
}

export const jamDigg: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.548.006v3.5H0v7h5.544V.006zm-1.552 8.75v-3.5h1.552v3.5zm3.992-5.25h1.996v7H5.988zm0-3.5h1.996v1.969H5.988V.005zm8.205 3.5H8.871v7h3.326v1.531H8.871v1.969h5.322zm-3.326 5.25v-3.5h1.33v3.5zm9.092-5.25h-5.322v7h3.548v1.531h-3.548v1.969h5.322zm-1.774 5.25h-1.552v-3.5h1.552z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4.5 24 24"
}

export const jamDirection: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 4v4h12.98l2.853-1.714a.333.333 0 0 0 0-.572L14.98 4zm8-2h4.98a2 2 0 0 1 1.03.286L18.863 4a2.333 2.333 0 0 1 0 4L16.01 9.714a2 2 0 0 1-1.03.286H10v9a1 1 0 0 1-2 0v-9H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h6V1a1 1 0 1 1 2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamDirectionF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 2h4.98a2 2 0 0 1 1.03.286L18.863 4a2.333 2.333 0 0 1 0 4L16.01 9.714a2 2 0 0 1-1.03.286H10v9a1 1 0 0 1-2 0v-9H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h6V1a1 1 0 1 1 2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamDirections: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 3v4h12.98l2.853-1.714a.333.333 0 0 0 0-.572L14.98 3zm6-2a1 1 0 1 1 2 0h4.98a2 2 0 0 1 1.03.286L18.863 3a2.333 2.333 0 0 1 0 4L16.01 8.714A2 2 0 0 1 14.98 9H10v1h7.995a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H10v1a1 1 0 0 1-2 0v-1H5.015a2 2 0 0 1-1.03-.286L1.132 16a2.333 2.333 0 0 1 0-4l2.853-1.714A2 2 0 0 1 5.015 10H8V9H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm9.995 11H5.015l-2.853 1.714a.333.333 0 0 0 0 .572L5.015 16h12.98z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamDirectionsF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 1a1 1 0 1 1 2 0h4.98a2 2 0 0 1 1.03.286L18.863 3a2.333 2.333 0 0 1 0 4L16.01 8.714A2 2 0 0 1 14.98 9H10v1h7.995a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H10v1a1 1 0 0 1-2 0v-1H5.015a2 2 0 0 1-1.03-.286L1.132 16a2.333 2.333 0 0 1 0-4l2.853-1.714A2 2 0 0 1 5.015 10H8V9H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamDisc: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m7-8a6.99 6.99 0 0 1-2.89 5.666l-.53-.796L13 14a5 5 0 0 0 2-4a5 5 0 0 0-2-4l1.2-1.6A6.99 6.99 0 0 1 17 10m-7 3a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0-2a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamDiscF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m7-10a6.99 6.99 0 0 0-2.8-5.6L13 6a4.99 4.99 0 0 1 2 4a5 5 0 0 1-2 4l.58.87l.53.796A6.99 6.99 0 0 0 17 10m-7 3a3 3 0 1 0 0-6a3 3 0 0 0 0 6\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamDiscord: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15.45 0c1.118 0 2.031.901 2.05 2.025V20l-2.15-1.9l-1.21-1.12l-1.28-1.19l.53 1.85H2.05A2.055 2.055 0 0 1 0 15.615V2.06C0 .932.901.019 2.015 0zM7.32 4.78l-.1-.12h-.057c-.273.009-1.486.1-2.753 1.05l-.048.092c-.251.49-1.392 2.872-1.392 5.738l.02.033c.142.217 1.019 1.423 3.03 1.487l.295-.361l.375-.469c-1.166-.349-1.666-1.051-1.74-1.164l-.01-.016l.041.027q.07.047.239.143c.01.01.02.02.04.03c.03.02.06.03.09.05c.25.14.5.25.73.34c.41.16.9.32 1.47.43c.729.136 1.58.187 2.508.025l.082-.015c.47-.08.95-.22 1.45-.43c.35-.13.74-.32 1.15-.59l-.016.025c-.096.14-.62.833-1.794 1.165l.165.207c.253.314.495.603.495.603c2.21-.07 3.06-1.52 3.06-1.52c0-3.22-1.44-5.83-1.44-5.83c-1.238-.929-2.425-1.037-2.733-1.049L10.4 4.66l-.14.16c1.508.461 2.3 1.103 2.46 1.243l.03.027a8.15 8.15 0 0 0-5.03-.94c-.06 0-.11.01-.17.02l-.056.005c-.38.039-1.197.179-2.214.625l-.145.068c-.182.086-.314.153-.385.19l-.06.032s.813-.774 2.576-1.294zm-.38 3.61c.57 0 1.03.5 1.02 1.11c0 .61-.45 1.11-1.02 1.11c-.56 0-1.02-.5-1.02-1.11s.45-1.11 1.02-1.11m3.65 0c.57 0 1.02.5 1.02 1.11s-.45 1.11-1.02 1.11c-.56 0-1.02-.5-1.02-1.11s.45-1.11 1.02-1.11\"/>",
  "width": 18,
  "height": 20,
  "viewBox": "0 0 18 20"
}

export const jamDisqus: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10.365 18.75a9.76 9.76 0 0 1-6.23-2.224L0 17.067l1.595-3.805a9.1 9.1 0 0 1-.866-3.887C.729 4.196 5.045 0 10.364 0C15.69 0 20 4.196 20 9.375s-4.31 9.375-9.635 9.375m.061-14.375H6.875v10h3.501c3.313 0 5.249-2.144 5.249-5.027V9.32c0-2.882-1.911-4.946-5.199-4.946z\"/><path d=\"M13.004 9.381c0 1.62-1.013 2.534-2.54 2.534H9.426V6.828h1.038c1.527 0 2.54.927 2.54 2.527z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2.5 24 24"
}

export const jamDisqusCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M10.172 14.665a4.88 4.88 0 0 1-3.116-1.113l-2.068.271l.797-1.903a4.5 4.5 0 0 1-.433-1.944c0-2.59 2.159-4.689 4.819-4.689c2.664 0 4.82 2.099 4.82 4.689s-2.156 4.689-4.82 4.689zm.03-7.19H8.426v5.001h1.751c1.657 0 2.625-1.072 2.625-2.514v-.013c0-1.442-.956-2.474-2.6-2.474\"/><path d=\"M11.491 9.979c0 .81-.506 1.267-1.27 1.267h-.519V8.702h.519c.764 0 1.27.464 1.27 1.264z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamDisqusSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10.172 14.665a4.88 4.88 0 0 1-3.116-1.113l-2.068.271l.797-1.903a4.5 4.5 0 0 1-.433-1.944c0-2.59 2.159-4.689 4.819-4.689c2.664 0 4.82 2.099 4.82 4.689s-2.156 4.689-4.82 4.689zm.03-7.19H8.426v5.001h1.751c1.657 0 2.625-1.072 2.625-2.514v-.013c0-1.442-.956-2.474-2.6-2.474\"/><path d=\"M11.491 9.979c0 .81-.506 1.267-1.27 1.267h-.519V8.702h.519c.764 0 1.27.464 1.27 1.264z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamDj: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h8a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm4 15A5 5 0 1 1 8 7a5 5 0 0 1 0 10m0-2a3 3 0 1 0 0-6a3 3 0 0 0 0 6M4 3h4a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m7 0h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1M8 13a1 1 0 1 1 0-2a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamDjF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h8a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m4 17A5 5 0 1 0 8 7a5 5 0 0 0 0 10M4 3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm7 0a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM8 15a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0-2a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamDna: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 17h8v-2H2zm.535-4h6.93A4 4 0 0 0 6 11c-1.48 0-2.773.804-3.465 2M10 5V3H2v2zm-.535 2h-6.93A4 4 0 0 0 6 9c1.48 0 2.773-.804 3.465-2m-.147 3A6 6 0 0 1 12 15v4a1 1 0 0 1-2 0H2a1 1 0 0 1-2 0v-4a6 6 0 0 1 2.682-5A6 6 0 0 1 0 5V1a1 1 0 1 1 2 0h8a1 1 0 0 1 2 0v4a6 6 0 0 1-2.682 5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -2 24 24"
}

export const jamDocument: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h10a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm2 1h6a1 1 0 0 1 0 2H5a1 1 0 1 1 0-2m0 12h2a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2m0-4h6a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2m0-4h6a1 1 0 0 1 0 2H5a1 1 0 1 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamDocumentF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h10a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 7a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 8a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2zM4 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamDoor: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 0h8a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m0 2v16h8V2zm2 7h1a1 1 0 1 1 0 2H4a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -2 24 24"
}

export const jamDownload: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m8 6.641l1.121-1.12a1 1 0 0 1 1.415 1.413L7.707 9.763a.997.997 0 0 1-1.414 0L3.464 6.934A1 1 0 1 1 4.88 5.52L6 6.641V1a1 1 0 1 1 2 0zM1 12h12a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -5 24 24"
}

export const jamDribbble: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10c5.51 0 10-4.48 10-10S15.51 0 10 0m6.605 4.61a8.5 8.5 0 0 1 1.93 5.314c-.281-.054-3.101-.629-5.943-.271c-.065-.141-.12-.293-.184-.445a25 25 0 0 0-.564-1.236c3.145-1.28 4.577-3.124 4.761-3.362M10 1.475c2.17 0 4.154.813 5.662 2.148c-.152.216-1.443 1.941-4.48 3.08c-1.399-2.57-2.95-4.675-3.189-5A8.7 8.7 0 0 1 10 1.475m-3.633.803a54 54 0 0 1 3.167 4.935c-3.992 1.062-7.517 1.04-7.896 1.04a8.58 8.58 0 0 1 4.729-5.975M1.453 10.01v-.26c.37.01 4.512.065 8.775-1.215c.25.477.477.965.694 1.453c-.109.033-.228.065-.336.098c-4.404 1.42-6.747 5.303-6.942 5.629a8.52 8.52 0 0 1-2.19-5.705ZM10 18.547a8.48 8.48 0 0 1-5.239-1.8c.152-.315 1.888-3.656 6.703-5.337c.022-.01.033-.01.054-.022a35.3 35.3 0 0 1 1.823 6.475a8.4 8.4 0 0 1-3.341.684m4.761-1.465c-.086-.52-.542-3.015-1.659-6.084c2.679-.423 5.022.271 5.314.369a8.47 8.47 0 0 1-3.655 5.715\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const jamDrupal: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.134 3.711c-1.022-.635-1.989-.884-2.953-1.52C9.583 1.788 8.754.827 8.058 0c-.134 1.327-.54 1.866-1.003 2.251c-.982.768-1.6.998-2.45 1.46c-.714.366-4.592 2.673-4.592 7.634S4.201 19.96 8.85 19.96c4.65 0 8.683-3.365 8.683-8.46s-3.782-7.403-4.4-7.788zm.078 14.308c-.097.096-.984.711-2.026.808c-1.042.096-2.45.153-3.299-.616c-.135-.135-.097-.326 0-.402c.096-.079.173-.136.29-.136s.095 0 .154.038c.386.308.964.557 2.198.557c1.236 0 2.105-.344 2.49-.634c.174-.134.25-.019.27.058s.058.193-.077.327m-3.344-1.618c.213-.193.56-.501.89-.635c.327-.135.499-.116.809-.116c.308 0 .637.02.868.174s.367.5.442.69c.078.194 0 .309-.153.386c-.134.076-.154.038-.289-.211c-.134-.25-.25-.5-.926-.5c-.675 0-.887.23-1.215.5c-.328.269-.444.365-.56.211c-.116-.153-.077-.308.134-.5zm6.964-3.666c0 .596-.192 1.672-.656 2.345c-.462.674-.75.925-1.293.886c-.695-.059-2.084-2.212-2.971-2.252c-1.118-.037-3.55 2.33-5.46 2.33c-1.159 0-1.505-.174-1.89-.425c-.58-.404-.87-1.019-.85-1.865c.02-1.5 1.427-2.903 3.203-2.922c2.256-.02 3.821 2.229 4.958 2.21c.965-.017 2.818-1.903 3.725-1.903c.964 0 1.234.998 1.234 1.596\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2 24 24"
}

export const jamDrupalCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M12.194 6.827c-.512-.318-.996-.443-1.48-.762c-.299-.202-.714-.683-1.063-1.098c-.067.665-.27.936-.503 1.128c-.492.385-.801.5-1.227.732c-.358.183-2.3 1.339-2.3 3.825c0 2.485 2.097 4.315 4.426 4.315s4.351-1.685 4.351-4.238s-1.895-3.71-2.204-3.902m.04 7.169a2.1 2.1 0 0 1-1.016.404c-.522.048-1.228.077-1.653-.308c-.067-.068-.049-.163 0-.202c.048-.04.087-.068.145-.068c.059 0 .048 0 .078.02c.193.154.483.278 1.101.278c.619 0 1.054-.172 1.247-.317c.087-.068.126-.01.136.029c.01.038.029.096-.039.164zm-1.676-.811c.106-.097.28-.251.445-.318c.164-.068.25-.058.406-.058c.154 0 .32.01.435.087c.116.077.184.25.221.346c.04.097 0 .154-.076.193c-.067.038-.077.02-.145-.106c-.067-.125-.126-.25-.464-.25s-.445.115-.609.25s-.222.183-.28.106s-.04-.154.067-.25m3.489-1.837c0 .299-.096.838-.329 1.175c-.231.338-.376.463-.648.444c-.348-.03-1.044-1.108-1.488-1.128c-.56-.02-1.779 1.167-2.736 1.167c-.58 0-.754-.087-.947-.213c-.29-.202-.435-.51-.426-.934c.01-.752.715-1.455 1.605-1.464c1.13-.01 1.915 1.116 2.484 1.107c.484-.009 1.412-.954 1.867-.954c.483 0 .618.5.618.8\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamDrupalSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M12.194 6.827c-.512-.318-.996-.443-1.48-.762c-.299-.202-.714-.683-1.063-1.098c-.067.665-.27.936-.503 1.128c-.492.385-.801.5-1.227.732c-.358.183-2.3 1.339-2.3 3.825c0 2.485 2.097 4.315 4.426 4.315s4.351-1.685 4.351-4.238s-1.895-3.71-2.204-3.902m.04 7.169a2.1 2.1 0 0 1-1.016.404c-.522.048-1.228.077-1.653-.308c-.067-.068-.049-.163 0-.202c.048-.04.087-.068.145-.068c.059 0 .048 0 .078.02c.193.154.483.278 1.101.278c.619 0 1.054-.172 1.247-.317c.087-.068.126-.01.136.029c.01.038.029.096-.039.164zm-1.676-.811c.106-.097.28-.251.445-.318c.164-.068.25-.058.406-.058c.154 0 .32.01.435.087c.116.077.184.25.221.346c.04.097 0 .154-.076.193c-.067.038-.077.02-.145-.106c-.067-.125-.126-.25-.464-.25s-.445.115-.609.25s-.222.183-.28.106s-.04-.154.067-.25m3.489-1.837c0 .299-.096.838-.329 1.175c-.231.338-.376.463-.648.444c-.348-.03-1.044-1.108-1.488-1.128c-.56-.02-1.779 1.167-2.736 1.167c-.58 0-.754-.087-.947-.213c-.29-.202-.435-.51-.426-.934c.01-.752.715-1.455 1.605-1.464c1.13-.01 1.915 1.116 2.484 1.107c.484-.009 1.412-.954 1.867-.954c.483 0 .618.5.618.8\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamEbay: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18.853 2.229L17.16 5.81l-1.7-3.583h-1.183l.303.598c-.4-.63-1.191-.79-1.914-.79c-2.115 0-2.25 1.22-2.25 1.414h1.052s.055-.712 1.125-.712c.695 0 1.233.335 1.233.979v.23h-1.233c-1.368 0-2.196.351-2.433 1.063q.037-.237.037-.491c0-1.369-.876-2.469-2.356-2.469c-1.386 0-1.817.788-1.817.788V.202H5.007v4.011c-.015-.871-.552-2.177-2.43-2.177C1.17 2.037 0 2.664 0 4.559c0 1.5.788 2.445 2.613 2.445c2.148 0 2.286-1.49 2.286-1.49H3.86s-.224.802-1.31.802c-.884 0-1.52-.629-1.52-1.51h3.979v1.246c0 .332-.023.799-.023.799h.993s.036-.335.036-.641c0 0 .49.808 1.824.808c1.138 0 1.98-.673 2.259-1.71q-.008.081-.009.168c0 1.007.8 1.555 1.882 1.555c1.474 0 1.949-.857 1.949-.857c0 .341.025.677.025.677h.935s-.036-.417-.036-.683V3.866c0-.309-.048-.566-.135-.782l1.897 3.746l-.892 1.779h1.125l3.088-6.38h-1.073zM1.053 4.1c0-.864.749-1.356 1.487-1.356c.842 0 1.416.543 1.416 1.356zM7.59 6.295c-1.018 0-1.567-.837-1.567-1.764c0-.864.492-1.755 1.56-1.755c.954 0 1.56.745 1.56 1.745c0 1.072-.7 1.774-1.553 1.774m6.235-1.354c0 .4-.234 1.39-1.61 1.39c-.752 0-1.076-.396-1.076-.855c0-.835 1.088-.84 2.686-.84z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -7.5 24 24"
}

export const jamEgg: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 18a6 6 0 0 0 6-6c0-4.221-3.418-10-6-10S2 7.779 2 12a6 6 0 0 0 6 6m0 2a8 8 0 0 1-8-8C0 7.582 3.582 0 8 0s8 7.582 8 12a8 8 0 0 1-8 8\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamEggF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 20.565a8 8 0 0 1-8-8c0-4.418 3.582-12 8-12s8 7.582 8 12a8 8 0 0 1-8 8\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -1.5 24 24"
}

export const jamEggs: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11.843 12.37A4 4 0 0 0 18 9c0-1.238-.623-3.136-1.58-4.698C15.513 2.822 14.524 2 14 2s-1.513.822-2.42 2.302a12 12 0 0 0-.935 1.884a12.6 12.6 0 0 0-1.277-2.024C10.522 1.91 12.26 0 14 0c3 0 6 5.686 6 9a6 6 0 0 1-8.943 5.23c.36-.563.63-1.19.786-1.86M6 17a6 6 0 0 1-6-6c0-3.314 3-9 6-9s6 5.686 6 9a6 6 0 0 1-6 6m0-2a4 4 0 0 0 4-4c0-1.238-.623-3.136-1.58-4.698C7.513 4.822 6.524 4 6 4s-1.513.822-2.42 2.302C2.623 7.864 2 9.762 2 11a4 4 0 0 0 4 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3.5 24 24"
}

export const jamEggsF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 17a6 6 0 0 1-6-6c0-3.314 3-9 6-9s6 5.686 6 9a6 6 0 0 1-6 6m6.612-2.161A5.98 5.98 0 0 0 14 11c0-2.518-1.732-6.405-3.88-8.127C11.213 1.227 12.607 0 14 0c3 0 6 5.686 6 9a6 6 0 0 1-7.388 5.839\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3.5 24 24"
}

export const jamEject: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17.31 6.51c.843.728.925 1.988.182 2.814a2.05 2.05 0 0 1-1.526.676H2.034C.911 10 0 9.107 0 8.006c0-.573.251-1.118.69-1.496L7.656.498a2.065 2.065 0 0 1 2.688 0zM2.034 8.006h13.932L9 1.994zM18 14v2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2m-2 0H2v2h14z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -3 24 24"
}

export const jamEjectCircle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m1.746-12.587l2.898 4.055c.646.905.389 2.13-.576 2.737a2.2 2.2 0 0 1-1.17.334H7.102c-1.16 0-2.102-.883-2.102-1.972c0-.391.124-.774.356-1.099l2.898-4.055c.647-.905 1.952-1.146 2.917-.54c.227.143.422.327.575.54m-4.644 5.154h5.796L10 6.512zM6 13.539h8a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamEjectCircleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m1.746-14.587a2 2 0 0 0-.575-.54c-.965-.606-2.27-.365-2.917.54L5.356 9.468A1.9 1.9 0 0 0 5 10.567c0 1.089.941 1.972 2.102 1.972h5.796c.417 0 .824-.116 1.17-.334c.965-.607 1.222-1.832.576-2.737zM6 13.54a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2zm1.102-2.972L10 6.512l2.898 4.055z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamEjectSquare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm7.746 3.413l2.898 4.055c.646.905.389 2.13-.576 2.737a2.2 2.2 0 0 1-1.17.334H7.102c-1.16 0-2.102-.883-2.102-1.972c0-.391.124-.774.356-1.099l2.898-4.055c.647-.905 1.952-1.146 2.917-.54c.227.143.422.327.575.54m-4.644 5.154h5.796L10 6.512zM6 13.539h8a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamEjectSquareF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m7.746 5.413a2 2 0 0 0-.575-.54c-.965-.606-2.27-.365-2.917.54L5.356 9.468A1.9 1.9 0 0 0 5 10.567c0 1.089.941 1.972 2.102 1.972h5.796c.417 0 .824-.116 1.17-.334c.965-.607 1.222-1.832.576-2.737zM6 13.54a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2zm1.102-2.972L10 6.512l2.898 4.055z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamEnvelope: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m3.598 2l5.747 5.12a1 1 0 0 0 1.33 0L16.423 2zM18 3.273l-5.994 5.341a3 3 0 0 1-3.992 0L2 3.254V12h16zM2 0h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -5 24 24"
}

export const jamEnvelopeF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18.572.083L10.676 7.12a1 1 0 0 1-1.331 0L1.416.087A2 2 0 0 1 2 0h16a2 2 0 0 1 .572.083m1.356 1.385q.071.255.072.532v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 .072-.534l7.942 7.148a3 3 0 0 0 3.992 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -5 24 24"
}

export const jamEnvelopeOpen: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m2.328 6.868l7.017 6.253a1 1 0 0 0 1.33 0l7.009-6.246l-7.137-4.665a1 1 0 0 0-1.094 0zM18 7.082v2.19l-5.994 5.342a3 3 0 0 1-3.992 0L2 9.254V7.083V18h16zM.906 5.408L8.359.536a3 3 0 0 1 3.282 0l7.453 4.872A2 2 0 0 1 20 7.082V18a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7.082a2 2 0 0 1 .906-1.674\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamEnvelopeOpenF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m19.25 5.52l-8.574 7.6a1 1 0 0 1-1.331 0L.703 5.56q.095-.082.203-.152L8.359.536a3 3 0 0 1 3.282 0l7.453 4.872q.081.053.156.113zM20 7.69V18a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7.698l8.014 6.916a3 3 0 0 0 3.992 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamExtinguisher: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.45 4.145A2 2 0 0 1 6.067 4H4a2 2 0 0 0-2 2v3a1 1 0 1 1-2 0V6a4 4 0 0 1 4-4h2.077a2 2 0 0 1 3.381-.117A1 1 0 0 1 11.45 2h1.311L18.722.036l.003.002a1 1 0 0 1 1.273.906L20 .945v3.992l-.002.001L20 5a1 1 0 0 1-1.275.962l-.003.002L12.892 4H11.45v1.009q0 .045-.004.09A4.5 4.5 0 0 1 15 9.5V17a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V9.5a4.5 4.5 0 0 1 3.457-4.378a1 1 0 0 1-.007-.113zm8.597-.471V2.436l-1.866.597zM10.5 7A2.5 2.5 0 0 0 8 9.5V17a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V9.5A2.5 2.5 0 0 0 10.5 7\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamExtinguisherF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.45 4.145A2 2 0 0 1 6.067 4H4a2 2 0 0 0-2 2v3a1 1 0 1 1-2 0V6a4 4 0 0 1 4-4h2.077a2 2 0 0 1 3.381-.117A1 1 0 0 1 11.45 2h1.311L18.722.036l.003.002a1 1 0 0 1 1.273.906L20 .945v3.992l-.002.001L20 5a1 1 0 0 1-1.275.962l-.003.002L12.892 4H11.45v1.009q0 .045-.004.09A4.5 4.5 0 0 1 15 9.5V17a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V9.5a4.5 4.5 0 0 1 3.457-4.378a1 1 0 0 1-.007-.113z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamEye: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 6c0-1.81-3.76-3.985-8.007-4C5.775 1.985 2 4.178 2 6c0 1.825 3.754 4.006 7.997 4C14.252 9.994 18 7.82 18 6m-8 6c-5.042.007-10-2.686-10-6S4.984-.017 10 0s10 2.686 10 6s-4.958 5.993-10 6m0-2a4 4 0 1 1 0-8a4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6 24 24"
}

export const jamEyeClose: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m15.398 7.23l1.472-1.472C18.749 6.842 20 8.34 20 10c0 3.314-4.958 5.993-10 6a14.7 14.7 0 0 1-3.053-.32l1.747-1.746q.64.067 1.303.066h.002c-.415 0-.815-.063-1.191-.18l1.981-1.982c.47-.202.847-.579 1.05-1.049l1.98-1.981A4 4 0 0 1 10.022 14C14.267 13.985 18 11.816 18 10c0-.943-1.022-1.986-2.602-2.77m-9.302 3.645A4 4 0 0 1 9.993 6C5.775 5.985 2 8.178 2 10c0 .896.904 1.877 2.327 2.644L2.869 14.1C1.134 13.028 0 11.585 0 10c0-3.314 4.984-6.017 10-6c.914.003 1.827.094 2.709.262l-1.777 1.776q-.435-.033-.88-.038q.424.007.823.096l-4.78 4.779zM19.092.707a1 1 0 0 1 0 1.414l-16.97 16.97a1 1 0 1 1-1.415-1.413L17.677.708a1 1 0 0 1 1.415 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamEyeCloseF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.329 11.885L2.12 19.092a1 1 0 1 1-1.414-1.414l7.324-7.324a2 2 0 0 1 2.322-2.322L17.679.706a1 1 0 0 1 1.414 1.414l-7.208 7.21a2 2 0 0 1-2.556 2.556zm7.54-6.127C18.75 6.842 20 8.34 20 10c0 3.314-4.958 5.993-10 6a14.7 14.7 0 0 1-3.053-.32l1.861-1.86a4 4 0 0 0 5.011-5.011zm-4.16-1.496l-1.834 1.834a4 4 0 0 0-4.779 4.779L2.869 14.1C1.134 13.028 0 11.585 0 10c0-3.314 4.984-6.017 10-6c.914.003 1.827.094 2.709.262\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamEyeF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 12c-5.042.007-10-2.686-10-6S4.984-.017 10 0s10 2.686 10 6s-4.958 5.993-10 6m0-2a4 4 0 1 0 0-8a4 4 0 0 0 0 8m0-2a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6 24 24"
}

export const jamEyedropper: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6.502 12.348h2.829l2.707-2.578l-1.414-1.347zm-1.987 1.905a4.7 4.7 0 0 0-1.002 1.653l-.334.954l1.002-.318a5.05 5.05 0 0 0 1.954-1.15l1.196-1.14H4.515zM14.866 9.77a.92.92 0 0 1 0 1.347a1.036 1.036 0 0 1-1.414 0L7.55 16.738a7.1 7.1 0 0 1-2.737 1.61l-2.899.921c-.523.166-1.09-.103-1.264-.602a.9.9 0 0 1 0-.603l.966-2.76a6.6 6.6 0 0 1 1.69-2.606L9.21 7.076a.92.92 0 0 1 0-1.347a1.036 1.036 0 0 1 1.414 0l4.242-4.04c1.172-1.116 3.071-1.116 4.243 0a2.76 2.76 0 0 1 0 4.04l-4.243 4.04zm-2.828-2.694l1.414 1.347l4.243-4.04a.92.92 0 0 0 0-1.347a1.036 1.036 0 0 0-1.414 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamEyedropperF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m13.473 11.693l-1.36 1.36l-8.417-.068L9.23 7.451a1 1 0 1 1 1.415-1.414l4.242-4.243a3 3 0 1 1 4.243 4.243l-4.243 4.242a1 1 0 0 1-1.414 1.414m-3.191 3.192L7.57 17.596a7 7 0 0 1-2.736 1.691l-2.899.966A1 1 0 0 1 .67 18.988l.967-2.899a7 7 0 0 1 .522-1.186z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1.5 24 24"
}

export const jamFacebook: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2.046 3.865v2.748H.032v3.36h2.014v9.986H6.18V9.974h2.775s.26-1.611.386-3.373H6.197V4.303c0-.343.45-.805.896-.805h2.254V0H6.283c-4.34 0-4.237 3.363-4.237 3.865\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7 -2 24 24"
}

export const jamFacebookCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M8.695 6.937v1.377H7.687v1.683h1.008V15h2.072V9.997h1.39s.131-.807.194-1.69h-1.576v-1.15c0-.173.226-.404.45-.404h1.128V5h-1.535C8.644 5 8.695 6.685 8.695 6.937\"/><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamFacebookSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M8.695 6.937v1.377H7.687v1.683h1.008V15h2.072V9.997h1.39s.131-.807.194-1.69h-1.576v-1.15c0-.173.226-.404.45-.404h1.128V5h-1.535C8.644 5 8.695 6.685 8.695 6.937\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamFastBackward: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 5.915L10.51.69a1.966 1.966 0 0 1 2.814-.182c.43.386.676.942.676 1.526v3.88L18.51.69a1.966 1.966 0 0 1 2.814-.182c.43.386.676.942.676 1.526v13.932C22 17.089 21.107 18 20.006 18a1.98 1.98 0 0 1-1.496-.69L14 12.085v3.88C14 17.09 13.107 18 12.006 18a1.98 1.98 0 0 1-1.496-.69L6 12.085V16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm0 3.092l6.006 6.959V2.034L6 8.993zm8 0l6.006 6.959V2.034L14 8.993zM2 2v14h2V2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1 -3 24 24"
}

export const jamFastBackwardCircle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-3.92-6.4V14a1 1 0 0 1-2 0V6a1 1 0 1 1 2 0v2.509l2.516-2.842c.377-.426.9-.667 1.447-.667c.866 0 1.604.594 1.882 1.425l.671-.758c.377-.426.9-.667 1.447-.667c1.104 0 2 .965 2 2.156v5.688c0 .575-.213 1.125-.591 1.53a1.9 1.9 0 0 1-2.829-.011l-.706-.767c-.1.29-.258.556-.465.778a1.9 1.9 0 0 1-2.829-.011zm7.963 1.244V7.156L11.906 9.57l-.004.948zm-4 0V7.156l-2.567 2.9z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamFastBackwardCircleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m6.08 11.6l2.543 2.763a1.9 1.9 0 0 0 2.829.011c.207-.222.365-.488.465-.778l.706.767a1.9 1.9 0 0 0 2.829.011c.378-.405.59-.955.59-1.53V7.156c0-1.19-.895-2.156-2-2.156c-.546 0-1.069.241-1.446.667l-.671.758C11.647 5.595 10.909 5 10.043 5c-.547 0-1.07.241-1.447.667L6.08 8.51V6a1 1 0 1 0-2 0v8a1 1 0 0 0 2 0zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m4.043-7.156l-2.141-2.326l.004-.948l2.137-2.414zm-4 0l-2.567-2.788l2.567-2.9z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamFastBackwardSquare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm2.08 9.6V14a1 1 0 0 1-2 0V6a1 1 0 1 1 2 0v2.509l2.516-2.842c.377-.426.9-.667 1.447-.667c.866 0 1.604.594 1.882 1.425l.671-.758c.377-.426.9-.667 1.447-.667c1.104 0 2 .965 2 2.156v5.688c0 .575-.213 1.125-.591 1.53a1.9 1.9 0 0 1-2.829-.011l-.706-.767c-.1.29-.258.556-.465.778a1.9 1.9 0 0 1-2.829-.011zm7.963 1.244V7.156L11.906 9.57l-.004.948zm-4 0V7.156l-2.567 2.9z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamFastBackwardSquareF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m6.08 11.6l2.543 2.763a1.9 1.9 0 0 0 2.829.011c.207-.222.365-.488.465-.778l.706.767a1.9 1.9 0 0 0 2.829.011c.378-.405.59-.955.59-1.53V7.156c0-1.19-.895-2.156-2-2.156c-.546 0-1.069.241-1.446.667l-.671.758C11.647 5.595 10.909 5 10.043 5c-.547 0-1.07.241-1.447.667L6.08 8.51V6a1 1 0 1 0-2 0v8a1 1 0 0 0 2 0zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m10.043 12.844l-2.141-2.326l.004-.948l2.137-2.414zm-4 0l-2.567-2.788l2.567-2.9z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamFastForward: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m16 12.085l-4.51 5.225a1.966 1.966 0 0 1-2.814.182A2.05 2.05 0 0 1 8 15.966v-3.88L3.49 17.31a1.966 1.966 0 0 1-2.814.182A2.05 2.05 0 0 1 0 15.966V2.034C0 .911.893 0 1.994 0c.573 0 1.118.251 1.496.69L8 5.915v-3.88C8 .91 8.893 0 9.994 0c.573 0 1.118.251 1.496.69L16 5.915V2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm0-3.078v-.014L9.994 2.034V8.84q.012.161 0 .322v6.805zM1.994 2.034v13.932L8.006 9zM18 2v14h2V2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1 -3 24 24"
}

export const jamFastForwardCircle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m4.043-6.4L11.5 14.364a1.9 1.9 0 0 1-2.829.011a2.2 2.2 0 0 1-.465-.778l-.706.767a1.9 1.9 0 0 1-2.829.011a2.24 2.24 0 0 1-.59-1.53V7.156c0-1.19.895-2.156 2-2.156c.546 0 1.068.241 1.446.667l.67.758C8.477 5.595 9.214 5 10.08 5c.547 0 1.07.241 1.447.667l2.516 2.842V6a1 1 0 0 1 2 0v8a1 1 0 1 1-2 0zM6.08 12.845l2.141-2.326l-.004-.948L6.08 7.156v5.688zm4 0l2.567-2.788l-2.567-2.9z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamFastForwardCircleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m14.043 8.509l-2.516-2.842A1.93 1.93 0 0 0 10.08 5c-.867 0-1.604.594-1.882 1.425l-.671-.758A1.93 1.93 0 0 0 6.08 5c-1.104 0-2 .965-2 2.156v5.688c0 .575.213 1.125.591 1.53a1.9 1.9 0 0 0 2.829-.011l.706-.767c.1.29.258.556.465.778a1.9 1.9 0 0 0 2.829-.011l2.543-2.762V14a1 1 0 0 0 2 0V6a1 1 0 1 0-2 0zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m-4.268-7.13V7.181l2.137 2.413l.004.949l-2.141 2.325zm4.426 0V7.181l2.567 2.899l-2.567 2.788z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamFastForwardSquare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm10.043 9.6L11.5 14.364a1.9 1.9 0 0 1-2.829.011a2.2 2.2 0 0 1-.465-.778l-.706.767a1.9 1.9 0 0 1-2.829.011a2.24 2.24 0 0 1-.59-1.53V7.156c0-1.19.895-2.156 2-2.156c.546 0 1.068.241 1.446.667l.67.758C8.477 5.595 9.214 5 10.08 5c.547 0 1.07.241 1.447.667l2.516 2.842V6a1 1 0 0 1 2 0v8a1 1 0 1 1-2 0zM6.08 12.845l2.141-2.326l-.004-.948L6.08 7.156v5.688zm4 0l2.567-2.788l-2.567-2.9z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamFastForwardSquareF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m14.043 8.509l-2.516-2.842A1.93 1.93 0 0 0 10.08 5c-.867 0-1.604.594-1.882 1.425l-.671-.758A1.93 1.93 0 0 0 6.08 5c-1.104 0-2 .965-2 2.156v5.688c0 .575.213 1.125.591 1.53a1.9 1.9 0 0 0 2.829-.011l.706-.767c.1.29.258.556.465.778a1.9 1.9 0 0 0 2.829-.011l2.543-2.762V14a1 1 0 0 0 2 0V6a1 1 0 1 0-2 0zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m1.973 12.93V7.242L8.11 9.656l.004.948zm4.03-.055V7.187l2.567 2.9z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamFeather: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m13.89 10.808l3.616-3.616a3 3 0 0 0-4.243-4.242L11.77 4.444l.598 2.23l.896-.896a1 1 0 1 1 1.415 1.414L11.66 10.21zm-1.633 1.633l-2.23-.598l-2.74 2.74l2.66.169zm-2.12-6.364L5.71 10.502l.163 2.665l4.86-4.86l-.598-2.23zM5.403 16.466L1.95 19.92a1 1 0 0 1-1.414-1.414l3.45-3.45l-.326-5.331l8.19-8.19a5 5 0 1 1 7.07 7.072l-8.198 8.198l-5.318-.34z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1.5 -1.5 24 24"
}

export const jamFeatherF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m16.393 12.029l-4.461-1.196l3.018-3.018a1 1 0 1 0-1.414-1.414l-.897.897l-1.195-4.462l.677-.677a5 5 0 0 1 7.071 7.07zm-1.633 1.633l-3.766 3.766l-5.318-.339l4.623-4.623zM4.343 15.594l1.414 1.414l-3.535 3.535A1 1 0 1 1 .808 19.13l3.45-3.45l-.326-5.331L9.811 4.47l1.195 4.462z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1.5 -1.5 24 24"
}

export const jamFemale: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 12A5 5 0 1 0 7 2a5 5 0 0 0 0 10m1 4h1a1 1 0 0 1 0 2H8v1a1 1 0 0 1-2 0v-1H5a1 1 0 0 1 0-2h1v-2q0-.036.002-.07A7.002 7.002 0 0 1 7 0a7 7 0 0 1 .998 13.93L8 14z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamFile: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.298 2H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V4.961zM3 0h8l5 4v13a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamFileF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h8l5 4v13a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamFiles: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 15H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v3h3l3 3v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2zm0-2V7a2 2 0 0 1 2-2h2V2H2v11zm8.172-6H8v11h8V8.828z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2 24 24"
}

export const jamFilesF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 4H7a2 2 0 0 0-2 2v9H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2zM8 5h7l3 3v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2 24 24"
}

export const jamFilter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m2.08 2l6.482 8.101A2 2 0 0 1 9 11.351V18l2-1.5v-5.15a2 2 0 0 1 .438-1.249L17.92 2zm0-2h15.84a2 2 0 0 1 1.561 3.25L13 11.35v5.15a2 2 0 0 1-.8 1.6l-2 1.5A2 2 0 0 1 7 18v-6.65L.519 3.25A2 2 0 0 1 2.08 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamFilterF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1.08.858h15.84a1 1 0 0 1 .78 1.625l-6.48 8.101a1 1 0 0 0-.22.625v5.149a1 1 0 0 1-.4.8l-2 1.5a1 1 0 0 1-1.6-.8v-6.65a1 1 0 0 0-.22-.624L.3 2.483A1 1 0 0 1 1.08.858\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2.5 24 24"
}

export const jamFingerprint: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 7a1 1 0 1 1-2 0a7 7 0 1 1 14 0v2a1 1 0 0 1-2 0V7A5 5 0 1 0 2 7m3 3a1 1 0 0 1-2 0V7a4 4 0 1 1 8 0a1 1 0 0 1-2 0a2 2 0 1 0-4 0zm-2 3a1 1 0 0 1 2 0a2 2 0 1 0 4 0v-3a1 1 0 1 1 2 0v3a4 4 0 1 1-8 0m3-5a1 1 0 1 1 2 0v4a1 1 0 0 1-2 0zm-6 3a1 1 0 0 1 2 0v2a5 5 0 0 0 10 0a1 1 0 0 1 2 0a7 7 0 0 1-14 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamFirstAid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 6a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm2-2V3a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1h2a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm2 0h6V3a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1zm2 4h2v6H9zm-2 2h6v2H7z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3 24 24"
}

export const jamFirstAidF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 4.858v-1a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1h2a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3zm6 6v-2H9v2H7v2h2v2h2v-2h2v-2zm-4-6h6v-1a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2.5 24 24"
}

export const jamFish: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.366 2.085C9.773 2.973 10 3.96 10 5s-.227 2.027-.634 2.915C12.104 7.567 14 6.215 14 5s-1.896-2.567-4.634-2.915M15 2.577c1.052-1.184 2.851-2.074 5-2.42v9.685c-2.149-.345-3.948-1.235-5-2.42C13.635 8.96 11.012 10 8 10c-4.418 0-8-2.239-8-5s3.582-5 8-5c3.012 0 5.635 1.04 7 2.577M18 7V3c-1.15.23-2 1.038-2 2s.85 1.77 2 2M2 5c0 1.27 2.077 2.696 5.032 2.958A4.97 4.97 0 0 0 8 5a4.97 4.97 0 0 0-.968-2.958C4.077 2.304 2 3.73 2 5m3 1a1 1 0 1 1 0-2a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -7 24 24"
}

export const jamFiverr: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M16.25 16.25v-10h-10v-.625c0-1.034.841-1.875 1.875-1.875H10V0H8.125A5.63 5.63 0 0 0 2.5 5.625v.625H0V10h2.5v6.25H0V20h8.75v-3.75h-2.5V10h6.285v6.25H10V20h8.75v-3.75z\"/><circle cx=\"14.375\" cy=\"1.875\" r=\"1.875\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2.5 -2 24 24"
}

export const jamFiverrCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M13.427 13.148v-5h-5v-.312c0-.517.42-.938.938-.938h.937V5.023h-.937a2.816 2.816 0 0 0-2.813 2.813v.312h-1.25v1.875h1.25v3.125h-1.25v1.875h4.375v-1.875h-1.25v-3.125h3.143v3.125h-1.268v1.875h4.375v-1.875z\"/><circle cx=\"12.402\" cy=\"5.971\" r=\"1.001\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamFiverrSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M13.427 13.148v-5h-5v-.312c0-.517.42-.938.938-.938h.937V5.023h-.937a2.816 2.816 0 0 0-2.813 2.813v.312h-1.25v1.875h1.25v3.125h-1.25v1.875h4.375v-1.875h-1.25v-3.125h3.143v3.125h-1.268v1.875h4.375v-1.875z\"/><circle cx=\"12.402\" cy=\"5.971\" r=\"1.001\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamFlag: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 1h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H2v7a1 1 0 0 1-2 0V1a1 1 0 1 1 2 0m0 9h12V3H2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamFlagF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 1h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H2v7a1 1 0 0 1-2 0V1a1 1 0 1 1 2 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamFlame: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5.652 5.594q-.242.291-.424.522q-.37.473-.7.922C2.813 9.383 2 11.204 2 12.381C2 15.461 4.665 18 8 18s6-2.538 6-5.619c0-1.888-1.97-5.13-5.972-9.453c-1.192 1.307-1.988 2.2-2.376 2.666M8 20c-4.418 0-8-3.411-8-7.619q0-2.54 2.914-6.523a28 28 0 0 1 1.202-1.545Q4.952 3.311 8 0q8 8.174 8 12.381C16 16.589 12.418 20 8 20m0-3c-2.21 0-4-1.706-4-3.81Q4 11.087 8 7q4 4.087 4 6.19C12 15.294 10.21 17 8 17m-2-3.81c0 .977.874 1.81 2 1.81s2-.833 2-1.81c0-.537-.654-1.675-2-3.24c-1.346 1.565-2 2.703-2 3.24\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamFlameF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 20c-4.418 0-8-3.411-8-7.619q0-2.54 2.914-6.523a28 28 0 0 1 1.202-1.545Q4.952 3.311 8 0q8 8.174 8 12.381C16 16.589 12.418 20 8 20m0-3c2.21 0 4-1.706 4-3.81Q12 11.087 8 7q-4 4.087-4 6.19C4 15.294 5.79 17 8 17\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamFlashlightOff: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m13.31 5.825l3.865 3.865c.334-.09.642-.265.896-.518l2.121-2.122l-4.242-4.242l-2.122 2.12a2 2 0 0 0-.518.897m1.933 4.76l-2.829-2.828l-9.192 9.193a1 1 0 0 0 0 1.414l1.414 1.414a1 1 0 0 0 1.414 0l9.193-9.192zm-2.829-7.07l2.122-2.122a2 2 0 0 1 2.828 0l4.243 4.243a2 2 0 0 1 0 2.828l-2.122 2.122a4 4 0 0 1-2.578 1.164l-9.443 9.442a3 3 0 0 1-4.242 0l-1.414-1.414a3 3 0 0 1 0-4.242l9.442-9.443a4 4 0 0 1 1.164-2.578m-2.121 9.192a1 1 0 0 1 0-1.414l1.414-1.414a1 1 0 1 1 1.414 1.414l-1.414 1.414a1 1 0 0 1-1.414 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-0.5 -0.5 24 24"
}

export const jamFlashlightOffF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 6.757L14.243 11L5.05 20.192a2 2 0 0 1-2.828 0L.808 18.778a2 2 0 0 1 0-2.828zm.904-1.924a3 3 0 0 1 .695-1.09l3.35-3.35a1 1 0 0 1 1.415 0l4.243 4.243a1 1 0 0 1 0 1.414l-3.32 3.32a3 3 0 0 1-1.134.712l-5.25-5.25zm-2.318 7.581a1 1 0 0 0 1.414 0L11.414 11A1 1 0 1 0 10 9.586L8.586 11a1 1 0 0 0 0 1.414\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1.5 -1.5 24 24"
}

export const jamFlashlightOn: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m13.24 13.12l.381.02a1 1 0 0 0 .764-.29l2.121-2.122l-3.535-3.536l-2.122 2.122a1 1 0 0 0-.291.763l.021.38zm-1.684 1.143l-2.121-2.12l-7.071 7.07a1 1 0 0 0 0 1.414l.707.708a1 1 0 0 0 1.414 0zM9.435 7.9l2.121-2.12a2 2 0 0 1 2.829 0l3.535 3.535a2 2 0 0 1 0 2.828l-2.12 2.12a3 3 0 0 1-2.288.875L5.9 22.748a3 3 0 0 1-4.242 0l-.707-.706a3 3 0 0 1 0-4.243l7.611-7.611a3 3 0 0 1 .874-2.289zm8.485 0a1 1 0 0 1 0-1.414l2.122-2.121a1 1 0 1 1 1.414 1.414L19.335 7.9a1 1 0 0 1-1.415 0m1.863 1.674a1 1 0 0 1 .707-1.225l1.932-.518a1 1 0 1 1 .517 1.932l-1.931.518a1 1 0 0 1-1.225-.707m-3.984-3.795a1 1 0 0 1 0-1.414l2.121-2.121a1 1 0 0 1 1.415 1.414l-2.122 2.121a1 1 0 0 1-1.414 0m-1.673-1.862a1 1 0 0 1-.707-1.225L13.936.76a1 1 0 1 1 1.932.518l-.517 1.932a1 1 0 0 1-1.225.707\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const jamFlashlightOnF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m7.2 10.81l3.99 3.99l-6.65 6.65a1.88 1.88 0 0 1-2.66 0L.55 20.12a1.88 1.88 0 0 1 0-2.66zm.85-1.809a2.8 2.8 0 0 1 .654-1.024l3.151-3.15a.94.94 0 0 1 1.33 0l3.99 3.99a.94.94 0 0 1 0 1.33l-3.123 3.121a2.8 2.8 0 0 1-1.066.669zm8.714-1.925a.87.87 0 0 1 0-1.227l2.098-2.097a.868.868 0 0 1 1.227 1.227l-2.097 2.097a.87.87 0 0 1-1.228 0m1.573 1.394a.87.87 0 0 1 .614-1.063l1.956-.524a.868.868 0 0 1 .45 1.677l-1.957.524a.87.87 0 0 1-1.063-.614m-3.414-3.235a.87.87 0 0 1 0-1.227L17.02 1.91a.868.868 0 0 1 1.228 1.227L16.15 5.235a.87.87 0 0 1-1.228 0zM13.53 3.663a.87.87 0 0 1-.614-1.063L13.44.644a.868.868 0 0 1 1.677.449l-.524 1.956a.87.87 0 0 1-1.063.614\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1 -1 24 24"
}

export const jamFlask: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 2v5.938l-1.142.542a5 5 0 1 0 4.284 0L8 7.938V2zM4 6.674V0h6v6.674a7 7 0 1 1-6 0M3.535 11h6.93a4 4 0 1 1-6.93 0M4 0h6a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamFlickr: Icon = {
  "body": "<g fill=\"currentColor\"><circle cx=\"4.727\" cy=\"4.757\" r=\"4.727\"/><circle cx=\"15.255\" cy=\"4.757\" r=\"4.727\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -7 24 24"
}

export const jamFlickrCircle: Icon = {
  "body": "<g fill=\"currentColor\"><circle cx=\"7.364\" cy=\"10.379\" r=\"2.364\"/><circle cx=\"12.628\" cy=\"10.379\" r=\"2.364\"/><path d=\"M10 18.494a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2c-5.523 0-10-4.478-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1.5 24 24"
}

export const jamFlickrSquare: Icon = {
  "body": "<g fill=\"currentColor\"><circle cx=\"7.364\" cy=\"10.379\" r=\"2.364\"/><circle cx=\"12.628\" cy=\"10.379\" r=\"2.364\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamFlower: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7.094 11.59a6 6 0 0 1 .346-.466a3.5 3.5 0 0 1-.406-1.637A3.5 3.5 0 0 1 7.01 4.54a3.5 3.5 0 0 1 3.473-3.472A3.5 3.5 0 0 1 13 0c.943 0 1.799.373 2.428.98a3.504 3.504 0 0 1 3.521 3.5A3.57 3.57 0 0 1 20 7c0 .95-.379 1.813-.994 2.443V9.5A3.5 3.5 0 0 1 15.45 13c-.631.618-1.496 1-2.45 1c-.96 0-1.83-.387-2.463-1.013a3.5 3.5 0 0 1-1.68-.428a3.775 3.775 0 0 0 .127 4.623l1.79 2.184a1 1 0 1 1-1.547 1.268l-1.79-2.184a5.8 5.8 0 0 1-.964-1.692a3.21 3.21 0 0 1-3.404-.177q-1.452-1.018-2.48-6.547q4.713.266 6.166 1.283q.18.127.34.274zm4.265-.604l.586.58c.28.277.653.434 1.055.434c.4 0 .77-.154 1.05-.429l.596-.584l.835.013c.854 0 1.525-.671 1.525-1.5l-.013-.857l.581-.596C17.847 7.767 18 7.398 18 7c0-.41-.163-.79-.45-1.072l-.606-.593l.005-.847c0-.837-.671-1.509-1.5-1.509l-.823.005l-.585-.564A1.5 1.5 0 0 0 13 2a1.5 1.5 0 0 0-1.079.458l-.583.603l-.84.007A1.5 1.5 0 0 0 9.01 4.556l-.006.812l-.571.578C8.156 6.226 8 6.598 8 7c0 .407.16.783.443 1.065l.592.587v.834a1.5 1.5 0 0 0 1.5 1.5zM13 9a2 2 0 1 1 0-4a2 2 0 0 1 0 4m-8.783 5.942a1.213 1.213 0 0 0 1.39-1.986c-.358-.251-1.198-.491-2.47-.674c.42 1.566.826 2.483 1.08 2.66\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1.5 24 24"
}

export const jamFolder: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 4H9.415l-.471-1.334A1 1 0 0 0 8 2H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m-6.17-2H17a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h5c1.306 0 2.417.835 2.83 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamFolderF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.83 2H17a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h5c1.306 0 2.417.835 2.83 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamFolderOpen: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 5a1 1 0 0 0-1-1H9.415l-.471-1.334A1 1 0 0 0 8 2H3a1 1 0 0 0-1 1v2zm0 2H2v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1zm-7.17-5H17a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h5c1.306 0 2.417.835 2.83 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamFolderOpenF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 5V3a3 3 0 0 1 3-3h5c1.306 0 2.417.835 2.83 2H17a3 3 0 0 1 3 3zm0 2h20v6a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamFolderZip: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.83 2H17a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h5c1.306 0 2.417.835 2.83 2M17 4H9.415l-.471-1.334A1 1 0 0 0 8 2H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m-3 2h2v2h-2zm-2-2h2v2h-2zm0 4h2v2h-2zm2 2h2v2h-2zm-2 2h2v2h-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamFolderZipF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.83 2H17a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h5c1.306 0 2.417.835 2.83 2M14 6v2h2V6zm-2-2v2h2V4zm0 4v2h2V8zm2 2v2h2v-2zm-2 2v2h2v-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamFootball: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2.835 14h6.33A10.3 10.3 0 0 0 10 10c0-1.37-.302-2.741-.835-4h-6.33A10.3 10.3 0 0 0 2 10c0 1.37.302 2.741.835 4m1.106 2c.484.688 1.01 1.254 1.499 1.63c.343.265.58.37.56.37s.217-.105.56-.37c.489-.376 1.015-.942 1.499-1.63H3.94zM7 11h1a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2h1V9H4a1 1 0 1 1 0-2h4a1 1 0 1 1 0 2H7zM3.941 4H8.06c-.484-.688-1.01-1.254-1.499-1.63C6.217 2.105 5.98 2 6 2s-.217.105-.56.37c-.489.376-1.015.942-1.499 1.63M6 20c-2 0-6-4.477-6-10S4 0 6 0s6 4.477 6 10s-4 10-6 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -2 24 24"
}

export const jamFork: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 18a1 1 0 1 0 0-2a1 1 0 0 0 0 2m1.033-3.817A3.001 3.001 0 1 1 7 14.17v-1.047q0-.111.008-.221a1 1 0 0 0-.462-.637L3.46 10.42A3 3 0 0 1 2 7.845V5.829a3.001 3.001 0 1 1 2 0v2.016a1 1 0 0 0 .487.858l3.086 1.846a3 3 0 0 1 .443.324a3 3 0 0 1 .444-.324l3.086-1.846a1 1 0 0 0 .487-.858V5.841A3.001 3.001 0 0 1 13 0a3 3 0 0 1 1.033 5.817v2.028a3 3 0 0 1-1.46 2.575l-3.086 1.846a1 1 0 0 0-.462.637q.008.11.008.22zM3 4a1 1 0 1 0 0-2a1 1 0 0 0 0 2m10 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamForkF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.033 15.04A3.001 3.001 0 1 1 7 15.03v-1.047q0-.111.008-.221a1 1 0 0 0-.462-.638L3.46 11.277A3 3 0 0 1 2 8.703V6.687a3.001 3.001 0 1 1 2 0v2.016a1 1 0 0 0 .487.858l3.086 1.846a3 3 0 0 1 .443.324a3 3 0 0 1 .444-.324l3.086-1.846a1 1 0 0 0 .487-.858V6.699A3.001 3.001 0 0 1 13 .858a3 3 0 0 1 1.033 5.817v2.028a3 3 0 0 1-1.46 2.574l-3.086 1.846a1 1 0 0 0-.462.638q.008.11.008.22v1.06z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -1.5 24 24"
}

export const jamForward: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.49 17.31a1.966 1.966 0 0 1-2.814.182A2.05 2.05 0 0 1 10 15.966V2.034C10 .911 10.893 0 11.994 0c.573 0 1.118.251 1.496.69l6.012 6.966c.664.768.664 1.92 0 2.688zM11.994 2.034v13.932L18.006 9zM3.49 17.31a1.966 1.966 0 0 1-2.814.182A2.05 2.05 0 0 1 0 15.966V2.034C0 .911.893 0 1.994 0c.573 0 1.118.251 1.496.69l6.012 6.966c.664.768.664 1.92 0 2.688zM1.994 2.034v13.932L8.006 9z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3 24 24"
}

export const jamForwardCircle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-.973-4.754l-1.956 1.398c-.905.646-2.13.389-2.737-.576A2.2 2.2 0 0 1 4 12.898V7.102C4 5.942 4.883 5 5.972 5c.391 0 .774.124 1.099.356l1.956 1.398C9.182 5.76 9.994 5 10.972 5c.391 0 .774.124 1.099.356l4.055 2.898c.905.647 1.146 1.952.54 2.917a2 2 0 0 1-.54.575l-4.055 2.898c-.905.646-2.13.389-2.737-.576a2.2 2.2 0 0 1-.307-.822m1.945-6.144v5.796L15.027 10zm-5 0v5.796l3.02-2.159l.004-1.476z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamForwardCircleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.027 13.246c.046.293.15.573.307.822c.607.965 1.832 1.222 2.737.576l4.055-2.898c.213-.153.397-.348.54-.575c.606-.965.365-2.27-.54-2.917L12.07 5.356A1.9 1.9 0 0 0 10.972 5c-.978 0-1.79.759-1.945 1.754L7.07 5.356A1.9 1.9 0 0 0 5.972 5C4.883 5 4 5.941 4 7.102v5.796c0 .417.116.824.334 1.17c.607.965 1.832 1.222 2.737.576zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m.972-12.898v5.796L15.027 10zm-5 0v5.796l3.02-2.159l.004-1.476z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamForwardSquare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm5.027 11.246l-1.956 1.398c-.905.646-2.13.389-2.737-.576A2.2 2.2 0 0 1 4 12.898V7.102C4 5.942 4.883 5 5.972 5c.391 0 .774.124 1.099.356l1.956 1.398C9.182 5.76 9.994 5 10.972 5c.391 0 .774.124 1.099.356l4.055 2.898c.905.647 1.146 1.952.54 2.917a2 2 0 0 1-.54.575l-4.055 2.898c-.905.646-2.13.389-2.737-.576a2.2 2.2 0 0 1-.307-.822m1.945-6.144v5.796L15.027 10zm-5 0v5.796l3.02-2.159l.004-1.476z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamForwardSquareF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.027 13.246c.046.293.15.573.307.822c.607.965 1.832 1.222 2.737.576l4.055-2.898c.213-.153.397-.348.54-.575c.606-.965.365-2.27-.54-2.917L12.07 5.356A1.9 1.9 0 0 0 10.972 5c-.978 0-1.79.759-1.945 1.754L7.07 5.356A1.9 1.9 0 0 0 5.972 5C4.883 5 4 5.941 4 7.102v5.796c0 .417.116.824.334 1.17c.607.965 1.832 1.222 2.737.576zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m6.972 7.102L15.027 10l-4.055 2.898zm-5 0l3.024 2.161l-.003 1.476l-3.02 2.159V7.102z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamFoursquare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.467.771A2.13 2.13 0 0 0 11.833 0H2.159C.974 0 .01.987.01 2.2v16.786c0 .418.253.792.635.94a.96.96 0 0 0 1.084-.273l5.189-5.985h3.481c1.064 0 1.957-.78 2.123-1.855l1.435-9.27a2.23 2.23 0 0 0-.489-1.772zm-2.403 4.844H6.465c-.55 0-1.015.461-1.005 1.025c.01.547.446.987.983.987h4.16a.5.5 0 0 1 .485.582l-.465 3.024a.496.496 0 0 1-.487.425l-3.662-.002a.97.97 0 0 0-.735.339l-3.763 4.34V2.2c0-.104.082-.188.183-.188h9.272a.5.5 0 0 1 .488.577l-.368 2.594a.496.496 0 0 1-.487.432\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamGamepad: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 5h1a1 1 0 1 1 0 2H7v1a1 1 0 1 1-2 0V7H4a1 1 0 1 1 0-2h1V4a1 1 0 1 1 2 0zm2.318-4h5.364A6 6 0 0 1 24 6c0 3.314-2.686 10-6 10c-1.976 0-3.729-2.378-4.822-5h-2.356C9.73 13.622 7.976 16 6 16C2.686 16 0 9.314 0 6a6 6 0 0 1 9.318-5m5.968 2H8.714l-.504-.335A4 4 0 0 0 2 6c0 3.117 2.542 8 4 8c.722 0 2.004-1.438 2.976-3.77L9.49 9h5.022l.513 1.23C15.996 12.562 17.278 14 18 14c1.458 0 4-4.883 4-8a4 4 0 0 0-6.21-3.335zM18 5a1 1 0 1 1 0-2a1 1 0 0 1 0 2m-2 2a1 1 0 1 1 0-2a1 1 0 0 1 0 2m4 0a1 1 0 1 1 0-2a1 1 0 0 1 0 2m-2 2a1 1 0 1 1 0-2a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 -4 24 24"
}

export const jamGamepadF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 5V4a1 1 0 1 0-2 0v1H4a1 1 0 1 0 0 2h1v1a1 1 0 1 0 2 0V7h1a1 1 0 1 0 0-2zm2.318-4h5.364A6 6 0 0 1 24 6c0 3.314-2.686 10-6 10c-1.976 0-3.729-2.378-4.822-5h-2.356C9.73 13.622 7.976 16 6 16C2.686 16 0 9.314 0 6a6 6 0 0 1 9.318-5M18 5a1 1 0 1 0 0-2a1 1 0 0 0 0 2m-2 2a1 1 0 1 0 0-2a1 1 0 0 0 0 2m4 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2m-2 2a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 -4 24 24"
}

export const jamGamepadRetro: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 5h1a1 1 0 1 1 0 2H7v1a1 1 0 1 1-2 0V7H4a1 1 0 1 1 0-2h1V4a1 1 0 1 1 2 0zM6 0h12a6 6 0 1 1-4.472 10h-3.056A6 6 0 1 1 6 0m0 2a4 4 0 1 0 2.982 6.666L9.578 8h4.844l.596.666A4 4 0 1 0 18 2zm12 3a1 1 0 1 1 0-2a1 1 0 0 1 0 2m-2 2a1 1 0 1 1 0-2a1 1 0 0 1 0 2m4 0a1 1 0 1 1 0-2a1 1 0 0 1 0 2m-2 2a1 1 0 1 1 0-2a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 -6 24 24"
}

export const jamGamepadRetroF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 5V4a1 1 0 1 0-2 0v1H4a1 1 0 1 0 0 2h1v1a1 1 0 1 0 2 0V7h1a1 1 0 1 0 0-2zM6 0h12a6 6 0 1 1-4.472 10h-3.056A6 6 0 1 1 6 0m12 5a1 1 0 1 0 0-2a1 1 0 0 0 0 2m-2 2a1 1 0 1 0 0-2a1 1 0 0 0 0 2m4 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2m-2 2a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 -6 24 24"
}

export const jamGamma: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 0a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 2H2v10h10zm-1 1v3H9V5H6v6H4V5H3V3z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const jamGhost: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 0a8 8 0 0 1 8 8v12l-4.919-1l-3.08 1l-2.992-1L0 20V8a8 8 0 0 1 8-8m6 8A6 6 0 0 0 2 8v9.561l3.138-.626l2.871.96l2.955-.96l3.036.618zm-8.5 2a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamGhostF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 0a8 8 0 0 1 8 8v12l-4.919-1l-3.08 1l-2.992-1L0 20V8a8 8 0 0 1 8-8M5.5 10a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m5 0a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamGhostOrg: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.049 15.31H7.89v3.774H.049zm11.76 0h7.836v3.774h-7.836zM.043 7.762h19.604v3.774H.043zM.049.214h11.762v3.774H.049zm15.681 0h3.92v3.774h-3.92z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamGhostOrgCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M5.024 12.655h3.92v1.887h-3.92zm5.881 0h3.918v1.887h-3.918zM5.021 8.881h9.802v1.887H5.021zm.003-3.774h5.881v1.887H5.024zm7.841 0h1.96v1.887h-1.96z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamGhostOrgSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M5.024 12.655h3.92v1.887h-3.92zm5.881 0h3.918v1.887h-3.918zM5.021 8.881h9.802v1.887H5.021zm.003-3.774h5.881v1.887H5.024zm7.841 0h1.96v1.887h-1.96z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamGift: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 12v6h10v-6zm11.437-5.952A2 2 0 0 1 16 8v2a2 2 0 0 1-1.017 1.742Q15 11.868 15 12v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-6q0-.131.017-.258A2 2 0 0 1 0 10V8a2 2 0 0 1 1.563-1.952A4 4 0 0 1 8 1.354a4 4 0 0 1 6.437 4.694M14 8H2v2h12zM7 4a2 2 0 1 0-2 2h2zm2 2h2a2 2 0 1 0-2-2zM7 7h2v12H7z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamGiftF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 20v-8h6v6a2 2 0 0 1-2 2zM7 6v4H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h.535A4 4 0 0 1 8 1.354A4 4 0 0 1 14.465 6H15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9V6zm0 14H3a2 2 0 0 1-2-2v-6h6zM7 6V4a2 2 0 1 0-2 2zm2 0h2a2 2 0 1 0-2-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamGithub: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18.88 1.099Q17.78-.001 16.233 0H3.746Q2.198 0 1.099 1.099Q-.001 2.199 0 3.746v12.487q0 1.548 1.099 2.647q1.1 1.1 2.647 1.099H6.66q.285 0 .429-.02a.5.5 0 0 0 .286-.169q.143-.15.143-.435l-.007-.885q-.006-.846-.006-1.34l-.3.052q-.285.052-.721.046a5.6 5.6 0 0 1-.904-.091a2 2 0 0 1-.872-.39a1.65 1.65 0 0 1-.572-.8l-.13-.3a3.3 3.3 0 0 0-.41-.663q-.28-.364-.566-.494l-.09-.065a1 1 0 0 1-.17-.156a.7.7 0 0 1-.117-.182q-.039-.092.065-.15q.104-.06.378-.059l.26.04q.26.051.643.311a2.1 2.1 0 0 1 .631.677q.3.532.722.813q.423.28.852.28t.742-.065a2.6 2.6 0 0 0 .585-.196q.117-.871.637-1.34a9 9 0 0 1-1.333-.234a5.3 5.3 0 0 1-1.223-.507a3.5 3.5 0 0 1-1.047-.872q-.416-.52-.683-1.365q-.266-.846-.266-1.952q0-1.573 1.027-2.68q-.48-1.183.091-2.652q.378-.118 1.119.175t1.086.5q.345.21.553.352a9.2 9.2 0 0 1 2.497-.338q1.288 0 2.498.338l.494-.312a7 7 0 0 1 1.197-.572q.689-.26 1.054-.143q.585 1.47.103 2.653q1.028 1.105 1.028 2.68q0 1.106-.267 1.957q-.266.852-.689 1.366a3.7 3.7 0 0 1-1.053.865q-.63.351-1.223.507a9 9 0 0 1-1.333.235q.675.585.676 1.846v3.11q0 .22.065.357a.36.36 0 0 0 .208.189q.143.052.254.064q.111.014.318.013h2.914q1.548 0 2.647-1.099t1.099-2.647V3.746q0-1.548-1.1-2.647z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamGithubCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M8.18 15.008q.18 0 .271-.012a.32.32 0 0 0 .18-.107q.09-.094.09-.274l-.004-.557q-.004-.533-.004-.844l-.188.033a2.4 2.4 0 0 1-.455.028a3.5 3.5 0 0 1-.57-.057a1.3 1.3 0 0 1-.548-.246a1.04 1.04 0 0 1-.36-.503l-.082-.189a2 2 0 0 0-.258-.417a1 1 0 0 0-.357-.312l-.057-.04a.6.6 0 0 1-.106-.1a.5.5 0 0 1-.074-.114q-.024-.057.04-.094a.5.5 0 0 1 .238-.037l.164.025q.165.032.406.196q.24.164.397.426q.189.336.455.512a.96.96 0 0 0 .536.176q.27 0 .467-.04a1.6 1.6 0 0 0 .369-.124q.073-.548.4-.843a5.6 5.6 0 0 1-.839-.148a3.4 3.4 0 0 1-.77-.32a2.2 2.2 0 0 1-.66-.548q-.26-.328-.43-.86a4.1 4.1 0 0 1-.167-1.229q0-.99.647-1.687q-.303-.745.057-1.671q.239-.075.705.11q.467.184.684.316q.217.13.348.22a5.8 5.8 0 0 1 1.573-.212q.81 0 1.573.213l.31-.197q.32-.196.754-.36q.435-.165.664-.09q.37.926.065 1.67q.648.697.648 1.688q0 .696-.168 1.233t-.434.86a2.3 2.3 0 0 1-.664.545a3.3 3.3 0 0 1-.77.32a5.6 5.6 0 0 1-.84.147q.426.368.426 1.163v1.957q0 .14.041.226a.23.23 0 0 0 .131.119q.09.032.16.04t.2.009z\"/><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamGithubSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M8.18 15.008q.18 0 .271-.012a.32.32 0 0 0 .18-.107q.09-.094.09-.274l-.004-.557q-.004-.533-.004-.844l-.188.033a2.4 2.4 0 0 1-.455.028a3.5 3.5 0 0 1-.57-.057a1.3 1.3 0 0 1-.548-.246a1.04 1.04 0 0 1-.36-.503l-.082-.189a2 2 0 0 0-.258-.417a1 1 0 0 0-.357-.312l-.057-.04a.6.6 0 0 1-.106-.1a.5.5 0 0 1-.074-.114q-.024-.057.04-.094a.5.5 0 0 1 .238-.037l.164.025q.165.032.406.196q.24.164.397.426q.189.336.455.512a.96.96 0 0 0 .536.176q.27 0 .467-.04a1.6 1.6 0 0 0 .369-.124q.073-.548.4-.843a5.6 5.6 0 0 1-.839-.148a3.4 3.4 0 0 1-.77-.32a2.2 2.2 0 0 1-.66-.548q-.26-.328-.43-.86a4.1 4.1 0 0 1-.167-1.229q0-.99.647-1.687q-.303-.745.057-1.671q.239-.075.705.11q.467.184.684.316q.217.13.348.22a5.8 5.8 0 0 1 1.573-.212q.81 0 1.573.213l.31-.197q.32-.196.754-.36q.435-.165.664-.09q.37.926.065 1.67q.648.697.648 1.688q0 .696-.168 1.233t-.434.86a2.3 2.3 0 0 1-.664.545a3.3 3.3 0 0 1-.77.32a5.6 5.6 0 0 1-.84.147q.426.368.426 1.163v1.957q0 .14.041.226a.23.23 0 0 0 .131.119q.09.032.16.04t.2.009z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamGitlab: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.006 18.443L6.326 7.118h7.36zm0 0L1.168 7.118h5.158zM1.168 7.118l8.838 11.325l-9.68-7.032a.76.76 0 0 1-.276-.852zm0 0L3.385.296a.38.38 0 0 1 .724 0l2.217 6.822zm8.838 11.325l3.68-11.325h5.157zm8.837-11.325l1.119 3.441a.76.76 0 0 1-.277.852l-9.68 7.032zm0 0h-5.157L15.902.296a.38.38 0 0 1 .725 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2.5 24 24"
}

export const jamGitlabCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M10 14.616L8.159 8.95h3.682zm0 0L5.578 8.95h2.58zM5.578 8.95L10 14.616l-4.843-3.518a.38.38 0 0 1-.138-.427l.56-1.722zm0 0l1.11-3.413a.19.19 0 0 1 .362 0L8.159 8.95h-2.58zM10 14.616l1.841-5.667h2.58zm4.422-5.667l.56 1.722a.38.38 0 0 1-.14.427L10 14.616zm0 0h-2.58l1.108-3.413a.19.19 0 0 1 .363 0z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamGitlabSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 14.616L8.159 8.95h3.682zm0 0L5.578 8.95h2.58zM5.578 8.95L10 14.616l-4.843-3.518a.38.38 0 0 1-.138-.427l.56-1.722zm0 0l1.11-3.413a.19.19 0 0 1 .362 0L8.159 8.95h-2.58zM10 14.616l1.841-5.667h2.58zm4.422-5.667l.56 1.722a.38.38 0 0 1-.14.427L10 14.616zm0 0h-2.58l1.108-3.413a.19.19 0 0 1 .363 0z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamGlassEmpty: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 5a5 5 0 1 0 9-3H3c-.643.854-1 1.897-1 3m4 13v-6.07A7.002 7.002 0 0 1 2.101 0h9.798A7.002 7.002 0 0 1 8 11.93V18h2a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamGlassFilled: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2.1 4h9.8a5 5 0 0 0-.9-2H3a5 5 0 0 0-.9 2m9.8 2H2.1a5.002 5.002 0 0 0 9.8 0M6 18v-6.07A7.002 7.002 0 0 1 2.101 0h9.798A7.002 7.002 0 0 1 8 11.93V18h2a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamGlassFilledF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 18v-6.07A7.002 7.002 0 0 1 2.101 0h9.798A7.002 7.002 0 0 1 8 11.93V18h2a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zM2 5h10q-.357-2.145-1-3H3q-.643.855-1 3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamGlue: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 11a1 1 0 0 0-1 1v7h6v-7a1 1 0 0 0-1-1zm1-5V1a1 1 0 1 1 2 0v5h1a1 1 0 0 1 1 1v2.17c1.165.413 2 1.524 2 2.83v7a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-7c0-1.306.835-2.417 2-2.83V7a1 1 0 0 1 1-1zm0 2v1h2V8z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7 -1.5 24 24"
}

export const jamGlueF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 9H2V7.393a1 1 0 0 1 1-1h1v-5a1 1 0 1 1 2 0v5h1a1 1 0 0 1 1 1zm.809 1A3 3 0 0 1 10 12.393v7a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-7c0-.977.467-1.845 1.191-2.393z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7 -1 24 24"
}

export const jamGoogle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4.376 8.068A6 6 0 0 0 4.056 10c0 .734.132 1.437.376 2.086a5.946 5.946 0 0 0 8.57 3.045h.001a5.96 5.96 0 0 0 2.564-3.043H10.22V8.132h9.605a10 10 0 0 1-.044 3.956a10 10 0 0 1-3.52 5.71A9.96 9.96 0 0 1 10 20A9.998 9.998 0 0 1 1.118 5.401A10 10 0 0 1 10 0c2.426 0 4.651.864 6.383 2.302l-3.24 2.652a5.948 5.948 0 0 0-8.767 3.114\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamGoogleCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M7.188 9.034a2.97 2.97 0 0 0 .028 2.01a2.973 2.973 0 0 0 4.285 1.522a2.98 2.98 0 0 0 1.283-1.522H10.11V9.066h4.803a5 5 0 0 1-1.783 4.833A5 5 0 1 1 10 5a4.98 4.98 0 0 1 3.191 1.152l-1.62 1.326a2.974 2.974 0 0 0-4.384 1.557z\"/><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamGooglePlay: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m17.625 9.267l-3.635-2.1L11 10.061l2.733 2.644l3.892-2.25a.68.68 0 0 0 .342-.593a.68.68 0 0 0-.342-.595M13.373 6.81l-4-2.312L.607 0l9.901 9.584zM.752 19.98l8.636-4.763l3.728-2.155l-2.608-2.524zM.022.388l-.01 19.355l10.003-9.682z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2 24 24"
}

export const jamGooglePlayCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"m14.335 9.61l-1.817-1.05l-1.495 1.446l1.366 1.322l1.946-1.124a.34.34 0 0 0 .172-.297a.34.34 0 0 0-.172-.298zM12.21 8.38l-2-1.155l-4.384-2.25l4.95 4.793zM5.9 14.966l4.317-2.382l1.864-1.077l-1.304-1.263zM5.534 5.17l-.005 9.677l5.002-4.841z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamGooglePlaySquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"m14.335 9.61l-1.817-1.05l-1.495 1.446l1.366 1.322l1.946-1.124a.34.34 0 0 0 .172-.297a.34.34 0 0 0-.172-.298zM12.21 8.38l-2-1.155l-4.384-2.25l4.95 4.793zM5.9 14.966l4.317-2.382l1.864-1.077l-1.304-1.263zM5.534 5.17l-.005 9.677l5.002-4.841z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamGooglePlus: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17.5 5V2.5h-1.25V5h-2.5v1.25h2.5v2.5h1.25v-2.5H20V5zM6.25 5v2.5h3.536A3.76 3.76 0 0 1 6.25 10A3.755 3.755 0 0 1 2.5 6.25A3.755 3.755 0 0 1 6.25 2.5c.896 0 1.759.321 2.429.905L10.32 1.52A6.2 6.2 0 0 0 6.25 0A6.257 6.257 0 0 0 0 6.25a6.257 6.257 0 0 0 6.25 6.25a6.257 6.257 0 0 0 6.25-6.25V5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -5.5 24 24"
}

export const jamGooglePlusCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M13.75 9.5V8.25h-.625V9.5h-1.25v.625h1.25v1.25h.625v-1.25H15V9.5zm-5.625 0v1.25h1.768A1.88 1.88 0 0 1 8.125 12a1.877 1.877 0 0 1-1.875-1.875c0-1.034.841-1.875 1.875-1.875c.448 0 .88.16 1.214.453l.822-.943A3.1 3.1 0 0 0 8.125 7A3.13 3.13 0 0 0 5 10.125a3.13 3.13 0 0 0 3.125 3.125a3.13 3.13 0 0 0 3.125-3.125V9.5z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamGooglePlusSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M13.75 9.5V8.25h-.625V9.5h-1.25v.625h1.25v1.25h.625v-1.25H15V9.5zm-5.625 0v1.25h1.768A1.88 1.88 0 0 1 8.125 12a1.877 1.877 0 0 1-1.875-1.875c0-1.034.841-1.875 1.875-1.875c.448 0 .88.16 1.214.453l.822-.943A3.1 3.1 0 0 0 8.125 7A3.13 3.13 0 0 0 5 10.125a3.13 3.13 0 0 0 3.125 3.125a3.13 3.13 0 0 0 3.125-3.125V9.5z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamGoogleSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M7.188 9.034a2.97 2.97 0 0 0 .028 2.01a2.973 2.973 0 0 0 4.285 1.522a2.98 2.98 0 0 0 1.283-1.522H10.11V9.066h4.803a5 5 0 0 1-1.783 4.833A5 5 0 1 1 10 5a4.98 4.98 0 0 1 3.191 1.152l-1.62 1.326a2.974 2.974 0 0 0-4.384 1.557z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamGps: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18.913 2.9L2.632 9.226l4.829 2.006a5.77 5.77 0 0 1 3.118 3.119l2.006 4.828zm1.847.682l-6.328 16.281c-.4 1.03-1.551 1.557-2.571 1.18a1.92 1.92 0 0 1-1.11-1.067l-2.007-4.83a3.85 3.85 0 0 0-2.079-2.078l-4.828-2.006C.833 10.645.375 9.486.814 8.472A2.05 2.05 0 0 1 1.949 7.38L18.23 1.052a1.945 1.945 0 0 1 2.53 2.53\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1.5 -1 24 24"
}

export const jamGpsF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m18.919 2.635l-5.953 16.08c-.376 1.016-1.459 1.538-2.418 1.165a1.85 1.85 0 0 1-1.045-1.054l-1.887-4.77a3.7 3.7 0 0 0-1.955-2.052l-4.542-1.981C.174 9.61-.256 8.465.157 7.465a1.97 1.97 0 0 1 1.067-1.079L16.54.136c.967-.395 2.04.101 2.395 1.109c.157.446.151.94-.015 1.39z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamGrid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 2v4h4V2zm0-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m12 0h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m0 2v4h4V2zm0 10h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2m0 2v4h4v-4zM2 12h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2m0 2v4h4v-4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamGridF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 0h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m12 0h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m0 12h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2M2 12h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamHairdryer: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 8.286h4.017l.584.571a4 4 0 0 0 1.991 1.062l1.096.224l2.364 6.495a1 1 0 1 0 1.88-.684l-2.333-6.407l.793-.892A4 4 0 0 0 10.6 3.143l-.584.571H6zm-2 0V3.714H2v4.572zm5.2 2H2a2 2 0 0 1-2-2V3.714a2 2 0 0 1 2-2h7.2a6 6 0 0 1 8.686 8.27l1.925 5.286a3 3 0 1 1-5.638 2.052l-1.982-5.444a6 6 0 0 1-2.99-1.592zM12 5h3a1 1 0 0 1 0 2h-3a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamHairdryerF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 10.286V1.714h3.2a6 6 0 0 1 8.686 8.27l1.925 5.286a3 3 0 1 1-5.638 2.052l-1.982-5.444a6 6 0 0 1-2.99-1.592zm-2 0H2a2 2 0 0 1-2-2V3.714a2 2 0 0 1 2-2h2zM12 5a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamHammer: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m2.536 8.9l2.828 2.828l6.364-6.364l-2.829-2.828zm12.727 5.656l-4.95-4.95l-.706.708l4.95 4.95zm1.415 1.415l-.707.707l1.767 1.767a.5.5 0 0 0 .707-.707zM6.01 2.596L7.485 1.12a2 2 0 0 1 2.829 0l2.828 2.829a2 2 0 0 1 0 2.828l-1.414 1.414l8.132 8.132a2.5 2.5 0 1 1-3.536 3.536l-8.132-8.132l-1.414 1.414a2 2 0 0 1-2.828 0l-2.83-2.827a2 2 0 0 1 0-2.829l1.475-1.474a1.5 1.5 0 0 1 .293-1.708L4.303 2.89a1.5 1.5 0 0 1 1.708-.293z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1.5 -1.5 24 24"
}

export const jamHammerF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2.288 5.703a1.5 1.5 0 0 1 .293-1.707L3.996 2.58a1.5 1.5 0 0 1 1.707-.293L7.178.814a2 2 0 0 1 2.828 0l2.829 2.828a2 2 0 0 1 0 2.829L6.47 12.835a2 2 0 0 1-2.829 0L.814 10.006a2 2 0 0 1 0-2.828zM9.3 12.835l3.536-3.536l3.535 3.536l-3.535 3.535zm4.95 4.95l3.535-3.536l1.768 1.768a2.5 2.5 0 0 1-3.535 3.535l-1.768-1.768z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1.5 -1.5 24 24"
}

export const jamHashtag: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 6v2h2V6zm0-2h2V1a1 1 0 1 1 2 0v3h3a1 1 0 0 1 0 2h-3v2h3a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3H6v3a1 1 0 0 1-2 0v-3H1a1 1 0 1 1 0-2h3V6H1a1 1 0 1 1 0-2h3V1a1 1 0 1 1 2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -5 24 24"
}

export const jamHeader: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 4h4V1a1 1 0 1 1 2 0v8a1 1 0 1 1-2 0V6H2v3a1 1 0 1 1-2 0V1a1 1 0 1 1 2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-8 -7 24 24"
}

export const jamHeader1: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 4h4V1a1 1 0 1 1 2 0v8a1 1 0 1 1-2 0V6H2v3a1 1 0 1 1-2 0V1a1 1 0 1 1 2 0zm9.52.779H10V3h3.36v7h-1.84z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -7 24 24"
}

export const jamHeader2: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 4h4V1a1 1 0 1 1 2 0v8a1 1 0 1 1-2 0V6H2v3a1 1 0 1 1-2 0V1a1 1 0 1 1 2 0zm12.88 4.352V10H10V8.986l.1-.246l1.785-1.913c.43-.435.793-.77.923-1.011c.124-.23.182-.427.182-.587c0-.14-.04-.242-.127-.327a.47.47 0 0 0-.351-.127a.44.44 0 0 0-.355.158c-.105.117-.165.288-.173.525l-.012.338h-1.824l.016-.366c.034-.735.272-1.33.718-1.77S11.902 3 12.585 3q.637 0 1.14.275a2.1 2.1 0 0 1 .806.8q.299.516.3 1.063c0 .416-.23.849-.456 1.307c-.222.45-.534.876-1.064 1.555l-.116.123l-.254.229z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4.5 -7 24 24"
}

export const jamHeader3: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 4h4V1a1 1 0 1 1 2 0v8a1 1 0 1 1-2 0V6H2v3a1 1 0 1 1-2 0V1a1 1 0 1 1 2 0zm12.453 2.513l.043.055c.254.334.38.728.38 1.172c0 .637-.239 1.187-.707 1.628c-.466.439-1.06.658-1.763.658c-.671 0-1.235-.209-1.671-.627s-.673-.983-.713-1.676L10 7.353h1.803l.047.295c.038.238.112.397.215.49c.1.091.23.137.402.137a.57.57 0 0 0 .422-.159a.5.5 0 0 0 .158-.38c0-.163-.067-.295-.224-.419c-.17-.134-.438-.21-.815-.215l-.345-.004v-1.17l.345-.004c.377-.004.646-.08.815-.215c.157-.124.224-.255.224-.418a.5.5 0 0 0-.158-.381a.57.57 0 0 0-.422-.159a.57.57 0 0 0-.402.138c-.103.092-.177.251-.215.489l-.047.295H10l.022-.37c.04-.693.277-1.258.713-1.675c.436-.419 1-.628 1.67-.628c.704 0 1.298.22 1.764.658c.468.441.708.991.708 1.629a1.9 1.9 0 0 1-.424 1.226\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4.5 -6.5 24 24"
}

export const jamHeader4: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 4h4V1a1 1 0 1 1 2 0v8a1 1 0 1 1-2 0V6H2v3a1 1 0 1 1-2 0V1a1 1 0 1 1 2 0zm10.636 4.74H10V7.302l.06-.198l2.714-4.11h1.687v3.952h.538V8.74h-.538V10h-1.825zm.154-1.283V5.774l-1.1 1.683z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4.5 -7 24 24"
}

export const jamHeader5: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 4h4V1a1 1 0 1 1 2 0v8a1 1 0 1 1-2 0V6H2v3a1 1 0 1 1-2 0V1a1 1 0 1 1 2 0zm8.003 4.317h2.68c.386 0 .699-.287.699-.642s-.313-.642-.698-.642H10.01l.002-.244L10 3h5.086v1.888h-3.144l.014.617h1.114c1.355 0 2.469.984 2.523 2.23c.052 1.21-.972 2.231-2.288 2.28l-.095.001l-3.21-.02V8.73z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -6.5 24 24"
}

export const jamHeader6: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 4h4V1a1 1 0 1 1 2 0v8a1 1 0 1 1-2 0V6H2v3a1 1 0 1 1-2 0V1a1 1 0 1 1 2 0zm11.949 2.057c.43.44.651.999.651 1.64c0 .629-.228 1.18-.67 1.62c-.442.437-.99.663-1.613.663a2.2 2.2 0 0 1-1.649-.693c-.43-.45-.652-.985-.652-1.58q0-.337.1-.672c.063-.211.664-1.627.837-1.966q.377-.737 1.197-2.137l1.78.652l-.917 1.88c.249.113.733.386.936.593m-1.63.765a.85.85 0 0 0-.858.863a.85.85 0 0 0 .252.613a.865.865 0 0 0 1.48-.614a.84.84 0 0 0-.25-.611a.87.87 0 0 0-.623-.251z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4.5 -7 24 24"
}

export const jamHeadset: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 16.09a1 1 0 1 1-2 0V10C0 4.477 4.477 0 10 0s10 4.477 10 10v3.086a1 1 0 1 1-2 0V10a8 8 0 1 0-16 0zM2 10h2a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2m0 2v5h2v-5zm14-2h2a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2m0 2v5h2v-5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2.5 24 24"
}

export const jamHeadsetF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M20 10.858v7a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h2a8 8 0 1 0-16 0h2a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-7c0-5.523 4.477-10 10-10s10 4.477 10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamHeart: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.636 7.208L10 13.572l6.364-6.364a3 3 0 1 0-4.243-4.243L10 5.086l-2.121-2.12a3 3 0 0 0-4.243 4.242M9.293 1.55l.707.707l.707-.707a5 5 0 1 1 7.071 7.071l-7.07 7.071a1 1 0 0 1-1.415 0l-7.071-7.07a5 5 0 1 1 7.07-7.071z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamHeartF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m9.293 1.55l.707.708l.707-.707a5 5 0 1 1 7.071 7.071l-7.07 7.071a1 1 0 0 1-1.415 0L2.222 8.622a5 5 0 1 1 7.07-7.071z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamHelmet: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15 18h2a1 1 0 0 0 1-1v-2h-3zm-2-8a3 3 0 0 0-3 3h3zm2 0v3h5v4a3 3 0 0 1-3 3h-4v-5h-3v5q-.67-.017-1-.05c-5.053-.5-9-4.764-9-9.95C0 4.477 4.477 0 10 0c5.178 0 9.437 3.936 9.949 8.98q.034.335.051 1.02zm-7 3a5 5 0 0 1 5-5h4.749A8.006 8.006 0 0 0 10 2a8 8 0 0 0-8 8a8.006 8.006 0 0 0 6 7.749zm-2-3a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamHelmetF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15 18h2a1 1 0 0 0 1-1v-2h-3zm-2-8a3 3 0 0 0-3 3h3zm2 0v3h5v4a3 3 0 0 1-3 3h-4v-5h-3v5q-.67-.017-1-.05c-5.053-.5-9-4.764-9-9.95C0 4.477 4.477 0 10 0c5.178 0 9.437 3.936 9.949 8.98q.034.335.051 1.02zm-9 0a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamHelp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0-3a1 1 0 1 1 0-2a1 1 0 0 1 0 2m1.276-3.218a1 1 0 0 1-1.232-1.576l.394-.308a1.5 1.5 0 1 0-1.847-2.364l-.394.308a1 1 0 1 1-1.23-1.576l.393-.308a3.5 3.5 0 1 1 4.31 5.516z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamHelpF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20.393c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.478 10 10s-4.477 10-10 10m1.276-8.218l.394-.308a3.5 3.5 0 1 0-4.31-5.516l-.394.308a1 1 0 1 0 1.231 1.576l.394-.308a1.5 1.5 0 0 1 1.847 2.364l-.394.308a1 1 0 1 0 1.232 1.576M10 15.393a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1.5 24 24"
}

export const jamHighlighter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m8.038 11.06l-1.035 3.207l1.776 1.775l3.165-1.077l-3.906-3.906zm1.24-1.59l4.242 4.243l6.364-6.364a2 2 0 0 0 0-2.829L18.47 3.106a2 2 0 0 0-2.829 0L9.277 9.47zm-3.503 6.4L3.88 17.765l1.653 1.151l1.644-1.644zM19.884 1.692l1.414 1.414a4 4 0 0 1 0 5.657l-7.778 7.778l-4.22 1.437l-3.536 3.535L.778 18.04l4.291-4.292L6.45 9.47l7.778-7.778a4 4 0 0 1 5.657 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-0.5 -1 24 24"
}

export const jamHighlighterF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m12.914 15.45l-3.182 1.06l-4.242-4.242l1.06-3.182zm1.414-1.414L7.964 7.672l6.364-6.364c1.566-1.566 3.969-1.69 5.657 0l.707.707c1.69 1.688 1.566 4.091 0 5.657zM7.964 17.57L5.136 20.4L.893 17.571l3.536-3.535l3.535 3.535z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1 -1.5 24 24"
}

export const jamHistory: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.106 9h3.953c.546 0 .988.448.988 1s-.442 1-.988 1h-4.941a.994.994 0 0 1-.988-1V4c0-.552.442-1 .988-1s.988.448.988 1zm6-6.071A10.03 10.03 0 0 1 22 10c0 5.523-4.424 10-9.882 10v-2c4.366 0 7.906-3.582 7.906-8a8.02 8.02 0 0 0-2.316-5.657A7.83 7.83 0 0 0 12.118 2C8.574 2 5.574 4.36 4.571 7.612l1.352-.923a.98.98 0 0 1 1.372.27a1.007 1.007 0 0 1-.267 1.388l-3.277 2.237a.98.98 0 0 1-1.372-.27L.17 6.998a1.007 1.007 0 0 1 .267-1.389a.98.98 0 0 1 1.372.27l.839 1.259C3.863 3.01 7.643 0 12.118 0c2.729 0 5.2 1.12 6.988 2.929\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1 -2 24 24"
}

export const jamHome: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 18V7.132l-8-4.8l-8 4.8V18h4v-2.75a4 4 0 1 1 8 0V18zm-6 2v-4.75a2 2 0 1 0-4 0V20H2a2 2 0 0 1-2-2V7.132a2 2 0 0 1 .971-1.715l8-4.8a2 2 0 0 1 2.058 0l8 4.8A2 2 0 0 1 20 7.132V18a2 2 0 0 1-2 2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamHomeF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13 20.565v-5a3 3 0 0 0-6 0v5H2a2 2 0 0 1-2-2V7.697a2 2 0 0 1 .971-1.715l8-4.8a2 2 0 0 1 2.058 0l8 4.8A2 2 0 0 1 20 7.697v10.868a2 2 0 0 1-2 2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1.5 24 24"
}

export const jamHourglass: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 2v4a3 3 0 1 0 6 0V2zm8 16a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2v-4a4.99 4.99 0 0 1 2-4a5 5 0 0 1-2-4V2a1 1 0 1 1 0-2h10a1 1 0 0 1 0 2v4a5 5 0 0 1-2 4a4.99 4.99 0 0 1 2 4zm-2 0v-4a3 3 0 0 0-6 0v4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -2 24 24"
}

export const jamHourglassF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 18a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2v-4a4.99 4.99 0 0 1 2-4a5 5 0 0 1-2-4V2a1 1 0 1 1 0-2h10a1 1 0 0 1 0 2v4a5 5 0 0 1-2 4a4.99 4.99 0 0 1 2 4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -2 24 24"
}

export const jamIceCream: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 2a3 3 0 0 0-3 3v6a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V5a3 3 0 0 0-3-3m1 12v5a1 1 0 0 1-2 0v-5H3a3 3 0 0 1-3-3V5a5 5 0 1 1 10 0v6a3 3 0 0 1-3 3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7 -2 24 24"
}

export const jamIceCreamF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 14v5a1 1 0 0 1-2 0v-5H3a3 3 0 0 1-3-3V5a5 5 0 1 1 10 0v6a3 3 0 0 1-3 3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7 -2 24 24"
}

export const jamIdCard: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 0h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m0 2v10h16V2zm9 2h5a1 1 0 0 1 0 2h-5a1 1 0 0 1 0-2m0 3h5a1 1 0 0 1 0 2h-5a1 1 0 0 1 0-2M4 4h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -5 24 24"
}

export const jamIdCardF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 0h16c1.105 0 2 .831 2 1.857v9.286C20 12.169 19.105 13 18 13H2c-1.105 0-2-.831-2-1.857V1.857C0 .831.895 0 2 0m9 3a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2zm0 3a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2zM3 3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -5.5 24 24"
}

export const jamInbox: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 5.702V12h16V5.702L15.039 2H4.96zM0 5l4-5h12l4 5v7a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm13.874 2a4.002 4.002 0 0 1-7.748 0H2V5h16v2zm-2.142 0H8.268a2 2 0 0 0 3.464 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -5 24 24"
}

export const jamInboxF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M20 5H0l4-5h12zm0 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7h6.126a4.002 4.002 0 0 0 7.748 0zM8.265 7h3.465a2 2 0 0 1-3.465 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -5 24 24"
}

export const jamInboxes: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 4.961V18h16V4.961L14.298 2H5.702zM0 4l5-4h10l5 4v14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm13.874 2a4.002 4.002 0 0 1-7.748 0H2V4h16v2zm-2.142 0H8.268a2 2 0 0 0 3.464 0m2.142 7a4.002 4.002 0 0 1-7.748 0H2v-2h16v2zm-2.142 0H8.268a2 2 0 0 0 3.464 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamInboxesF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M20 6v5H0V6h6.126a4.002 4.002 0 0 0 7.748 0zm0-2H0l5-4h10zm0 9v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-5h6.126a4.002 4.002 0 0 0 7.748 0zM8.268 13h3.464a2 2 0 0 1-3.464 0m-.002-6.988h3.464a2 2 0 0 1-3.464 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamIndent: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 0h12a1 1 0 0 1 0 2H2a1 1 0 1 1 0-2m0 8h12a1 1 0 0 1 0 2H2a1 1 0 1 1 0-2m6-4h6a1 1 0 0 1 0 2H8a1 1 0 1 1 0-2M4.44 5.857L2.382 7.091a1 1 0 0 1-1.515-.857V3.766a1 1 0 0 1 1.515-.857l2.056 1.234a1 1 0 0 1 0 1.714z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4.5 -7 24 24"
}

export const jamInfinite: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5.5 9a3.5 3.5 0 1 0 0-7a3.5 3.5 0 0 0 0 7M11 5.5a3.5 3.5 0 1 0 .668-2.057a6.5 6.5 0 0 0-1.001-1.887A5.5 5.5 0 1 1 10 8.663A5.5 5.5 0 1 1 11 5.5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6.5 24 24"
}

export const jamInfo: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0-10a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1m0-1a1 1 0 1 1 0-2a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamInfoF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-12a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m0-1a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamInstagram: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M14.017 0h-8.07A5.954 5.954 0 0 0 0 5.948v8.07a5.954 5.954 0 0 0 5.948 5.947h8.07a5.954 5.954 0 0 0 5.947-5.948v-8.07A5.954 5.954 0 0 0 14.017 0m3.94 14.017a3.94 3.94 0 0 1-3.94 3.94h-8.07a3.94 3.94 0 0 1-3.939-3.94v-8.07a3.94 3.94 0 0 1 3.94-3.939h8.07a3.94 3.94 0 0 1 3.939 3.94v8.07z\"/><path d=\"M9.982 4.819A5.17 5.17 0 0 0 4.82 9.982a5.17 5.17 0 0 0 5.163 5.164a5.17 5.17 0 0 0 5.164-5.164A5.17 5.17 0 0 0 9.982 4.82zm0 8.319a3.155 3.155 0 1 1 0-6.31a3.155 3.155 0 0 1 0 6.31\"/><circle cx=\"15.156\" cy=\"4.858\" r=\"1.237\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamInstantPicture: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14 8.322V2H2v12h3.576l3.97-5.292A3 3 0 0 1 14 8.322m0 3.753l-1.188-2.066a1 1 0 0 0-1.667-.101L8.076 14H14zM14 16H2v2h12zM2 0h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m4 9a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0-2a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamInstantPictureF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m16 11.252l-1.454-2.24a3 3 0 0 0-5-.304L5.575 14H0V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2zM8.076 14l3.07-4.092a1 1 0 0 1 1.666.101L15.284 14zM16 16v2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2zM6 9a3 3 0 1 0 0-6a3 3 0 0 0 0 6\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamIntersection: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 14A7 7 0 1 1 10 .674a7 7 0 1 1 0 12.653A7 7 0 0 1 7 14M7 2a5 5 0 1 0 1 9.9A6.98 6.98 0 0 1 6 7a6.98 6.98 0 0 1 2-4.9A5 5 0 0 0 7 2m7 5a6.98 6.98 0 0 1-2 4.9a5 5 0 1 0 0-9.8A6.98 6.98 0 0 1 14 7\"/>",
  "width": 20,
  "height": 14,
  "viewBox": "0 0 20 14"
}

export const jamItalic: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m2.273 8l1.95-6H3a1 1 0 1 1 0-2h5a1 1 0 1 1 0 2H6.326l-1.95 6H6a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7.5 -7 24 24"
}

export const jamJoystick: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 6a2 2 0 1 0 0-4a2 2 0 0 0 0 4m1 7h2a3 3 0 0 1 3 3v4H0v-4a3 3 0 0 1 3-3h6V7.874A4.002 4.002 0 0 1 10 0a4 4 0 0 1 1 7.874zm-9 5h12v-2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1zm2.5-6h2a1.5 1.5 0 0 1 0 3h-2a1.5 1.5 0 0 1 0-3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamJoystickF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7.915 13H9V7.874A4.002 4.002 0 0 1 10 0a4 4 0 0 1 1 7.874V13h2a3 3 0 0 1 3 3v4H0v-4a3 3 0 0 1 3-3h.085A1.5 1.5 0 0 1 4.5 12h2a1.5 1.5 0 0 1 1.415 1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamKey: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m8.612 16.337l3.746-3.747l1.027.183a5 5 0 1 0-4.039-4.039l.184 1.028l-6.994 6.994l.177 2.651l2.651.177l1.833-1.833l-.707-.707a1 1 0 0 1 1.415-1.414zm.707-13.435a7 7 0 1 1 3.715 11.84L6.137 21.64l-4.43-.295a1 1 0 0 1-.932-.932l-.295-4.43l6.898-6.898a6.99 6.99 0 0 1 1.94-6.183zm4.242 5.656A2 2 0 1 1 16.39 5.73a2 2 0 0 1-2.829 2.828\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1 -1 24 24"
}

export const jamKeyF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m10.026 17.609l-2.121-2.122a1 1 0 1 0-1.415 1.415l2.122 2.12l-2.475 2.476l-4.43-.296a1 1 0 0 1-.932-.93L.48 15.84l6.898-6.898a7 7 0 1 1 5.657 5.657l-3.01 3.009zm3.535-9.193a2 2 0 1 0 2.829-2.828a2 2 0 0 0-2.829 2.828\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1 -1 24 24"
}

export const jamKeyboard: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm0 4h2v2H3zm0-3h2v2H3zm0 6h2v2H3zm3 0h8v2H6zm0-3h2v2H6zm0-3h2v2H6zm3 3h2v2H9zm0-3h2v2H9zm6 6h2v2h-2zm-3-3h2v2h-2zm0-3h2v2h-2zm3 0h2v5h-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -5 24 24"
}

export const jamKeyboardF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m0 6v2h2V6zm0-3v2h2V3zm0 6v2h2V9zm3 0v2h8V9zm0-3v2h2V6zm0-3v2h2V3zm3 3v2h2V6zm0-3v2h2V3zm6 6v2h2V9zm-3-3v2h2V6zm0-3v2h2V3zm3 0v5h2V3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -5 24 24"
}

export const jamLanguage: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11.525 14h4.385l-1.993-4.954zm5.19 2h-6.156l-1.658 3.435a1 1 0 0 1-1.802-.87l5.017-10.388a2 2 0 0 1 3.656.123l4.156 10.327a1 1 0 0 1-1.856.746zM1 0h8a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2m0 5a1 1 0 1 1 0-2h7.003a2 2 0 0 1 1.736 2.992c-.945 1.654-1.993 2.844-3.165 3.554c-1.472.893-3.32 1.372-5.537 1.453a1 1 0 1 1-.074-1.998c1.898-.07 3.419-.464 4.574-1.165C6.384 7.323 7.213 6.382 8.003 5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamLayers: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m13.071 7.762l6.417 2.575a1 1 0 0 1 .01 1.852l-8.85 3.664a1 1 0 0 1-.765 0L1.032 12.19a1 1 0 0 1 .01-1.852l6.53-2.62c.374-.15 1.556.29 2.693.294c1.215.004 2.387-.417 2.806-.249zM4.064 11.28l6.201 2.567l6.202-2.567l-6.202-2.489zM10.638.786l8.85 3.551a1 1 0 0 1 .01 1.852l-8.85 3.664a1 1 0 0 1-.765 0L1.032 6.19a1 1 0 0 1 .01-1.852L9.892.786a1 1 0 0 1 .746 0M4.064 5.28l6.201 2.567l6.202-2.567l-6.202-2.489z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1.5 -4 24 24"
}

export const jamLayersF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m10.638.786l8.85 3.551a1 1 0 0 1 .01 1.852l-8.85 3.664a1 1 0 0 1-.765 0L1.032 6.19a1 1 0 0 1 .01-1.852L9.892.786a1 1 0 0 1 .746 0m5.759 8.31l3.091 1.241a1 1 0 0 1 .01 1.852l-8.85 3.664a1 1 0 0 1-.765 0L1.032 12.19a1 1 0 0 1 .01-1.852l3.091-1.24l5.176 2.142a2.5 2.5 0 0 0 1.912 0l5.176-2.142z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1.5 -4 24 24"
}

export const jamLayout: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 18h6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h4V8H2V6h14v2H9zM3 0h12a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2 24 24"
}

export const jamLayoutF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 20V8h9v9a3 3 0 0 1-3 3zm-2 0H3a3 3 0 0 1-3-3V8h7zM18 6H0V3a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2 24 24"
}

export const jamLeaf: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.237 15.747a8.56 8.56 0 0 0-1.17 4.324a1 1 0 1 1-2 0c0-2.123.637-4.163 1.785-5.879a7 7 0 0 1 .062-7.738Q4.078 3.249 16.084.801q-.402 10.277-2.563 13.482a7 7 0 0 1-10.284 1.464m1.206-1.6a5 5 0 0 0 7.42-.984c1.004-1.488 1.737-4.815 2.084-9.85C8.004 4.7 4.484 6.222 3.572 7.573a5 5 0 0 0-.357 4.972q.645-.636 1.4-1.16l.508-.352a1 1 0 0 1 1.139 1.644l-.507.352a8.6 8.6 0 0 0-1.312 1.119z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3.5 -1 24 24"
}

export const jamLeafF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1.32 13.211a7 7 0 0 1 .594-6.757Q4.078 3.249 16.084.801q-.402 10.277-2.563 13.482a7 7 0 0 1-9.467 2.05a7.6 7.6 0 0 1 2.27-2.482l.507-.352a2 2 0 1 0-2.278-3.288l-.507.352A11.6 11.6 0 0 0 1.32 13.21zm.746 6.86a1 1 0 1 1-2 0c0-3.466 1.7-6.712 4.55-8.686l.507-.352a1 1 0 0 1 1.139 1.644l-.507.352a8.57 8.57 0 0 0-3.689 7.042\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3.5 -1 24 24"
}

export const jamLifebuoy: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m3.446-12.032a4 4 0 0 0-1.414-1.414l3.625-3.625l1.414 1.414zm-5.478 5.478l-3.625 3.625l-1.414-1.414l3.625-3.625a4 4 0 0 0 1.414 1.414m0-6.892a4 4 0 0 0-1.414 1.414L2.929 4.343L4.343 2.93zm4.736 6.394a4 4 0 1 1 .244-.244q.29-.316.498-.672l2.874 2.874a8 8 0 0 1-1.414 1.414l-2.874-2.874q.356-.21.672-.498M10 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamLifebuoyF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2.268 16.41a10.05 10.05 0 0 1 0-12.721l4.318 4.318a4.03 4.03 0 0 0 0 4.085zm1.42 1.421l4.32-4.318a4.03 4.03 0 0 0 4.084 0l4.318 4.318a10.05 10.05 0 0 1-12.721 0zM16.41 2.268l-4.318 4.318a4.03 4.03 0 0 0-4.085 0L3.69 2.268a10.05 10.05 0 0 1 12.72 0m1.421 1.42a10.05 10.05 0 0 1 0 12.722l-4.318-4.318a4.03 4.03 0 0 0 0-4.085L17.83 3.69z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1.5 -1.5 24 24"
}

export const jamLightbulb: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 14v-2.298l.856-.597a5 5 0 1 0-5.712 0l.856.597V14h1V6a1 1 0 1 1 2 0v8zm0 2H5v2h4zM0 7a7 7 0 1 1 11 5.745V18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5.255A6.99 6.99 0 0 1 0 7\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamLightbulbF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 14.565H8v-8a1 1 0 1 0-2 0v8H3V13.31a7 7 0 1 1 8 0zm0 2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -1.5 24 24"
}

export const jamLine: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19.914 9.003a6.7 6.7 0 0 1-.764 2.2c-.179.324-1.056 1.558-1.325 1.884c-1.478 1.788-3.953 3.851-8.092 5.857a.545.545 0 0 1-.78-.552l.21-1.885a.545.545 0 0 0-.483-.604C3.781 15.388 0 12.04 0 7.986C0 3.576 4.476 0 9.997 0c5.366 0 9.744 3.377 9.987 7.615c.007.123.026.516.01.78c-.011.16-.034.365-.08.608m-15.414.6V6.24a.512.512 0 1 0-1.023 0v3.877c0 .284.23.514.512.514h2.045a.512.512 0 0 0 0-1.027H4.5zm3.154 1.028a.4.4 0 0 0 .4-.401V6.128a.4.4 0 0 0-.4-.402h-.223a.4.4 0 0 0-.4.402v4.102a.4.4 0 0 0 .4.4zm4.133-4.391v2.369s-2.042-2.676-2.074-2.71a.5.5 0 0 0-.4-.172a.527.527 0 0 0-.492.534v3.856a.512.512 0 1 0 1.023 0V7.763s2.073 2.698 2.104 2.727c.09.086.211.14.346.14c.284.003.516-.249.516-.534V6.24a.512.512 0 1 0-1.023 0m4.858 0a.51.51 0 0 0-.512-.514h-2.045a.51.51 0 0 0-.511.514v3.877c0 .284.229.514.511.514h2.045a.512.512 0 0 0 0-1.027H14.6v-.912h1.534a.512.512 0 0 0 0-1.027H14.6v-.912h1.534c.283 0 .512-.23.512-.513z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2.5 24 24"
}

export const jamLink: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.19 9.345a.97.97 0 0 1 1.37 0a.966.966 0 0 1 0 1.367l-2.055 2.052a1.93 1.93 0 0 0 0 2.735a1.94 1.94 0 0 0 2.74 0l4.794-4.787a.966.966 0 0 0 0-1.367a.966.966 0 0 1 0-1.368a.97.97 0 0 1 1.37 0a2.9 2.9 0 0 1 0 4.103l-4.795 4.787a3.88 3.88 0 0 1-5.48 0a3.864 3.864 0 0 1 0-5.47L3.19 9.344zm11.62-.69a.97.97 0 0 1-1.37 0a.966.966 0 0 1 0-1.367l2.055-2.052a1.93 1.93 0 0 0 0-2.735a1.94 1.94 0 0 0-2.74 0L7.962 7.288a.966.966 0 0 0 0 1.367a.966.966 0 0 1 0 1.368a.97.97 0 0 1-1.37 0a2.9 2.9 0 0 1 0-4.103l4.795-4.787a3.88 3.88 0 0 1 5.48 0a3.864 3.864 0 0 1 0 5.47L14.81 8.656z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -3 24 24"
}

export const jamLinkedin: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19.959 11.719v7.379h-4.278v-6.885c0-1.73-.619-2.91-2.167-2.91c-1.182 0-1.886.796-2.195 1.565c-.113.275-.142.658-.142 1.043v7.187h-4.28s.058-11.66 0-12.869h4.28v1.824l-.028.042h.028v-.042c.568-.875 1.583-2.126 3.856-2.126c2.815 0 4.926 1.84 4.926 5.792M2.421.026C.958.026 0 .986 0 2.249c0 1.235.93 2.224 2.365 2.224h.028c1.493 0 2.42-.989 2.42-2.224C4.787.986 3.887.026 2.422.026zM.254 19.098h4.278V6.229H.254z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamLinkedinCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M15 11.13v3.697h-2.143v-3.45c0-.866-.31-1.457-1.086-1.457c-.592 0-.945.398-1.1.784c-.056.138-.071.33-.071.522v3.601H8.456s.029-5.842 0-6.447H10.6v.913l-.014.021h.014v-.02c.285-.44.793-1.066 1.932-1.066c1.41 0 2.468.922 2.468 2.902M6.213 5.271C5.48 5.271 5 5.753 5 6.385c0 .62.466 1.115 1.185 1.115h.014c.748 0 1.213-.496 1.213-1.115c-.014-.632-.465-1.114-1.199-1.114m-1.086 9.556h2.144V8.38H5.127z\"/><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamLinkedinSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M15 11.13v3.697h-2.143v-3.45c0-.866-.31-1.457-1.086-1.457c-.592 0-.945.398-1.1.784c-.056.138-.071.33-.071.522v3.601H8.456s.029-5.842 0-6.447H10.6v.913l-.014.021h.014v-.02c.285-.44.793-1.066 1.932-1.066c1.41 0 2.468.922 2.468 2.902M6.213 5.271C5.48 5.271 5 5.753 5 6.385c0 .62.466 1.115 1.185 1.115h.014c.748 0 1.213-.496 1.213-1.115c-.014-.632-.465-1.114-1.199-1.114m-1.086 9.556h2.144V8.38H5.127z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamLogIn: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6.641 9.828H1a1 1 0 1 1 0-2h5.641l-1.12-1.12a1 1 0 0 1 1.413-1.415L9.763 8.12a.997.997 0 0 1 0 1.415l-2.829 2.828A1 1 0 0 1 5.52 10.95zM13 0a1 1 0 0 1 1 1v16a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -3 24 24"
}

export const jamLogOut: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.414 7.828h5.642a1 1 0 1 1 0 2H3.414l1.122 1.122a1 1 0 1 1-1.415 1.414L.293 9.536a.997.997 0 0 1 0-1.415L3.12 5.293a1 1 0 0 1 1.415 1.414zM13 0a1 1 0 0 1 1 1v16a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -3 24 24"
}

export const jamLtr: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 2v9a1 1 0 0 1-2 0V6H6a3 3 0 1 1 0-6h7a1 1 0 0 1 0 2h-1v9a1 1 0 0 1-2 0V2zM1.657 9L.284 10.36a.955.955 0 0 0 0 1.358a.977.977 0 0 0 1.373 0L3.716 9.68a.955.955 0 0 0 0-1.36l-2.06-2.038a.977.977 0 0 0-1.372 0a.955.955 0 0 0 0 1.359zM7 2H6a1 1 0 1 0 0 2h1z\"/>",
  "width": 14,
  "height": 12,
  "viewBox": "0 0 14 12"
}

export const jamLuggage: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15 6v8h-2V6H7v8H5V6a3 3 0 0 0-3 3v2a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3M7.17 4h5.66a3.004 3.004 0 0 0-5.66 0M5.1 4a5.002 5.002 0 0 1 9.8 0h.1a5 5 0 0 1 5 5v2a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V9a5 5 0 0 1 5-5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamLuggageF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13 4v12H7V4zm2 0a5 5 0 0 1 5 5v2a5 5 0 0 1-5 5zM5 4v12a5 5 0 0 1-5-5V9a5 5 0 0 1 5-5m.1 0a5.002 5.002 0 0 1 9.8 0h-2.07a3.001 3.001 0 0 0-5.66 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamMagic: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m14.243 7.172l3.535-3.536l-.707-.707l-3.535 3.535zm-1.415 1.414l-.707-.707L2.93 17.07l.707.707l9.192-9.192zm4.95-7.778l2.121 2.12a1 1 0 0 1 0 1.415L4.343 19.9a1 1 0 0 1-1.414 0L.808 17.78a1 1 0 0 1 0-1.415L16.364.808a1 1 0 0 1 1.414 0M8.586.1l1.393.704L11.414.1l-.68 1.46l.68 1.368l-1.384-.664l-1.444.664l.689-1.42zm9.9 7.07l1.393.705l1.435-.704l-.68 1.46l.68 1.368l-1.384-.664l-1.445.664l.69-1.42l-.69-1.408z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1 -1.5 24 24"
}

export const jamMagicF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m15.092 8.02l-2.829-2.828L16.506.95a1 1 0 0 1 1.414 0l1.415 1.414a1 1 0 0 1 0 1.414l-4.243 4.243zm-1.414 1.415l-9.9 9.9a1 1 0 0 1-1.414 0L.95 17.92a1 1 0 0 1 0-1.414l9.9-9.9zM8.728.243l1.393.704l1.435-.704l-.679 1.46l.68 1.368l-1.384-.664l-1.445.664l.689-1.42zm9.9 7.07l1.393.705l1.435-.704l-.68 1.46l.68 1.368l-1.384-.664l-1.445.664l.69-1.42l-.69-1.408z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1 -2 24 24"
}

export const jamMagnet: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13 12c0-2.878-1.516-5-3-5s-3 2.122-3 5v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-6C0 5.373 4.477 0 10 0s10 5.373 10 12v6a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2zm2 0h3c0-5.595-3.67-10-8-10S2 6.405 2 12h3c0-3.866 2.239-7 5-7s5 3.134 5 7M2 18h3v-4H2zm13 0h3v-4h-3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMagnetF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15 12c0-3.866-2.239-7-5-7s-5 3.134-5 7H0C0 5.373 4.477 0 10 0s10 5.373 10 12zM0 14h5v5a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm15 0h5v5a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMale: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4.364 14.636a5 5 0 1 0 7.071-7.071a5 5 0 0 0-7.071 7.071m7.728-9.142l2.553-2.553h-1.517a1 1 0 0 1 0-2h4a.997.997 0 0 1 1 1v4a1 1 0 1 1-2 0V4.286l-2.622 2.622A7.002 7.002 0 0 1 2.95 16.05a7 7 0 0 1 9.142-10.556\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2.5 -2.5 24 24"
}

export const jamMap: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m2 17.613l3.419-1.14A5 5 0 0 1 6 16.317V2.387L2 3.721zm-.662 2.328A1 1 0 0 1 0 19V3a1 1 0 0 1 .706-.956L5.419.473a5 5 0 0 1 3.162 0l3.47 1.157a3 3 0 0 0 1.898 0L18.662.059A1 1 0 0 1 20 1v16a1 1 0 0 1-.706.956l-4.713 1.571a5 5 0 0 1-3.162 0l-3.47-1.157a3 3 0 0 0-1.898 0zM18 16.28V2.387l-3.419 1.14a5 5 0 0 1-.581.156v13.93l4-1.334zm-6 1.334V3.683a5 5 0 0 1-.581-.156L8 2.387v13.93a5 5 0 0 1 .581.156L12 17.613z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMapF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13 2.641v18a5 5 0 0 1-1.581-.256L8 19.245V1.175a5 5 0 0 1 .581.156l3.47 1.157A3 3 0 0 0 13 2.64zm2-.504l3.662-1.22A1 1 0 0 1 20 1.858v16a1 1 0 0 1-.706.956L15 20.245zm-9-.962v18.07L1.338 20.8A1 1 0 0 1 0 19.858v-16a1 1 0 0 1 .706-.956L5.419 1.33A5 5 0 0 1 6 1.175\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1.5 24 24"
}

export const jamMapMarker: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 7A5 5 0 1 0 2 7c0 1.726 1.66 5.031 5 9.653c3.34-4.622 5-7.927 5-9.653M7 20Q0 10.865 0 7a7 7 0 1 1 14 0q0 3.865-7 13m0-9a4 4 0 1 1 0-8a4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamMapMarkerF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 20.565q-7-9.135-7-13a7 7 0 1 1 14 0q0 3.865-7 13m0-9a4 4 0 1 0 0-8a4 4 0 0 0 0 8\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -1.5 24 24"
}

export const jamMask: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 1.02Q12.64 0 14.5 0a5.5 5.5 0 0 1 0 11q-1.86 0-4.5-1.057Q7.36 11 5.5 11a5.5 5.5 0 0 1 0-11Q7.36 0 10 1.02m.721 1.866L10 3.164l-.721-.278C7.731 2.288 6.463 2 5.5 2a3.5 3.5 0 0 0 0 7c.953 0 2.215-.296 3.757-.913L10 7.789l.743.298C12.285 8.704 13.547 9 14.5 9a3.5 3.5 0 0 0 0-7c-.963 0-2.231.288-3.779.886M6 7c-1.105 0-2-.672-2-1.5S4.895 4 6 4s2 .672 2 1.5S7.105 7 6 7m8 0c-1.105 0-2-.672-2-1.5S12.895 4 14 4s2 .672 2 1.5S15.105 7 14 7\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6.5 24 24"
}

export const jamMaskF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 1.878q2.64-1.02 4.5-1.02a5.5 5.5 0 0 1 0 11q-1.86 0-4.5-1.057q-2.64 1.057-4.5 1.057a5.5 5.5 0 0 1 0-11q1.86 0 4.5 1.02m-4 5.98c1.105 0 2-.672 2-1.5c0-.829-.895-1.5-2-1.5s-2 .671-2 1.5c0 .828.895 1.5 2 1.5m8 0c1.105 0 2-.672 2-1.5c0-.829-.895-1.5-2-1.5s-2 .671-2 1.5c0 .828.895 1.5 2 1.5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6 24 24"
}

export const jamMedal: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m4 14.517l-.612-1.258a1 1 0 0 0-.43-.447l-2-1.06a1 1 0 0 1-.485-1.181l.71-2.273a1 1 0 0 0 0-.596l-.71-2.273a1 1 0 0 1 .486-1.182l1.999-1.06a1 1 0 0 0 .43-.446L4.393.674A1 1 0 0 1 5.615.165l2.062.703a1 1 0 0 0 .646 0l2.062-.703a1 1 0 0 1 1.222.51l1.005 2.066a1 1 0 0 0 .43.447l2 1.06a1 1 0 0 1 .485 1.181l-.71 2.273a1 1 0 0 0 0 .596l.71 2.273a1 1 0 0 1-.486 1.182l-1.999 1.06a1 1 0 0 0-.43.446L12 14.517v6.879l-4-1.358l-4 1.358zm2 1.187v2.9l2-.679l2 .68v-2.901l-1.677-.572a1 1 0 0 0-.646 0zm4.813-3.32a3 3 0 0 1 1.293-1.339l1.264-.67l-.462-1.48a3 3 0 0 1 0-1.79l.462-1.48l-1.264-.67a3 3 0 0 1-1.293-1.34l-.619-1.272l-1.226.418a3 3 0 0 1-1.936 0l-1.226-.418l-.619 1.273a3 3 0 0 1-1.293 1.339l-1.264.67l.462 1.48a3 3 0 0 1 0 1.79l-.462 1.48l1.264.67a3 3 0 0 1 1.293 1.34l.619 1.272l1.226-.418a3 3 0 0 1 1.936 0l1.226.418zM8 5a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0V6a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -1 24 24"
}

export const jamMedalF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 17.502c.307.2.699.26 1.067.133l2.536-.864a1.23 1.23 0 0 1 .794 0l2.536.864c.368.126.76.067 1.067-.133v3.894l-4-1.358l-4 1.358zm3.677-2.37l-2.062.703a1 1 0 0 1-1.222-.51L3.388 13.26a1 1 0 0 0-.43-.447l-2-1.06a1 1 0 0 1-.485-1.181l.71-2.273a1 1 0 0 0 0-.596L.473 5.43a1 1 0 0 1 .486-1.182l1.999-1.06a1 1 0 0 0 .43-.446L4.393.674A1 1 0 0 1 5.615.165l2.062.703a1 1 0 0 0 .646 0l2.062-.703a1 1 0 0 1 1.222.51l1.005 2.066a1 1 0 0 0 .43.447l2 1.06a1 1 0 0 1 .485 1.181l-.71 2.273a1 1 0 0 0 0 .596l.71 2.273a1 1 0 0 1-.486 1.182l-1.999 1.06a1 1 0 0 0-.43.446l-1.005 2.067a1 1 0 0 1-1.222.509l-2.062-.703a1 1 0 0 0-.646 0M8 5a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -1 24 24"
}

export const jamMedical: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 12.917v.583a4.5 4.5 0 1 0 9 0v-1.67a3.001 3.001 0 1 1 2 0v1.67a6.5 6.5 0 1 1-13 0v-.583A6 6 0 0 1 0 7V2a2 2 0 0 1 2-2h1a1 1 0 1 1 0 2H2v5a4 4 0 1 0 8 0V2H9a1 1 0 1 1 0-2h1a2 2 0 0 1 2 2v5a6 6 0 0 1-5 5.917M17 10a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMedium: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2.372 3.264a.78.78 0 0 0-.252-.658L.252.339V0H6.05l4.482 9.905L14.472 0H20v.339L18.403 1.88a.47.47 0 0 0-.177.452v11.334a.47.47 0 0 0 .177.452l1.56 1.542V16H12.12v-.339l1.615-1.58c.159-.16.159-.207.159-.451V4.468L9.402 15.962h-.606L3.566 4.468v7.704c-.043.324.064.65.29.884l2.101 2.568v.338H0v-.338l2.1-2.568a1.03 1.03 0 0 0 .272-.884z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamMediumCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M6.186 7.632a.4.4 0 0 0-.126-.33L5.126 6.17V6h2.9l2.24 4.952L12.236 6H15v.17l-.798.77a.24.24 0 0 0-.089.226v5.668a.24.24 0 0 0 .089.225l.78.772V14H11.06v-.17l.807-.79c.08-.08.08-.103.08-.225V8.234L9.7 13.981h-.303L6.783 8.234v3.852a.53.53 0 0 0 .145.442l1.05 1.284v.17H5v-.17l1.05-1.284a.52.52 0 0 0 .136-.442z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMediumSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M6.186 7.632a.4.4 0 0 0-.126-.33L5.126 6.17V6h2.9l2.24 4.952L12.236 6H15v.17l-.798.77a.24.24 0 0 0-.089.226v5.668a.24.24 0 0 0 .089.225l.78.772V14H11.06v-.17l.807-.79c.08-.08.08-.103.08-.225V8.234L9.7 13.981h-.303L6.783 8.234v3.852a.53.53 0 0 0 .145.442l1.05 1.284v.17H5v-.17l1.05-1.284a.52.52 0 0 0 .136-.442z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMenu: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 0h5a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2m7 8h5a1 1 0 0 1 0 2H8a1 1 0 1 1 0-2M1 4h12a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -7 24 24"
}

export const jamMerge: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 4a1 1 0 1 0 0-2a1 1 0 0 0 0 2M7 5.83a3.001 3.001 0 1 1 2.033-.013v2.028q0 .111-.008.221a1 1 0 0 0 .462.637l3.086 1.846a3 3 0 0 1 1.46 2.575v1.059a3.001 3.001 0 1 1-2-.024v-1.035a1 1 0 0 0-.487-.858L8.46 10.42a3 3 0 0 1-.444-.324a3 3 0 0 1-.443.324l-3.086 1.846a1 1 0 0 0-.487.858v1.047a3.001 3.001 0 1 1-2 0v-1.047a3 3 0 0 1 1.46-2.575l3.086-1.846a1 1 0 0 0 .462-.637A3 3 0 0 1 7 7.845V5.829zM3 18a1 1 0 1 0 0-2a1 1 0 0 0 0 2m10 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamMergeF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.033 5.817v2.028q0 .111-.008.221a1 1 0 0 0 .462.637l3.086 1.846a3 3 0 0 1 1.46 2.575v1.059a3.001 3.001 0 1 1-2-.024v-1.035a1 1 0 0 0-.487-.858L8.46 10.42a3 3 0 0 1-.444-.324a3 3 0 0 1-.443.324l-3.086 1.846a1 1 0 0 0-.487.858v1.047a3.001 3.001 0 1 1-2 0v-1.047a3 3 0 0 1 1.46-2.575l3.086-1.846a1 1 0 0 0 .462-.637A3 3 0 0 1 7 7.845V5.829a3.001 3.001 0 1 1 2.033-.012\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamMessage: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.378 12H17a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1a1 1 0 0 1 1 1v3.013zM3 0h14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-6.958l-6.444 4.808A1 1 0 0 1 2 18.006V14a2 2 0 0 1-2-2V3a3 3 0 0 1 3-3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2.5 24 24"
}

export const jamMessageAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m5.978 14.969l.002-.033zm.001-.167l.001.003v-.003zm.04 1.9c2.678-2.462 3.007-2.656 3.793-2.734C13.364 13.615 16 11.01 16 8.004c0-3.26-3.085-6.003-7-6.003S2 4.745 2 8.004c0 1.893 1.175 3.767 3.054 4.957c.783.495.958 1.117.941 1.778l-.009.15c.022.33.032.92.033 1.814zm3.99-.743q-.277.027-4.32 3.774a1 1 0 0 1-1.68-.742q.03-3.543-.024-4.04c-.018-.173.032-.28 0-.3C1.708 13.212 0 10.775 0 8.005C0 3.584 4.03 0 9 0s9 3.584 9 8.004c0 4.117-3.495 7.509-7.99 7.955z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2 24 24"
}

export const jamMessageAltF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.01 15.959q-.279.027-4.321 3.774a1 1 0 0 1-1.68-.742q.03-3.543-.024-4.04c-.018-.173.032-.28 0-.3C1.708 13.212 0 10.775 0 8.005C0 3.584 4.03 0 9 0s9 3.584 9 8.004c0 4.117-3.495 7.509-7.99 7.955\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2 24 24"
}

export const jamMessageAltWriting: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.01 15.959q-.279.027-4.321 3.774a1 1 0 0 1-1.68-.742q.03-3.543-.024-4.04c-.018-.173.032-.28 0-.3C1.708 13.212 0 10.775 0 8.005C0 3.584 4.03 0 9 0s9 3.584 9 8.004c0 4.117-3.495 7.509-7.99 7.955m-3.99.744c2.677-2.463 3.006-2.657 3.792-2.735C13.364 13.615 16 11.01 16 8.004c0-3.26-3.085-6.003-7-6.003S2 4.745 2 8.004c0 1.893 1.175 3.767 3.054 4.957c.783.495.958 1.117.941 1.778l-.009.15c.022.33.032.92.033 1.814zM12 10a2 2 0 1 1 0-4a2 2 0 0 1 0 4m-6 0a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2 24 24"
}

export const jamMessageAltWritingF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.01 15.959q-.279.027-4.321 3.774a1 1 0 0 1-1.68-.742q.03-3.543-.024-4.04c-.018-.173.032-.28 0-.3C1.708 13.212 0 10.775 0 8.005C0 3.584 4.03 0 9 0s9 3.584 9 8.004c0 4.117-3.495 7.509-7.99 7.955M12 10a2 2 0 1 0 0-4a2 2 0 0 0 0 4m-6 0a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2 24 24"
}

export const jamMessageF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 .565h14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-6.958l-6.444 4.808A1 1 0 0 1 2 18.57v-4.006a2 2 0 0 1-2-2v-9a3 3 0 0 1 3-3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMessageWriting: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-6.958l-6.444 4.808A1 1 0 0 1 2 18.006V14a2 2 0 0 1-2-2V3a3 3 0 0 1 3-3m6.378 12H17a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1a1 1 0 0 1 1 1v3.013zM13 9a2 2 0 1 1 0-4a2 2 0 0 1 0 4M7 9a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2.5 24 24"
}

export const jamMessageWritingF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 .858h14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-6.958l-6.444 4.808A1 1 0 0 1 2 18.864v-4.006a2 2 0 0 1-2-2v-9a3 3 0 0 1 3-3m10 9a2 2 0 1 0 0-4a2 2 0 0 0 0 4m-6 0a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMessages: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.656 17.979A1 1 0 0 1 2 17.243V15a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H8.003zm.844-3.093a.54.54 0 0 0 .26-.069l2.355-1.638A1 1 0 0 1 7.686 13H12a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v5c0 .54.429.982 1 1c.41.016.707.083.844.226c.128.134.135.36.156.79c.003.063.003.177 0 .37a.5.5 0 0 0 .5.5m11.5-4.87a7 7 0 0 0 0 .37zc.02-.43.028-.656.156-.79c.137-.143.434-.21.844-.226c.571-.018 1-.46 1-1V3a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1H5V2a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2v2.243a1 1 0 0 1-1.656.736L16 13.743z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2.5 24 24"
}

export const jamMessagesAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m7.403 14.026l.64-.11q.186-.032.443-.098C10.6 13.288 12 11.708 12 10c0-2.135-2.176-4-5-4s-5 1.865-5 4c0 1.218.702 2.378 1.931 3.15l.036.02L5 13.74v2.763zm.982 1.86l-3.667 3.78A1 1 0 0 1 3 18.97v-4.05l-.132-.076C1.129 13.752 0 11.989 0 10c0-3.314 3.134-6 7-6s7 2.686 7 6c0 2.726-2.121 5.028-5.026 5.758a8 8 0 0 1-.589.128M6.936 3C8.146 1.207 10.41 0 13 0c3.866 0 7 2.686 7 6c0 1.989-1.13 3.752-2.868 4.844L17 10.92v4.05a1 1 0 0 1-1.718.696l-1.735-1.788l1.043-1.798l.41.423V9.74l1.033-.57l.036-.02C17.299 8.378 18 7.218 18 6c0-2.135-2.176-4-5-4c-1.28 0-2.426.383-3.297 1z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMessagesAltF: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M7.46 2.332C8.74.913 10.746 0 13 0c3.866 0 7 2.686 7 6c0 1.989-1.13 3.752-2.868 4.844L17 10.92v4.05a1 1 0 0 1-1.718.696l-1.14-1.174c1.069-1.264 1.698-2.816 1.698-4.493c0-4.067-3.698-7.395-8.38-7.667\"/><path d=\"m8.385 15.886l-3.667 3.78A1 1 0 0 1 3 18.97v-4.05l-.132-.076C1.129 13.752 0 11.989 0 10c0-3.314 3.134-6 7-6s7 2.686 7 6c0 2.726-2.121 5.028-5.026 5.758a8 8 0 0 1-.589.128\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMessagesF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.656 17.979A1 1 0 0 1 2 17.243V15a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H8.003zM16 10.017a7 7 0 0 0 0 .369zq.007-.16.004-4.019a3 3 0 0 0-3-2.997H5V2a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2v2.243a1 1 0 0 1-1.656.736L16 13.743z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2.5 24 24"
}

export const jamMessenger: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.683 16.418C1.436 14.722 0 12.14 0 9.248C0 4.14 4.477 0 10 0s10 4.14 10 9.248s-4.477 9.248-10 9.248a10.8 10.8 0 0 1-2.96-.412l-3.357 1.891zm5.25-9.703l-5.394 5.66l4.908-2.67l2.565 2.67l5.362-5.66l-4.853 2.622l-2.589-2.622z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMic: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.465 14H8a1 1 0 0 1 0-2h2v-2H8a1 1 0 1 1 0-2h2V6H8a1 1 0 1 1 0-2h1.465A4 4 0 0 0 6 2c-1.48 0-2.773.804-3.465 2H4a1 1 0 1 1 0 2H2v2h2a1 1 0 1 1 0 2H2v2h2a1 1 0 0 1 0 2H2.535A4 4 0 0 0 6 16c1.48 0 2.773-.804 3.465-2m-1.492 3.668a2 2 0 1 1-3.945 0A6 6 0 0 1 0 12V6a6 6 0 1 1 12 0v6a6 6 0 0 1-4.027 5.668\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -2 24 24"
}

export const jamMicAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 2a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3m0-2a5 5 0 0 1 5 5v6a5 5 0 0 1-10 0V5a5 5 0 0 1 5-5M0 11.03a1 1 0 1 1 2 0A6.97 6.97 0 0 0 8.97 18h.06A6.97 6.97 0 0 0 16 11.03a1 1 0 1 1 2 0A8.97 8.97 0 0 1 9.03 20h-.06A8.97 8.97 0 0 1 0 11.03\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2 24 24"
}

export const jamMicCircle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0-14.395a3 3 0 0 1 3 3v4a3 3 0 1 1-6 0v-4a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1m-6 5a1 1 0 0 1 2 0v.022a4 4 0 1 0 8 0v-.022a1 1 0 0 1 2 0v.022a6 6 0 1 1-12 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMicCircleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-16.395a3 3 0 0 0-3 3v4a3 3 0 1 0 6 0v-4a3 3 0 0 0-3-3m-6 7v.022a6 6 0 1 0 12 0v-.022a1 1 0 0 0-2 0v.022a4 4 0 1 1-8 0v-.022a1 1 0 0 0-2 0m6-5a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMicF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 12H8a1 1 0 0 0 0 2h3.659a6.02 6.02 0 0 1-3.686 3.668a2 2 0 1 1-3.945 0A6.02 6.02 0 0 1 .34 14H4a1 1 0 0 0 0-2H0v-2h4a1 1 0 1 0 0-2H0V6h4a1 1 0 1 0 0-2H.341A6.002 6.002 0 0 1 11.66 4H8a1 1 0 1 0 0 2h4v2H8a1 1 0 1 0 0 2h4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -2 24 24"
}

export const jamMicSquare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm6 1.605a3 3 0 0 1 3 3v4a3 3 0 1 1-6 0v-4a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1m-6 5a1 1 0 0 1 2 0v.022a4 4 0 1 0 8 0v-.022a1 1 0 0 1 2 0v.022a6 6 0 1 1-12 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMicSquareF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m6 3.605a3 3 0 0 0-3 3v4a3 3 0 1 0 6 0v-4a3 3 0 0 0-3-3m-6 7v.022a6 6 0 1 0 12 0v-.022a1 1 0 0 0-2 0v.022a4 4 0 1 1-8 0v-.022a1 1 0 0 0-2 0m6-5a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMicrochip: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm2 2h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1m1 2v2h2V9zM6 0a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1M1 5h2a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2m16 0h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2M1 9h2a1 1 0 1 1 0 2H1a1 1 0 0 1 0-2m16 0h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2M1 13h2a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2m16 0h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2M6 16a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m8-16a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1m0 16a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1M10 0a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1m0 16a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMicrochipF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 17.858v2a1 1 0 0 1-2 0v-2H7v2a1 1 0 0 1-2 0v-2q0-.085.014-.166a3 3 0 0 1-1.848-1.848a1 1 0 0 1-.166.014H1a1 1 0 0 1 0-2h2v-2H1a1 1 0 0 1 0-2h2v-2H1a1 1 0 1 1 0-2h2q.085 0 .166.014c.3-.864.984-1.548 1.848-1.848A1 1 0 0 1 5 3.858v-2a1 1 0 1 1 2 0v2h2v-2a1 1 0 1 1 2 0v2h2v-2a1 1 0 0 1 2 0v2q0 .084-.014.166c.864.3 1.548.984 1.848 1.848A1 1 0 0 1 17 5.858h2a1 1 0 0 1 0 2h-2v2h2a1 1 0 0 1 0 2h-2v2h2a1 1 0 0 1 0 2h-2q-.085 0-.166-.014a3 3 0 0 1-1.848 1.848q.014.081.014.166v2a1 1 0 0 1-2 0v-2zm-3-10a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1.5 24 24"
}

export const jamMinus: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 0h12a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -11 24 24"
}

export const jamMinusCircle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10M5 9h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMinusCircleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10M5 9a1 1 0 1 0 0 2h10a1 1 0 0 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMinusRectangle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m1 9h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMinusRectangleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m1 9a1 1 0 1 0 0 2h10a1 1 0 0 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMoon: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 10c0 4.43 3.478 8 7.742 8c.658 0 1.302-.085 1.922-.248c-2.996-2.2-4.896-5.786-4.896-9.752c0-2.09.527-4.095 1.489-5.853C4.699 2.863 2 6.097 2 10m6.768-2c0 4.632 3.068 8.528 7.232 9.665A9.56 9.56 0 0 1 9.742 20C4.362 20 0 15.523 0 10S4.362 0 9.742 0c.868 0 1.71.117 2.511.335A10.09 10.09 0 0 0 8.768 8\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamMoonF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12.253.335A10.09 10.09 0 0 0 8.768 8c0 4.632 3.068 8.528 7.232 9.665A9.56 9.56 0 0 1 9.742 20C4.362 20 0 15.523 0 10S4.362 0 9.742 0c.868 0 1.71.117 2.511.335\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamMoreHorizontal: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 4a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0 2a3 3 0 1 1 0-6a3 3 0 0 1 0 6m14 0a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0-2a1 1 0 1 0 0-2a1 1 0 0 0 0 2m-7 2a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0-2a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -9 24 24"
}

export const jamMoreHorizontalF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 6a3 3 0 1 1 0-6a3 3 0 0 1 0 6m14 0a3 3 0 1 1 0-6a3 3 0 0 1 0 6m-7 0a3 3 0 1 1 0-6a3 3 0 0 1 0 6\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -9 24 24"
}

export const jamMoreVertical: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 4a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0 2a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0 14a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0-2a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0-5a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0-2a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-9 -2 24 24"
}

export const jamMoreVerticalF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 6a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0 14a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0-7a3 3 0 1 1 0-6a3 3 0 0 1 0 6\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-9 -2 24 24"
}

export const jamMountain: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m14.846 9.334l-3.985-6.762a1 1 0 0 0-1.723 0L7.11 6.015c.202 1.979.943 2.783 2.387 2.783c2.005 0 3.816.176 5.35.536zm1.555 2.637c-1.547-.767-3.977-1.173-6.905-1.173c-1.819 0-3.11-.832-3.813-2.364l-3.57 6.058A1 1 0 0 0 2.975 16h14.05a1 1 0 0 0 .861-1.508l-1.485-2.52zM12.584 1.556l7.025 11.92A3 3 0 0 1 17.025 18H2.975A3 3 0 0 1 .39 13.477l7.025-11.92a3 3 0 0 1 5.17 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3 24 24"
}

export const jamMountainF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17.797 10.402c-2.038-.98-5.317-1.604-8.3-1.604c-1.828 0-2.951-3.163-3.264-5.235l1.182-2.007a3 3 0 0 1 5.17 0zm1.673 2.839l.14.236A3 3 0 0 1 17.024 18H2.975A3 3 0 0 1 .39 13.477l4.517-7.664c.417 2.76 2.144 4.985 4.59 4.985c2.747 0 6.71.536 9.973 2.443\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3 24 24"
}

export const jamMove: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m18.799 9.957l-1.121-1.121a1 1 0 1 1 1.414-1.415l2.828 2.829a1 1 0 0 1 0 1.414l-2.828 2.828a1 1 0 0 1-1.414-1.414l1.121-1.121h-6.485v6.485l1.121-1.121a1 1 0 0 1 1.414 1.414l-2.828 2.829a1 1 0 0 1-1.414 0l-2.829-2.829a1 1 0 0 1 1.414-1.414l1.122 1.121v-6.485H3.828l1.122 1.121a1 1 0 0 1-1.414 1.414L.707 11.664a1 1 0 0 1 0-1.414l2.829-2.83A1 1 0 0 1 4.95 8.836l-1.122 1.12h6.486V3.473l-1.122 1.12a1 1 0 0 1-1.414-1.414L10.607.35a1 1 0 0 1 1.414 0l2.828 2.829a1 1 0 1 1-1.414 1.414l-1.121-1.121v6.485z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-0.5 -1 24 24"
}

export const jamMoveAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12.586 2H11a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0V3.414L9.414 8L14 12.586V11a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1h-4a1 1 0 0 1 0-2h1.586L8 9.414L3.414 14H5a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1v-4a1 1 0 0 1 2 0v1.586L6.586 8L2 3.414V5a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H3.414L8 6.586z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -4 24 24"
}

export const jamMovie: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 15v3h8v-7H6zm-2-2v-2H2V9h2V7H2v6zm0 2H2v1a2 2 0 0 0 2 2zm14-2V7h-2v2h2v2h-2v2zm0 2h-2v3a2 2 0 0 0 2-2zm-4-8V2H6v7h8zm4-2V4a2 2 0 0 0-2-2v3zM4 5V2a2 2 0 0 0-2 2v1zm0-5h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMug: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm10.874 1H16a4 4 0 0 1 4 4v3a4 4 0 0 1-4 4h-1v2a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h7a4 4 0 0 1 3.874 3M15 12h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMugF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14.874 3H16a4 4 0 0 1 4 4v3a4 4 0 0 1-4 4h-1v2a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h7a4 4 0 0 1 3.874 3M15 12h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMusic: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7.954 12.304V1a1 1 0 0 1 1-1h.028a1 1 0 0 1 1 1v14.065c.197 1.969-1.42 3.99-3.874 4.693c-2.69.772-5.368-.333-5.98-2.468s1.073-4.491 3.764-5.263c1.47-.421 2.935-.283 4.062.277m-2.4 5.521c1.698-.487 2.645-1.81 2.37-2.77c-.276-.961-1.78-1.582-3.478-1.095s-2.645 1.81-2.37 2.771c.276.96 1.78 1.581 3.478 1.094\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7 -2 24 24"
}

export const jamMusicF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7.954 12.87V1.564a1 1 0 0 1 1-1h.028a1 1 0 0 1 1 1V15.63c.197 1.969-1.42 3.99-3.874 4.693c-2.69.772-5.368-.333-5.98-2.468s1.073-4.491 3.764-5.263c1.47-.421 2.935-.283 4.062.277z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7 -1.5 24 24"
}

export const jamMyspace: Icon = {
  "body": "<g fill=\"currentColor\"><ellipse cx=\"2.835\" cy=\"4.885\" rx=\"2.576\" ry=\"2.55\"/><path d=\"M2.8 8.102C1.24 8.121 0 9.41 0 10.954v.718c0 .166.136.3.304.3h5.063a.303.303 0 0 0 .304-.3v-.763c0-1.562-1.289-2.826-2.87-2.807z\"/><ellipse cx=\"9.361\" cy=\"4.303\" rx=\"2.788\" ry=\"2.76\"/><path d=\"M9.323 7.784c-1.688.02-3.03 1.415-3.03 3.086v.802a.3.3 0 0 0 .303.3h5.529a.303.303 0 0 0 .304-.3v-.85c0-1.69-1.394-3.058-3.106-3.038m7.163-1.434c1.763 0 3.193-1.416 3.193-3.162S18.249.027 16.486.027s-3.193 1.415-3.193 3.161s1.43 3.162 3.193 3.162m0 .825c-1.94 0-3.514 1.558-3.514 3.48v1.017c0 .166.136.3.304.3h6.42a.303.303 0 0 0 .304-.3v-1.018c0-1.921-1.573-3.479-3.514-3.479\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6 24 24"
}

export const jamMyspaceCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><ellipse cx=\"6.418\" cy=\"9.443\" rx=\"1.288\" ry=\"1.275\"/><path d=\"M6.4 11.051c-.78.01-1.4.654-1.4 1.426v.359c0 .083.068.15.152.15h2.531a.15.15 0 0 0 .152-.15v-.382A1.41 1.41 0 0 0 6.4 11.051\"/><ellipse cx=\"9.68\" cy=\"9.151\" rx=\"1.394\" ry=\"1.38\"/><path d=\"M9.661 10.892a1.54 1.54 0 0 0-1.515 1.543v.4c0 .084.068.151.152.151h2.764a.15.15 0 0 0 .153-.15v-.425c0-.845-.698-1.53-1.554-1.519m3.582-.717c.882 0 1.597-.708 1.597-1.581s-.715-1.58-1.597-1.58s-1.597.707-1.597 1.58s.715 1.58 1.597 1.58zm0 .413c-.97 0-1.757.779-1.757 1.74v.508c0 .083.068.15.152.15h3.21a.15.15 0 0 0 .152-.15v-.509c0-.96-.787-1.74-1.757-1.74z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamMyspaceSquare: Icon = {
  "body": "<g fill=\"currentColor\"><ellipse cx=\"6.418\" cy=\"9.443\" rx=\"1.288\" ry=\"1.275\"/><path d=\"M6.4 11.051c-.78.01-1.4.654-1.4 1.426v.359c0 .083.068.15.152.15h2.531a.15.15 0 0 0 .152-.15v-.382A1.41 1.41 0 0 0 6.4 11.051\"/><ellipse cx=\"9.68\" cy=\"9.151\" rx=\"1.394\" ry=\"1.38\"/><path d=\"M9.661 10.892a1.54 1.54 0 0 0-1.515 1.543v.4c0 .084.068.151.152.151h2.764a.15.15 0 0 0 .153-.15v-.425c0-.845-.698-1.53-1.554-1.519m3.582-.717c.882 0 1.597-.708 1.597-1.581s-.715-1.58-1.597-1.58s-1.597.707-1.597 1.58s.715 1.58 1.597 1.58zm0 .413c-.97 0-1.757.779-1.757 1.74v.508c0 .083.068.15.152.15h3.21a.15.15 0 0 0 .152-.15v-.509c0-.96-.787-1.74-1.757-1.74z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamNapster: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M12.07 13.98a5.9 5.9 0 0 1-2.002 1.243a5.25 5.25 0 0 1-2.002-1.243h4.005\"/><path d=\"M3.99 2.87C5.49 1.15 7.636.078 10.067.078s4.577 1.071 6.08 2.792a8.5 8.5 0 0 1 2.002-.306v2.811a3.92 3.92 0 0 1 1.716 3.232a3.89 3.89 0 0 1-1.716 3.213l-.072.076c-.429 4.13-3.861 7.304-8.01 7.304c-4.22 0-7.652-3.232-8.081-7.38A3.91 3.91 0 0 1 .27 8.606c0-1.358.715-2.563 1.717-3.213v-2.83c.715.02 1.359.134 2.002.306zm2.36 2.983a6.66 6.66 0 0 0-2.79-1.472v6.578c0 3.671 2.933 6.616 6.508 6.616s6.437-2.945 6.437-6.636V4.381a7.1 7.1 0 0 0-2.717 1.472a6.4 6.4 0 0 0-3.72-1.204c-1.359 0-2.646.44-3.718 1.204m0-1.912c1.144-.593 2.36-.937 3.718-.937c1.36 0 2.575.344 3.72.937c.214-.172.5-.325.786-.478c-1.144-1.128-2.79-1.817-4.506-1.817s-3.361.689-4.506 1.836c.215.115.573.287.788.46z\"/><path d=\"M12.07 10.959c1.074-.134 2.933-.115 2.933-.115c-.071.344 0 1.32-1.072 1.931c-.143.096-.573.248-1.001.268c-1.002.038-2.432.057-2.432.057c.286-1.166.643-2.046 1.573-2.141m-4.005 0c.858.095 1.287.975 1.573 2.141c0 0-1.43-.02-2.431-.057c-.43-.02-.858-.173-1.002-.268c-1.073-.612-1-1.587-1.073-1.931c0 0 1.86-.02 2.933.115m3.862 5.258c-.5.344-1.144.536-1.86.536a3.7 3.7 0 0 1-1.93-.536s.07-.21.142-.383c.143-.21.286-.267.286-.267a5.4 5.4 0 0 0 1.502.21c.5 0 1.001-.077 1.502-.21c0 0 .143.076.286.306c.072.191.072.344.072.344\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamNapsterCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M11.035 11.99a2.9 2.9 0 0 1-1 .621a2.6 2.6 0 0 1-1.002-.621z\"/><path d=\"M6.995 6.435a4 4 0 0 1 3.04-1.396c1.215 0 2.288.536 3.039 1.396a4.2 4.2 0 0 1 1.001-.153v1.406c.5.334.858.936.858 1.615c0 .68-.358 1.272-.858 1.607l-.036.038c-.214 2.065-1.93 3.652-4.005 3.652c-2.11 0-3.826-1.616-4.04-3.69a1.93 1.93 0 0 1 0-3.213V6.282c.357.01.679.067 1 .153zm1.18 1.492A3.3 3.3 0 0 0 6.78 7.19v3.29c0 1.835 1.466 3.307 3.254 3.307s3.219-1.472 3.219-3.317V7.19a3.54 3.54 0 0 0-1.36.737a3.2 3.2 0 0 0-1.859-.603c-.68 0-1.323.22-1.86.603zm0-.956a4 4 0 0 1 1.86-.47c.679 0 1.286.173 1.859.47a2.6 2.6 0 0 1 .393-.24a3.24 3.24 0 0 0-2.253-.908c-.858 0-1.68.344-2.253.918c.108.057.286.143.394.23\"/><path d=\"M11.035 10.48c.537-.068 1.467-.058 1.467-.058c-.036.172 0 .66-.537.966a1.2 1.2 0 0 1-.5.133c-.5.02-1.216.03-1.216.03c.143-.584.321-1.024.786-1.072m-2.002.001c.43.047.644.487.787 1.07c0 0-.716-.01-1.216-.029a1.2 1.2 0 0 1-.5-.134c-.537-.306-.501-.793-.537-.965c0 0 .93-.01 1.466.057m1.931 2.63c-.25.172-.572.267-.93.267a1.84 1.84 0 0 1-.965-.267s.035-.106.071-.192a.36.36 0 0 1 .143-.134a2.7 2.7 0 0 0 1.502 0s.072.039.143.153a.6.6 0 0 1 .036.173\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamNapsterSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M11.035 11.99a2.9 2.9 0 0 1-1 .621a2.6 2.6 0 0 1-1.002-.621z\"/><path d=\"M6.995 6.435a4 4 0 0 1 3.04-1.396c1.215 0 2.288.536 3.039 1.396a4.2 4.2 0 0 1 1.001-.153v1.406c.5.334.858.936.858 1.615c0 .68-.358 1.272-.858 1.607l-.036.038c-.214 2.065-1.93 3.652-4.005 3.652c-2.11 0-3.826-1.616-4.04-3.69a1.93 1.93 0 0 1 0-3.213V6.282c.357.01.679.067 1 .153zm1.18 1.492A3.3 3.3 0 0 0 6.78 7.19v3.29c0 1.835 1.466 3.307 3.254 3.307s3.219-1.472 3.219-3.317V7.19a3.54 3.54 0 0 0-1.36.737a3.2 3.2 0 0 0-1.859-.603c-.68 0-1.323.22-1.86.603zm0-.956a4 4 0 0 1 1.86-.47c.679 0 1.286.173 1.859.47a2.6 2.6 0 0 1 .393-.24a3.24 3.24 0 0 0-2.253-.908c-.858 0-1.68.344-2.253.918c.108.057.286.143.394.23\"/><path d=\"M11.035 10.48c.537-.068 1.467-.058 1.467-.058c-.036.172 0 .66-.537.966a1.2 1.2 0 0 1-.5.133c-.5.02-1.216.03-1.216.03c.143-.584.321-1.024.786-1.072m-2.002.001c.43.047.644.487.787 1.07c0 0-.716-.01-1.216-.029a1.2 1.2 0 0 1-.5-.134c-.537-.306-.501-.793-.537-.965c0 0 .93-.01 1.466.057m1.931 2.63c-.25.172-.572.267-.93.267a1.84 1.84 0 0 1-.965-.267s.035-.106.071-.192a.36.36 0 0 1 .143-.134a2.7 2.7 0 0 0 1.502 0s.072.039.143.153a.6.6 0 0 1 .036.173\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamNewsletter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 0h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m0 2v10h16V2zm3 6h6a1 1 0 0 1 0 2H5a1 1 0 1 1 0-2m10-5h2v2h-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -5 24 24"
}

export const jamNewsletterF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 .565h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2m3 8a1 1 0 1 0 0 2h6a1 1 0 0 0 0-2zm10-5v2h2v-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4.5 24 24"
}

export const jamNewspaper: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h10a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm2 13h2a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2m6-12a1 1 0 1 1 0 2a1 1 0 0 1 0-2m0 3a1 1 0 1 1 0 2a1 1 0 0 1 0-2m-6 6h6a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2m0-3h6a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2m.5-6h2A1.5 1.5 0 0 1 9 4.5v2A1.5 1.5 0 0 1 7.5 8h-2A1.5 1.5 0 0 1 4 6.5v-2A1.5 1.5 0 0 1 5.5 3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamNewspaperF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h10a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m8 2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2zM3 9a1 1 0 1 0 0 2h10a1 1 0 0 0 0-2zm0 3a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2zm0 3a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2zm8-10a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2zM3 2a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamNpm: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M0 0h20v6.857H10V8H5.556V6.857H0zm1.111 5.714h2.222V2.286h1.111v3.428h1.112V1.143H1.11zm5.556-4.571v5.714h2.222V5.714h2.222V1.143zm5.555 0v4.571h2.222V2.286h1.112v3.428h1.11V2.286h1.112v3.428h1.11V1.143z\"/><path d=\"M10 4.7H9V2.2h1z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -8 24 24"
}

export const jamOdnoklassniki: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M4.974 14.011c-1.531-.16-2.912-.54-4.094-1.471c-.147-.116-.299-.228-.432-.357c-.518-.5-.57-1.074-.16-1.664c.35-.506.938-.641 1.549-.35c.118.055.23.126.339.201c2.203 1.524 5.23 1.566 7.441.069c.22-.17.454-.308.725-.378c.528-.136 1.02.059 1.303.524c.324.53.32 1.05-.079 1.461c-.611.633-1.347 1.09-2.164 1.409c-.773.302-1.62.454-2.457.554c.126.139.186.207.265.287c1.137 1.15 2.28 2.297 3.414 3.451c.386.394.467.881.254 1.339c-.233.5-.753.829-1.264.794c-.323-.023-.575-.185-.8-.412c-.858-.87-1.732-1.724-2.573-2.61c-.245-.258-.363-.209-.579.015c-.863.895-1.74 1.776-2.624 2.653c-.396.393-.868.464-1.328.24c-.488-.24-.8-.741-.775-1.246c.016-.342.183-.602.416-.836q1.688-1.7 3.371-3.4c.074-.076.144-.156.252-.273\"/><path d=\"M5.907 10.069C3.175 10.059.935 7.779.95 5.023C.966 2.237 3.208-.007 5.967 0c2.764.007 4.983 2.285 4.97 5.1c-.015 2.75-2.27 4.978-5.03 4.969m2.483-5.04a2.444 2.444 0 0 0-2.443-2.458A2.447 2.447 0 0 0 3.498 5.06A2.443 2.443 0 0 0 5.96 7.5a2.44 2.44 0 0 0 2.43-2.47z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -2 24 24"
}

export const jamOdnoklassnikiCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M9.53 11.996c-.77-.081-1.463-.272-2.057-.74c-.074-.058-.15-.114-.217-.18c-.26-.25-.287-.539-.08-.835c.175-.254.47-.322.778-.177a1 1 0 0 1 .17.102c1.107.766 2.628.787 3.74.034a1 1 0 0 1 .363-.19a.57.57 0 0 1 .655.264c.163.267.16.527-.04.734a3 3 0 0 1-1.087.708c-.388.152-.814.228-1.235.279c.064.07.094.104.134.144q.858.865 1.715 1.734c.194.198.235.443.128.673c-.117.25-.379.416-.635.398a.62.62 0 0 1-.402-.207c-.431-.437-.87-.866-1.293-1.311c-.123-.13-.183-.105-.291.007q-.652.674-1.319 1.334c-.199.197-.436.233-.667.12a.68.68 0 0 1-.39-.626a.63.63 0 0 1 .21-.42l1.694-1.709c.037-.038.072-.078.126-.136\"/><path d=\"M9.988 10a2.503 2.503 0 0 1-2.481-2.506A2.506 2.506 0 0 1 10.018 5a2.503 2.503 0 0 1 2.489 2.532C12.5 8.898 11.37 10.005 9.988 10m1.244-2.502a1.22 1.22 0 0 0-1.224-1.221a1.22 1.22 0 0 0-1.226 1.235a1.22 1.22 0 0 0 1.233 1.212a1.216 1.216 0 0 0 1.217-1.226\"/><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamOdnoklassnikiSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M9.53 11.996c-.77-.081-1.463-.272-2.057-.74c-.074-.058-.15-.114-.217-.18c-.26-.25-.287-.539-.08-.835c.175-.254.47-.322.778-.177a1 1 0 0 1 .17.102c1.107.766 2.628.787 3.74.034a1 1 0 0 1 .363-.19a.57.57 0 0 1 .655.264c.163.267.16.527-.04.734a3 3 0 0 1-1.087.708c-.388.152-.814.228-1.235.279c.064.07.094.104.134.144q.858.865 1.715 1.734c.194.198.235.443.128.673c-.117.25-.379.416-.635.398a.62.62 0 0 1-.402-.207c-.431-.437-.87-.866-1.293-1.311c-.123-.13-.183-.105-.291.007q-.652.674-1.319 1.334c-.199.197-.436.233-.667.12a.68.68 0 0 1-.39-.626a.63.63 0 0 1 .21-.42l1.694-1.709c.037-.038.072-.078.126-.136\"/><path d=\"M9.988 10a2.503 2.503 0 0 1-2.481-2.506A2.506 2.506 0 0 1 10.018 5a2.503 2.503 0 0 1 2.489 2.532C12.5 8.898 11.37 10.005 9.988 10m1.244-2.502a1.22 1.22 0 0 0-1.224-1.221a1.22 1.22 0 0 0-1.226 1.235a1.22 1.22 0 0 0 1.233 1.212a1.216 1.216 0 0 0 1.217-1.226\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamOpera: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14.918 1.57C13.423.56 11.572 0 9.485 0c-1.91 0-3.62.466-5.043 1.32C1.702 2.944.014 5.987.014 9.886c0 5.274 3.787 10.078 9.469 10.078s9.468-4.803 9.468-10.078c0-3.707-1.526-6.64-4.033-8.316m-5.434.293c3.048 0 3.785 4.182 3.785 7.982c0 3.52-.462 8.23-3.748 8.23s-3.829-4.756-3.829-8.276c0-3.8.744-7.936 3.792-7.936\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2.5 -2 24 24"
}

export const jamOperaCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M12.713 5.787c-.749-.506-1.676-.786-2.721-.786c-.956 0-1.813.233-2.526.66C6.093 6.476 5.248 8 5.248 9.953C5.248 12.594 7.145 15 9.991 15s4.742-2.406 4.742-5.048c0-1.857-.764-3.326-2.02-4.166zm-2.721.147c1.526 0 1.896 2.095 1.896 3.997c0 1.764-.232 4.123-1.878 4.123S8.092 11.672 8.092 9.91c0-1.903.373-3.975 1.9-3.975z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamOperaSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M12.713 5.787c-.749-.506-1.676-.786-2.721-.786c-.956 0-1.813.233-2.526.66C6.093 6.476 5.248 8 5.248 9.953C5.248 12.594 7.145 15 9.991 15s4.742-2.406 4.742-5.048c0-1.857-.764-3.326-2.02-4.166zm-2.721.147c1.526 0 1.896 2.095 1.896 3.997c0 1.764-.232 4.123-1.878 4.123S8.092 11.672 8.092 9.91c0-1.903.373-3.975 1.9-3.975z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamOrderedList: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 1h9a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2m0 8h9a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2m0-4h9a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2M.438.845h.72L1.111 3H.65L.7 1.28H.224zM.523 5.59l-.45-.053q.017-.367.234-.582a.76.76 0 0 1 .556-.214q.209 0 .37.089a.67.67 0 0 1 .26.258a.7.7 0 0 1 .097.342a1 1 0 0 1-.115.435q-.113.228-.407.535l-.158.17h.647V7H.014l.015-.231l.666-.68q.238-.24.313-.382a.5.5 0 0 0 .074-.245a.23.23 0 0 0-.067-.17a.24.24 0 0 0-.179-.067a.23.23 0 0 0-.182.081q-.05.056-.131.284m.982 4.398q.12.159.121.373a.7.7 0 0 1-.23.528a.8.8 0 0 1-.579.215a.76.76 0 0 1-.545-.203c-.142-.136-.22-.32-.183-.603l.456.042q.024.151.1.22a.28.28 0 0 0 .194.068q.124 0 .203-.078a.25.25 0 0 0 .08-.19a.26.26 0 0 0-.109-.209c-.075-.06-.187-.09-.386-.143l.046-.401a.6.6 0 0 0 .203-.042a.2.2 0 0 0 .092-.077a.2.2 0 0 0 .032-.1a.14.14 0 0 0-.045-.109a.18.18 0 0 0-.127-.044a.2.2 0 0 0-.13.044a.22.22 0 0 0-.08.113l-.048.035l-.444-.056a.7.7 0 0 1 .185-.413a.7.7 0 0 1 .53-.217q.284 0 .479.182a.58.58 0 0 1 .195.436a.5.5 0 0 1-.087.29c-.056.085-.136.153-.246.12a.63.63 0 0 1 .323.219\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -6 24 24"
}

export const jamOrientaton: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 10.941v7h12v-7zm0-2h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2m9.012-2h-2V2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H18v-2h.012V2h-7z\"/>",
  "width": 21,
  "height": 20,
  "viewBox": "0 0 21 20"
}

export const jamPadlock: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 12v6h10v-6zm10-2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2V5a5 5 0 1 1 10 0zm-2 0V5a3 3 0 1 0-6 0v5zm-3 7a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamPadlockAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 18a4 4 0 1 0 0-8a4 4 0 0 0 0 8M2 9.528V4a4 4 0 1 1 8 0v5.528a6 6 0 1 1-8 0M4 8.34A6 6 0 0 1 6 8c.701 0 1.374.12 2 .341V4a2 2 0 1 0-4 0v4.341zM6 16a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -2 24 24"
}

export const jamPadlockAltF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 9.528V4a4 4 0 1 1 8 0v5.528a6 6 0 1 1-8 0M4 8.34A6 6 0 0 1 6 8c.701 0 1.374.12 2 .341V4a2 2 0 1 0-4 0v4.341zM6 16a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -2 24 24"
}

export const jamPadlockAltOpen: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 18a4 4 0 1 0 0-8a4 4 0 0 0 0 8M2 9.528V4a4 4 0 1 1 8 0v1a1 1 0 1 1-2 0V4a2 2 0 1 0-4 0v4.341a6 6 0 1 1-2 1.186zM6 16a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -2 24 24"
}

export const jamPadlockAltOpenF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 9.528V4a4 4 0 1 1 8 0v1a1 1 0 1 1-2 0V4a2 2 0 1 0-4 0v4.341a6 6 0 1 1-2 1.186zM6 16a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -2 24 24"
}

export const jamPadlockF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2V5a5 5 0 1 1 10 0zm-5 7a2 2 0 1 0 0-4a2 2 0 0 0 0 4m3-7V5a3 3 0 1 0-6 0v5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamPadlockOpen: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 12v6h10v-6zm8-7a3 3 0 1 0-6 0v5h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2V5a5 5 0 1 1 10 0a1 1 0 0 1-2 0M7 17a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamPadlockOpenF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 5h-2a3 3 0 1 0-6 0v5h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2V5a5 5 0 1 1 10 0M7 17a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamPageBreak: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 6h2a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2m10 0h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2M6 6h2a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2M0 1a1 1 0 1 1 2 0v2.014h10V1a1 1 0 0 1 2 0v2.014a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm0 12.014V11a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v2.014a1 1 0 0 1-2 0V11H2v2.014a1 1 0 0 1-2 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const jamPaperPlane: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m16.907 4.44l-7.655 7.655q.341.489.575 1.048l1.91 4.599l5.17-13.303zm-9.002 6.308l7.656-7.656l-13.303 5.17l4.599 1.911a5.5 5.5 0 0 1 1.048.575m11.618-7.862l-6.027 15.506c-.38.98-1.477 1.483-2.449 1.124a1.83 1.83 0 0 1-1.057-1.017L8.08 13.9a3.66 3.66 0 0 0-1.98-1.98l-4.6-1.91C.546 9.613.11 8.51.528 7.544a1.95 1.95 0 0 1 1.08-1.04L17.114.475a1.852 1.852 0 0 1 2.41 2.41z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPaperPlaneF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7.671 13.44L19.926 1.384c.116.408.096.847-.061 1.25l-6.25 16.08c-.395 1.016-1.532 1.538-2.54 1.165a1.9 1.9 0 0 1-1.097-1.054l-1.981-4.77q-.136-.325-.326-.617zm-1.41-1.288a4 4 0 0 0-.317-.148l-4.77-1.981C.185 9.61-.268 8.465.165 7.465a2.02 2.02 0 0 1 1.121-1.079l16.08-6.25c.46-.179.94-.175 1.365-.025L6.26 12.152z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamParagraph: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 2v11a1 1 0 0 1-2 0V2H8v11a1 1 0 0 1-2 0V8H4a4 4 0 1 1 0-8h9a1 1 0 0 1 0 2zM6 6V2H4a2 2 0 1 0 0 4z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const jamPatreon: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12.808.01c-3.95 0-7.164 3.196-7.164 7.125c0 3.916 3.214 7.103 7.164 7.103c3.938 0 7.142-3.187 7.142-7.103c0-3.93-3.204-7.125-7.142-7.125M.05 18.99V.01h3.502v18.98z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2.5 24 24"
}

export const jamPatreonCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M11.464 5.206c-1.976 0-3.583 1.598-3.583 3.563c0 1.958 1.607 3.551 3.583 3.551c1.969 0 3.57-1.593 3.57-3.551a3.57 3.57 0 0 0-3.57-3.563m-6.38 9.49v-9.49h1.752v9.49z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPatreonSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M11.464 5.206c-1.976 0-3.583 1.598-3.583 3.563c0 1.958 1.607 3.551 3.583 3.551c1.969 0 3.57-1.593 3.57-3.551a3.57 3.57 0 0 0-3.57-3.563m-6.38 9.49v-9.49h1.752v9.49z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPause: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 0h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m0 2v14h2V2zm10-2h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m0 2v14h2V2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -3 24 24"
}

export const jamPaypal: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"m4.328 16.127l-.011.07a.9.9 0 0 1-.887.744H.9a.892.892 0 0 1-.88-1.04L2.57.745A.89.89 0 0 1 3.45 0h6.92a4.14 4.14 0 0 1 4.142 4.141q0 .409-.05.804a3.63 3.63 0 0 1 1.53 2.962a5.72 5.72 0 0 1-5.72 5.722h-.583a1.34 1.34 0 0 0-1.32 1.117l-.314 1.87l.314-1.87a1.34 1.34 0 0 1 1.32-1.117h.582a5.72 5.72 0 0 0 5.722-5.722a3.63 3.63 0 0 0-1.53-2.962a6.52 6.52 0 0 1-6.47 5.716H6.06a.97.97 0 0 0-.93.701l-1.155 6.862c-.08.48.289.916.775.916h2.214a.786.786 0 0 0 .775-.655l.315-1.87l-.315 1.87a.786.786 0 0 1-.775.655H4.751a.78.78 0 0 1-.6-.278a.78.78 0 0 1-.175-.638z\"/><path d=\"M15.45 5.995c.365.567.578 1.242.578 1.967a5.72 5.72 0 0 1-5.722 5.722h-.581c-.654 0-1.212.472-1.32 1.117l-.63 3.739a.786.786 0 0 1-.774.655H4.973l1.15-6.833c.118-.41.495-.7.93-.7h1.932a6.52 6.52 0 0 0 6.464-5.667zm-10.477 13.2h-.187a.786.786 0 0 1-.775-.916l.057-.338h.355a.9.9 0 0 0 .886-.743l.012-.07z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamPaypalCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"m8.252 13.405l-.006.036a.47.47 0 0 1-.462.388h-1.32a.465.465 0 0 1-.457-.542l1.329-7.9A.465.465 0 0 1 7.794 5H11.4c1.192 0 2.158.966 2.158 2.158q0 .213-.026.42c.483.342.798.906.798 1.543a2.98 2.98 0 0 1-2.982 2.982h-.303a.7.7 0 0 0-.688.582l-.164.974l.164-.974a.7.7 0 0 1 .688-.582h.303a2.98 2.98 0 0 0 2.982-2.982c0-.637-.315-1.2-.798-1.544a3.4 3.4 0 0 1-3.372 2.98H9.155a.505.505 0 0 0-.485.364l-.602 3.576a.41.41 0 0 0 .404.478h1.154c.2 0 .37-.145.404-.342l.164-.974l-.164.974a.41.41 0 0 1-.404.342H8.472a.408.408 0 0 1-.404-.478z\"/><path d=\"M13.967 8c.19.295.301.647.301 1.025a2.98 2.98 0 0 1-2.981 2.982h-.304a.7.7 0 0 0-.688.582l-.327 1.949a.41.41 0 0 1-.404.341H8.507l.6-3.56a.505.505 0 0 1 .484-.366h1.007A3.4 3.4 0 0 0 13.967 8m-5.46 6.88H8.41a.41.41 0 0 1-.404-.478l.03-.176h.185a.47.47 0 0 0 .461-.388l.007-.036l-.182 1.077z\"/><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPaypalSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"m8.252 13.405l-.006.036a.47.47 0 0 1-.462.388h-1.32a.465.465 0 0 1-.457-.542l1.329-7.9A.465.465 0 0 1 7.794 5H11.4c1.192 0 2.158.966 2.158 2.158q0 .213-.026.42c.483.342.798.906.798 1.543a2.98 2.98 0 0 1-2.982 2.982h-.303a.7.7 0 0 0-.688.582l-.164.974l.164-.974a.7.7 0 0 1 .688-.582h.303a2.98 2.98 0 0 0 2.982-2.982c0-.637-.315-1.2-.798-1.544a3.4 3.4 0 0 1-3.372 2.98H9.155a.505.505 0 0 0-.485.364l-.602 3.576a.41.41 0 0 0 .404.478h1.154c.2 0 .37-.145.404-.342l.164-.974l-.164.974a.41.41 0 0 1-.404.342H8.472a.408.408 0 0 1-.404-.478z\"/><path d=\"M13.967 8c.19.295.301.647.301 1.025a2.98 2.98 0 0 1-2.981 2.982h-.304a.7.7 0 0 0-.688.582l-.327 1.949a.41.41 0 0 1-.404.341H8.507l.6-3.56a.505.505 0 0 1 .484-.366h1.007A3.4 3.4 0 0 0 13.967 8m-5.46 6.88H8.41a.41.41 0 0 1-.404-.478l.03-.176h.185a.47.47 0 0 0 .461-.388l.007-.036l-.182 1.077z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPen: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m5.648 12.276l-1.65 1.1l-.415 1.68l1.665-.42l1.104-1.656zM7.1 10.899l.627.627l.091-.032c.937-.334 1.88-1.019 2.824-2.089c1.139-1.29 3.061-3.587 5.757-6.879a.211.211 0 0 0-.297-.297c-3.286 2.693-5.583 4.616-6.881 5.758c-1.076.946-1.76 1.888-2.088 2.819zm-.615 5.486L.843 17.814l1.4-5.671l3.004-2.004Q5.926 8.225 7.9 6.486Q9.88 4.743 14.836.682a2.21 2.21 0 0 1 3.111 3.112q-4.065 4.963-5.804 6.934q-1.734 1.965-3.652 2.65z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2.5 -3 24 24"
}

export const jamPenF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8.406 12.732L5.367 9.693q.815-1.435 2.375-2.838q2.012-1.812 7.1-6.126a1.795 1.795 0 0 1 2.53 2.53q-4.32 5.097-6.125 7.1q-1.402 1.555-2.841 2.373M3.99 11.146l2.965 2.964l-1.366 1.906l-5.276 1.795l1.771-5.3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -3 24 24"
}

export const jamPencil: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12.238 5.472L3.2 14.51l-.591 2.016l1.975-.571l9.068-9.068zM13.78 3.93l1.414 1.414l1.318-1.318a.5.5 0 0 0 0-.707l-.708-.707a.5.5 0 0 0-.707 0L13.781 3.93zm3.439-2.732l.707.707a2.5 2.5 0 0 1 0 3.535L5.634 17.733l-4.22 1.22a1 1 0 0 1-1.237-1.241l1.248-4.255l12.26-12.26a2.5 2.5 0 0 1 3.535 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2.5 -2.5 24 24"
}

export const jamPencilF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m16.318 6.11l-3.536-3.535l1.415-1.414c.63-.63 2.073-.755 2.828 0l.707.707c.755.755.631 2.198 0 2.829zm-1.414 1.415l-9.9 9.9l-4.596 1.06l1.06-4.596l9.9-9.9z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2.5 -2.5 24 24"
}

export const jamPeriscope: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M7.986 0C3.58 0 .01 3.516.01 7.852c0 5.155 6.485 12.12 7.976 12.12s7.975-6.77 7.975-12.12C15.96 3.516 12.39 0 7.986 0M7.95 13.73c-3.136 0-5.677-2.503-5.677-5.59S4.814 2.551 7.95 2.551s5.676 2.503 5.676 5.59s-2.541 5.589-5.676 5.589\"/><path d=\"M7.95 3.631q-.211 0-.418.02c.338.384.543.885.543 1.433c0 1.211-.997 2.193-2.227 2.193A2.23 2.23 0 0 1 3.87 6.09c-.32.615-.5 1.311-.5 2.05c0 2.49 2.05 4.509 4.58 4.509c2.529 0 4.58-2.019 4.58-4.51S10.479 3.63 7.95 3.63z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamPeriscopeCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M9.993 5C7.79 5 6.005 6.758 6.005 8.926c0 2.577 3.243 6.06 3.988 6.06s3.987-3.385 3.987-6.06C13.98 6.758 12.195 5 9.993 5m-.018 6.865c-1.568 0-2.839-1.251-2.839-2.795c0-1.543 1.271-2.794 2.839-2.794c1.567 0 2.838 1.25 2.838 2.794s-1.27 2.795-2.838 2.795\"/><path d=\"M9.975 6.816q-.105 0-.21.01c.17.192.272.442.272.716c0 .606-.498 1.096-1.113 1.096c-.43 0-.804-.24-.989-.593c-.16.308-.25.656-.25 1.025c0 1.245 1.025 2.255 2.29 2.255c1.264 0 2.29-1.01 2.29-2.255s-1.025-2.254-2.29-2.254\"/><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPeriscopeSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M9.993 5C7.79 5 6.005 6.758 6.005 8.926c0 2.577 3.243 6.06 3.988 6.06s3.987-3.385 3.987-6.06C13.98 6.758 12.195 5 9.993 5m-.018 6.865c-1.568 0-2.839-1.251-2.839-2.795c0-1.543 1.271-2.794 2.839-2.794c1.567 0 2.838 1.25 2.838 2.794s-1.27 2.795-2.838 2.795\"/><path d=\"M9.975 6.816q-.105 0-.21.01c.17.192.272.442.272.716c0 .606-.498 1.096-1.113 1.096c-.43 0-.804-.24-.989-.593c-.16.308-.25.656-.25 1.025c0 1.245 1.025 2.255 2.29 2.255c1.264 0 2.29-1.01 2.29-2.255s-1.025-2.254-2.29-2.254\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPhone: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h6a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm3 15a1 1 0 1 1 0-2a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -2 24 24"
}

export const jamPhoneF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 .565h6a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-14a3 3 0 0 1 3-3m3 17a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -1.5 24 24"
}

export const jamPicture: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 8.503V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3.504l4.39-7.322a3 3 0 0 1 4.69-.582zm0 2.823l-3.828-3.814a1 1 0 0 0-1.563.195L8.836 14H17a1 1 0 0 0 1-1zM3 0h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 9a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0-2a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamPictureEdit: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 13V9a1 1 0 1 1-2 0V7a1 1 0 1 1 2 0V3a1 1 0 1 1-2 0a3 3 0 0 1 3-3a1 1 0 1 1 0 2h4a1 1 0 1 1 0-2h3a1 1 0 0 1 0 2h4a1 1 0 0 1 0-2h3a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3a1 1 0 0 1 2 0m16-4.497V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3.504l4.39-7.322a3 3 0 0 1 4.69-.582zm0 2.823l-3.828-3.814a1 1 0 0 0-1.563.195L8.836 14H17a1 1 0 0 0 1-1zM6 9a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0-2a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 20,
  "height": 16,
  "viewBox": "0 0 20 16"
}

export const jamPictureF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m20 10.536l-4.416-4.44a3 3 0 0 0-4.69.582L5.072 16H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3zm-.011 2.724A3 3 0 0 1 17 16H7.64l4.969-8.293a1 1 0 0 1 1.563-.195zM6 9a3 3 0 1 0 0-6a3 3 0 0 0 0 6\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamPictures: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 8v10h12V8zm2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm2 0h8a2 2 0 0 1 2 2v4h2V2H6zm0 9a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0-2a1 1 0 1 0 0-2a1 1 0 0 0 0 2m1-7a3 3 0 1 1 6 0h-2a1 1 0 0 0-2 0zm1.864 13.518l-1.728-1.007l2.725-4.673a3 3 0 0 1 4.8-.52l1.088 1.184l-1.473 1.354l-1.087-1.184a1 1 0 0 0-1.6.174zm6.512-12.97a2.99 2.99 0 0 1 3.285.77l1.088 1.184l-1.473 1.354l-1.087-1.184A1 1 0 0 0 16 8.457V8c0-.571-.24-1.087-.624-1.451z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPicturesF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m16 14.606l-1.339-1.287a3 3 0 0 0-4.8.52L5.94 20H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2zm0 2.752V18a2 2 0 0 1-2 2H8.512l3.077-5.154a1 1 0 0 1 1.6-.174zM6 15a3 3 0 1 0 0-6a3 3 0 0 0 0 6M4 5V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6.76l-1.339-1.441a3 3 0 0 0-1.887-.953C16.408 5.557 15.64 5 14.75 5h-1.92a3.001 3.001 0 0 0-5.66 0zm13 9V8.512a1 1 0 0 1 .189.16L20 11.661V12a2 2 0 0 1-2 2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPieChart: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10M9 1h2v10H9zm0 8h10v2H9z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPieChartAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19.95 11c-.501 5.053-4.765 9-9.95 9c-5.523 0-10-4.477-10-10C0 4.815 3.947.551 9 .05v2.012A8.001 8.001 0 0 0 10 18a8 8 0 0 0 7.938-7h2.013zm0-2h-2.012A8.004 8.004 0 0 0 11 2.062V.049A10 10 0 0 1 19.95 9\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPieChartF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19.95 11c-.501 5.053-4.765 9-9.95 9c-5.523 0-10-4.477-10-10C0 4.815 3.947.551 9 .05V11zm0-2H11V.05A10 10 0 0 1 19.95 9\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPin: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m12.626 11.346l-.184-1.036l4.49-4.491l-2.851-2.852l-4.492 4.49l-1.035-.184a5.05 5.05 0 0 0-2.734.269l6.538 6.537a5.05 5.05 0 0 0 .268-2.733m-4.25 1.604L2.67 18.654a1.008 1.008 0 0 1-1.426-1.426l5.705-5.704L2.67 7.245a7.05 7.05 0 0 1 6.236-1.958l3.747-3.747a2.017 2.017 0 0 1 2.853 0l2.852 2.853a2.017 2.017 0 0 1 0 2.852l-3.747 3.747a7.05 7.05 0 0 1-1.958 6.236z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2.5 -2.5 24 24"
}

export const jamPinAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 9.9A5.002 5.002 0 0 1 5 0a5 5 0 0 1 1 9.9V19a1 1 0 0 1-2 0zM5 8a3 3 0 1 0 0-6a3 3 0 0 0 0 6\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7 -2 24 24"
}

export const jamPinAltF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 10.465a5.002 5.002 0 0 1 1-9.9a5 5 0 0 1 1 9.9v9.1a1 1 0 0 1-2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7 -1.5 24 24"
}

export const jamPinF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m7.374 12.268l-5.656 5.657A1 1 0 1 1 .303 16.51l5.657-5.656L1.718 6.61A6.99 6.99 0 0 1 7.9 4.67L11.617.954a2 2 0 0 1 2.828 0l2.829 2.828a2 2 0 0 1 0 2.829l-3.716 3.716a6.99 6.99 0 0 1-1.941 6.183z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2.5 24 24"
}

export const jamPinterest: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6.17 13.097c-.506 2.726-1.122 5.34-2.95 6.705c-.563-4.12.829-7.215 1.475-10.5c-1.102-1.91.133-5.755 2.457-4.808c2.86 1.166-2.477 7.102 1.106 7.844c3.741.774 5.269-6.683 2.949-9.109C7.855-.272 1.45 3.15 2.238 8.163c.192 1.226 1.421 1.598.491 3.29C.584 10.962-.056 9.22.027 6.897C.159 3.097 3.344.435 6.538.067c4.04-.466 7.831 1.527 8.354 5.44c.59 4.416-1.823 9.2-6.142 8.855c-1.171-.093-1.663-.69-2.58-1.265\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4.5 -2 24 24"
}

export const jamPinterestCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M9.355 11.614C9.1 12.99 8.79 14.31 7.866 15c-.284-2.08.419-3.644.745-5.303c-.556-.964.067-2.906 1.24-2.427c1.445.588-1.25 3.586.56 3.96c1.888.392 2.66-3.374 1.488-4.6c-1.692-1.768-4.927-.04-4.529 2.492c.097.62.718.807.248 1.661c-1.083-.247-1.406-1.127-1.365-2.3c.067-1.92 1.675-3.263 3.289-3.45c2.04-.235 3.954.772 4.219 2.748c.297 2.23-.921 4.646-3.103 4.472c-.59-.047-.84-.35-1.303-.64z\"/><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPinterestSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M9.355 11.614C9.1 12.99 8.79 14.31 7.866 15c-.284-2.08.419-3.644.745-5.303c-.556-.964.067-2.906 1.24-2.427c1.445.588-1.25 3.586.56 3.96c1.888.392 2.66-3.374 1.488-4.6c-1.692-1.768-4.927-.04-4.529 2.492c.097.62.718.807.248 1.661c-1.083-.247-1.406-1.127-1.365-2.3c.067-1.92 1.675-3.263 3.289-3.45c2.04-.235 3.954.772 4.219 2.748c.297 2.23-.921 4.646-3.103 4.472c-.59-.047-.84-.35-1.303-.64z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPizzaSlice: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4.258 6.884L9.97 16.977l5.618-9.83c-1.33-.105-2.712-.453-4.242-.992c-.395-.14-.598-.171-.78-.148c-.154.02-1.723.569-2.643.802q-1.743.44-3.665.075m-1.41-2.49c1.702.67 3.224.82 4.584.476c.738-.187 2.478-.796 2.883-.847c.529-.067 1.03.01 1.696.245c1.774.626 3.296.956 4.703.909l.887-1.552A18.6 18.6 0 0 0 9.966 2a18.6 18.6 0 0 0-7.569 1.596l.451.797zM.542 2.268A20.5 20.5 0 0 1 9.966 0c3.362 0 6.606.8 9.496 2.306a1 1 0 0 1 .406 1.383l-9.034 15.807a1 1 0 0 1-1.738-.004L.13 3.65a1 1 0 0 1 .412-1.38zM8 10a1 1 0 1 1 0-2a1 1 0 0 1 0 2m3 3a1 1 0 1 1 0-2a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPlane: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m10.725 9.094l-5.509 5.51l-1.87-.777l-.167.169l2.38 1.587l1.588 2.38l.168-.168l-.776-1.87l5.509-5.508l4.328 6.252l.21-.208l-2.887-7.696l4.4-4.398a.935.935 0 0 0-1.323-1.323l-4.4 4.399l-7.694-2.886l-.21.209zm5.39 10.483l-4.33-6.253l-3.04 3.04l.777 1.87l-2.666 2.665l-2.645-3.967l-3.968-2.646l2.666-2.666l1.869.776l3.04-3.04l-6.253-4.328l2.646-2.645l7.695 2.885l3.547-3.547a2.806 2.806 0 1 1 3.968 3.968l-3.547 3.547l2.886 7.696l-2.646 2.645z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1.5 -1.5 24 24"
}

export const jamPlaneF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m12.685 13.285l-3.44 3.06l.528 2.423l-2.488 2.488l-2.507-3.921l-3.921-2.507l2.488-2.488L5.9 13l2.927-3.573l-6.171-4.114l2.828-2.829L13.2 5.057l3.793-3.793c1.171-1.172 2.985-1.258 4.05-.193s.978 2.878-.193 4.05l-3.793 3.793l2.571 7.713l-2.828 2.829z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1 -1 24 24"
}

export const jamPlay: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.82 9.523a.976.976 0 0 0-.324-1.363L3.574 2.128a1.03 1.03 0 0 0-.535-.149c-.56 0-1.013.443-1.013.99V15.03c0 .185.053.366.153.523c.296.464.92.606 1.395.317l9.922-6.031c.131-.08.243-.189.325-.317zm.746 1.997l-9.921 6.031c-1.425.867-3.3.44-4.186-.951A2.9 2.9 0 0 1 0 15.03V2.97C0 1.329 1.36 0 3.04 0c.567 0 1.123.155 1.605.448l9.921 6.032c1.425.866 1.862 2.696.975 4.088c-.246.386-.58.712-.975.952\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -3 24 24"
}

export const jamPlayCircle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m4.126-6.254l-4.055 2.898c-.905.646-2.13.389-2.737-.576A2.2 2.2 0 0 1 7 12.898V7.102C7 5.942 7.883 5 8.972 5c.391 0 .774.124 1.099.356l4.055 2.898c.905.647 1.146 1.952.54 2.917a2 2 0 0 1-.54.575M8.972 7.102v5.796L13.027 10z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPlayCircleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m4.126-8.254c.213-.153.397-.348.54-.575c.606-.965.365-2.27-.54-2.917L10.07 5.356A1.9 1.9 0 0 0 8.972 5C7.883 5 7 5.941 7 7.102v5.796c0 .417.116.824.334 1.17c.607.965 1.832 1.222 2.737.576zm-5.2-4.616l4.055 2.898l-4.056 2.897z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPlaySquare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm10.126 9.746l-4.055 2.898c-.905.646-2.13.389-2.737-.576A2.2 2.2 0 0 1 7 12.898V7.102C7 5.942 7.883 5 8.972 5c.391 0 .774.124 1.099.356l4.055 2.898c.905.647 1.146 1.952.54 2.917a2 2 0 0 1-.54.575M8.972 7.102v5.796L13.027 10z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPlaySquareF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m10.126 11.746c.213-.153.397-.348.54-.575c.606-.965.365-2.27-.54-2.917L10.07 5.356A1.9 1.9 0 0 0 8.972 5C7.883 5 7 5.941 7 7.102v5.796c0 .417.116.824.334 1.17c.607.965 1.832 1.222 2.737.576zm-5.2-4.616l4.055 2.898l-4.056 2.897V7.13z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPlug: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 9v3.5A3.5 3.5 0 0 0 5.5 16h1a3.5 3.5 0 0 0 3.5-3.5V9zm6-2V1a1 1 0 1 1 2 0v6a2 2 0 0 1 2 2v3.5a5.5 5.5 0 0 1-4.155 5.334A1.5 1.5 0 0 1 6.5 20h-1a1.5 1.5 0 0 1-1.345-2.166A5.5 5.5 0 0 1 0 12.5V9a2 2 0 0 1 2-2V1a1 1 0 1 1 2 0v6z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -2 24 24"
}

export const jamPlugF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 7.565h8a2 2 0 0 1 2 2v3.5a5.5 5.5 0 0 1-4.155 5.334A1.5 1.5 0 0 1 6.5 20.565h-1a1.5 1.5 0 0 1-1.345-2.166A5.5 5.5 0 0 1 0 13.065v-3.5a2 2 0 0 1 2-2m2-1H2v-5a1 1 0 1 1 2 0zm6 0H8v-5a1 1 0 1 1 2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -1.5 24 24"
}

export const jamPlus: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8.9 6.9v-5a1 1 0 1 0-2 0v5h-5a1 1 0 1 0 0 2h5v5a1 1 0 1 0 2 0v-5h5a1 1 0 1 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4.5 -4.5 24 24"
}

export const jamPlusCircle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m1-7v4a1 1 0 0 1-2 0v-4H5a1 1 0 0 1 0-2h4V5a1 1 0 1 1 2 0v4h4a1 1 0 0 1 0 2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPlusCircleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 11h4a1 1 0 0 0 0-2h-4V5a1 1 0 0 0-2 0v4H5a1 1 0 1 0 0 2h4v4a1 1 0 0 0 2 0zm-1 9C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPlusRectangle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m7 11v4a1 1 0 0 1-2 0v-4H5a1 1 0 0 1 0-2h4V5a1 1 0 1 1 2 0v4h4a1 1 0 0 1 0 2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPlusRectangleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 11h4a1 1 0 0 0 0-2h-4V5a1 1 0 0 0-2 0v4H5a1 1 0 1 0 0 2h4v4a1 1 0 0 0 2 0zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPocketWatch: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 13h2a1 1 0 0 1 0 2H8a1 1 0 0 1-1-1v-4a1 1 0 1 1 2 0zM7 5.732V5a1 1 0 1 1 2 0v.732a2 2 0 1 0-2 0m-2.041.866a4 4 0 1 1 6.082 0A8.002 8.002 0 0 1 8 22A8 8 0 0 1 4.959 6.598M8 20A6 6 0 1 0 8 8a6 6 0 0 0 0 12\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -1 24 24"
}

export const jamPocketWatchF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 13v-3a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1h3a1 1 0 0 0 0-2zM5 5.732V5a1 1 0 1 1 2 0v.732a2 2 0 1 0-2 0M6 20A6 6 0 1 1 6 8a6 6 0 0 1 0 12M2.959 6.598a4 4 0 1 1 6.082 0A8 8 0 0 0 6 6a8 8 0 0 0-3.041.598\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -2 24 24"
}

export const jamPodcast: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 19.8c-4.564-.927-8-4.962-8-9.8C0 4.477 4.477 0 10 0s10 4.477 10 10c0 4.838-3.436 8.873-8 9.8v-2.052a8 8 0 1 0-4 0zm0-4.141a6 6 0 1 1 4 0v-2.194a4 4 0 1 0-4 0zm3-3.927V20H9v-8.268a2 2 0 1 1 2 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPower: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 4.1a.97.97 0 0 1-.617-.898c0-.536.448-.972 1-.972q.175.001.332.055q.001-.005.004-.003C15.834 3.658 18 6.708 18 10.252C18 15.082 13.97 19 9 19s-9-3.917-9-8.749C0 6.732 2.137 3.7 5.218 2.31a1 1 0 0 1 .392-.076c.552 0 1 .435 1 .971a.97.97 0 0 1-.61.896c-2.365 1.092-4 3.436-4 6.15c0 3.758 3.134 6.805 7 6.805s7-3.047 7-6.805c0-2.714-1.635-5.058-4-6.15zM9 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2.5 24 24"
}

export const jamPrinter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16 14h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h1V9h12zM4 4V0h12v4h1a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-1v4H4v-4H3a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm2 14h8v-7H6zM6 4h8V2H6z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamPrinterF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16 4h1a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-1V9H4v7H3a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1v2h12zM6 20v-9h8v9zM6 4V0h8v4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamQrCode: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13 18h3a2 2 0 0 0 2-2v-3a1 1 0 0 1 2 0v3a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4v-3a1 1 0 0 1 2 0v3a2 2 0 0 0 2 2h3a1 1 0 0 1 0 2h6a1 1 0 0 1 0-2M2 7a1 1 0 1 1-2 0V4a4 4 0 0 1 4-4h3a1 1 0 1 1 0 2H4a2 2 0 0 0-2 2zm16 0V4a2 2 0 0 0-2-2h-3a1 1 0 0 1 0-2h3a4 4 0 0 1 4 4v3a1 1 0 0 1-2 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamQuora: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17.495 15.682s-.097 1.434-1.39 1.434c-1 0-1.682-.768-2.32-1.765c1.814-1.597 2.966-3.982 2.966-6.646C16.751 3.897 13.001 0 8.377 0S.003 3.897.003 8.705s3.749 8.705 8.374 8.705c.84 0 1.65-.129 2.414-.368c.967 1.55 2.195 2.943 4.117 2.943c3.912 0 4.074-4.303 4.074-4.303zm-9.118.293c-2.696 0-4.882-3.255-4.882-7.27s2.186-7.27 4.882-7.27s4.882 3.255 4.882 7.27c0 1.597-.346 3.073-.932 4.272c-.662-.953-1.456-1.764-2.592-2.022c-2.015-.459-3.75.456-4.3.912l.517 1.076s.523-.303 1.82 0c.817.19 1.452 1.334 2.18 2.646a3.46 3.46 0 0 1-1.575.386\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2.5 -2 24 24"
}

export const jamQuoraCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M9.5 17a7.5 7.5 0 1 0 0-15a7.5 7.5 0 0 0 0 15m0 2a9.5 9.5 0 1 1 0-19a9.5 9.5 0 0 1 0 19\"/><path d=\"M14.07 12.847s-.049.718-.696.718c-.5 0-.841-.385-1.16-.884a4.42 4.42 0 0 0 1.483-3.325C13.697 6.95 11.821 5 9.507 5s-4.19 1.95-4.19 4.356s1.876 4.356 4.19 4.356c.42 0 .826-.065 1.208-.184c.484.775 1.098 1.472 2.06 1.472c1.958 0 2.039-2.153 2.039-2.153zm-4.563.147c-1.35 0-2.443-1.629-2.443-3.638s1.094-3.638 2.443-3.638c1.35 0 2.443 1.629 2.443 3.638c0 .799-.173 1.537-.466 2.138c-.331-.477-.729-.883-1.297-1.013c-1.009-.229-1.877.229-2.152.457l.259.539s.261-.152.91 0c.41.095.727.667 1.09 1.323a1.7 1.7 0 0 1-.787.194\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2.5 -2.5 24 24"
}

export const jamQuoraSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M14.07 12.847s-.049.718-.696.718c-.5 0-.841-.385-1.16-.884a4.42 4.42 0 0 0 1.483-3.325C13.697 6.95 11.821 5 9.507 5s-4.19 1.95-4.19 4.356s1.876 4.356 4.19 4.356c.42 0 .826-.065 1.208-.184c.484.775 1.098 1.472 2.06 1.472c1.958 0 2.039-2.153 2.039-2.153zm-4.563.147c-1.35 0-2.443-1.629-2.443-3.638s1.094-3.638 2.443-3.638c1.35 0 2.443 1.629 2.443 3.638c0 .799-.173 1.537-.466 2.138c-.331-.477-.729-.883-1.297-1.013c-1.009-.229-1.877.229-2.152.457l.259.539s.261-.152.91 0c.41.095.727.667 1.09 1.323a1.7 1.7 0 0 1-.787.194\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamQuote: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 0a1 1 0 1 1 0 2c-.893 0-1.695.39-2.245 1.01A3 3 0 1 1 0 6V5a5 5 0 0 1 5-5m8 0a1 1 0 0 1 0 2c-.893 0-1.695.39-2.245 1.01A3 3 0 1 1 8 6V5a5 5 0 0 1 5-5M3 5a1 1 0 1 0 0 2a1 1 0 0 0 0-2m8 0a1 1 0 1 0 0 2a1 1 0 0 0 0-2\"/>",
  "width": 14,
  "height": 9,
  "viewBox": "0 0 14 9"
}

export const jamRainbow: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10h-2a8 8 0 1 0-16 0zm4 0a6 6 0 1 1 12 0h-2a4 4 0 1 0-8 0zm4 0a2 2 0 1 1 4 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -7 24 24"
}

export const jamRec: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12m0 2A8 8 0 1 1 8 0a8 8 0 0 1 0 16\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -4 24 24"
}

export const jamRectangle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm0-2h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamRectangleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 .565h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-10a3 3 0 0 1 3-3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3.5 24 24"
}

export const jamReddit: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M19.986 8.029a2.51 2.51 0 0 0-4.285-1.771c-1.404-.906-3.197-1.483-5.166-1.573a2.73 2.73 0 0 1 1.028-2.139a2.74 2.74 0 0 1 2.315-.539l.112.025l-.004.084a2.095 2.095 0 1 0 .328-1.121L14.113.95a3.81 3.81 0 0 0-3.228.752a3.81 3.81 0 0 0-1.433 2.983c-1.97.09-3.762.667-5.165 1.572a2.51 2.51 0 1 0-2.94 3.994q-.092.465-.093.952c0 3.606 3.912 6.53 8.74 6.53c4.826 0 8.739-2.924 8.739-6.53q0-.486-.093-.952a2.51 2.51 0 0 0 1.346-2.222m-3.905-6.925a1.013 1.013 0 0 1 0 2.025a1.013 1.013 0 0 1 0-2.025M1.083 8.03c0-.787.64-1.427 1.427-1.427c.337 0 .646.118.89.314c-.763.655-1.354 1.425-1.721 2.27a1.42 1.42 0 0 1-.596-1.157m14.442 6.923c-1.465 1.095-3.43 1.698-5.532 1.698s-4.067-.603-5.531-1.698c-1.37-1.023-2.125-2.355-2.125-3.75c0-1.394.754-2.725 2.125-3.75C5.926 6.359 7.89 5.757 9.993 5.757s4.067.602 5.532 1.697c1.37 1.024 2.125 2.355 2.125 3.75c0 1.394-.755 2.726-2.125 3.75zm2.782-5.767c-.367-.845-.958-1.614-1.721-2.269c.244-.196.554-.314.89-.314c.787 0 1.427.64 1.427 1.427c0 .476-.235.898-.596 1.156\"/><circle cx=\"6.801\" cy=\"9.678\" r=\"1.143\"/><circle cx=\"13.185\" cy=\"9.678\" r=\"1.143\"/><path d=\"M12.701 12.455a4.36 4.36 0 0 1-2.94 1.138a4.33 4.33 0 0 1-3.195-1.39a.541.541 0 1 0-.793.738a5.47 5.47 0 0 0 3.988 1.735a5.44 5.44 0 0 0 3.67-1.421a.541.541 0 1 0-.73-.8\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3 24 24"
}

export const jamRedo: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m19.347 7.24l.847-1.266a.984.984 0 0 1 1.375-.259c.456.31.58.93.277 1.383L19.65 10.38a.984.984 0 0 1-1.375.259L14.97 8.393a1 1 0 0 1-.277-1.382a.984.984 0 0 1 1.375-.26l1.344.915C16.428 4.386 13.42 2 9.863 2c-4.357 0-7.89 3.582-7.89 8s3.533 8 7.89 8c.545 0 .987.448.987 1s-.442 1-.987 1C4.416 20 0 15.523 0 10S4.416 0 9.863 0c4.504 0 8.302 3.06 9.484 7.24\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1 -2 24 24"
}

export const jamRefresh: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m17.83 4.194l.42-1.377a1 1 0 1 1 1.913.585l-1.17 3.825a1 1 0 0 1-1.248.664l-3.825-1.17a1 1 0 1 1 .585-1.912l1.672.511A7.381 7.381 0 0 0 3.185 6.584l-.26.633a1 1 0 1 1-1.85-.758l.26-.633A9.381 9.381 0 0 1 17.83 4.194M2.308 14.807l-.327 1.311a1 1 0 1 1-1.94-.484l.967-3.88a1 1 0 0 1 1.265-.716l3.828.954a1 1 0 0 1-.484 1.941l-1.786-.445a7.384 7.384 0 0 0 13.216-1.792a1 1 0 1 1 1.906.608a9.38 9.38 0 0 1-5.38 5.831a9.386 9.386 0 0 1-11.265-3.328\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1.5 -2.5 24 24"
}

export const jamRefreshReverse: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m4.859 5.308l1.594-.488a1 1 0 0 1 .585 1.913l-3.825 1.17a1 1 0 0 1-1.249-.665L.794 3.413a1 1 0 1 1 1.913-.585l.44 1.441C5.555.56 10.332-1.035 14.573.703a9.38 9.38 0 0 1 5.38 5.831a1 1 0 1 1-1.905.608A7.381 7.381 0 0 0 4.86 5.308zm12.327 8.195l-1.775.443a1 1 0 1 1-.484-1.94l3.643-.909a1 1 0 0 1 .61-.08a1 1 0 0 1 .84.75l.968 3.88a1 1 0 0 1-1.94.484l-.33-1.322a9.381 9.381 0 0 1-16.384-1.796l-.26-.634a1 1 0 1 1 1.851-.758l.26.633a7.381 7.381 0 0 0 13.001 1.25z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1.5 -2.5 24 24"
}

export const jamRepeat: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m11.774 15l1.176 1.176a1 1 0 0 1-1.414 1.414l-2.829-2.828a1 1 0 0 1 0-1.414l2.829-2.829a1 1 0 0 1 1.414 1.415L11.883 13H14a4 4 0 1 0 0-8a1 1 0 0 1 0-2a6 6 0 1 1 0 12zM8.273 3L7.176 1.904A1 1 0 0 1 8.591.489l2.828 2.829a1 1 0 0 1 0 1.414L8.591 7.56a1 1 0 0 1-1.415-1.414L8.323 5H6a4 4 0 1 0 0 8a1 1 0 0 1 0 2A6 6 0 1 1 6 3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3 24 24"
}

export const jamRocket: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m9.808 12.971l.076-1.064l.927-.529A11.6 11.6 0 0 0 13.243 9.5c2.64-2.641 3.446-5.746 2.475-6.718c-.972-.97-4.077-.166-6.718 2.475c-.76.76-1.397 1.59-1.878 2.432l-.53.927l-1.063.076a3.97 3.97 0 0 0-2.355.988a11 11 0 0 1 3.351 2.295c.98.98 1.752 2.117 2.295 3.351a3.97 3.97 0 0 0 .988-2.355M6.835 15.8a7 7 0 0 1-.663.771q-1.758 1.758-5.304 1.06q-.695-3.545 1.06-5.303q.372-.37.772-.663a9 9 0 0 0-2.598-.81a6 6 0 0 1 1.473-2.416a5.98 5.98 0 0 1 3.81-1.741a13.6 13.6 0 0 1 2.2-2.855c3.32-3.32 7.594-4.427 9.547-2.475c1.952 1.953.844 6.227-2.475 9.546a13.6 13.6 0 0 1-2.855 2.2a5.98 5.98 0 0 1-1.741 3.81a5.96 5.96 0 0 1-2.416 1.474a9 9 0 0 0-.81-2.598M5.11 13.39a2.6 2.6 0 0 0-.54-.415c-.432.15-.94.48-1.405.944c-.219.22-.487.959-.49 1.905c.946-.003 1.688-.274 1.905-.49c.465-.466.795-.973.944-1.405a2.6 2.6 0 0 0-.414-.54zm7.778-7.78a1 1 0 1 1 1.414-1.413A1 1 0 0 1 12.89 5.61z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2.5 -2.5 24 24"
}

export const jamRocketF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7.21 16.067a7 7 0 0 1-.664.772q-1.758 1.757-5.303 1.06q-.697-3.545 1.06-5.303q.372-.37.772-.663a9 9 0 0 0-2.599-.81A6 6 0 0 1 1.95 8.707a5.98 5.98 0 0 1 3.81-1.742a13.6 13.6 0 0 1 2.2-2.854c3.32-3.32 7.593-4.428 9.546-2.475s.845 6.227-2.475 9.546a13.6 13.6 0 0 1-2.854 2.2a5.98 5.98 0 0 1-1.742 3.81a5.96 5.96 0 0 1-2.416 1.474a9 9 0 0 0-.81-2.599zM13.262 5.88a1 1 0 1 0 1.415-1.415a1 1 0 0 0-1.415 1.415m-7.778 7.778q-.164-.165-.53-.503c-.432.15-.944.574-1.414 1.033c-.371.363-.497.973-.5 1.92c.946-.004 1.62-.22 1.914-.506c.471-.459.89-.917 1.04-1.35c-.112-.194-.346-.43-.51-.594\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2.5 -2.5 24 24"
}

export const jamRssFeed: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1.996 15.97a1.996 1.996 0 1 1 0-3.992a1.996 1.996 0 0 1 0 3.992M1.12 7.977a.998.998 0 0 1-.247-1.98a8.103 8.103 0 0 1 9.108 8.04v.935a.998.998 0 1 1-1.996 0v-.934a6.108 6.108 0 0 0-6.865-6.06zM0 1.065A1 1 0 0 1 .93.002C8.717-.517 15.448 5.374 15.967 13.16q.063.94 0 1.88a.998.998 0 1 1-1.992-.133q.054-.808 0-1.614C13.53 6.607 7.75 1.548 1.065 1.994A1 1 0 0 1 0 1.064z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -4 24 24"
}

export const jamRtl: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6.007 2v9a1 1 0 0 1-2.002 0V6H3.004A3 3 0 0 1 0 3c0-1.657 1.345-3 3.004-3h7.008a1 1 0 1 1 0 2h-1v9a1 1 0 0 1-2.003 0V2zm6.284 6.877l1.416 1.414a1 1 0 0 1 0 1.414c-.391.39-1.025.39-1.416 0l-2.124-2.121a1 1 0 0 1 0-1.415l2.124-2.12a1 1 0 0 1 1.416 0a1 1 0 0 1 0 1.413L12.29 8.877ZM4.005 2H3.004a1 1 0 1 0 0 2h1V2Z\"/>",
  "width": 14,
  "height": 12,
  "viewBox": "0 0 14 12"
}

export const jamRubber: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12.728 12.728L8.485 8.485l-5.657 5.657l2.122 2.121a3 3 0 0 0 4.242 0zM11.284 17H14a1 1 0 0 1 0 2H3a1 1 0 0 1-.133-1.991l-1.453-1.453a2 2 0 0 1 0-2.828L12.728 1.414a2 2 0 0 1 2.828 0L19.8 5.657a2 2 0 0 1 0 2.828z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1.5 -2.5 24 24"
}

export const jamRuler: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m14.95 7.879l-.707-.707a1 1 0 0 1 1.414-1.415l.707.707l1.414-1.414l-2.828-2.828L2.222 14.95l2.828 2.828l1.414-1.414L5.05 14.95a1 1 0 0 1 1.414-1.414L7.88 14.95l1.414-1.414l-.707-.708A1 1 0 0 1 10 11.414l.707.707l1.414-1.414l-1.414-1.414a1 1 0 0 1 1.414-1.414l1.415 1.414zM.808 13.536L13.536.808a2 2 0 0 1 2.828 0l2.828 2.828a2 2 0 0 1 0 2.828L6.464 19.192a2 2 0 0 1-2.828 0L.808 16.364a2 2 0 0 1 0-2.828\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamRulerF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m16.757 9.243l-1.414 1.414l-2.828-2.829A1 1 0 1 0 11.1 9.243l2.828 2.828l-1.414 1.414l-2.122-2.121a1 1 0 1 0-1.414 1.414l2.122 2.121l-1.415 1.415l-2.828-2.829A1 1 0 0 0 5.444 14.9l2.828 2.829l-1.414 1.414a2 2 0 0 1-2.829 0l-2.828-2.828a2 2 0 0 1 0-2.829L13.929.757a2 2 0 0 1 2.828 0l2.829 2.829a2 2 0 0 1 0 2.828l-1.414 1.414l-2.122-2.12a1 1 0 1 0-1.414 1.413z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1.5 -2 24 24"
}

export const jamSave: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 0h11.22a2 2 0 0 1 1.345.52l2.78 2.527A2 2 0 0 1 18 4.527V16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m0 2v14h14V4.527L13.22 2zm4 8h6a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2m0 2v4h6v-4zm7-9a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V4a1 1 0 0 1 1-1M5 3h5a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m1 3h3V5H6z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -3 24 24"
}

export const jamSaveF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14 18.565v-7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v7H2a2 2 0 0 1-2-2v-14a2 2 0 0 1 2-2h11.22a2 2 0 0 1 1.345.52l2.78 2.527A2 2 0 0 1 18 5.092v11.473a2 2 0 0 1-2 2zm-1-15a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m-8 0a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zm1 9h6v4H6zm0-5v-3h3v3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2.5 24 24"
}

export const jamScissors: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.107 10.554L7.363 12.63a3.99 3.99 0 0 1-.192 4.89a4.004 4.004 0 0 1-5.635.492a3.99 3.99 0 0 1-.493-5.628a4.005 4.005 0 0 1 4.788-1.038L7.801 9L2.413 2.587a1 1 0 0 1 .123-1.407a1 1 0 0 1 1.409.123l5.162 6.144l5.161-6.144a1 1 0 0 1 1.41-.123a1 1 0 0 1 .123 1.407L10.412 9l1.97 2.345a4.005 4.005 0 0 1 4.788 1.038a3.99 3.99 0 0 1-.493 5.628a4.004 4.004 0 0 1-5.635-.492a3.99 3.99 0 0 1-.192-4.89zm-6.285 5.927a2 2 0 0 0 2.571-3.06a2 2 0 0 0-2.818.246c-.71.845-.6 2.105.247 2.814m12.57 0a1.996 1.996 0 0 0 .246-2.814a2 2 0 0 0-2.817-.246a1.996 1.996 0 0 0-.247 2.814c.71.845 1.972.955 2.818.246\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2.5 -2.5 24 24"
}

export const jamScreen: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 2a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm0-2h14a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m4 16h6a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3 24 24"
}

export const jamScreenF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 .565h14a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3m4 16h6a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2.5 24 24"
}

export const jamScrewdriver: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5.343 18.071a1 1 0 0 1 0 1.414L3.93 20.9a1 1 0 0 1-1.414 0L1.1 19.485a1 1 0 0 1 0-1.414l1.414-1.414a1 1 0 0 1 1.414 0L9.586 11a2 2 0 0 1 0-2.828l7.07-7.071a2 2 0 0 1 2.83 0l1.413 1.414a2 2 0 0 1 0 2.828l-7.07 7.071a2 2 0 0 1-2.829 0zM12.414 11l7.071-7.071l-1.414-1.414L11 9.585z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1 -1 24 24"
}

export const jamScrewdriverF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m18.778 7.464l-4.95 4.95a2 2 0 0 1-2.828 0l-5.657 5.657a1 1 0 0 1 0 1.414L3.93 20.9a1 1 0 0 1-1.414 0L1.1 19.485a1 1 0 0 1 0-1.414l1.414-1.414a1 1 0 0 1 1.414 0L9.586 11a2 2 0 0 1 0-2.828l4.95-4.95zm1.414-1.414L15.95 1.808l.707-.707a2 2 0 0 1 2.828 0L20.9 2.515a2 2 0 0 1 0 2.828z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1 -1 24 24"
}

export const jamSearch: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12m6.32-1.094l3.58 3.58a1 1 0 1 1-1.415 1.413l-3.58-3.58a8 8 0 1 1 1.414-1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2.5 -2.5 24 24"
}

export const jamSearchFolder: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 16a1 1 0 0 1 0-2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H9.415l-.471-1.334A1 1 0 0 0 8 2H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1a1 1 0 0 1 0 2a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h5c1.306 0 2.417.835 2.83 2H17a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3m-5.01-.096a5.002 5.002 0 0 1-6.293-7.707a5 5 0 0 1 7.707 6.293l2.9 2.9a1 1 0 0 1-1.415 1.413l-2.9-2.899zm-.636-2.05A3 3 0 1 0 7.11 9.61a3 3 0 0 0 4.243 4.243z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSearchMinus: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12m6.32-1.094l3.58 3.58a1 1 0 1 1-1.415 1.413l-3.58-3.58a8 8 0 1 1 1.414-1.414zM5 7h6a1 1 0 0 1 0 2H5a1 1 0 1 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2.5 -2.5 24 24"
}

export const jamSearchPlus: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12m6.32-1.094l3.58 3.58a1 1 0 1 1-1.415 1.413l-3.58-3.58a8 8 0 1 1 1.414-1.414zM9 7h2a1 1 0 0 1 0 2H9v2a1 1 0 0 1-2 0V9H5a1 1 0 1 1 0-2h2V5a1 1 0 1 1 2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2.5 -2.5 24 24"
}

export const jamSelectAll: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.01 14a1 1 0 0 1 .988 1h12.004a1 1 0 0 1 1-1V4a1 1 0 0 1-1-1H4.01a1 1 0 0 1-1 1zm.988 3a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h.01V4a1 1 0 0 1-.998-1V1a1 1 0 0 1 .999-1H3.01a1 1 0 0 1 1 1h11.992a1 1 0 0 1 1-1H19a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-1.998a1 1 0 0 1-1-1z\"/>",
  "width": 20,
  "height": 18,
  "viewBox": "0 0 20 18"
}

export const jamSetBackward: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6.18 8.477a.976.976 0 0 0 .324 1.363l9.922 6.032c.16.097.346.149.535.149c.56 0 1.013-.443 1.013-.99V2.97a.97.97 0 0 0-.153-.523a1.027 1.027 0 0 0-1.395-.317L6.504 8.16c-.131.08-.243.189-.325.317zM6 6.136L15.355.449c1.425-.867 3.3-.44 4.186.951c.3.471.459 1.014.459 1.569V15.03c0 1.641-1.36 2.97-3.04 2.97a3.1 3.1 0 0 1-1.605-.448L6 11.865V16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zM2 2v14h2V2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3 24 24"
}

export const jamSetBackwardCircle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-2.486-6.164V14a1 1 0 0 1-2 0V6a1 1 0 1 1 2 0v2.164l3.93-2.808A1.9 1.9 0 0 1 12.542 5c1.09 0 1.972.941 1.972 2.102v5.796c0 .417-.116.824-.334 1.17c-.606.965-1.832 1.222-2.736.576zm5.028-4.734L8.487 10l4.055 2.898z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSetBackwardCircleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7.514 8.164V6a1 1 0 1 0-2 0v8a1 1 0 0 0 2 0v-2.164l3.93 2.808c.904.646 2.13.389 2.736-.576c.218-.346.334-.753.334-1.17V7.102c0-1.16-.883-2.102-1.972-2.102c-.391 0-.773.124-1.098.356zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m2.561-12.898v5.796L8.506 10z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSetBackwardSquare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm3.514 9.836V14a1 1 0 0 1-2 0V6a1 1 0 1 1 2 0v2.164l3.93-2.808A1.9 1.9 0 0 1 12.542 5c1.09 0 1.972.941 1.972 2.102v5.796c0 .417-.116.824-.334 1.17c-.606.965-1.832 1.222-2.736.576zm5.028-4.734L8.487 10l4.055 2.898z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSetBackwardSquareF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7.514 8.164V6a1 1 0 1 0-2 0v8a1 1 0 0 0 2 0v-2.164l3.93 2.808c.904.646 2.13.389 2.736-.576c.218-.346.334-.753.334-1.17V7.102c0-1.16-.883-2.102-1.972-2.102c-.391 0-.773.124-1.098.356zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m8.548 7.12v5.796l-4.055-2.898z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSetForward: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.82 9.523a.976.976 0 0 0-.324-1.363L3.574 2.128a1.03 1.03 0 0 0-.535-.149c-.56 0-1.013.443-1.013.99V15.03c0 .185.053.366.153.523c.296.464.92.606 1.395.317l9.922-6.031c.131-.08.243-.189.325-.317zm.18 2.341l-9.355 5.687c-1.425.867-3.3.44-4.186-.951A2.9 2.9 0 0 1 0 15.03V2.97C0 1.329 1.36 0 3.04 0c.567 0 1.123.155 1.605.448L14 6.135V2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zM16 2v14h2V2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3 24 24"
}

export const jamSetForwardCircle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m2.514-6.164l-3.929 2.808c-.905.646-2.13.389-2.736-.576a2.2 2.2 0 0 1-.335-1.17V7.102C5.514 5.942 6.397 5 7.487 5c.39 0 .773.124 1.098.356l3.93 2.808V6a1 1 0 0 1 2 0v8a1 1 0 1 1-2 0v-2.164zM7.487 7.102v5.796L11.542 10z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSetForwardCircleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12.514 11.836V14a1 1 0 0 0 2 0V6a1 1 0 1 0-2 0v2.164L8.585 5.356A1.9 1.9 0 0 0 7.487 5c-1.09 0-1.973.941-1.973 2.102v5.796c0 .417.117.824.335 1.17c.606.965 1.831 1.222 2.736.576l3.93-2.808zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10M7.355 7.08l4.055 2.898l-4.055 2.898z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSetForwardSquare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm8.514 9.836l-3.929 2.808c-.905.646-2.13.389-2.736-.576a2.2 2.2 0 0 1-.335-1.17V7.102C5.514 5.942 6.397 5 7.487 5c.39 0 .773.124 1.098.356l3.93 2.808V6a1 1 0 0 1 2 0v8a1 1 0 1 1-2 0v-2.164zM7.487 7.102v5.796L11.542 10z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSetForwardSquareF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12.514 11.836V14a1 1 0 0 0 2 0V6a1 1 0 1 0-2 0v2.164L8.585 5.356A1.9 1.9 0 0 0 7.487 5c-1.09 0-1.973.941-1.973 2.102v5.796c0 .417.117.824.335 1.17c.606.965 1.831 1.222 2.736.576l3.93-2.808zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m3.496 7.136l4.056 2.898l-4.056 2.898z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSetSquare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m3.413.646l15.97 15.938A2 2 0 0 1 17.972 20H2a2 2 0 0 1-2-2V2.061A2 2 0 0 1 3.413.646M2 2.06V18h15.97zm2 7.353a1 1 0 0 1 1.707-.707l5.586 5.586A1 1 0 0 1 10.586 16H5a1 1 0 0 1-1-1zM6 14h2l-2-2zm7 3a1 1 0 1 1 0 2a1 1 0 0 1 0-2m-8 0a1 1 0 1 1 0 2a1 1 0 0 1 0-2m4 0a1 1 0 1 1 0 2a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSetSquareF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14 20v-1a1 1 0 0 0-2 0v1h-2v-1a1 1 0 0 0-2 0v1H6v-1a1 1 0 0 0-2 0v1H2a2 2 0 0 1-2-2V2.061A2 2 0 0 1 3.413.646l15.97 15.938A2 2 0 0 1 17.972 20zM4 9.414V15a1 1 0 0 0 1 1h5.586a1 1 0 0 0 .707-1.707L5.707 8.707A1 1 0 0 0 4 9.414\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSettingsAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 12V1a1 1 0 1 1 2 0v11h1a1 1 0 0 1 0 2h-1v1a1 1 0 0 1-2 0v-1H8a1 1 0 0 1 0-2zm7-10V1a1 1 0 0 1 2 0v1h1a1 1 0 0 1 0 2h-1v11a1 1 0 0 1-2 0V4h-1a1 1 0 0 1 0-2zM4 5h1a1 1 0 1 1 0 2H4v8a1 1 0 0 1-2 0V7H1a1 1 0 1 1 0-2h1V1a1 1 0 1 1 2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamShare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 3.414v5.642a1 1 0 1 1-2 0V3.414L4.879 4.536A1 1 0 0 1 3.464 3.12L6.293.293a.997.997 0 0 1 1.414 0l2.829 2.828A1 1 0 1 1 9.12 4.536zM3 6a1 1 0 1 1 0 2H2v4h10V8h-1a1 1 0 0 1 0-2h1a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -5 24 24"
}

export const jamShareAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16 6a2 2 0 1 0 0-4a2 2 0 0 0 0 4M7.928 9.24a4 4 0 0 1-.026 1.644l5.04 2.537a4 4 0 1 1-.867 1.803l-5.09-2.562a4 4 0 1 1 .083-5.228l5.036-2.522a4 4 0 1 1 .929 1.772zM4 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4m12 6a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamShareAltF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7.928 9.24a4 4 0 0 1-.026 1.644l5.04 2.537a4 4 0 1 1-.867 1.803l-5.09-2.562a4 4 0 1 1 .083-5.228l5.036-2.522a4 4 0 1 1 .929 1.772z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamShield: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 4.386V8a9.02 9.02 0 0 0 3.08 6.787L8 17.342l2.92-2.555A9.02 9.02 0 0 0 14 8V4.386l-6-2.25zM.649 2.756L8 0l7.351 2.757a1 1 0 0 1 .649.936V8c0 3.177-1.372 6.2-3.763 8.293L8 20l-4.237-3.707A11.02 11.02 0 0 1 0 8V3.693a1 1 0 0 1 .649-.936z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamShieldCheck: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 4.386V8a9.02 9.02 0 0 0 3.08 6.787L8 17.342l2.92-2.555A9.02 9.02 0 0 0 14 8V4.386l-6-2.25zM.649 2.756L8 0l7.351 2.757a1 1 0 0 1 .649.936V8c0 3.177-1.372 6.2-3.763 8.293L8 20l-4.237-3.707A11.02 11.02 0 0 1 0 8V3.693a1 1 0 0 1 .649-.936zm6.29 7.512l3.536-3.536a1 1 0 0 1 1.414 1.414L7.646 12.39a1 1 0 0 1-1.414 0l-2.121-2.121a1 1 0 0 1 1.414-1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamShieldCheckF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.02 11.02 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936m6.29 7.51L5.525 9.42a1 1 0 1 0-1.414 1.414l2.121 2.121a1 1 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414l-3.536 3.536z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -1.5 24 24"
}

export const jamShieldClose: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 4.386V8a9.02 9.02 0 0 0 3.08 6.787L8 17.342l2.92-2.555A9.02 9.02 0 0 0 14 8V4.386l-6-2.25zM.649 2.756L8 0l7.351 2.757a1 1 0 0 1 .649.936V8c0 3.177-1.372 6.2-3.763 8.293L8 20l-4.237-3.707A11.02 11.02 0 0 1 0 8V3.693a1 1 0 0 1 .649-.936zM9.414 9l1.414 1.414a1 1 0 1 1-1.414 1.414L8 10.414l-1.414 1.414a1 1 0 0 1-1.414-1.414L6.586 9L5.172 7.586a1 1 0 1 1 1.414-1.414L8 7.586l1.414-1.414a1 1 0 1 1 1.414 1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamShieldCloseF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m9.414 9.565l1.414-1.414a1 1 0 1 0-1.414-1.414L8 8.15L6.586 6.737A1 1 0 1 0 5.172 8.15l1.414 1.414l-1.414 1.414a1 1 0 1 0 1.414 1.414L8 10.98l1.414 1.414a1 1 0 1 0 1.414-1.414zM.65 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.02 11.02 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -1.5 24 24"
}

export const jamShieldF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.02 11.02 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -1.5 24 24"
}

export const jamShieldHalf: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m8 2.136l-6 2.25V8a9.02 9.02 0 0 0 3.08 6.787L8 17.342zm-7.351.62L8 0l7.351 2.757a1 1 0 0 1 .649.936V8c0 3.177-1.372 6.2-3.763 8.293L8 20l-4.237-3.707A11.02 11.02 0 0 1 0 8V3.693a1 1 0 0 1 .649-.936z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamShieldMinus: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 4.386V8a9.02 9.02 0 0 0 3.08 6.787L8 17.342l2.92-2.555A9.02 9.02 0 0 0 14 8V4.386l-6-2.25zM.649 2.756L8 0l7.351 2.757a1 1 0 0 1 .649.936V8c0 3.177-1.372 6.2-3.763 8.293L8 20l-4.237-3.707A11.02 11.02 0 0 1 0 8V3.693a1 1 0 0 1 .649-.936zM5 8h6a1 1 0 0 1 0 2H5a1 1 0 1 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamShieldMinusF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.02 11.02 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936M5 8.565a1 1 0 1 0 0 2h6a1 1 0 0 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -1.5 24 24"
}

export const jamShieldPlus: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 4.386V8a9.02 9.02 0 0 0 3.08 6.787L8 17.342l2.92-2.555A9.02 9.02 0 0 0 14 8V4.386l-6-2.25zM.649 2.756L8 0l7.351 2.757a1 1 0 0 1 .649.936V8c0 3.177-1.372 6.2-3.763 8.293L8 20l-4.237-3.707A11.02 11.02 0 0 1 0 8V3.693a1 1 0 0 1 .649-.936zM9 8h2a1 1 0 0 1 0 2H9v2a1 1 0 0 1-2 0v-2H5a1 1 0 1 1 0-2h2V6a1 1 0 1 1 2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamShieldPlusF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 8.565v-2a1 1 0 1 0-2 0v2H5a1 1 0 1 0 0 2h2v2a1 1 0 0 0 2 0v-2h2a1 1 0 0 0 0-2zM.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.02 11.02 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -1.5 24 24"
}

export const jamShopify: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m12.338 2.395l.032.027l1.18 1.171l1.6.12c.073.006.16.061.174.161l2.172 14.693l-6.148 1.33L0 17.771S1.456 6.509 1.511 6.11c.073-.524.091-.541.648-.716l1.796-.557C4.339 3.208 5.565 0 8.13 0c.335 0 .723.18 1.037.594L9.26.591c1.101 0 1.727.939 2.082 1.96l.595-.184c.08-.024.278-.056.4.028zM9.261 7.11s-.513-.297-1.55-.297c-2.692 0-4.026 1.798-4.026 3.656c0 2.208 2.203 2.268 2.203 3.611c0 .325-.23.77-.795.77c-.864 0-1.888-.88-1.888-.88l-.521 1.724s.996 1.212 2.944 1.212c1.623 0 2.827-1.222 2.827-3.12c0-2.413-2.685-2.807-2.685-3.837c0-.19.06-.938 1.254-.938a3.5 3.5 0 0 1 1.478.354zm1.455-4.366c-.243-.743-.621-1.389-1.189-1.46c.141.405.23.916.23 1.55l-.001.208zM8.823 1.41c-.626.268-1.342.98-1.723 2.454l1.983-.614v-.111c0-.766-.102-1.334-.26-1.73zM8.061.688c-1.844 0-2.879 2.42-3.315 3.905l1.567-.486C6.686 2.161 7.567 1.187 8.39.8a.6.6 0 0 0-.33-.11z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2 24 24"
}

export const jamShopifyCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"m13.264 6.833l-.805-.06l-.592-.589l.592.59s.77.056.805.06c.037.002.08.03.088.08l1.091 7.385l-3.09.668L5.65 13.9s.732-5.66.76-5.86c.036-.264.045-.273.325-.36l.902-.28c.194-.82.81-2.432 2.1-2.432c.168 0 .363.09.52.299l.047-.002c.554 0 .868.472 1.047.985l.299-.092a.3.3 0 0 1 .135-.01zm-2.96 1.708s-.257-.15-.779-.15c-1.353 0-2.023.904-2.023 1.838c0 1.11 1.107 1.14 1.107 1.815a.383.383 0 0 1-.4.386c-.434 0-.948-.441-.948-.441l-.262.866s.5.609 1.48.609c.815 0 1.42-.614 1.42-1.568c0-1.213-1.35-1.411-1.35-1.929c0-.095.031-.471.631-.471c.41 0 .743.178.743.178zm.732-2.195c-.123-.373-.313-.698-.598-.733c.071.203.115.46.115.779v.104zm-.952-.67c-.314.135-.674.492-.866 1.233l.997-.308v-.056c0-.385-.052-.67-.13-.87zm-.383-.363c-.926 0-1.447 1.216-1.666 1.962l.788-.244c.187-.978.63-1.468 1.043-1.662a.3.3 0 0 0-.165-.056\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamShopifySquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"m13.264 6.833l-.805-.06l-.592-.589l.592.59s.77.056.805.06c.037.002.08.03.088.08l1.091 7.385l-3.09.668L5.65 13.9s.732-5.66.76-5.86c.036-.264.045-.273.325-.36l.902-.28c.194-.82.81-2.432 2.1-2.432c.168 0 .363.09.52.299l.047-.002c.554 0 .868.472 1.047.985l.299-.092a.3.3 0 0 1 .135-.01zm-2.96 1.708s-.257-.15-.779-.15c-1.353 0-2.023.904-2.023 1.838c0 1.11 1.107 1.14 1.107 1.815a.383.383 0 0 1-.4.386c-.434 0-.948-.441-.948-.441l-.262.866s.5.609 1.48.609c.815 0 1.42-.614 1.42-1.568c0-1.213-1.35-1.411-1.35-1.929c0-.095.031-.471.631-.471c.41 0 .743.178.743.178zm.732-2.195c-.123-.373-.313-.698-.598-.733c.071.203.115.46.115.779v.104zm-.952-.67c-.314.135-.674.492-.866 1.233l.997-.308v-.056c0-.385-.052-.67-.13-.87zm-.383-.363c-.926 0-1.447 1.216-1.666 1.962l.788-.244c.187-.978.63-1.468 1.043-1.662a.3.3 0 0 0-.165-.056\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamShoppingBag: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 10a1 1 0 0 0-1 1v3a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4v-3a1 1 0 0 0-1-1zm2-2V5a5 5 0 1 1 10 0v3h2a3 3 0 0 1 3 3v3a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6v-3a3 3 0 0 1 3-3zm2 0h6V5a3 3 0 0 0-6 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamShoppingBagAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 8v9a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8zm0-2V3a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v3h2v11a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V6zm2 0h6V3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamShoppingBagAltF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 6V3a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v3h2v11a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V6zm2 0h6V3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamShoppingBagF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 8V5a5 5 0 1 1 10 0v3h2a3 3 0 0 1 3 3v3a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6v-3a3 3 0 0 1 3-3zm2 0h6V5a3 3 0 0 0-6 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamShoppingCart: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 16a2 2 0 1 1 0-4a2 2 0 0 1 0 4m7 0a2 2 0 1 1 0-4a2 2 0 0 1 0 4M.962 1.923A.962.962 0 0 1 .962 0h1.151c.902 0 1.682.626 1.878 1.506l1.253 5.642c.196.88.976 1.506 1.878 1.506h7.512l1.442-5.77H6.731a.962.962 0 0 1 0-1.922h9.345a1.923 1.923 0 0 1 1.866 2.39L16.5 9.12a1.92 1.92 0 0 1-1.866 1.457H7.122a3.846 3.846 0 0 1-3.755-3.012L2.113 1.923z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -4 24 24"
}

export const jamShuffle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19.548 4.837L16.875 7.51a1 1 0 0 1-1.415-1.414L16.556 5H15.1a5.22 5.22 0 0 0-5.089 4.058A5.264 5.264 0 0 0 15.105 13h1.502l-1.147-1.147a1 1 0 0 1 1.415-1.414l2.828 2.828a1 1 0 0 1 .282.562a1.01 1.01 0 0 1-.437 1.008l-2.673 2.673a1 1 0 0 1-1.415-1.414L16.556 15h-1.451a7.26 7.26 0 0 1-6.114-3.34A7.22 7.22 0 0 1 2.901 15H1a1 1 0 0 1 0-2h1.901a5.22 5.22 0 0 0 5.06-3.936A5.26 5.26 0 0 0 2.836 5H1a1 1 0 1 1 0-2h1.836a7.26 7.26 0 0 1 6.143 3.387A7.22 7.22 0 0 1 15.1 3h1.508L15.46 1.853A1 1 0 1 1 16.875.439l2.828 2.828a1 1 0 0 1 .282.562a1.01 1.01 0 0 1-.437 1.008\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3 24 24"
}

export const jamSignal: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 10a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m4-4a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1m4-4a1 1 0 0 1 1 1v10a1 1 0 0 1-2 0V3a1 1 0 0 1 1-1m4-2a1 1 0 0 1 1 1v12a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -5 24 24"
}

export const jamSitemap: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 14v4h4v-4zm12-3H6a1 1 0 0 0-1 1h1a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1a3 3 0 0 1 3-3h3V8H8a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-1v1h3a3 3 0 0 1 3 3h1a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1a1 1 0 0 0-1-1M8 2v4h4V2zm6 12v4h4v-4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSitemapF: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M2 12.858h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2m6-12h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2m6 12h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2\"/><path d=\"M9 9.858v-2h2v4H6a1 1 0 0 0-1 1v.935H3v-.935a3 3 0 0 1 3-3z\"/><path d=\"M10 11.858v-2h4a3 3 0 0 1 3 3v1.02h-2v-1.02a1 1 0 0 0-1-1z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1.5 24 24"
}

export const jamSkull: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11 18h2a1 1 0 0 0 1-1v-2.07l1.065-.563A5.5 5.5 0 0 0 18 9.5v-2A5.5 5.5 0 0 0 12.5 2h-5A5.5 5.5 0 0 0 2 7.5v2a5.5 5.5 0 0 0 2.935 4.867L6 14.93V17a1 1 0 0 0 1 1h2v-2a1 1 0 0 1 2 0zm5-1a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-.865A7.5 7.5 0 0 1 0 9.5v-2A7.5 7.5 0 0 1 7.5 0h5A7.5 7.5 0 0 1 20 7.5v2a7.5 7.5 0 0 1-4 6.635zM6 11a2 2 0 1 1 0-4a2 2 0 0 1 0 4m8 0a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSkullF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16 17.858a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-.865a7.5 7.5 0 0 1-4-6.635v-2a7.5 7.5 0 0 1 7.5-7.5h5a7.5 7.5 0 0 1 7.5 7.5v2a7.5 7.5 0 0 1-4 6.635zm-10-6a2 2 0 1 0 0-4a2 2 0 0 0 0 4m8 0a2 2 0 1 0 0-4a2 2 0 0 0 0 4m-4 4a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1.5 24 24"
}

export const jamSkype: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19.126 11.425A9.26 9.26 0 0 0 8.534.834A5.596 5.596 0 0 0 .833 8.535a9.26 9.26 0 0 0 10.591 10.592c.854.525 1.86.831 2.939.831a5.596 5.596 0 0 0 4.763-8.534zm-4.75 2.766q-.59.846-1.72 1.321q-1.129.476-2.672.476q-1.85 0-3.058-.651a3.96 3.96 0 0 1-1.393-1.252q-.537-.784-.539-1.532c0-.294.112-.55.33-.759c.221-.21.505-.315.84-.315q.414 0 .704.247q.285.245.481.716q.236.548.508.912q.27.36.762.597q.487.236 1.297.236q1.11-.001 1.796-.476c.46-.318.68-.706.68-1.174c0-.374-.118-.67-.363-.902q-.368-.351-.96-.537a17 17 0 0 0-1.596-.4q-1.343-.293-2.252-.685q-.911-.393-1.45-1.074q-.54-.687-.539-1.7q0-.965.568-1.716q.57-.751 1.64-1.152t2.51-.4q1.152 0 1.994.265q.84.267 1.4.707q.558.443.818.93q.26.49.26.957q-.002.436-.33.782c-.22.23-.499.347-.825.346q-.443.002-.685-.211c-.156-.14-.32-.36-.497-.67q-.336-.645-.804-1.005c-.304-.235-.805-.358-1.502-.356q-.966 0-1.55.39c-.392.261-.58.565-.58.92c0 .224.065.412.194.573q.195.244.547.421q.353.18.713.28q.364.104 1.204.3q1.051.228 1.909.504q.855.276 1.46.674q.607.398.947 1.011q.342.614.342 1.495q0 1.062-.59 1.907z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSkypeCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M14.583 10.724a4.64 4.64 0 0 0-5.307-5.307a2.804 2.804 0 0 0-3.858 3.859a4.64 4.64 0 0 0 5.307 5.307a2.804 2.804 0 0 0 3.859-3.859zm-2.38 1.386q-.296.424-.862.662q-.565.24-1.339.239q-.926 0-1.532-.327a2 2 0 0 1-.698-.627q-.27-.393-.27-.768a.5.5 0 0 1 .166-.38a.6.6 0 0 1 .42-.158a.53.53 0 0 1 .353.124a.94.94 0 0 1 .241.359q.119.274.255.457q.135.18.381.299q.245.118.65.118q.556 0 .9-.238c.23-.16.341-.354.341-.589a.6.6 0 0 0-.182-.452a1.2 1.2 0 0 0-.48-.269a9 9 0 0 0-.8-.2a6.3 6.3 0 0 1-1.129-.343a1.8 1.8 0 0 1-.727-.538q-.27-.345-.27-.852q0-.483.285-.86q.285-.375.822-.577q.535-.2 1.257-.2q.577 0 .999.132q.42.134.702.355q.28.221.41.466t.13.479a.56.56 0 0 1-.166.392a.55.55 0 0 1-.413.173q-.222.001-.343-.106q-.116-.104-.25-.335a1.5 1.5 0 0 0-.402-.504c-.152-.118-.403-.18-.752-.178q-.485 0-.777.195c-.197.131-.29.283-.29.462q0 .166.096.286a.8.8 0 0 0 .275.211q.176.09.357.141q.182.051.603.15q.527.114.956.253q.429.138.732.337q.304.2.475.507t.17.749q0 .531-.294.955\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSkypeSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M14.583 10.724a4.64 4.64 0 0 0-5.307-5.307a2.804 2.804 0 0 0-3.858 3.859a4.64 4.64 0 0 0 5.307 5.307a2.804 2.804 0 0 0 3.859-3.859zm-2.38 1.386q-.296.424-.862.662q-.565.24-1.339.239q-.926 0-1.532-.327a2 2 0 0 1-.698-.627q-.27-.393-.27-.768a.5.5 0 0 1 .166-.38a.6.6 0 0 1 .42-.158a.53.53 0 0 1 .353.124a.94.94 0 0 1 .241.359q.119.274.255.457q.135.18.381.299q.245.118.65.118q.556 0 .9-.238c.23-.16.341-.354.341-.589a.6.6 0 0 0-.182-.452a1.2 1.2 0 0 0-.48-.269a9 9 0 0 0-.8-.2a6.3 6.3 0 0 1-1.129-.343a1.8 1.8 0 0 1-.727-.538q-.27-.345-.27-.852q0-.483.285-.86q.285-.375.822-.577q.535-.2 1.257-.2q.577 0 .999.132q.42.134.702.355q.28.221.41.466t.13.479a.56.56 0 0 1-.166.392a.55.55 0 0 1-.413.173q-.222.001-.343-.106q-.116-.104-.25-.335a1.5 1.5 0 0 0-.402-.504c-.152-.118-.403-.18-.752-.178q-.485 0-.777.195c-.197.131-.29.283-.29.462q0 .166.096.286a.8.8 0 0 0 .275.211q.176.09.357.141q.182.051.603.15q.527.114.956.253q.429.138.732.337q.304.2.475.507t.17.749q0 .531-.294.955\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSlack: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19.874 10.725a1.777 1.777 0 0 0-2.24-1.143l-1.792.583l-1.217-3.75l1.792-.583a1.782 1.782 0 0 0-1.1-3.39l-1.79.585l-.583-1.795a1.776 1.776 0 0 0-2.24-1.144a1.78 1.78 0 0 0-1.141 2.245l.582 1.795l-3.742 1.219C6.05 4.255 5.82 3.552 5.82 3.552a1.777 1.777 0 0 0-2.24-1.144a1.78 1.78 0 0 0-1.142 2.244l.583 1.796l-1.85.602A1.78 1.78 0 0 0 .07 9.218c.272.945 1.274 1.521 2.2 1.22l1.85-.603l1.216 3.75l-1.849.603a1.784 1.784 0 0 0-1.103 2.167c.272.945 1.274 1.523 2.2 1.22c.008-.002.736-.238 1.851-.602l.601 1.852A1.78 1.78 0 0 0 9.2 19.93c.943-.272 1.52-1.276 1.217-2.205l-.6-1.852l3.743-1.219l.601 1.853a1.78 1.78 0 0 0 2.163 1.105c.944-.273 1.52-1.277 1.218-2.205l-.601-1.853l1.791-.584a1.783 1.783 0 0 0 1.142-2.245m-11.156 1.76l-1.216-3.75l3.742-1.218l1.217 3.75z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSlackCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M14.956 10.362a.89.89 0 0 0-1.122-.571l-.898.291c-.198-.612-.41-1.263-.61-1.875l.898-.291a.89.89 0 1 0-.55-1.695l-.898.292l-.292-.897a.89.89 0 1 0-1.693.55l.292.898l-1.875.61l-.292-.898a.89.89 0 0 0-1.694.55l.292.898l-.926.301a.89.89 0 0 0-.553 1.084c.136.472.638.76 1.103.61l.926-.302l.61 1.875l-.927.302a.89.89 0 0 0-.553 1.083c.137.473.639.762 1.103.61c.004 0 .368-.119.927-.3l.301.925a.89.89 0 0 0 1.084.553c.472-.136.761-.638.61-1.103c-.001-.003-.12-.367-.3-.926c.612-.199 1.263-.41 1.874-.61l.301.927a.89.89 0 0 0 1.084.553c.473-.137.761-.639.61-1.103l-.301-.926l.897-.292a.89.89 0 0 0 .572-1.123m-5.588.88l-.61-1.875c.613-.198 1.264-.41 1.875-.609l.61 1.875z\"/><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSlackSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M14.956 10.362a.89.89 0 0 0-1.122-.571l-.898.291c-.198-.612-.41-1.263-.61-1.875l.898-.291a.89.89 0 1 0-.55-1.695l-.898.292l-.292-.897a.89.89 0 1 0-1.693.55l.292.898l-1.875.61l-.292-.898a.89.89 0 0 0-1.694.55l.292.898l-.926.301a.89.89 0 0 0-.553 1.084c.136.472.638.76 1.103.61l.926-.302l.61 1.875l-.927.302a.89.89 0 0 0-.553 1.083c.137.473.639.762 1.103.61c.004 0 .368-.119.927-.3l.301.925a.89.89 0 0 0 1.084.553c.472-.136.761-.638.61-1.103c-.001-.003-.12-.367-.3-.926c.612-.199 1.263-.41 1.874-.61l.301.927a.89.89 0 0 0 1.084.553c.473-.137.761-.639.61-1.103l-.301-.926l.897-.292a.89.89 0 0 0 .572-1.123m-5.588.88l-.61-1.875c.613-.198 1.264-.41 1.875-.609l.61 1.875z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSmiley: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-3.92-4.606a1 1 0 1 1 1.84-.788a2.264 2.264 0 0 0 4.16 0a1 1 0 1 1 1.84.788a4.264 4.264 0 0 1-7.84 0M7 6a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1m6 0a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSmileyF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20.858c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m-3.92-6.606a4.264 4.264 0 0 0 7.84 0a1 1 0 1 0-1.84-.788a2.264 2.264 0 0 1-4.16 0a1 1 0 1 0-1.84.788M7 6.858a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1m6 0a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1.5 24 24"
}

export const jamSnapchat: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15.899 7.75q.499-.112.501-.164l.1-.045a1 1 0 0 1 .406-.082c.152 0 .304.028.435.082c.391.139.636.424.642.744c.003.131-.037.334-.242.545c-.173.176-.433.332-.798.476a5 5 0 0 1-.292.099c-.37.117-.93.295-1.076.637c-.075.174-.043.403.105.703c.048.116 1.253 2.855 3.927 3.295a.465.465 0 0 1 .391.485a.6.6 0 0 1-.05.206c-.096.223-.317.411-.676.578c-.44.203-1.097.373-1.956.508c-.043.083-.09.295-.119.428a7 7 0 0 1-.115.465c-.071.244-.259.384-.536.384c-.116 0-.266-.02-.46-.057a5.3 5.3 0 0 0-1.049-.11q-.367 0-.75.063c-.49.081-.912.379-1.402.724c-.715.503-1.525 1.075-2.763 1.075a2 2 0 0 1-.144-.004l-.101.004c-1.237 0-2.047-.572-2.762-1.077c-.49-.345-.912-.642-1.402-.723a4.6 4.6 0 0 0-.75-.064c-.438 0-.791.069-1.048.119c-.177.033-.328.063-.46.063c-.35 0-.484-.212-.537-.39a6 6 0 0 1-.115-.468c-.031-.142-.076-.348-.12-.43c-.858-.134-1.516-.305-1.956-.51c-.36-.165-.581-.354-.677-.58a.6.6 0 0 1-.05-.203a.467.467 0 0 1 .392-.487a4.5 4.5 0 0 0 1.706-.664a5.6 5.6 0 0 0 1.215-1.073a6.6 6.6 0 0 0 1.018-1.58q.205-.417.095-.68c-.146-.342-.708-.52-1.078-.637c-.106-.034-.207-.065-.292-.099q-.487-.192-.745-.426C2 8.597 2 8.319 2.026 8.179c.041-.214.191-.405.424-.542a1.2 1.2 0 0 1 .598-.167a.8.8 0 0 1 .339.07q.108.051.212.09q.003.047.414.123q.14.026.265.026a.8.8 0 0 0 .328-.062l-.028-.446c-.085-1.352-.191-3.036.257-4.035A5.5 5.5 0 0 1 6.053 1.49c.423-.4.913-.724 1.459-.964A5.8 5.8 0 0 1 9.798.042l.394-.003c.445 0 1.333.062 2.284.482a5.1 5.1 0 0 1 1.464.965a5.4 5.4 0 0 1 1.223 1.751c.448 1 .342 2.684.255 4.038l-.003.057q-.014.2-.024.387a.8.8 0 0 0 .276.06q.11-.006.232-.03z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2.5 24 24"
}

export const jamSnapchatCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M14.804 12.292c-1.337-.22-1.94-1.59-1.964-1.647q-.11-.223-.052-.352c.073-.171.353-.26.538-.318l.146-.05a1.1 1.1 0 0 0 .399-.238a.38.38 0 0 0 .121-.273c-.003-.16-.126-.302-.321-.371A.6.6 0 0 0 13.453 9a.5.5 0 0 0-.202.042a1.1 1.1 0 0 1-.417.118a.4.4 0 0 1-.138-.03l.012-.193l.002-.029c.043-.676.096-1.518-.128-2.018a2.7 2.7 0 0 0-.612-.876a2.6 2.6 0 0 0-.732-.483a2.9 2.9 0 0 0-1.142-.24l-.197.001a2.9 2.9 0 0 0-1.143.241a2.6 2.6 0 0 0-.73.482a2.7 2.7 0 0 0-.609.874c-.223.5-.17 1.341-.128 2.018l.014.223a.4.4 0 0 1-.164.03q-.19 0-.445-.119a.4.4 0 0 0-.17-.035a.6.6 0 0 0-.3.084a.41.41 0 0 0-.211.27c-.013.07-.013.21.142.351q.13.117.373.213q.065.025.146.05c.185.058.466.147.539.318q.055.132-.048.34c-.022.052-.181.41-.508.79a2.8 2.8 0 0 1-.608.537a2.2 2.2 0 0 1-.853.331a.233.233 0 0 0-.196.244q.003.053.025.102q.07.168.339.29q.332.154.978.255c.022.04.044.144.06.215q.023.112.057.234c.026.089.094.195.268.195c.067 0 .142-.015.23-.032c.13-.025.305-.06.525-.06q.184 0 .375.033c.245.04.456.189.7.361c.358.253.763.539 1.382.539l.05-.002l.072.002c.619 0 1.024-.286 1.382-.538c.245-.172.456-.321.7-.362a2.3 2.3 0 0 1 .9.024q.144.028.23.028c.139 0 .233-.07.268-.192q.034-.118.058-.232c.014-.067.038-.173.06-.214q.645-.102.977-.254c.18-.084.29-.178.339-.29a.3.3 0 0 0 .025-.102a.233.233 0 0 0-.196-.243z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSnapchatSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M14.804 12.292c-1.337-.22-1.94-1.59-1.964-1.647q-.11-.223-.052-.352c.073-.171.353-.26.538-.318l.146-.05a1.1 1.1 0 0 0 .399-.238a.38.38 0 0 0 .121-.273c-.003-.16-.126-.302-.321-.371A.6.6 0 0 0 13.453 9a.5.5 0 0 0-.202.042a1.1 1.1 0 0 1-.417.118a.4.4 0 0 1-.138-.03l.012-.193l.002-.029c.043-.676.096-1.518-.128-2.018a2.7 2.7 0 0 0-.612-.876a2.6 2.6 0 0 0-.732-.483a2.9 2.9 0 0 0-1.142-.24l-.197.001a2.9 2.9 0 0 0-1.143.241a2.6 2.6 0 0 0-.73.482a2.7 2.7 0 0 0-.609.874c-.223.5-.17 1.341-.128 2.018l.014.223a.4.4 0 0 1-.164.03q-.19 0-.445-.119a.4.4 0 0 0-.17-.035a.6.6 0 0 0-.3.084a.41.41 0 0 0-.211.27c-.013.07-.013.21.142.351q.13.117.373.213q.065.025.146.05c.185.058.466.147.539.318q.055.132-.048.34c-.022.052-.181.41-.508.79a2.8 2.8 0 0 1-.608.537a2.2 2.2 0 0 1-.853.331a.233.233 0 0 0-.196.244q.003.053.025.102q.07.168.339.29q.332.154.978.255c.022.04.044.144.06.215q.023.112.057.234c.026.089.094.195.268.195c.067 0 .142-.015.23-.032c.13-.025.305-.06.525-.06q.184 0 .375.033c.245.04.456.189.7.361c.358.253.763.539 1.382.539l.05-.002l.072.002c.619 0 1.024-.286 1.382-.538c.245-.172.456-.321.7-.362a2.3 2.3 0 0 1 .9.024q.144.028.23.028c.139 0 .233-.07.268-.192q.034-.118.058-.232c.014-.067.038-.173.06-.214q.645-.102.977-.254c.18-.084.29-.178.339-.29a.3.3 0 0 0 .025-.102a.233.233 0 0 0-.196-.243z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSnowboard: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18.51 1.527a4.416 4.416 0 0 1-.305 6.522A77 77 0 0 0 8.061 18.193a4.416 4.416 0 0 1-6.522.305a4.39 4.39 0 0 1 .317-6.499A74 74 0 0 0 12.01 1.844a4.39 4.39 0 0 1 6.499-.317zm-1.415 1.414a2.39 2.39 0 0 0-3.54.173a76 76 0 0 1-10.43 10.43a2.392 2.392 0 0 0-.005 3.691a2.416 2.416 0 0 0 3.401-.318A79 79 0 0 1 16.93 6.51a2.416 2.416 0 0 0 .166-3.568zM11.438 8.57a1 1 0 1 1 1.415-1.414a1 1 0 0 1-1.415 1.414m-4.95 4.95a1 1 0 1 1 1.415-1.415a1 1 0 0 1-1.414 1.415z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSnowboardF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18.504 1.47a3.61 3.61 0 0 1-.263 5.34q-4.646 3.811-6.101 5.266t-5.266 6.101a3.61 3.61 0 0 1-5.34.263a3.48 3.48 0 0 1 .291-5.183A72.4 72.4 0 0 0 13.321 1.761a3.48 3.48 0 0 1 5.183-.291m-7.071 7.07a1 1 0 1 0 1.414-1.413a1 1 0 0 0-1.414 1.414zM7.19 12.785a1 1 0 1 0 1.414-1.415a1 1 0 0 0-1.414 1.415\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSnowflake: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 6.126V1a1 1 0 1 1 2 0v5.126c.367.094.714.24 1.032.428l2.21-2.21a1 1 0 1 1 1.415 1.413l-2.21 2.211c.187.318.333.665.427 1.032H19a1 1 0 0 1 0 2h-5.126a4 4 0 0 1-.428 1.032l2.21 2.21a1 1 0 1 1-1.413 1.415l-2.211-2.21a4 4 0 0 1-1.032.427V19a1 1 0 0 1-2 0v-5.126a4 4 0 0 1-1.032-.428l-2.21 2.21a1 1 0 0 1-1.415-1.413l2.21-2.211A4 4 0 0 1 6.127 11H1a1 1 0 0 1 0-2h5.126a4 4 0 0 1 .428-1.032l-2.21-2.21a1 1 0 0 1 1.413-1.415l2.211 2.21A4 4 0 0 1 9 6.127zM10 12a2 2 0 1 1 0-4a2 2 0 0 1 0 4m-1 5.318l-.393.393a.985.985 0 0 1-1.393-1.393L9 14.532zm2-2.786l1.786 1.786a.985.985 0 0 1-1.393 1.393L11 17.318zm0-11.85l.393-.393a.985.985 0 0 1 1.393 1.393L11 5.468zM9 5.468L7.214 3.682a.985.985 0 0 1 1.393-1.393L9 2.682zM17.318 11l.393.393a.985.985 0 0 1-1.393 1.393L14.532 11zm-2.786-2l1.786-1.786a.985.985 0 0 1 1.393 1.393L17.318 9zM2.682 9l-.393-.393a.985.985 0 0 1 1.393-1.393L5.468 9zm2.786 2l-1.786 1.786a.985.985 0 0 1-1.393-1.393L2.682 11z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSoundcloud: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19.982 6.362c-.08-1.218-1.032-2.196-2.194-2.255a2.2 2.2 0 0 0-1.222.292C16.518 1.974 14.632.023 12.311.023c-.615 0-1.198.137-1.725.382a.33.33 0 0 0-.186.303v7.925c0 .183.142.332.316.332h6.957c1.333 0 2.402-1.183 2.31-2.603zM9.785.536a.326.326 0 0 0-.318.334v7.752c0 .184.142.334.318.334c.175 0 .318-.15.318-.334V.87a.326.326 0 0 0-.318-.334m-1.052.824a.326.326 0 0 0-.318.334v6.928c0 .184.143.334.318.334s.318-.15.318-.334V1.694a.326.326 0 0 0-.318-.334m-1.052.376a.326.326 0 0 0-.318.334v6.552c0 .184.143.334.318.334s.318-.15.318-.334V2.07a.326.326 0 0 0-.318-.334M6.63 1.235a.326.326 0 0 0-.319.334v7.053c0 .184.143.334.318.334s.318-.15.318-.334V1.57a.326.326 0 0 0-.318-.334zm-1.053.334a.326.326 0 0 0-.318.334v6.72c0 .183.143.333.318.333s.318-.15.318-.334v-6.72a.326.326 0 0 0-.318-.333m-1.052.668a.326.326 0 0 0-.317.334v6.051c0 .184.142.334.317.334s.318-.15.318-.334V2.571a.326.326 0 0 0-.318-.334M3.474 3.53a.326.326 0 0 0-.318.334v4.758c0 .184.142.334.318.334c.175 0 .317-.15.317-.334V3.864a.326.326 0 0 0-.317-.333zm-1.052.543a.326.326 0 0 0-.318.334v4.215c0 .184.142.334.318.334c.175 0 .318-.15.318-.334V4.407a.326.326 0 0 0-.318-.334m-1.052.125a.326.326 0 0 0-.318.333v3.967c0 .184.142.333.318.333c.175 0 .318-.15.318-.333V4.53a.326.326 0 0 0-.318-.333zM.318 5.07A.326.326 0 0 0 0 5.402v2.285c0 .185.142.334.318.334c.175 0 .318-.15.318-.334V5.403a.326.326 0 0 0-.318-.334z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -7.5 24 24"
}

export const jamSpeaker: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h8a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm4 15a4 4 0 1 1 0-8a4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0-8a1 1 0 1 1 0-2a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamSpeakerF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h8a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m4 17a4 4 0 1 0 0-8a4 4 0 0 0 0 8M7 7a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0 8a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamSpellCheck: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.54 6.002H2.457L1.95 7.39c-.17.466-.734.722-1.26.57c-.522-.15-.81-.651-.64-1.118L2.097 1.23C2.437.296 3.565-.215 4.615.087c.61.176 1.088.6 1.285 1.142L7.948 6.84c.17.467-.118.967-.643 1.119c-.525.15-1.089-.105-1.259-.571zm-.73-2l-.812-2.226l-.811 2.226zm2.536 7.583l4.948-4.952a.999.999 0 1 1 1.413 1.415l-5.654 5.659a1 1 0 0 1-1.414 0l-2.827-2.83a1.001 1.001 0 0 1 1.414-1.414z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const jamSpotify: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.992 0C4.474 0 0 4.474 0 9.992s4.474 9.992 9.992 9.992s9.992-4.474 9.992-9.992S15.51 0 9.992 0m4.348 15.683c-.127.329-.355.512-.59.512a.52.52 0 0 1-.344-.141c-1.796-1.588-3.87-1.843-5.294-1.778c-1.578.073-2.735.544-2.747.549c-.363.15-.74-.174-.839-.724c-.1-.55.114-1.119.477-1.27c.052-.022 1.297-.534 3.029-.62a9 9 0 0 1 2.917.32a8.1 8.1 0 0 1 3.146 1.737c.326.289.436.922.245 1.415m1.27-3.063c-.15.329-.42.512-.699.512a.68.68 0 0 1-.407-.141c-2.127-1.588-4.584-1.843-6.271-1.778c-1.87.073-3.24.544-3.253.549c-.431.15-.876-.174-.995-.724c-.118-.55.135-1.119.566-1.27c.061-.022 1.536-.534 3.587-.62c1.208-.051 2.37.057 3.456.32a10.2 10.2 0 0 1 3.726 1.737c.386.288.516.922.29 1.415m.782-2.996a.96.96 0 0 1-.5-.142C10.835 6.404 4.276 8.234 4.21 8.252c-.528.153-1.075-.17-1.22-.721s.165-1.12.693-1.272c.076-.022 1.885-.534 4.4-.62a18.6 18.6 0 0 1 4.24.32c1.686.333 3.223.917 4.57 1.738c.474.288.633.921.357 1.414a.99.99 0 0 1-.858.513\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSquare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSquareF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 .565h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4v-12a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1.5 24 24"
}

export const jamSquarespace: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.305 7.16L9.3 1.134a3.837 3.837 0 0 1 5.447 0a.987.987 0 0 1-.027 1.365a.96.96 0 0 1-1.363 0l-.09-.105a1.92 1.92 0 0 0-2.606.11l-6.128 6.16c-.403.374-1.013.374-1.388-.004a.97.97 0 0 1 .161-1.5zm13.456.131a.96.96 0 0 0-1.493.163L9.3 13.456a1.92 1.92 0 0 1-2.724 0l-.027-.005a.96.96 0 0 0-1.362 0a.97.97 0 0 0 .154 1.496a3.84 3.84 0 0 0 5.32-.123l6.101-6.164a.97.97 0 0 0 0-1.369zm-9.37 3.976a.97.97 0 0 0-.161 1.5c.375.377.984.377 1.388.004l6.128-6.161a1.92 1.92 0 0 1 2.723 0a1.94 1.94 0 0 1 0 2.738l-5.81 5.87a1.92 1.92 0 0 0 2.723 0l4.45-4.5a3.89 3.89 0 0 0 0-5.477a3.84 3.84 0 0 0-5.448 0L7.39 11.267zm-.816-.55l6.1-6.164a.97.97 0 0 0 0-1.369a.96.96 0 0 0-1.492.163L5.213 9.35a1.92 1.92 0 0 1-2.723 0a1.94 1.94 0 0 1 0-2.739L8.301.742a1.92 1.92 0 0 0-2.724 0l-4.449 4.5a3.887 3.887 0 0 0 0 5.475a3.836 3.836 0 0 0 5.447 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamSquarespaceCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M5.987 9.513L9.591 5.89a2.307 2.307 0 0 1 3.275 0a.593.593 0 0 1-.017.82a.577.577 0 0 1-.819 0l-.054-.063a1.153 1.153 0 0 0-1.567.066l-3.684 3.704a.6.6 0 0 1-.835-.002a.584.584 0 0 1 .097-.902m8.09.079a.577.577 0 0 0-.897.098l-3.59 3.608a1.154 1.154 0 0 1-1.637 0l-.016-.003a.577.577 0 0 0-.819 0a.584.584 0 0 0 .092.9c.91.834 2.32.81 3.2-.074l3.667-3.706a.585.585 0 0 0 0-.823m-5.634 2.39a.583.583 0 0 0-.097.902a.6.6 0 0 0 .835.003l3.685-3.705a1.154 1.154 0 0 1 1.637 0a1.17 1.17 0 0 1 0 1.647l-3.493 3.529a1.154 1.154 0 0 0 1.637 0l2.675-2.706a2.34 2.34 0 0 0 0-3.293a2.31 2.31 0 0 0-3.275 0zm-.49-.33l3.668-3.706a.584.584 0 0 0 0-.823a.576.576 0 0 0-.897.098l-3.59 3.608a1.153 1.153 0 0 1-1.637 0a1.17 1.17 0 0 1 0-1.647l3.494-3.528a1.153 1.153 0 0 0-1.638 0L4.678 8.359a2.337 2.337 0 0 0 0 3.293c.905.91 2.371.91 3.275 0\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSquarespaceSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M5.987 9.513L9.591 5.89a2.307 2.307 0 0 1 3.275 0a.593.593 0 0 1-.017.82a.577.577 0 0 1-.819 0l-.054-.063a1.153 1.153 0 0 0-1.567.066l-3.684 3.704a.6.6 0 0 1-.835-.002a.584.584 0 0 1 .097-.902m8.09.079a.577.577 0 0 0-.897.098l-3.59 3.608a1.154 1.154 0 0 1-1.637 0l-.016-.003a.577.577 0 0 0-.819 0a.584.584 0 0 0 .092.9c.91.834 2.32.81 3.2-.074l3.667-3.706a.585.585 0 0 0 0-.823m-5.634 2.39a.583.583 0 0 0-.097.902a.6.6 0 0 0 .835.003l3.685-3.705a1.154 1.154 0 0 1 1.637 0a1.17 1.17 0 0 1 0 1.647l-3.493 3.529a1.154 1.154 0 0 0 1.637 0l2.675-2.706a2.34 2.34 0 0 0 0-3.293a2.31 2.31 0 0 0-3.275 0zm-.49-.33l3.668-3.706a.584.584 0 0 0 0-.823a.576.576 0 0 0-.897.098l-3.59 3.608a1.153 1.153 0 0 1-1.637 0a1.17 1.17 0 0 1 0-1.647l3.494-3.528a1.153 1.153 0 0 0-1.638 0L4.678 8.359a2.337 2.337 0 0 0 0 3.293c.905.91 2.371.91 3.275 0\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamStackoverflow: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M13.492 18.136v-5.272h1.665v7.022H.13v-7.022h1.665v5.272z\"/><path d=\"m3.632 12.364l8.173 1.795l.346-1.727l-8.173-1.796zm1.082-4.091l7.567 3.704l.692-1.59l-7.568-3.728zm2.097-3.91l6.421 5.614l1.06-1.34L7.87 3.022l-1.06 1.34zM10.962.206L9.622 1.25l4.973 7.045l1.34-1.045zM3.46 16.364h8.346v-1.75H3.46z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamStackoverflowCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M12.746 14.068v-2.636h.832v3.511H6.065v-3.511h.832v2.636z\"/><path d=\"m7.816 11.182l4.087.898l.173-.864l-4.087-.898zm.54-2.046l3.785 1.853l.345-.796L8.703 8.33zm1.05-1.954l3.21 2.807l.53-.67l-3.21-2.808zm2.075-2.08l-.67.523l2.486 3.523l.67-.523zm-3.751 8.08h4.173v-.875H7.73z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamStackoverflowSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M12.746 14.068v-2.636h.832v3.511H6.065v-3.511h.832v2.636z\"/><path d=\"m7.816 11.182l4.087.898l.173-.864l-4.087-.898zm.54-2.046l3.785 1.853l.345-.796L8.703 8.33zm1.05-1.954l3.21 2.807l.53-.67l-3.21-2.808zm2.075-2.08l-.67.523l2.486 3.523l.67-.523zm-3.751 8.08h4.173v-.875H7.73z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamStamp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 18v-2H2v2zM7 14V9a5 5 0 1 1 6 0v5h5a2 2 0 0 1 2 2v4H0v-4a2 2 0 0 1 2-2zm4 0V8.001l.799-.6a3 3 0 1 0-3.598 0l.799.6V14z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamStampF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 7.465a4 4 0 1 1 4 0V14H8zM2 15h16a2 2 0 0 1 2 2v2H0v-2a2 2 0 0 1 2-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2.5 24 24"
}

export const jamStar: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m10 13.554l3.517 1.85l-.672-3.917l2.846-2.774l-3.932-.571L10 4.579L8.241 8.142l-3.932.571l2.846 2.774l-.672 3.916zm0 2.26L3.827 19.06l1.179-6.875L.01 7.317l6.902-1.003L10 .06l3.087 6.254l6.902 1.003l-4.995 4.868l1.18 6.875z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2.5 24 24"
}

export const jamStarF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m10 16.379l-6.173 3.245l1.179-6.874L.01 7.882l6.902-1.003L10 .624l3.087 6.255l6.902 1.003l-4.995 4.868l1.18 6.874z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamStarFull: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m10 16.207l-6.173 3.246l1.179-6.874L.01 7.71l6.902-1.003L10 .453l3.087 6.254l6.902 1.003l-4.995 4.869l1.18 6.874z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamStarHalf: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 15.814L3.827 19.06l1.179-6.875L.01 7.317l6.902-1.003L10 .06l3.087 6.254l6.902 1.003l-4.995 4.868l1.18 6.875zm0-2.26l3.517 1.85l-.672-3.917l2.846-2.774l-3.932-.571L10 4.579L8.241 8.142l-3.932.571l2.846 2.774l-.672 3.916zM10 .06l3.087 6.254l6.902 1.003l-4.995 4.868l1.18 6.875L10 15.814z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2.5 24 24"
}

export const jamStarHalfF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.989 0L10 .024V15.76l-.011-.006L3.815 19l1.179-6.874L0 7.257l6.902-1.003z\"/>",
  "width": 10,
  "height": 19,
  "viewBox": "0 0 10 19"
}

export const jamStation: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6.922 15.152A6 6 0 0 1 4 10a6 6 0 0 1 3.022-5.21a.2.2 0 0 1 .101-.03a1 1 0 0 1 1.325.946a1 1 0 0 1-.577.907A4 4 0 0 0 6 10c0 1.48.804 2.773 2 3.465v.001a1 1 0 0 1-.989 1.735l-.032-.016l-.011-.007zm6.245-.055a1 1 0 1 1-1.091-1.668a.1.1 0 0 1 .023-.023A4 4 0 0 0 14 10c0-1.48-.804-2.773-2-3.465v-.002a1 1 0 0 1 1.088-1.678A6 6 0 0 1 16 10a6 6 0 0 1-2.833 5.097M10 12a2 2 0 1 1 0-4a2 2 0 0 1 0 4m2.759 7.608a1 1 0 0 1-.412-1.958a8.004 8.004 0 0 0-.053-15.316a.1.1 0 0 1-.03-.016A1 1 0 1 1 12.941.44C17.03 1.696 20 5.5 20 10c0 4.547-3.034 8.384-7.188 9.6a.2.2 0 0 1-.053.008m-5.613-.021C3.014 18.359 0 14.53 0 10C0 5.479 3 1.658 7.12.421a1 1 0 0 1 .1-.03L7.228.39a1 1 0 0 1 .224-.025a1 1 0 0 1 .27 1.965a8.004 8.004 0 0 0 .013 15.347a1 1 0 1 1-.589 1.91\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamStop: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -4 24 24"
}

export const jamStopSign: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5.094 16.32A8 8 0 0 0 16.32 5.094zM3.68 14.906L14.906 3.68A8 8 0 0 0 3.68 14.906M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamStore: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 2H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zM3.01 8v9.965H5V13a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4.965h6.013V8H15c-.768 0-1.47-.289-2-.764A3 3 0 0 1 11 8H9c-.768 0-1.47-.289-2-.764A3 3 0 0 1 5 8zm-2-.754A3 3 0 0 1 0 5V3a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v2c0 .882-.38 1.676-.987 2.225v10.74a2 2 0 0 1-2 2h-7.64A2 2 0 0 1 9 20H7a2 2 0 0 1-.373-.035H3.011a2 2 0 0 1-2-2V7.245zM9 17.966V13H7v4.965h2zM12 2H8v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm2 0v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm0 9h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamStrikethrough: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.657 4.935H1.15a3 3 0 0 1-.15-.94v-.497A3.5 3.5 0 0 1 4.498 0H6a3 3 0 0 1 3 3a1 1 0 1 1-2 0a1 1 0 0 0-1-1H4.498C3.67 2 3 2.67 3 3.498v.497a1 1 0 0 0 .657.94m5.186 2.1c.102.301.157.624.157.96v.528a3.53 3.53 0 0 1-3.528 3.528H4a3 3 0 0 1-3-3V9a1 1 0 1 1 2 0v.05a1 1 0 0 0 1 1h1.472C6.316 10.05 7 9.367 7 8.523v-.528a1 1 0 0 0-.72-.96zM.5 5.51h9a.5.5 0 0 1 0 1h-9a.5.5 0 1 1 0-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7 -5.5 24 24"
}

export const jamStumbleupon: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M16.817 8.219v2.208c0 .743-.6 1.376-1.335 1.363a1.32 1.32 0 0 1-1.29-1.328V8.333a.377.377 0 0 0-.507-.357l-1.158.433a.37.37 0 0 1-.269-.003l-.69-.275a.377.377 0 0 0-.514.354v1.908c0 2.473 1.94 4.536 4.381 4.573c2.486.039 4.52-1.997 4.52-4.504V8.218a.343.343 0 0 0-.34-.344h-2.458a.343.343 0 0 0-.34.345\"/><path d=\"M11.054 4.334V5.39c0 .157.094.297.238.355l.99.395a.37.37 0 0 0 .27.003l1.394-.522a.38.38 0 0 0 .246-.357v-.896c0-2.34-1.837-4.294-4.15-4.33C7.69.001 5.764 1.928 5.764 4.303v6.124c0 .743-.6 1.376-1.335 1.363a1.32 1.32 0 0 1-1.29-1.328V8.219a.343.343 0 0 0-.34-.345H.34a.343.343 0 0 0-.34.345v2.174c0 2.473 1.94 4.536 4.381 4.573c2.486.039 4.52-1.997 4.52-4.504v-6.16c0-.618.513-1.118 1.13-1.088c.579.03 1.023.534 1.023 1.12\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4.5 24 24"
}

export const jamStumbleuponCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M13.388 10.155v1.135c0 .382-.301.707-.669.7a.67.67 0 0 1-.646-.682v-1.094a.19.19 0 0 0-.255-.183l-.58.222a.18.18 0 0 1-.134-.001l-.346-.142a.19.19 0 0 0-.258.182v.98c0 1.271.972 2.331 2.196 2.35c1.245.02 2.265-1.026 2.265-2.314v-1.153a.174.174 0 0 0-.17-.177h-1.232a.174.174 0 0 0-.171.177\"/><path d=\"M10.54 8.208v.542c0 .08.047.153.119.183l.496.203a.18.18 0 0 0 .135.001l.699-.268a.2.2 0 0 0 .123-.184v-.46c0-1.203-.92-2.206-2.08-2.225c-1.179-.018-2.144.972-2.144 2.192v3.147c0 .382-.301.707-.669.7a.67.67 0 0 1-.646-.682v-1.153a.174.174 0 0 0-.17-.177H5.17a.174.174 0 0 0-.171.177v1.118c0 1.27.972 2.33 2.196 2.35c1.245.02 2.265-1.027 2.265-2.315V8.192a.55.55 0 0 1 .566-.56c.29.016.512.275.512.576z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamStumbleuponSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M13.388 10.155v1.135c0 .382-.301.707-.669.7a.67.67 0 0 1-.646-.682v-1.094a.19.19 0 0 0-.255-.183l-.58.222a.18.18 0 0 1-.134-.001l-.346-.142a.19.19 0 0 0-.258.182v.98c0 1.271.972 2.331 2.196 2.35c1.245.02 2.265-1.026 2.265-2.314v-1.153a.174.174 0 0 0-.17-.177h-1.232a.174.174 0 0 0-.171.177\"/><path d=\"M10.54 8.208v.542c0 .08.047.153.119.183l.496.203a.18.18 0 0 0 .135.001l.699-.268a.2.2 0 0 0 .123-.184v-.46c0-1.203-.92-2.206-2.08-2.225c-1.179-.018-2.144.972-2.144 2.192v3.147c0 .382-.301.707-.669.7a.67.67 0 0 1-.646-.682v-1.153a.174.174 0 0 0-.17-.177H5.17a.174.174 0 0 0-.171.177v1.118c0 1.27.972 2.33 2.196 2.35c1.245.02 2.265-1.027 2.265-2.315V8.192a.55.55 0 0 1 .566-.56c.29.016.512.275.512.576z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSubscript: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m5.954 4.5l2.831 2.806a.986.986 0 0 1 0 1.403a1.007 1.007 0 0 1-1.415 0L4.54 5.903L1.707 8.71a1.007 1.007 0 0 1-1.415 0a.986.986 0 0 1 0-1.403L3.123 4.5L.294 1.694a.986.986 0 0 1 0-1.403a1.007 1.007 0 0 1 1.415 0L4.54 3.097L7.37.29a1.007 1.007 0 0 1 1.416 0a.986.986 0 0 1 0 1.403L5.955 4.5ZM14 12.352V14H9.078v-1.014l.101-.246l1.801-1.913c.433-.435.8-.77.93-1.011q.186-.346.184-.587a.42.42 0 0 0-.128-.327a.48.48 0 0 0-.355-.127a.45.45 0 0 0-.357.158c-.106.117-.167.288-.175.525l-.012.338h-1.84l.017-.366c.034-.735.274-1.33.723-1.77c.45-.44 1.03-.66 1.719-.66q.642 0 1.149.275q.51.28.814.8q.3.516.301 1.063c0 .416-.231.849-.46 1.307c-.223.45-.538.876-1.072 1.555l-.118.123l-.255.229z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const jamSubtraction: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13 0a7 7 0 1 1-3 13.326A7 7 0 1 1 10 .673A7 7 0 0 1 13 0M7 2a5 5 0 1 0 1.002 9.9A6.97 6.97 0 0 1 6 7c0-1.907.763-3.637 2-4.9A5 5 0 0 0 7 2m6 0a5 5 0 1 0 0 10a5 5 0 0 0 0-10\"/>",
  "width": 20,
  "height": 14,
  "viewBox": "0 0 20 14"
}

export const jamSun: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 13a3 3 0 1 0 0-6a3 3 0 0 0 0 6m0 2a5 5 0 1 1 0-10a5 5 0 0 1 0 10m0-15a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1m0 16a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1M1 9h2a1 1 0 1 1 0 2H1a1 1 0 0 1 0-2m16 0h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2m.071-6.071a1 1 0 0 1 0 1.414l-1.414 1.414a1 1 0 1 1-1.414-1.414l1.414-1.414a1 1 0 0 1 1.414 0M5.757 14.243a1 1 0 0 1 0 1.414L4.343 17.07a1 1 0 1 1-1.414-1.414l1.414-1.414a1 1 0 0 1 1.414 0zM4.343 2.929l1.414 1.414a1 1 0 0 1-1.414 1.414L2.93 4.343A1 1 0 0 1 4.343 2.93zm11.314 11.314l1.414 1.414a1 1 0 0 1-1.414 1.414l-1.414-1.414a1 1 0 1 1 1.414-1.414\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamSunF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 15.565a5 5 0 1 1 0-10a5 5 0 0 1 0 10m0-15a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0 16a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m-9-7h2a1 1 0 1 1 0 2H1a1 1 0 0 1 0-2m16 0h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2m.071-6.071a1 1 0 0 1 0 1.414l-1.414 1.414a1 1 0 1 1-1.414-1.414l1.414-1.414a1 1 0 0 1 1.414 0M5.757 14.808a1 1 0 0 1 0 1.414l-1.414 1.414a1 1 0 1 1-1.414-1.414l1.414-1.414a1 1 0 0 1 1.414 0M4.343 3.494l1.414 1.414a1 1 0 0 1-1.414 1.414L2.93 4.908a1 1 0 0 1 1.414-1.414zm11.314 11.314l1.414 1.414a1 1 0 0 1-1.414 1.414l-1.414-1.414a1 1 0 1 1 1.414-1.414\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1.5 24 24"
}

export const jamSuperscript: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1.708 5.29L4.54 8.098L7.37 5.29a1.007 1.007 0 0 1 1.416 0a.986.986 0 0 1 0 1.403L5.955 9.5l2.83 2.806a.986.986 0 0 1 0 1.403a1.007 1.007 0 0 1-1.415 0l-2.83-2.806l-2.832 2.806a1.007 1.007 0 0 1-1.415 0a.986.986 0 0 1 0-1.403L3.123 9.5L.294 6.694a.986.986 0 0 1 0-1.403a1.007 1.007 0 0 1 1.415 0ZM11.686 0q.642 0 1.149.275q.51.28.814.8c.2.343.301.7.301 1.063c0 .416-.231.849-.46 1.307c-.223.45-.538.876-1.072 1.555l-.118.123l-.255.229H14V7H9.078V5.986l.101-.246l1.801-1.913c.433-.435.8-.77.93-1.011q.186-.346.184-.587a.42.42 0 0 0-.128-.327a.48.48 0 0 0-.355-.127a.45.45 0 0 0-.357.158c-.106.117-.167.288-.175.525l-.012.338h-1.84l.017-.366c.034-.735.274-1.33.723-1.77c.45-.44 1.03-.66 1.719-.66\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const jamSwitchLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 2a5 5 0 1 0 0 10h6a5 5 0 0 0 0-10zm0-2h6a7 7 0 0 1 0 14H7A7 7 0 0 1 7 0m0 11a4 4 0 1 1 0-8a4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -5 24 24"
}

export const jamSwitchLeftF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 0h8a6 6 0 1 1 0 12H6A6 6 0 1 1 6 0m1 10a4 4 0 1 0 0-8a4 4 0 0 0 0 8m0-2a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6 24 24"
}

export const jamSwitchRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 2a5 5 0 1 0 0 10h6a5 5 0 0 0 0-10zm0-2h6a7 7 0 0 1 0 14H7A7 7 0 0 1 7 0m6 11a4 4 0 1 1 0-8a4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -5 24 24"
}

export const jamSwitchRightF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 0h7a6 6 0 1 1 0 12H6A6 6 0 1 1 6 0m6 10a4 4 0 1 0 0-8a4 4 0 0 0 0 8m0-2a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2.5 -6 24 24"
}

export const jamSword: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m6.778 10.728l1.414 1.414l8.436-8.435l-.236-1.179l-1.178-.236zM3.95 16.385a1 1 0 0 1-1.414 1.414L1.12 16.385a1 1 0 0 1 1.415-1.414l2.828-2.829l-1.414-1.414a1 1 0 0 1 1.414-1.414L14.556.12l3.536.707l.707 3.536l-9.192 9.192a1 1 0 1 1-1.415 1.415l-1.414-1.415l-2.828 2.829z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2.5 -2.5 24 24"
}

export const jamSwordF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.646 14.096a1 1 0 1 1-1.414 1.414l-1.414-1.414l-2.828 2.829a1 1 0 0 1-1.415 1.414l-1.414-1.414a1 1 0 0 1 1.414-1.415l2.829-2.828l-1.414-1.414a1 1 0 0 1 1.414-1.414zm.708-.707L6.11 9.146L14.596.661l3.536.707l.707 3.536z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2.5 -2.5 24 24"
}

export const jamTab: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 4v1h-7V2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM4 0h12a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 20,
  "height": 16,
  "viewBox": "0 0 20 16"
}

export const jamTable: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 4v8h10V4zm0-4h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const jamTableCell: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 6h4V2H2zm0 2v4h4V8zm10-2V2H8v4zm0 2H8v4h4zM2 0h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const jamTableCellMerge: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 2H2v2h2zm2 0v2h2V2h2v2h2V2zm6 4H6v6h6zm-8 6v-2H2v2zM2 8h2V6H2zm0-8h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const jamTableColAfter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 0a2 2 0 0 1 2 2v1a1 1 0 0 1-2 0V2H6v10h6v-1a1 1 0 0 1 2 0v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zM4 10H2v2h2zm6-6a1 1 0 0 1 1 1v1h1a1 1 0 0 1 0 2h-1v1a1 1 0 0 1-2 0V8H8a1 1 0 1 1 0-2h1V5a1 1 0 0 1 1-1M4 6H2v2h2zm0-4H2v2h2z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const jamTableColBefore: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 12V2H2v1a1 1 0 1 1-2 0V2a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-1a1 1 0 0 1 2 0v1zm2 0h2v-2h-2zm2-4V6h-2v2zm0-4V2h-2v2zM3 6V5a1 1 0 1 1 2 0v1h1a1 1 0 1 1 0 2H5v1a1 1 0 1 1-2 0V8H2a1 1 0 1 1 0-2z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const jamTableDelete: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 0h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m0 4v8h10V4zm5 5.414l-1.414 1.414a1 1 0 1 1-1.414-1.414L5.586 8L4.172 6.586a1 1 0 1 1 1.414-1.414L7 6.586l1.414-1.414a1 1 0 1 1 1.414 1.414L8.414 8l1.414 1.414a1 1 0 0 1-1.414 1.414z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const jamTableLeftHeader: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 2v10h8V2zM2 0h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const jamTableRightHeader: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 2H2v10h8zm2-2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const jamTableRowAbove: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 8V2h-1a1 1 0 0 1 0-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h1a1 1 0 1 1 0 2H2v6zm0 2h-2v2h2zm-4 2v-2H6v2zm-4 0v-2H2v2zm2-9V2a1 1 0 1 1 2 0v1h1a1 1 0 1 1 0 2H8v1a1 1 0 1 1-2 0V5H5a1 1 0 1 1 0-2z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const jamTableRowAfter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 6v6h1a1 1 0 0 1 0 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1a1 1 0 0 1 0-2h1V6zm0-2h2V2H2zm4-2v2h2V2zm4 0v2h2V2zm-2 9v1a1 1 0 0 1-2 0v-1H5a1 1 0 0 1 0-2h1V8a1 1 0 1 1 2 0v1h1a1 1 0 1 1 0 2z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const jamTableTopHeader: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 4v8h10V4zM0 2a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const jamTablet: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h10a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm5 15a1 1 0 1 1 0-2a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamTabletF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h10a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5 17a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamTag: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m17.014.872l3.448 3.447a2 2 0 0 1 .463 2.103l-1.763 4.812a1 1 0 0 1-.232.363l-8.323 8.323a2 2 0 0 1-2.829 0l-6.364-6.364a2 2 0 0 1 0-2.828l8.333-8.333a1 1 0 0 1 .364-.232L14.913.408a2 2 0 0 1 2.101.464m-6.009 3.094l-8.177 8.176l6.364 6.364l8.168-8.167l1.687-4.605L15.6 2.286zm2.784 3.58a1.5 1.5 0 1 1 2.12-2.121a1.5 1.5 0 0 1-2.12 2.12z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1.5 -1.5 24 24"
}

export const jamTagF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m17.014.73l3.448 3.447a2 2 0 0 1 .463 2.103l-1.763 4.812a1 1 0 0 1-.232.363l-8.323 8.323a2 2 0 0 1-2.829 0l-6.364-6.364a2 2 0 0 1 0-2.828l8.333-8.333a1 1 0 0 1 .364-.232L14.913.266a2 2 0 0 1 2.101.464M13.79 7.404a1.5 1.5 0 1 0 2.12-2.122a1.5 1.5 0 0 0-2.12 2.122\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1.5 -1.5 24 24"
}

export const jamTags: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11.586 15.071L13 13.657l1.414 1.414l6.165-6.165l1.09-3.552l-2.484-2.483l-1.079.336l-1.598-1.598L18.591.96a2 2 0 0 1 2.008.496l2.483 2.483a2 2 0 0 1 .498 2L22.345 9.97l-7.93 7.93l-2.83-2.828zM14.236.75l2.482 2.483a2 2 0 0 1 .498 2l-1.235 4.028l-7.93 7.931l-7.78-7.778L8.17 1.516L12.227.254a2 2 0 0 1 2.008.496zM3.1 9.414l4.95 4.95l6.164-6.165l1.09-3.552l-2.484-2.483l-3.585 1.115zm7.424-2.475a1.5 1.5 0 1 1 2.121-2.121a1.5 1.5 0 0 1-2.12 2.121zm6.886 1.022l.782-2.878q.674.228.917.518a1.5 1.5 0 0 1-.185 2.113q-.435.366-1.514.247\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 -3 24 24"
}

export const jamTagsF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m13.963 1.478l2.483 2.483a2 2 0 0 1 .498 2L15.71 9.99l-7.93 7.93L0 10.142l7.899-7.899l4.056-1.26a2 2 0 0 1 2.008.495m-3.71 6.19a1.5 1.5 0 1 0 2.121-2.122a1.5 1.5 0 0 0-2.121 2.121zm7.222 1.047q.813.032 1.178-.273a1.5 1.5 0 0 0 .185-2.113q-.164-.196-.527-.364a2 2 0 0 0-.538-1.848L16.05 2.395l2.269-.706a2 2 0 0 1 2.008.496l2.483 2.483a2 2 0 0 1 .498 2l-1.235 4.028l-7.93 7.931l-2.795-2.794l5.688-5.688z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 -2.5 24 24"
}

export const jamTarget: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0-1a7 7 0 1 1 0-14a7 7 0 0 1 0 14m0-2a5 5 0 1 0 0-10a5 5 0 0 0 0 10m0-1a4 4 0 1 1 0-8a4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0-1a1 1 0 1 1 0-2a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamTaskList: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 0h8a6 6 0 0 1 6 6v8a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6m0 2a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4zm6 7h3a1 1 0 0 1 0 2h-3a1 1 0 0 1 0-2m-2 4h5a1 1 0 0 1 0 2h-5a1 1 0 0 1 0-2m0-8h5a1 1 0 0 1 0 2h-5a1 1 0 1 1 0-2m-4.172 5.243L7.95 8.12a1 1 0 1 1 1.414 1.415l-2.828 2.828a1 1 0 0 1-1.415 0L3.707 10.95a1 1 0 0 1 1.414-1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamTaskListF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 0h8a6 6 0 0 1 6 6v8a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6m6 9a1 1 0 0 0 0 2h3a1 1 0 1 0 0-2zm-2 4a1 1 0 0 0 0 2h5a1 1 0 1 0 0-2zm0-8a1 1 0 1 0 0 2h5a1 1 0 0 0 0-2zm-4.172 5.243l-.707-.707a1 1 0 1 0-1.414 1.414l1.414 1.414a1 1 0 0 0 1.415 0l2.828-2.828A1 1 0 0 0 7.95 8.12l-2.122 2.122z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamTelegram: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10S4.477 0 10 0m4.442 6c-.381.007-.966.207-3.779 1.362a485 485 0 0 0-5.907 2.512q-.72.283-.753.553c-.044.346.46.453 1.094.657c.517.166 1.213.36 1.575.368q.492.01 1.098-.4q4.139-2.76 4.273-2.789c.063-.014.15-.032.21.02c.059.052.053.15.046.177c-.05.211-2.641 2.538-2.79 2.691l-.072.072c-.55.543-1.105.898-.147 1.521c.866.563 1.37.922 2.26 1.5c.57.368 1.017.805 1.605.752c.271-.025.55-.276.693-1.026c.335-1.77.995-5.608 1.147-7.19a1.7 1.7 0 0 0-.017-.393a.42.42 0 0 0-.144-.27c-.121-.098-.309-.118-.392-.117\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export const jamTemperature: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 15a5 5 0 1 1-8-4V3a3 3 0 1 1 6 0v8c1.214.912 2 2.364 2 4m-3.201-2.401l-.799-.6V3a1 1 0 1 0-2 0v8.999l-.799.6a3 3 0 1 0 3.598 0M5 17a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7 -2 24 24"
}

export const jamTemplate: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 12h5a1 1 0 0 0 1-1V6H6zm-2 0V6H2v5a1 1 0 0 0 1 1zm8-9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1h10zM3 0h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const jamTerminal: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m5.243 7.071l-4.95-4.95A1 1 0 1 1 1.707.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414zM6.929 12h8a1 1 0 0 1 0 2h-8a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -5 24 24"
}

export const jamText: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 1v2a1 1 0 0 1-2 0V2H7v8h1a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2h1V2H2v1a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1\"/>",
  "width": 12,
  "height": 12,
  "viewBox": "0 0 12 12"
}

export const jamThunder: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8.997 6.968H6.708V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v5.923a1 1 0 0 0 .966 1l1.937.061v7.404a.549.549 0 0 0 1.053.216l3.96-9.242a1 1 0 0 0-.92-1.394zM8.708 3v1.968h.289a3 3 0 0 1 2.757 4.181l-3.96 9.243a2.549 2.549 0 0 1-4.891-1.004v-5.466A3 3 0 0 1 0 8.923V3a3 3 0 0 1 3-3h2.708a3 3 0 0 1 3 3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -2 24 24"
}

export const jamThunderF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5.708 4.968h1.789a1.5 1.5 0 0 1 1.378 2.09l-3.96 9.243a1.049 1.049 0 0 1-2.012-.413v-6.92L1.45 8.923A1.5 1.5 0 0 1 0 7.423V1.5A1.5 1.5 0 0 1 1.5 0h2.708a1.5 1.5 0 0 1 1.5 1.5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7.5 -3.5 24 24"
}

export const jamTicket: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 9H8a1 1 0 1 1 0-2h2V2.001a5 5 0 0 1-8 0V7h2a1 1 0 1 1 0 2H2v8.999a5 5 0 0 1 8 0zM0 20V0h3.17a3.001 3.001 0 0 0 5.66 0H12v20H8.83a3.001 3.001 0 0 0-5.66 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -2 24 24"
}

export const jamTicketF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 9v11H8.83a3.001 3.001 0 0 0-5.66 0H0V9h4a1 1 0 1 0 0-2H0V0h3.17a3.001 3.001 0 0 0 5.66 0H12v7H8a1 1 0 1 0 0 2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -2 24 24"
}

export const jamTools: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m2 8.654l2.813 2.822l6.332-6.35l-2.814-2.823l-6.332 6.35zm4.441 8.128l2.11-2.117a.993.993 0 0 1 1.408 0a1 1 0 0 1 0 1.411l-2.11 2.117a1 1 0 0 1 0 1.411L6.44 21.015a.993.993 0 0 1-1.407 0l-1.407-1.41a1 1 0 0 1 0-1.412l1.407-1.411a.993.993 0 0 1 1.407 0zm9.146-6.35l6.331-6.35l-1.407-1.412l-6.331 6.35c-.777-.78-.912-1.907-.302-2.52L19.406.956c.61-.612 1.735-.477 2.512.303l1.407 1.41c.778.78.913 1.909.302 2.52l-5.528 5.545c-.61.612-1.735.477-2.512-.303zm-.924 3.866L9.738 9.36l-.704.706l4.925 4.939zm1.407 1.412l-.704.705l1.759 1.764c.194.195.51.195.703 0a.5.5 0 0 0 0-.705zM2.06 5.77a1.5 1.5 0 0 1 .291-1.704l1.407-1.41a1.49 1.49 0 0 1 1.699-.293L6.924.892a1.986 1.986 0 0 1 2.814 0l2.814 2.823a2 2 0 0 1 0 2.822l-1.407 1.411l8.09 8.114a2.5 2.5 0 0 1 0 3.528a2.48 2.48 0 0 1-3.517 0l-8.09-8.114l-1.408 1.411c-.777.78-2.037.78-2.814 0L.592 10.065a2 2 0 0 1 0-2.823l1.467-1.47z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 -1 24 24"
}

export const jamToolsF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2.131 5.668a1.5 1.5 0 0 1 .294-1.708l1.414-1.414a1.5 1.5 0 0 1 1.707-.293L7.021.778a2 2 0 0 1 2.828 0l2.829 2.829a2 2 0 0 1 0 2.828l-1.415 1.414l-.05-.05l-3.535 3.536l.05.05l-1.414 1.414a2 2 0 0 1-2.829 0L.657 9.971a2 2 0 0 1 0-2.829zm6.96 7.08l3.536-3.535l3.586 3.586l-3.535 3.536l-3.586-3.586zm5 5l3.536-3.535l1.768 1.768a2.5 2.5 0 0 1-3.535 3.536l-1.768-1.768zm2.83-15.556l4.242 4.243l-3.839 3.839c-.613.613-1.744.478-2.525-.303l-1.414-1.415c-.781-.78-.917-1.911-.303-2.525zM18.334.778l.303-.303c.613-.614 1.744-.478 2.525.303l1.414 1.414c.781.781.917 1.912.303 2.526l-.303.303L18.335.778zM5.607 16.335l2.12-2.122a1 1 0 1 1 1.415 1.414L7.021 17.75a1 1 0 0 1 0 1.414l-1.414 1.414a1 1 0 0 1-1.415 0l-1.414-1.414a1 1 0 0 1 0-1.414l1.414-1.414a1 1 0 0 1 1.415 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 -1.5 24 24"
}

export const jamTorch: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 10v1l1.25.43l.602 8.433a.148.148 0 0 0 .296 0l.602-8.433L6 11v-1zM.535 8A4 4 0 0 1 0 6q0-2.21 4-6q4 3.79 4 6c0 .729-.195 1.412-.535 2H8v3a2 2 0 0 1-1.35 1.892l-.508 7.113a2.148 2.148 0 0 1-4.284 0l-.509-7.113A2 2 0 0 1 0 11V8zm2.13-3.495C2.196 5.205 2 5.719 2 6a2 2 0 1 0 4 0c0-.281-.197-.795-.664-1.495Q4.836 3.754 4 2.842a14 14 0 0 0-1.336 1.663z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-8 -1 24 24"
}

export const jamTorchF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 10h8v1a2 2 0 0 1-1.35 1.892l-.508 7.113a2.148 2.148 0 0 1-4.284 0l-.509-7.113A2 2 0 0 1 0 11zm7.465-2H8H0h.535A4 4 0 0 1 0 6q0-2.21 4-6q4 3.79 4 6c0 .729-.195 1.412-.535 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-8 -1 24 24"
}

export const jamTotem: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 18h4V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1zm6 .268A2 2 0 0 1 15 20H5a2 2 0 0 1 1-1.732V3a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3zM9 9h2v2H9zm1-4a1 1 0 1 1 0-2a1 1 0 0 1 0 2M1.286 6h17.433a1 1 0 0 1 .97 1.243l-1.31 5.242A2 2 0 0 1 16.439 14H3.588a2 2 0 0 1-1.939-1.507L.317 7.246A1 1 0 0 1 1.286 6m1.286 2l1.017 4h12.85l1-4H2.571z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamTrain: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 15h8a2 2 0 0 0 2-2v-2H2v2a2 2 0 0 0 2 2m8.813 1.917A2 2 0 0 1 11.131 20H4.87a2 2 0 0 1-1.682-3.083A4 4 0 0 1 0 13V4a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v9a4 4 0 0 1-3.187 3.917M14 9V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v5zm-2-6a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V4a1 1 0 0 1 1-1M4 14a1 1 0 1 1 0-2a1 1 0 0 1 0 2m8 0a1 1 0 1 1 0-2a1 1 0 0 1 0 2m-7.131 4h6.262l-.666-1h-4.93z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamTrainF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 2a2 2 0 0 0-2 2v5.038l12-.023V4a2 2 0 0 0-2-2zm7.667 15L11 16H5l-.667 1H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v9a4 4 0 0 1-4 4zM4 14a1 1 0 1 0 0-2a1 1 0 0 0 0 2m8 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0-11a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V4a1 1 0 0 1 1-1M4.314 17.029l7.371-.001l.279.417A1 1 0 0 1 11.13 19H4.87a1 1 0 0 1-.833-1.555z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2.5 24 24"
}

export const jamTransgender: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 14A5 5 0 1 0 7 4a5 5 0 0 0 0 10m6.013-8.586A7.002 7.002 0 0 1 7.998 15.93L8 16v1h1a1 1 0 0 1 0 2H8v1a1 1 0 0 1-2 0v-1H5a1 1 0 0 1 0-2h1v-1q0-.036.002-.07A7.002 7.002 0 0 1 7 2a6.98 6.98 0 0 1 4.745 1.853l1.85-1.85H12.01a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0V3.417z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -1.5 24 24"
}

export const jamTrash: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 2V1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-.133l-.68 10.2a3 3 0 0 1-2.993 2.8H5.826a3 3 0 0 1-2.993-2.796L2.137 7H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm10 2H2v1h14zM4.141 7l.687 10.068a1 1 0 0 0 .998.932h6.368a1 1 0 0 0 .998-.934L13.862 7zM7 8a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1m4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2 24 24"
}

export const jamTrashAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1zM12.83 5H3.17l.722 13h8.216zM2 2v1h12V2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1m4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamTrashAltF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m14.778 6l-.673 12.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.222 6zM1 0h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1m5 8a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m4 0a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -2 24 24"
}

export const jamTrashF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 2h5a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h5V1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1zm3.8 6l-.613 9.2a3 3 0 0 1-2.993 2.8H5.826a3 3 0 0 1-2.993-2.796L2.205 8zM7 9a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0v-7a1 1 0 0 0-1-1m4 0a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0v-7a1 1 0 0 0-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2 24 24"
}

export const jamTree: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m10.728 5.547l-.632-.446l-.167-.755a3.002 3.002 0 0 0-5.858 0l-.167.755l-.632.446A3 3 0 1 0 6.2 10.75l.801-.35l.8.35a3 3 0 0 0 2.927-5.204zM8 12.9V19a1 1 0 0 1-2 0v-6.1a5 5 0 0 1-3.882-8.987a5.002 5.002 0 0 1 9.764 0A5 5 0 0 1 8 12.9\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamTreeAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.348 12h7.304l-2.57-4.774L9.54 7.12L7 2.887L4.461 7.12l1.46.104zm7.958-3.003l1.9 3.529a1 1 0 0 1-.88 1.474H8v5a1 1 0 0 1-2 0v-5H1.674a1 1 0 0 1-.88-1.474l1.9-3.529l-.72-.387a1 1 0 0 1-.065-1.124L6.143.429a1 1 0 0 1 1.714 0l4.234 7.057a1 1 0 0 1-.064 1.123z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamTreeAltF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 14.858H1.674a1 1 0 0 1-.88-1.474l1.9-3.529a1 1 0 0 1-.785-1.512l4.234-7.056a1 1 0 0 1 1.714 0l4.234 7.056a1 1 0 0 1-.785 1.512l1.9 3.529a1 1 0 0 1-.88 1.474H8v6H6z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -1.5 24 24"
}

export const jamTreeF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 13.758v6.1a1 1 0 0 1-2 0v-6.1A5 5 0 0 1 2.118 4.77a5.002 5.002 0 0 1 9.764 0A5 5 0 0 1 8 13.758\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -1.5 24 24"
}

export const jamTrello: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17.562 0H2.438A2.435 2.435 0 0 0 0 2.432v15.087a2.435 2.435 0 0 0 2.438 2.432h15.124A2.435 2.435 0 0 0 20 17.519V2.432A2.435 2.435 0 0 0 17.562 0M8.7 15.55a1.13 1.13 0 0 1-1.132 1.13H3.732A1.13 1.13 0 0 1 2.6 15.55V3.893c0-.624.507-1.13 1.132-1.13h3.836A1.13 1.13 0 0 1 8.7 3.893zm8.7-5.015a1.13 1.13 0 0 1-1.132 1.13h-3.836a1.13 1.13 0 0 1-1.132-1.13V3.893c0-.624.507-1.13 1.132-1.13h3.836a1.13 1.13 0 0 1 1.132 1.13z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamTriangle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.528 2.358a1 1 0 0 0-1.377.32l-6.095 9.794A1 1 0 0 0 3.905 14h12.19a1 1 0 0 0 .85-1.528l-6.096-9.794a1 1 0 0 0-.32-.32zm2.019-.737l6.095 9.794A3 3 0 0 1 16.095 16H3.905a3 3 0 0 1-2.547-4.585L7.453 1.62a3 3 0 0 1 5.094 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamTriangleDanger: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m12.8 1.613l6.701 11.161c.963 1.603.49 3.712-1.057 4.71a3.2 3.2 0 0 1-1.743.516H3.298C1.477 18 0 16.47 0 14.581c0-.639.173-1.264.498-1.807L7.2 1.613C8.162.01 10.196-.481 11.743.517c.428.276.79.651 1.057 1.096m-2.22.839a1.077 1.077 0 0 0-1.514.365L2.365 13.98a1.17 1.17 0 0 0-.166.602c0 .63.492 1.14 1.1 1.14H16.7c.206 0 .407-.06.581-.172a1.164 1.164 0 0 0 .353-1.57L10.933 2.817a1.1 1.1 0 0 0-.352-.365zM10 14a1 1 0 1 1 0-2a1 1 0 0 1 0 2m0-9a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0V6a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3 24 24"
}

export const jamTriangleDangerF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m12.8 1.613l6.701 11.161c.963 1.603.49 3.712-1.057 4.71a3.2 3.2 0 0 1-1.743.516H3.298C1.477 18 0 16.47 0 14.581c0-.639.173-1.264.498-1.807L7.2 1.613C8.162.01 10.196-.481 11.743.517c.428.276.79.651 1.057 1.096M10 14a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0-9a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3 24 24"
}

export const jamTriangleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m12.547 1.621l6.095 9.794A3 3 0 0 1 16.095 16H3.905a3 3 0 0 1-2.547-4.585L7.453 1.62a3 3 0 0 1 5.094 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamTrophy: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 18h6v-1H2zm.294-3Q1.394 12.263 1 9Q.457 4.5 1 0h8q.466 4.993 0 9a32.7 32.7 0 0 1-1.287 6H8a2 2 0 0 1 2 2v3H0v-3a2 2 0 0 1 2-2zm.692-6.24q.417 3.455 1.423 6.24H5.61a31 31 0 0 0 1.402-6.231Q7.369 5.713 7.147 2h-4.33a35.5 35.5 0 0 0 .168 6.76z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7 -2 24 24"
}

export const jamTrophyF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2.294 15Q1.394 12.263 1 9Q.457 4.5 1 0h8q.466 4.993 0 9a32.7 32.7 0 0 1-1.287 6H8a2 2 0 0 1 2 2v3H0v-3a2 2 0 0 1 2-2zM3 16v2h4v-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7 -2 24 24"
}

export const jamTube: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 7a1 1 0 1 1 0 2v2a1 1 0 0 1 0 2v4a1 1 0 0 0 2 0V2H2zM0 0h6v17a3 3 0 0 1-6 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-9 -2 24 24"
}

export const jamTumblr: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.888 15.905s-.614.683-1.781.683c-1.168 0-1.69-.683-1.69-1.692V9.18h3.775V5.715H7.417V0H4.575C4.13 2.564 2.38 4.7.005 5.748v3.431h2.773v6.584c0 .914.891 4.237 5.438 4.237c2.672 0 3.778-1.662 3.778-1.662z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -2 24 24"
}

export const jamTumblrCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M12.441 12.953s-.307.34-.89.34c-.584 0-.845-.34-.845-.845V9.59h1.887V7.857h-1.887V5H9.285C9.062 6.282 8.187 7.35 7 7.874V9.59h1.386v3.291c0 .457.446 2.119 2.72 2.119c1.335 0 1.888-.83 1.888-.83z\"/><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamTumblrSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M12.441 12.953s-.307.34-.89.34c-.584 0-.845-.34-.845-.845V9.59h1.887V7.857h-1.887V5H9.285C9.062 6.282 8.187 7.35 7 7.874V9.59h1.386v3.291c0 .457.446 2.119 2.72 2.119c1.335 0 1.888-.83 1.888-.83z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamTwitch: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M1.25 0L0 3.75V17.5h5V20h2.5l2.5-2.5h3.75l5-5.325V0zM17.5 11.25L14 15H9.568l-2.693 1.959V15H2.5V1.25h15z\"/><path d=\"M8.75 5H10v5H8.75zm3.75 0h1.25v5H12.5z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2.5 -2 24 24"
}

export const jamTwitter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M20 1.907a8.3 8.3 0 0 1-2.356.637A4.07 4.07 0 0 0 19.448.31a8.4 8.4 0 0 1-2.607.98A4.12 4.12 0 0 0 13.846.015c-2.266 0-4.103 1.81-4.103 4.04q0 .476.106.92A11.7 11.7 0 0 1 1.393.754a3.96 3.96 0 0 0-.554 2.03a4.02 4.02 0 0 0 1.824 3.363A4.15 4.15 0 0 1 .805 5.64v.05c0 1.958 1.415 3.591 3.29 3.963a4.2 4.2 0 0 1-1.08.141q-.397 0-.773-.075a4.1 4.1 0 0 0 3.832 2.807a8.3 8.3 0 0 1-5.095 1.727q-.498-.001-.979-.056a11.73 11.73 0 0 0 6.289 1.818c7.547 0 11.673-6.157 11.673-11.496l-.014-.523A8.1 8.1 0 0 0 20 1.907\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -4 24 24"
}

export const jamTwitterCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M15 6.947c-.368.16-.763.27-1.178.318c.424-.25.748-.646.902-1.117a4.2 4.2 0 0 1-1.304.49A2.06 2.06 0 0 0 11.923 6c-1.133 0-2.051.905-2.051 2.02q0 .237.053.46a5.85 5.85 0 0 1-4.228-2.11a2 2 0 0 0-.278 1.015c0 .7.363 1.32.913 1.681a2.1 2.1 0 0 1-.93-.253v.025a2.03 2.03 0 0 0 1.646 1.98a2.1 2.1 0 0 1-.927.034a2.05 2.05 0 0 0 1.916 1.403a4.16 4.16 0 0 1-2.548.864q-.248 0-.489-.028A5.86 5.86 0 0 0 8.144 14c3.774 0 5.837-3.078 5.837-5.748l-.007-.262A4.1 4.1 0 0 0 15 6.947\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamTwitterSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M15 6.947c-.368.16-.763.27-1.178.318c.424-.25.748-.646.902-1.117a4.2 4.2 0 0 1-1.304.49A2.06 2.06 0 0 0 11.923 6c-1.133 0-2.051.905-2.051 2.02q0 .237.053.46a5.85 5.85 0 0 1-4.228-2.11a2 2 0 0 0-.278 1.015c0 .7.363 1.32.913 1.681a2.1 2.1 0 0 1-.93-.253v.025a2.03 2.03 0 0 0 1.646 1.98a2.1 2.1 0 0 1-.927.034a2.05 2.05 0 0 0 1.916 1.403a4.16 4.16 0 0 1-2.548.864q-.248 0-.489-.028A5.86 5.86 0 0 0 8.144 14c3.774 0 5.837-3.078 5.837-5.748l-.007-.262A4.1 4.1 0 0 0 15 6.947\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamUmbrella: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 3a8 8 0 0 0-7.748 6h15.496C16.86 5.55 13.728 3 10 3m-1 8H0c0-5.186 3.947-9.45 9.001-9.95L9 1a1 1 0 1 1 1.999.05C16.053 1.55 20 5.813 20 11h-9v6a1 1 0 0 0 2 0a1 1 0 0 1 2 0a3 3 0 0 1-6 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamUmbrellaClosed: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 13.418L0 15L6.234 1.642a1 1 0 1 1 1.533 0L14 15l-6-1.582V17a1 1 0 0 0 2 0a1 1 0 0 1 2 0a3 3 0 0 1-6 0zM7 4.73l-3.383 7.249L7 11.086l3.383.892L7 4.729z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamUmbrellaClosedF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m6 13.983l-6 1.582L6.234 2.207a1 1 0 1 1 1.533 0L14 15.565l-6-1.582v3.582a1 1 0 0 0 2 0a1 1 0 0 1 2 0a3 3 0 0 1-6 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -1.5 24 24"
}

export const jamUmbrellaF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 11H0c0-5.186 3.947-9.45 9.001-9.95L9 1a1 1 0 1 1 1.999.05C16.053 1.55 20 5.813 20 11h-9v6a1 1 0 0 0 2 0a1 1 0 0 1 2 0a3 3 0 0 1-6 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamUnderline: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1.5 10h7a.5.5 0 1 1 0 1h-7a.5.5 0 1 1 0-1M7 2a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2v3a4 4 0 1 1-8 0V2a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2v3a2 2 0 1 0 4 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-7 -6.5 24 24"
}

export const jamUndo: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m5.308 7.612l1.352-.923a.98.98 0 0 1 1.372.27a1.01 1.01 0 0 1-.266 1.388l-3.277 2.237a.98.98 0 0 1-1.372-.27L.907 6.998a1.007 1.007 0 0 1 .266-1.389a.98.98 0 0 1 1.372.27l.839 1.259C4.6 3.01 8.38 0 12.855 0c5.458 0 9.882 4.477 9.882 10s-4.424 10-9.882 10a.994.994 0 0 1-.988-1c0-.552.443-1 .988-1c4.366 0 7.906-3.582 7.906-8s-3.54-8-7.906-8C9.311 2 6.312 4.36 5.308 7.612\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-0.5 -2 24 24"
}

export const jamUnindent: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 0h12a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2m0 8h12a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2m6-4h6a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m-6.44.143l2.057-1.234a1 1 0 0 1 1.515.857v2.468a1 1 0 0 1-1.515.857L.561 5.857a1 1 0 0 1 0-1.714z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -7 24 24"
}

export const jamUnion: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.858 2.48L10 2.888l-.858-.408a5 5 0 1 0 0 9.04l.858-.408l.858.408a5 5 0 1 0 0-9.04M13 0a7 7 0 1 1-3 13.326A7 7 0 1 1 10 .673A7 7 0 0 1 13 0\"/>",
  "width": 20,
  "height": 14,
  "viewBox": "0 0 20 14"
}

export const jamUniverse: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.694 17.306c-1.91-1.912.258-7.18 4.845-11.767S15.394-1.217 17.306.694c1.91 1.912-.258 7.18-4.845 11.767S2.606 19.217.694 17.306M2.08 15.92c.815.816 5.102-.95 8.997-4.845s5.66-8.182 4.845-8.997c-.815-.816-5.102.95-8.997 4.845s-5.66 8.182-4.845 8.997m3.46-3.46C.952 7.874-1.217 2.606.694.694c1.912-1.91 7.18.258 11.767 4.845s6.756 9.855 4.845 11.767c-1.912 1.91-7.18-.258-11.767-4.845zm1.385-1.385c3.895 3.895 8.182 5.66 8.997 4.845c.816-.815-.95-5.102-4.845-8.997S2.895 1.263 2.08 2.078c-.816.815.95 5.102 4.845 8.997M9 11a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -3 24 24"
}

export const jamUnlink: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6.456 10.218a1.93 1.93 0 0 0-1.902.492L2.5 12.762A1.935 1.935 0 0 0 5.238 15.5l2.052-2.053a1.93 1.93 0 0 0 .492-1.902a.968.968 0 0 1-1.326-1.326Zm4.446-4.446a.968.968 0 0 1 1.326 1.326a1.93 1.93 0 0 0 1.902-.492l1.37-1.368A1.935 1.935 0 1 0 12.762 2.5l-1.368 1.37a1.93 1.93 0 0 0-.492 1.902m5.965-4.639a3.87 3.87 0 0 1 0 5.473l-1.368 1.368A3.87 3.87 0 0 1 10.026 2.5l1.368-1.368a3.87 3.87 0 0 1 5.473 0ZM8.658 9.342a3.87 3.87 0 0 1 0 5.472l-2.052 2.053a3.87 3.87 0 0 1-5.473-5.473l2.053-2.052a3.87 3.87 0 0 1 5.472 0\"/>",
  "width": 18,
  "height": 18,
  "viewBox": "0 0 18 18"
}

export const jamUnorderedList: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h9a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2m0 8h9a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2m0-4h9a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2M1 0a1 1 0 1 1 0 2a1 1 0 0 1 0-2m0 8a1 1 0 1 1 0 2a1 1 0 0 1 0-2m0-4a1 1 0 1 1 0 2a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -7 24 24"
}

export const jamUnsplash: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13 10.35c0 1.736-1.375 3.086-3 3.086s-3-1.35-3-3.086s1.375-3.086 3-3.086c1.688.065 3 1.415 3 3.086m7-4.757v9.578c0 1.479-1.188 2.765-2.688 2.765H2.688C1.188 17.936 0 16.714 0 15.17V5.53c0-1.48 1.188-2.766 2.688-2.766H5l.5-1.478C5.75.579 6.563 0 7.313 0h5.375c.75 0 1.562.579 1.812 1.286l.5 1.543h2.313c1.5 0 2.687 1.221 2.687 2.764m-5.375 4.821c0-2.635-2.063-4.821-4.688-4.821c-2.562 0-4.687 2.186-4.687 4.821c0 2.636 2.063 4.822 4.688 4.822a4.79 4.79 0 0 0 4.687-4.822\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3 24 24"
}

export const jamUnsplashCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M11.596 10.72c0 .867-.687 1.542-1.5 1.542s-1.5-.675-1.5-1.543s.688-1.543 1.5-1.543c.844.032 1.5.707 1.5 1.543zm3.5-2.38v4.79c0 .74-.593 1.382-1.343 1.382H6.44c-.75 0-1.344-.61-1.344-1.382V8.308c0-.739.594-1.382 1.344-1.382h1.156l.25-.739c.125-.354.532-.643.907-.643h2.687c.375 0 .781.29.906.643l.25.771h1.157c.75 0 1.343.611 1.343 1.383zm-2.687 2.411c0-1.318-1.031-2.41-2.344-2.41c-1.281 0-2.344 1.092-2.344 2.41s1.032 2.411 2.344 2.411a2.395 2.395 0 0 0 2.344-2.41z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamUnsplashSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M11.596 10.72c0 .867-.687 1.542-1.5 1.542s-1.5-.675-1.5-1.543s.688-1.543 1.5-1.543c.844.032 1.5.707 1.5 1.543zm3.5-2.38v4.79c0 .74-.593 1.382-1.343 1.382H6.44c-.75 0-1.344-.61-1.344-1.382V8.308c0-.739.594-1.382 1.344-1.382h1.156l.25-.739c.125-.354.532-.643.907-.643h2.687c.375 0 .781.29.906.643l.25.771h1.157c.75 0 1.343.611 1.343 1.383zm-2.687 2.411c0-1.318-1.031-2.41-2.344-2.41c-1.281 0-2.344 1.092-2.344 2.41s1.032 2.411 2.344 2.411a2.395 2.395 0 0 0 2.344-2.41z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamUpload: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 3.414v5.642a1 1 0 1 1-2 0V3.414L4.879 4.536A1 1 0 0 1 3.464 3.12L6.293.293a1 1 0 0 1 1.414 0l2.829 2.828A1 1 0 1 1 9.12 4.536zM1 12h12a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -5 24 24"
}

export const jamUser: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.534 10.07a1 1 0 1 1 .733 1.86A3.58 3.58 0 0 0 2 15.26V17a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1.647a3.66 3.66 0 0 0-2.356-3.419a1 1 0 1 1 .712-1.868A5.66 5.66 0 0 1 14 15.353V17a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-1.74a5.58 5.58 0 0 1 3.534-5.19M7 0a4 4 0 0 1 4 4v2a4 4 0 1 1-8 0V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v2a2 2 0 1 0 4 0V4a2 2 0 0 0-2-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamUserCircle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0-14a4 4 0 0 1 4 4v2a4 4 0 1 1-8 0V8a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v2a2 2 0 1 0 4 0V8a2 2 0 0 0-2-2M5.91 16.876a8 8 0 0 1-1.58-1.232a5.6 5.6 0 0 1 2.204-1.574a1 1 0 1 1 .733 1.86c-.532.21-.993.538-1.358.946zm8.144.022a3.65 3.65 0 0 0-1.41-.964a1 1 0 1 1 .712-1.868a5.65 5.65 0 0 1 2.284 1.607a8 8 0 0 1-1.586 1.225\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamUserMinus: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.534 10.07a1 1 0 1 1 .733 1.86A3.58 3.58 0 0 0 2 15.26V17a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1.647a3.66 3.66 0 0 0-2.356-3.419a1 1 0 1 1 .712-1.868A5.66 5.66 0 0 1 14 15.353V17a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-1.74a5.58 5.58 0 0 1 3.534-5.19M7 0a4 4 0 0 1 4 4v2a4 4 0 1 1-8 0V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v2a2 2 0 1 0 4 0V4a2 2 0 0 0-2-2m6 3h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamUserPlus: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.534 10.07a1 1 0 1 1 .733 1.86A3.58 3.58 0 0 0 2 15.26V17a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1.647a3.66 3.66 0 0 0-2.356-3.419a1 1 0 1 1 .712-1.868A5.66 5.66 0 0 1 14 15.353V17a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-1.74a5.58 5.58 0 0 1 3.534-5.19M7 0a4 4 0 0 1 4 4v2a4 4 0 1 1-8 0V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v2a2 2 0 1 0 4 0V4a2 2 0 0 0-2-2m10 3h2a1 1 0 0 1 0 2h-2v2a1 1 0 0 1-2 0V7h-2a1 1 0 0 1 0-2h2V3a1 1 0 0 1 2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamUserRemove: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.534 10.07a1 1 0 1 1 .733 1.86A3.58 3.58 0 0 0 2 15.26V17a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1.647a3.66 3.66 0 0 0-2.356-3.419a1 1 0 1 1 .712-1.868A5.66 5.66 0 0 1 14 15.353V17a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-1.74a5.58 5.58 0 0 1 3.534-5.19M7 0a4 4 0 0 1 4 4v2a4 4 0 1 1-8 0V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v2a2 2 0 1 0 4 0V4a2 2 0 0 0-2-2m10.414 4l1.414 1.414a1 1 0 0 1-1.414 1.414L16 7.414l-1.414 1.414a1 1 0 1 1-1.414-1.414L14.586 6l-1.414-1.414a1 1 0 0 1 1.414-1.414L16 4.586l1.414-1.414a1 1 0 1 1 1.414 1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamUserSquare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm1.229 16H4a2 2 0 0 1-.813-.172a5.58 5.58 0 0 1 3.347-3.758a1 1 0 1 1 .733 1.86A3.58 3.58 0 0 0 5.229 18m9.512 0a3.66 3.66 0 0 0-2.097-2.066a1 1 0 1 1 .712-1.868a5.66 5.66 0 0 1 3.437 3.77A2 2 0 0 1 16 18zM10 4a4 4 0 0 1 4 4v2a4 4 0 1 1-8 0V8a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v2a2 2 0 1 0 4 0V8a2 2 0 0 0-2-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamUsers: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.534 11.07a1 1 0 1 1 .733 1.86A3.58 3.58 0 0 0 2 16.26V18a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1.647a3.66 3.66 0 0 0-2.356-3.419a1 1 0 1 1 .712-1.868A5.66 5.66 0 0 1 14 16.353V18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-1.74a5.58 5.58 0 0 1 3.534-5.19M7 1a4 4 0 0 1 4 4v2a4 4 0 1 1-8 0V5a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v2a2 2 0 1 0 4 0V5a2 2 0 0 0-2-2m9 17a1 1 0 0 1 0-2h1a1 1 0 0 0 1-1v-1.838a3.39 3.39 0 0 0-2.316-3.213a1 1 0 1 1 .632-1.898A5.39 5.39 0 0 1 20 15.162V17a3 3 0 0 1-3 3zM13 2a1 1 0 0 1 0-2a4 4 0 0 1 4 4v2a4 4 0 0 1-4 4a1 1 0 0 1 0-2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1.5 24 24"
}

export const jamViadeo: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M13.71 10.006q-.02-.048-.046-.096c-.183.095-.355.191-.533.273q-.263.12-.534.215c-.185.064-.374.114-.56.168q0 .024.003.038q.011.036.026.073a5.7 5.7 0 0 1 .382 2.04a5.6 5.6 0 0 1-.24 1.722c-.258.843-.675 1.598-1.29 2.233c-.897.927-2 1.426-3.281 1.542c-.118.011-.238.01-.366.014c.005-.029.004-.035.007-.037l.2-.15a10.6 10.6 0 0 0 3.138-3.777a9.34 9.34 0 0 0 .966-3.98c.015-.683-.045-1.36-.163-2.032a12.6 12.6 0 0 0-.615-2.234a1 1 0 0 0-.052-.11l-.026-.179c0-.02 0-.058-.002-.066A11 11 0 0 0 10.37 3.8a8.6 8.6 0 0 0-1.038-2.34A6.1 6.1 0 0 0 8.183.113C8.14.077 8.095.043 8.042 0c-.002.028-.008.045-.003.056q.049.089.101.176a34 34 0 0 1 2.072 4.216c.163.4.311.804.466 1.206l.046.084l.025.178c.008.212.02.43.024.618a27 27 0 0 1-.12 3.3a23 23 0 0 1-.202 1.513a16 16 0 0 1-.425 1.867a11 11 0 0 1-.874 2.179a6.8 6.8 0 0 1-1.24 1.67c-.463.45-.99.804-1.588 1.052a.32.32 0 0 1-.195.02a5.1 5.1 0 0 1-2.202-1.007a5.15 5.15 0 0 1-1.344-1.62a5.6 5.6 0 0 1-.658-2.145a6 6 0 0 1 .02-1.338a5.4 5.4 0 0 1 .426-1.572a5.7 5.7 0 0 1 1.427-1.927a5 5 0 0 1 1.582-.975a5 5 0 0 1 1.178-.283a5.5 5.5 0 0 1 1.074-.015q.687.052 1.332.301c.037.015.076.024.131.04c.038-.298.097-.582.185-.858a7 7 0 0 1 .33-.805c-.067-.053-.14-.065-.208-.087a7 7 0 0 0-1.788-.323a7.7 7.7 0 0 0-1.938.134a6.3 6.3 0 0 0-2.145.85a7.2 7.2 0 0 0-1.657 1.454C.806 9.213.236 10.666.148 12.309a8 8 0 0 0 .051 1.416c.084.664.252 1.304.518 1.918a7.55 7.55 0 0 0 1.85 2.575q.883.81 2.003 1.238a7 7 0 0 0 2.158.44a8 8 0 0 0 2.046-.147a6.3 6.3 0 0 0 2.498-1.112a7.3 7.3 0 0 0 1.516-1.537a7.07 7.07 0 0 0 1.41-3.899a8 8 0 0 0-.091-1.755a7 7 0 0 0-.396-1.44z\"/><path d=\"M17.07 2.23a6.6 6.6 0 0 0-.653-1.595c-.041-.072-.087-.14-.14-.225l-.104.188c-.2.38-.45.722-.76 1.021c-.468.452-1.008.78-1.645.936q-.082.02-.166.045a6 6 0 0 0-1.348.559a2.5 2.5 0 0 0-.747.65a2.5 2.5 0 0 0-.541 1.684c.022.512.169.99.416 1.439c.012.021.03.04.055.074c2.014-.494 3.528-1.647 4.574-3.47c-.004.062-.002.092-.009.12q-.053.236-.161.453a4 4 0 0 1-.604.867c-.41.46-.875.859-1.363 1.23c-.592.452-1.212.86-1.855 1.233c-.047.027-.103.045-.139.105q.129.118.257.23c.33.275.689.5 1.1.635c.387.127.78.162 1.183.092a2.63 2.63 0 0 0 1.287-.624c.362-.312.647-.688.887-1.098c.14-.238.269-.481.358-.743a6.6 6.6 0 0 0 .118-3.807z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-3 -2 24 24"
}

export const jamViber: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M17.29 8.607c.024-2.892-2.439-5.543-5.49-5.91a4 4 0 0 1-.197-.03a3 3 0 0 0-.465-.05c-.626 0-.793.44-.837.701q-.064.384.121.637c.207.281.572.331.865.371c.085.012.166.023.234.038c2.742.613 3.665 1.576 4.116 4.295c.011.066.016.148.022.235c.02.325.06 1.001.787 1.001q.091 0 .194-.015c.676-.103.655-.721.645-1.018c-.003-.084-.006-.163.002-.216l.002-.04z\"/><path d=\"M10.96 1.636q.124.008.222.021c4.503.693 6.574 2.826 7.147 7.364c.01.077.012.171.013.27c.006.355.018 1.093.81 1.108h.024q.374 0 .588-.223c.246-.257.23-.64.215-.948q-.005-.115-.006-.21c.058-4.64-3.96-8.849-8.596-9.005q-.03 0-.056.003l-.055.003q-.072-.001-.164-.008C11.03.006 10.947 0 10.862 0c-.738 0-.878.525-.896.838c-.041.723.658.774.994.798m7.152 13.25a14 14 0 0 1-.287-.224c-.492-.396-1.015-.76-1.52-1.113l-.315-.22c-.648-.455-1.23-.676-1.78-.676c-.742 0-1.388.41-1.922 1.217c-.236.358-.523.532-.876.532a1.7 1.7 0 0 1-.706-.177c-2.09-.948-3.584-2.402-4.438-4.321c-.413-.928-.279-1.534.447-2.028c.413-.28 1.18-.801 1.127-1.8c-.062-1.133-2.563-4.544-3.617-4.931a2.05 2.05 0 0 0-1.396-.004C1.618 1.548.75 2.264.315 3.209c-.42.914-.4 1.987.054 3.103c1.315 3.227 3.163 6.041 5.494 8.363c2.281 2.273 5.085 4.134 8.333 5.533c.293.126.6.195.825.245c.076.017.142.032.19.045a.3.3 0 0 0 .081.011h.026c1.528 0 3.363-1.396 3.926-2.987c.494-1.394-.408-2.083-1.132-2.636m-6.476-9.563c-.261.006-.806.02-.997.574q-.135.39.032.669c.162.27.473.354.755.4c1.025.164 1.552.73 1.657 1.783c.049.49.38.833.803.833a1 1 0 0 0 .096-.006c.51-.06.757-.435.735-1.114c.008-.708-.362-1.512-.993-2.152c-.632-.642-1.394-1.004-2.088-.987\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -1.5 24 24"
}

export const jamViberCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M13.644 9.404c.012-1.492-1.219-2.86-2.744-3.049l-.1-.015a1.4 1.4 0 0 0-.232-.026c-.313 0-.396.226-.418.361a.43.43 0 0 0 .06.329c.104.145.286.17.432.192q.066.008.117.02c1.371.315 1.833.812 2.058 2.215q.008.053.01.122c.01.167.031.516.395.516q.045 0 .096-.008c.339-.053.328-.372.323-.525a1 1 0 0 1 0-.111l.002-.02z\"/><path d=\"M10.48 5.807c.04.003.08.006.111.011c2.25.358 3.286 1.458 3.573 3.8q.006.061.006.14c.003.183.009.563.405.571h.012a.38.38 0 0 0 .294-.115c.123-.133.115-.33.108-.49q-.004-.058-.003-.107c.028-2.395-1.98-4.567-4.298-4.647l-.028.001l-.027.002q-.036 0-.082-.004l-.12-.006c-.369 0-.439.27-.448.432c-.02.373.329.4.497.412m3.575 6.837l-.143-.115c-.246-.204-.508-.392-.76-.574l-.158-.114c-.324-.234-.615-.349-.89-.349c-.37 0-.693.212-.96.629q-.175.275-.438.274a.85.85 0 0 1-.353-.091c-1.045-.49-1.792-1.24-2.219-2.23c-.206-.48-.14-.792.224-1.047c.206-.144.59-.413.563-.928c-.03-.585-1.281-2.345-1.808-2.545a1 1 0 0 0-.698-.002c-.605.21-1.04.58-1.257 1.067c-.21.472-.2 1.025.028 1.601c.657 1.666 1.58 3.118 2.746 4.316c1.14 1.173 2.542 2.133 4.166 2.855c.146.065.3.1.412.126l.095.024a.2.2 0 0 0 .04.006h.013c.764 0 1.681-.72 1.963-1.542c.247-.72-.204-1.075-.566-1.36zM10.818 7.71c-.13.003-.403.01-.499.296q-.066.202.016.345c.081.14.237.183.378.206c.512.085.776.378.828.92c.025.254.19.43.402.43l.048-.002q.383-.049.367-.575c.004-.366-.181-.78-.496-1.11c-.316-.332-.697-.519-1.044-.51\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamViberSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M13.644 9.404c.012-1.492-1.219-2.86-2.744-3.049l-.1-.015a1.4 1.4 0 0 0-.232-.026c-.313 0-.396.226-.418.361a.43.43 0 0 0 .06.329c.104.145.286.17.432.192q.066.008.117.02c1.371.315 1.833.812 2.058 2.215q.008.053.01.122c.01.167.031.516.395.516q.045 0 .096-.008c.339-.053.328-.372.323-.525a1 1 0 0 1 0-.111l.002-.02z\"/><path d=\"M10.48 5.807c.04.003.08.006.111.011c2.25.358 3.286 1.458 3.573 3.8q.006.061.006.14c.003.183.009.563.405.571h.012a.38.38 0 0 0 .294-.115c.123-.133.115-.33.108-.49q-.004-.058-.003-.107c.028-2.395-1.98-4.567-4.298-4.647l-.028.001l-.027.002q-.036 0-.082-.004l-.12-.006c-.369 0-.439.27-.448.432c-.02.373.329.4.497.412m3.575 6.837l-.143-.115c-.246-.204-.508-.392-.76-.574l-.158-.114c-.324-.234-.615-.349-.89-.349c-.37 0-.693.212-.96.629q-.175.275-.438.274a.85.85 0 0 1-.353-.091c-1.045-.49-1.792-1.24-2.219-2.23c-.206-.48-.14-.792.224-1.047c.206-.144.59-.413.563-.928c-.03-.585-1.281-2.345-1.808-2.545a1 1 0 0 0-.698-.002c-.605.21-1.04.58-1.257 1.067c-.21.472-.2 1.025.028 1.601c.657 1.666 1.58 3.118 2.746 4.316c1.14 1.173 2.542 2.133 4.166 2.855c.146.065.3.1.412.126l.095.024a.2.2 0 0 0 .04.006h.013c.764 0 1.681-.72 1.963-1.542c.247-.72-.204-1.075-.566-1.36zM10.818 7.71c-.13.003-.403.01-.499.296q-.066.202.016.345c.081.14.237.183.378.206c.512.085.776.378.828.92c.025.254.19.43.402.43l.048-.002q.383-.049.367-.575c.004-.366-.181-.78-.496-1.11c-.316-.332-.697-.519-1.044-.51\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamVideoCamera: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm9.98 1.605L16 1.585A2 2 0 0 1 17.414 1H18a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-.586A2 2 0 0 1 16 10.414l-2.02-2.019A4 4 0 0 1 10 12H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h6a4 4 0 0 1 3.98 3.605M17.415 9H18V3h-.586l-3 3zM5 8a1 1 0 1 1 0-2a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6 24 24"
}

export const jamVideoCameraF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.98 3.605L16 1.585A2 2 0 0 1 17.414 1H18a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-.586A2 2 0 0 1 16 10.414l-2.02-2.019A4 4 0 0 1 10 12H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h6a4 4 0 0 1 3.98 3.605M5 8a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6 24 24"
}

export const jamVideoCameraVintage: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 11a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zm9.698.473l1.888-1.887A2 2 0 0 1 17 9h.586a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H17a2 2 0 0 1-1.414-.586l-1.888-1.887A4 4 0 0 1 10 19H4a4 4 0 0 1-4-4v-2a4 4 0 0 1 4-4h6a4 4 0 0 1 3.698 2.473M17 17h.586v-6H17l-3 3zM9.259 2.379a4.5 4.5 0 1 1-.386 5.785a5 5 0 1 1 .386-5.785M5 16a1 1 0 1 1 0-2a1 1 0 0 1 0 2m0-8a3 3 0 1 0 0-6a3 3 0 0 0 0 6m7.5 0a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2.5 24 24"
}

export const jamVideoCameraVintageF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.671 9c-.3-.243-.57-.525-.799-.837A5 5 0 0 1 8 9zm2.972.998c.456.401.82.905 1.055 1.475l1.888-1.887A2 2 0 0 1 17 9h.586a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H17a2 2 0 0 1-1.414-.586l-1.888-1.887A4 4 0 0 1 10 19H4a4 4 0 0 1-4-4v-2a4 4 0 0 1 2.46-3.693a5 5 0 1 1 6.799-6.929a4.5 4.5 0 1 1 3.385 7.62zM5 16a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0-8a3 3 0 1 0 0-6a3 3 0 0 0 0 6m7.5 0a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2.5 24 24"
}

export const jamVimeo: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19.129.849C18.646.323 17.946.042 17.05.016c-2.53-.083-4.319 1.277-5.317 4.04a.41.41 0 0 0 .083.42a.4.4 0 0 0 .405.118q.433-.12.847-.12c.369 0 .86.068 1.103.394c.188.25.213.626.076 1.116c-.115.413-.711 1.52-1.449 2.69c-.898 1.427-1.394 2.067-1.537 2.067c-.474 0-2.187-7.673-2.234-7.842C8.535 1.141 8.289.26 6.69.26C5.474.258 2.758 2.504.528 4.461l-.342.299a.54.54 0 0 0-.074.736l.415.54a.526.526 0 0 0 .727.109l.023-.017C2 5.611 2.68 5.121 3.195 5.094c.559-.027 1.044.855 1.622 2.955c1.102 4.078 2.775 8.94 4.493 8.94c1.794 0 3.935-1.538 6.703-5.176c2.505-3.294 3.846-5.905 3.933-7.806c.064-1.435-.21-2.498-.817-3.158\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3.5 24 24"
}

export const jamVimeoCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M14.586 6.216c-.242-.264-.593-.404-1.042-.417c-1.267-.042-2.164.64-2.664 2.024a.21.21 0 0 0 .042.21a.2.2 0 0 0 .203.06q.216-.06.424-.06c.185 0 .43.034.553.197q.141.19.038.56c-.058.207-.357.761-.726 1.348c-.45.715-.7 1.035-.77 1.035c-.238 0-1.097-3.845-1.12-3.93c-.247-.88-.37-1.323-1.17-1.323c-.611 0-1.972 1.126-3.09 2.107l-.17.15a.27.27 0 0 0-.038.368l.208.271a.264.264 0 0 0 .365.055l.011-.009c.362-.26.703-.505.961-.518c.28-.014.523.428.813 1.48c.552 2.044 1.39 4.48 2.251 4.48c.9 0 1.973-.77 3.36-2.594c1.255-1.65 1.927-2.959 1.97-3.911c.033-.72-.105-1.252-.409-1.583\"/><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamVimeoSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M14.586 6.216c-.242-.264-.593-.404-1.042-.417c-1.267-.042-2.164.64-2.664 2.024a.21.21 0 0 0 .042.21a.2.2 0 0 0 .203.06q.216-.06.424-.06c.185 0 .43.034.553.197q.141.19.038.56c-.058.207-.357.761-.726 1.348c-.45.715-.7 1.035-.77 1.035c-.238 0-1.097-3.845-1.12-3.93c-.247-.88-.37-1.323-1.17-1.323c-.611 0-1.972 1.126-3.09 2.107l-.17.15a.27.27 0 0 0-.038.368l.208.271a.264.264 0 0 0 .365.055l.011-.009c.362-.26.703-.505.961-.518c.28-.014.523.428.813 1.48c.552 2.044 1.39 4.48 2.251 4.48c.9 0 1.973-.77 3.36-2.594c1.255-1.65 1.927-2.959 1.97-3.911c.033-.72-.105-1.252-.409-1.583\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamVine: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18.74 9.818a.56.56 0 0 0-.611-.484a6 6 0 0 1-.676.043c-1.454 0-3.53-.112-4.813-.988a4 4 0 0 1-.318-.25c-.963-.847-1.172-1.89-1.178-2.617c-.008-.96.215-1.67.661-2.105a1.65 1.65 0 0 1 1.079-.469c.053.003.536.044.89.575c.273.409.608 1.34.186 3.245a.42.42 0 0 0 .256.483c.666.252 1.504.355 2.153.395c.2.012.38-.126.422-.326q.293-1.381.242-2.545c-.05-1.136-.346-2.117-.879-2.914C15.424.765 14.258.07 13.038.005c-.876-.048-2.184.263-3.225 1.28c-.718.702-1.57 2.011-1.551 4.261c.015 1.89.79 3.604 2.18 4.827c.425.374.97.757 1.66 1.085a23.8 23.8 0 0 1-3.888 5.184c-2.19-1.778-3.485-5.106-4.206-7.73a37 37 0 0 1-1.091-5.92a.5.5 0 0 0-.53-.457l-.951.066l1.438-.098l-2.37.162a.506.506 0 0 0-.462.557a40 40 0 0 0 1.176 6.433c.594 2.178 1.346 4.078 2.234 5.649c1.168 2.063 2.584 3.575 4.21 4.495a1.41 1.41 0 0 0 1.613-.151c.052-.044 1.285-1.089 2.767-2.926a27 27 0 0 0 2.316-3.36q.316-.543.598-1.094c1.013.13 2.188.145 3.548-.013a.565.565 0 0 0 .486-.645z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2.5 -2 24 24"
}

export const jamVineCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M14.613 9.925a.28.28 0 0 0-.306-.242a3 3 0 0 1-.338.021c-.728 0-1.767-.056-2.409-.494a1.72 1.72 0 0 1-.749-1.435c-.003-.48.108-.835.332-1.054a.82.82 0 0 1 .54-.234a.6.6 0 0 1 .445.288c.136.204.304.67.093 1.624a.21.21 0 0 0 .128.241c.333.126.753.178 1.078.198c.1.006.19-.063.21-.163q.147-.691.122-1.274c-.026-.568-.174-1.06-.44-1.458c-.366-.548-.949-.895-1.56-.929c-.438-.024-1.092.132-1.613.641c-.36.351-.786 1.006-.777 2.132a3.2 3.2 0 0 0 1.091 2.416c.213.187.486.378.831.543a12 12 0 0 1-1.946 2.594c-1.095-.89-1.744-2.556-2.104-3.869a19 19 0 0 1-.546-2.962a.25.25 0 0 0-.265-.229l-.476.033l.72-.049l-1.187.081a.253.253 0 0 0-.231.28c.05.531.203 1.803.589 3.218c.297 1.09.673 2.041 1.118 2.827c.584 1.032 1.292 1.79 2.106 2.25a.71.71 0 0 0 .807-.076c.026-.022.644-.545 1.385-1.464a13.4 13.4 0 0 0 1.459-2.23a7.3 7.3 0 0 0 1.775-.006a.283.283 0 0 0 .243-.322z\"/><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamVineSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M14.613 9.925a.28.28 0 0 0-.306-.242a3 3 0 0 1-.338.021c-.728 0-1.767-.056-2.409-.494a1.72 1.72 0 0 1-.749-1.435c-.003-.48.108-.835.332-1.054a.82.82 0 0 1 .54-.234a.6.6 0 0 1 .445.288c.136.204.304.67.093 1.624a.21.21 0 0 0 .128.241c.333.126.753.178 1.078.198c.1.006.19-.063.21-.163q.147-.691.122-1.274c-.026-.568-.174-1.06-.44-1.458c-.366-.548-.949-.895-1.56-.929c-.438-.024-1.092.132-1.613.641c-.36.351-.786 1.006-.777 2.132a3.2 3.2 0 0 0 1.091 2.416c.213.187.486.378.831.543a12 12 0 0 1-1.946 2.594c-1.095-.89-1.744-2.556-2.104-3.869a19 19 0 0 1-.546-2.962a.25.25 0 0 0-.265-.229l-.476.033l.72-.049l-1.187.081a.253.253 0 0 0-.231.28c.05.531.203 1.803.589 3.218c.297 1.09.673 2.041 1.118 2.827c.584 1.032 1.292 1.79 2.106 2.25a.71.71 0 0 0 .807-.076c.026-.022.644-.545 1.385-1.464a13.4 13.4 0 0 0 1.459-2.23a7.3 7.3 0 0 0 1.775-.006a.283.283 0 0 0 .243-.322z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamVoicemail: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.743 9h4.514A5.5 5.5 0 1 1 19 10.978V11H6v-.022A5.5 5.5 0 1 1 9.743 9M5.5 9a3.5 3.5 0 1 0 0-7a3.5 3.5 0 0 0 0 7m13 0a3.5 3.5 0 1 0 0-7a3.5 3.5 0 0 0 0 7\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 -6.5 24 24"
}

export const jamVolume: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 2h-.6a2 2 0 0 0-1.444.617L6.239 6.5H2v5h4.239l3.717 3.883A2 2 0 0 0 11.4 16h.6zM5.385 4.5L8.51 1.234A4 4 0 0 1 11.401 0H13a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-1.6a4 4 0 0 1-2.889-1.234L5.385 13.5H2a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -3 24 24"
}

export const jamVolumeCircle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-2.664-4.759a2 2 0 0 1-2-2v-2.5a2 2 0 0 1 2-2H8.34l1.823-1.709a2 2 0 0 1 1.368-.54h.205a1.6 1.6 0 0 1 1.6 1.6v7.8a1.6 1.6 0 0 1-1.6 1.6h-.205a2 2 0 0 1-1.368-.542L8.34 13.241zm1.795-4.5H7.336v2.5H9.13l2.205 2.067V6.674z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamVolumeCircleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m-2.664-6.759H8.34l1.823 1.71a2 2 0 0 0 1.368.54h.205a1.6 1.6 0 0 0 1.6-1.6v-7.8a1.6 1.6 0 0 0-1.6-1.6h-.205a2 2 0 0 0-1.368.541L8.34 6.742H7.336a2 2 0 0 0-2 2v2.5a2 2 0 0 0 2 2zm1.795-4.5l2.205-2.067v6.634L9.13 11.241H7.336v-2.5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamVolumeDown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 2h-.6a2 2 0 0 0-1.444.617L6.239 6.5H2v5h4.239l3.717 3.883A2 2 0 0 0 11.4 16h.6zM5.385 4.5L8.51 1.234A4 4 0 0 1 11.401 0H13a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-1.6a4 4 0 0 1-2.889-1.234L5.385 13.5H2a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2zM16 7a1 1 0 0 1 0-2a4 4 0 1 1 0 8a1 1 0 0 1 0-2a2 2 0 1 0 0-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -3 24 24"
}

export const jamVolumeDownCircle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-3.962-4.77a2 2 0 0 1-2-2v-2.5a2 2 0 0 1 2-2h1.005l1.823-1.709a2 2 0 0 1 1.367-.54h.205a1.6 1.6 0 0 1 1.6 1.6v7.8a1.6 1.6 0 0 1-1.6 1.6h-.205a2 2 0 0 1-1.367-.542L7.043 13.23zm1.795-4.5H6.038v2.5h1.795l2.205 2.067V6.664zm5.87.26a1 1 0 1 1 0-2a3 3 0 0 1 0 6a1 1 0 1 1 0-2a1 1 0 0 0 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamVolumeDownCircleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m-3.962-6.77h1.005l1.823 1.71a2 2 0 0 0 1.367.54h.205a1.6 1.6 0 0 0 1.6-1.6v-7.8a1.6 1.6 0 0 0-1.6-1.6h-.205a2 2 0 0 0-1.367.541l-1.823 1.71H6.038a2 2 0 0 0-2 2v2.5a2 2 0 0 0 2 2zm7.664-4.24a1 1 0 0 1 0 2a1 1 0 1 0 0 2a3 3 0 0 0 0-6a1 1 0 1 0 0 2m-5.869-.26l2.205-2.066v6.633L7.833 11.23H6.038v-2.5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamVolumeDownSquare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm2.038 11.23a2 2 0 0 1-2-2v-2.5a2 2 0 0 1 2-2h1.005l1.823-1.709a2 2 0 0 1 1.367-.54h.205a1.6 1.6 0 0 1 1.6 1.6v7.8a1.6 1.6 0 0 1-1.6 1.6h-.205a2 2 0 0 1-1.367-.542L7.043 13.23zm1.795-4.5H6.038v2.5h1.795l2.205 2.067V6.664zm5.87.26a1 1 0 1 1 0-2a3 3 0 0 1 0 6a1 1 0 1 1 0-2a1 1 0 0 0 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamVolumeDownSquareF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m2.038 13.23h1.005l1.823 1.71a2 2 0 0 0 1.367.54h.205a1.6 1.6 0 0 0 1.6-1.6v-7.8a1.6 1.6 0 0 0-1.6-1.6h-.205a2 2 0 0 0-1.367.541l-1.823 1.71H6.038a2 2 0 0 0-2 2v2.5a2 2 0 0 0 2 2zm7.664-4.24a1 1 0 0 1 0 2a1 1 0 1 0 0 2a3 3 0 0 0 0-6a1 1 0 1 0 0 2m-5.869-.26l2.205-2.066v6.633L7.833 11.23H6.038v-2.5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamVolumeMute: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 2h-.6a2 2 0 0 0-1.444.617L6.239 6.5H2v5h4.239l3.717 3.883A2 2 0 0 0 11.4 16h.6zM5.385 4.5L8.51 1.234A4 4 0 0 1 11.401 0H13a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-1.6a4 4 0 0 1-2.889-1.234L5.385 13.5H2a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2zM19.415 9l1.413 1.414a1 1 0 1 1-1.414 1.414L18 10.414l-1.414 1.414a1 1 0 1 1-1.414-1.414L16.586 9l-1.414-1.414a1 1 0 0 1 1.414-1.414L18 7.586l1.414-1.414a1 1 0 1 1 1.414 1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1 -3 24 24"
}

export const jamVolumeMuteCircle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m5.658-7.943l.707.707a1 1 0 0 1-1.414 1.414l-.707-.707l-.707.707a1 1 0 0 1-1.414-1.414l.707-.707l-.707-.707a1 1 0 1 1 1.414-1.415l.707.708l.707-.708a1 1 0 0 1 1.414 1.415zm-10.376 3.23a2 2 0 0 1-2-2v-2.5a2 2 0 0 1 2-2h1.005L8.11 5.078a2 2 0 0 1 1.368-.54h.204a1.6 1.6 0 0 1 1.6 1.6v7.8a1.6 1.6 0 0 1-1.6 1.6h-.204a2 2 0 0 1-1.368-.542l-1.823-1.709zm1.796-4.5H5.282v2.5h1.796l2.204 2.067V6.72z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamVolumeMuteCircleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m15.658 10.057l.707-.707a1 1 0 1 0-1.414-1.415l-.707.708l-.707-.708a1 1 0 0 0-1.414 1.415l.707.707l-.707.707a1 1 0 0 0 1.414 1.414l.707-.707l.707.707a1 1 0 0 0 1.414-1.414zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m-4.718-6.713h1.005l1.823 1.71a2 2 0 0 0 1.368.54h.204a1.6 1.6 0 0 0 1.6-1.6v-7.8a1.6 1.6 0 0 0-1.6-1.6h-.204a2 2 0 0 0-1.368.541l-1.823 1.71H5.282a2 2 0 0 0-2 2v2.5a2 2 0 0 0 2 2zm1.796-4.5L9.282 6.72v6.634l-2.204-2.067H5.282v-2.5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamVolumeMuteSquare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm11.658 8.057l.707.707a1 1 0 0 1-1.414 1.414l-.707-.707l-.707.707a1 1 0 0 1-1.414-1.414l.707-.707l-.707-.707a1 1 0 1 1 1.414-1.415l.707.708l.707-.708a1 1 0 0 1 1.414 1.415zm-10.376 3.23a2 2 0 0 1-2-2v-2.5a2 2 0 0 1 2-2h1.005L8.11 5.078a2 2 0 0 1 1.368-.54h.204a1.6 1.6 0 0 1 1.6 1.6v7.8a1.6 1.6 0 0 1-1.6 1.6h-.204a2 2 0 0 1-1.368-.542l-1.823-1.709zm1.796-4.5H5.282v2.5h1.796l2.204 2.067V6.72z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamVolumeMuteSquareF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m15.658 10.057l.707-.707a1 1 0 1 0-1.414-1.415l-.707.708l-.707-.708a1 1 0 0 0-1.414 1.415l.707.707l-.707.707a1 1 0 0 0 1.414 1.414l.707-.707l.707.707a1 1 0 0 0 1.414-1.414zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m1.282 13.287h1.005l1.823 1.71a2 2 0 0 0 1.368.54h.204a1.6 1.6 0 0 0 1.6-1.6v-7.8a1.6 1.6 0 0 0-1.6-1.6h-.204a2 2 0 0 0-1.368.541l-1.823 1.71H5.282a2 2 0 0 0-2 2v2.5a2 2 0 0 0 2 2zm1.796-4.5L9.282 6.72v6.634l-2.204-2.067H5.282v-2.5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamVolumeSquare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm3.336 11.241a2 2 0 0 1-2-2v-2.5a2 2 0 0 1 2-2H8.34l1.823-1.709a2 2 0 0 1 1.368-.54h.205a1.6 1.6 0 0 1 1.6 1.6v7.8a1.6 1.6 0 0 1-1.6 1.6h-.205a2 2 0 0 1-1.368-.542L8.34 13.241zm1.795-4.5H7.336v2.5H9.13l2.205 2.067V6.674z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamVolumeSquareF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m3.336 13.241H8.34l1.823 1.71a2 2 0 0 0 1.368.54h.205a1.6 1.6 0 0 0 1.6-1.6v-7.8a1.6 1.6 0 0 0-1.6-1.6h-.205a2 2 0 0 0-1.368.541L8.34 6.742H7.336a2 2 0 0 0-2 2v2.5a2 2 0 0 0 2 2zm1.795-4.5l2.205-2.067v6.634L9.13 11.241H7.336v-2.5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamVolumeUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 2h-.6a2 2 0 0 0-1.444.617L6.239 6.5H2v5h4.239l3.717 3.883A2 2 0 0 0 11.4 16h.6zM5.385 4.5L8.51 1.234A4 4 0 0 1 11.401 0H13a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-1.6a4 4 0 0 1-2.889-1.234L5.385 13.5H2a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2zM16 7a1 1 0 0 1 0-2a4 4 0 1 1 0 8a1 1 0 0 1 0-2a2 2 0 1 0 0-4m0-4a1 1 0 0 1 0-2a8 8 0 1 1 0 16a1 1 0 0 1 0-2a6 6 0 1 0 0-12\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 -3 24 24"
}

export const jamVolumeUpCircle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-4.88-4.744a2 2 0 0 1-2-2v-2.5a2 2 0 0 1 2-2h1.005l1.824-1.71a2 2 0 0 1 1.367-.54h.205a1.6 1.6 0 0 1 1.6 1.6v7.8a1.6 1.6 0 0 1-1.6 1.6h-.205a2 2 0 0 1-1.367-.541l-1.824-1.71H5.121zm1.796-4.5H5.121v2.5h1.795l2.205 2.067V6.689zm6.081-.731a1 1 0 0 1 0-2a3.97 3.97 0 0 1 3.972 3.971v.04a3.97 3.97 0 0 1-3.972 3.972a1 1 0 1 1 0-2a1.97 1.97 0 0 0 1.972-1.972v-.04a1.97 1.97 0 0 0-1.972-1.971M13 9a1 1 0 1 1 0 2a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamVolumeUpCircleF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m-4.88-6.744h1.005l1.824 1.709a2 2 0 0 0 1.367.54h.205a1.6 1.6 0 0 0 1.6-1.6v-7.8a1.6 1.6 0 0 0-1.6-1.6h-.205a2 2 0 0 0-1.367.542L6.125 6.756H5.121a2 2 0 0 0-2 2v2.5a2 2 0 0 0 2 2zm7.877-5.231a1.97 1.97 0 0 1 1.972 1.971v.04a1.97 1.97 0 0 1-1.972 1.972a1 1 0 0 0 0 2a3.97 3.97 0 0 0 3.972-3.972v-.04a3.97 3.97 0 0 0-3.972-3.971a1 1 0 0 0 0 2M13 9a1 1 0 1 0 0 2a1 1 0 0 0 0-2m-6.084-.244l2.205-2.067v6.634l-2.205-2.067H5.121v-2.5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamVolumeUpSquare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm8.997 6.025a1 1 0 0 1 0-2a3.97 3.97 0 0 1 3.972 3.971v.04a3.97 3.97 0 0 1-3.972 3.972a1 1 0 1 1 0-2a1.97 1.97 0 0 0 1.972-1.972v-.04a1.97 1.97 0 0 0-1.972-1.971M13 9a1 1 0 1 1 0 2a1 1 0 0 1 0-2m-7.88 4.256a2 2 0 0 1-2-2v-2.5a2 2 0 0 1 2-2h1.005l1.824-1.71a2 2 0 0 1 1.367-.54h.205a1.6 1.6 0 0 1 1.6 1.6v7.8a1.6 1.6 0 0 1-1.6 1.6h-.205a2 2 0 0 1-1.367-.541l-1.824-1.71H5.121zm1.796-4.5H5.121v2.5h1.795l2.205 2.067V6.689z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamVolumeUpSquareF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m1.12 13.256h1.005l1.824 1.709a2 2 0 0 0 1.367.54h.205a1.6 1.6 0 0 0 1.6-1.6v-7.8a1.6 1.6 0 0 0-1.6-1.6h-.205a2 2 0 0 0-1.367.542L6.125 6.756H5.121a2 2 0 0 0-2 2v2.5a2 2 0 0 0 2 2zm7.877-5.231a1.97 1.97 0 0 1 1.972 1.971v.04a1.97 1.97 0 0 1-1.972 1.972a1 1 0 0 0 0 2a3.97 3.97 0 0 0 3.972-3.972v-.04a3.97 3.97 0 0 0-3.972-3.971a1 1 0 0 0 0 2M13 9a1 1 0 1 0 0 2a1 1 0 0 0 0-2m-6.084-.244l2.205-2.067v6.634l-2.205-2.067H5.121v-2.5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamWatch: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 10h2a1 1 0 0 1 0 2H8a1 1 0 0 1-1-1V7a1 1 0 1 1 2 0zM4 4.07V3a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1.07A8 8 0 0 1 16 11a8 8 0 0 1-4 6.93V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-1.07A8 8 0 0 1 0 11a8 8 0 0 1 4-6.93m2-.818A8 8 0 0 1 8 3c.69 0 1.36.088 2 .252V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm0 15.496V19a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-.252a8.05 8.05 0 0 1-4 0M8 17A6 6 0 1 0 8 5a6 6 0 0 0 0 12\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4 -1 24 24"
}

export const jamWatchF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 10V7a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1h3a1 1 0 0 0 0-2zm3-5.93A7.96 7.96 0 0 0 6 3c-1.457 0-2.823.39-4 1.07V3a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3zm0 13.86V19a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-1.07A7.96 7.96 0 0 0 6 19c1.457 0 2.823-.39 4-1.07M6 17A6 6 0 1 1 6 5a6 6 0 0 1 0 12\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-6 -1 24 24"
}

export const jamWaterDrop: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 13a5 5 0 0 0 10 0c0-1.726-1.66-5.031-5-9.653C3.66 7.969 2 11.274 2 13M7 0q7 9.135 7 13a7 7 0 0 1-14 0Q0 9.135 7 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -2 24 24"
}

export const jamWaterDropF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 .565q7 9.135 7 13a7 7 0 1 1-14 0q0-3.865 7-13\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-5 -1.5 24 24"
}

export const jamWhatsapp: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M9.516.012C4.206.262.017 4.652.033 9.929a9.8 9.8 0 0 0 1.085 4.465L.06 19.495a.387.387 0 0 0 .47.453l5.034-1.184a10 10 0 0 0 4.284 1.032c5.427.083 9.951-4.195 10.12-9.58C20.15 4.441 15.351-.265 9.516.011zm6.007 15.367a7.78 7.78 0 0 1-5.52 2.27a7.8 7.8 0 0 1-3.474-.808l-.701-.347l-3.087.726l.65-3.131l-.346-.672A7.6 7.6 0 0 1 2.197 9.9c0-2.07.812-4.017 2.286-5.48a7.85 7.85 0 0 1 5.52-2.271c2.086 0 4.046.806 5.52 2.27a7.67 7.67 0 0 1 2.287 5.48c0 2.052-.825 4.03-2.287 5.481z\"/><path d=\"m14.842 12.045l-1.931-.55a.72.72 0 0 0-.713.186l-.472.478a.71.71 0 0 1-.765.16c-.913-.367-2.835-2.063-3.326-2.912a.69.69 0 0 1 .056-.774l.412-.53a.71.71 0 0 0 .089-.726L7.38 5.553a.723.723 0 0 0-1.125-.256c-.539.453-1.179 1.14-1.256 1.903c-.137 1.343.443 3.036 2.637 5.07c2.535 2.349 4.566 2.66 5.887 2.341c.75-.18 1.35-.903 1.727-1.494a.713.713 0 0 0-.408-1.072\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamWifi: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 13.992a1 1 0 1 1 0-2a1 1 0 0 1 0 2M7.894 11.44a1 1 0 0 1-1.788-.894a4.355 4.355 0 0 1 7.788 0a1 1 0 1 1-1.788.894a2.353 2.353 0 0 0-4.212 0M4.8 8.595a1 1 0 0 1-1.6-1.2a8.503 8.503 0 0 1 13.6 0a.999.999 0 1 1-1.6 1.2a6.503 6.503 0 0 0-10.4 0m-3.057-2.93A1 1 0 0 1 .257 4.329c4.843-5.377 13.13-5.813 18.512-.973q.513.461.974.973a.999.999 0 1 1-1.486 1.338a11 11 0 0 0-.826-.826C12.871.74 5.847 1.108 1.743 5.666z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -5 24 24"
}

export const jamWikipedia: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19.857.021h-3.982v.687h.398c.311 0 .592.161.751.431a.88.88 0 0 1 .016.872l-4.283 7.93l-1.95-4.69l1.836-3.402A2.17 2.17 0 0 1 14.548.708h.217V.02h-4.112v.688h.398c.311 0 .592.161.75.431a.88.88 0 0 1 .017.872l-1.333 2.467l-1.188-2.856a.65.65 0 0 1 .059-.62A.64.64 0 0 1 9.9.708h.435V.02H5.467v.688h.194c.909 0 1.723.546 2.074 1.391L9.49 6.32L7.535 9.942l-3.46-8.32a.65.65 0 0 1 .059-.62a.64.64 0 0 1 .544-.294h.598V.02H0v.688h.439c.908 0 1.723.546 2.074 1.391l3.988 9.591a.446.446 0 0 0 .804.042l.52-.964l1.986-3.676l1.912 4.598a.446.446 0 0 0 .804.041l.52-.963l4.819-8.92A2.17 2.17 0 0 1 19.77.709h.217V.02z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6 24 24"
}

export const jamWordpress: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.99 0C4.474 0 0 4.473 0 9.99s4.473 9.991 9.99 9.991s9.991-4.473 9.991-9.99S15.508 0 9.991 0zM1.428 9.99c0-1.208.268-2.357.742-3.394l4.085 10.9c-2.857-1.351-4.827-4.205-4.827-7.505zm8.564 8.343a9 9 0 0 1-2.42-.339l2.57-7.273l2.63 7.024l.06.116a8.8 8.8 0 0 1-2.84.472M11.168 6.08c.515-.027.98-.08.98-.08c.461-.053.408-.712-.053-.687c0 0-1.388.106-2.284.106c-.84 0-2.256-.106-2.256-.106c-.462-.026-.515.66-.055.688c0 0 .438.052.898.079l1.335 3.56l-1.874 5.475l-3.117-9.034c.517-.026.98-.079.98-.079c.46-.054.407-.713-.054-.688c0 0-1.387.106-2.281.106l-.551-.01c1.53-2.264 4.162-3.76 7.153-3.76c2.23 0 4.259.83 5.784 2.19l-.112-.008c-.841 0-1.437.713-1.437 1.48c0 .688.406 1.268.84 1.956c.329.557.706 1.27.706 2.3c0 .714-.28 1.542-.65 2.698l-.856 2.779zm3.127 11.117l2.617-7.365c.49-1.19.65-2.14.65-2.987q-.001-.46-.056-.858a8.15 8.15 0 0 1 1.049 4.003c-.001 3.077-1.713 5.763-4.26 7.207\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamWorld: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2.252 8A8 8 0 0 0 2 10c0 .69.088 1.36.252 2H5.1a20 20 0 0 1 0-4zm.818-2h2.346c.266-1.217.65-2.307 1.121-3.214A8.04 8.04 0 0 0 3.07 6m14.678 2H14.9a20 20 0 0 1 0 4h2.848a8.05 8.05 0 0 0 0-4m-.818-2a8.04 8.04 0 0 0-3.467-3.214c.472.907.855 1.997 1.121 3.214zM7.112 8A18 18 0 0 0 7 10c0 .685.038 1.355.112 2h5.776a17.8 17.8 0 0 0 0-4zm.358-2h5.06a10.8 10.8 0 0 0-.783-2.177C11.119 2.568 10.447 2 10 2s-1.119.568-1.747 1.823C7.938 4.455 7.673 5.19 7.47 6m-4.4 8a8.04 8.04 0 0 0 3.467 3.214c-.472-.907-.855-1.997-1.121-3.214zm13.86 0h-2.346c-.266 1.217-.65 2.307-1.121 3.214A8.04 8.04 0 0 0 16.93 14m-9.46 0c.203.81.468 1.545.783 2.177C8.881 17.432 9.553 18 10 18s1.119-.568 1.747-1.823c.315-.632.58-1.367.783-2.177zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamWrench: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2.464 6.748c.06.942.45 1.865 1.164 2.578a4 4 0 0 0 3.866 1.036l1.114-.298l9.162 9.161a1 1 0 0 0 1.414-1.414L10.022 8.65l.298-1.115A4 4 0 0 0 9.284 3.67a4 4 0 0 0-2.578-1.164L7.93 3.728A3 3 0 1 1 3.686 7.97zm-.9-3.727L5.1 6.556a1 1 0 0 0 1.415-1.414L2.979 1.606a6.002 6.002 0 0 1 9.273 6.445l8.346 8.346a3 3 0 0 1-4.243 4.243L8.01 12.294A6.002 6.002 0 0 1 1.565 3.02zm15.5 15.496l1.42-1.41l-1.42-1.414l-1.419 1.414l1.418 1.41z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1 -1 24 24"
}

export const jamWrenchF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m18.477 13.84l-4.243 4.243L8.01 11.86a6.002 6.002 0 0 1-6.445-9.273L5.1 6.12a1 1 0 0 0 1.415-1.414L2.979 1.17a6.002 6.002 0 0 1 9.273 6.445zm1.414 1.415l.707.707a3 3 0 0 1-4.243 4.243l-.707-.708z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-1 -1 24 24"
}

export const jamWrite: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m5.72 14.456l1.761-.508l10.603-10.73a.456.456 0 0 0-.003-.64l-.635-.642a.443.443 0 0 0-.632-.003L6.239 12.635zM18.703.664l.635.643c.876.887.884 2.318.016 3.196L8.428 15.561l-3.764 1.084a.9.9 0 0 1-1.11-.623a.9.9 0 0 1-.002-.506l1.095-3.84L15.544.647a2.215 2.215 0 0 1 3.159.016zM7.184 1.817c.496 0 .898.407.898.909a.903.903 0 0 1-.898.909H3.592c-.992 0-1.796.814-1.796 1.817v10.906c0 1.004.804 1.818 1.796 1.818h10.776c.992 0 1.797-.814 1.797-1.818v-3.635c0-.502.402-.909.898-.909s.898.407.898.91v3.634c0 2.008-1.609 3.636-3.593 3.636H3.592C1.608 19.994 0 18.366 0 16.358V5.452c0-2.007 1.608-3.635 3.592-3.635z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamWriteF: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m21.289.98l.59.59c.813.814.69 2.257-.277 3.223L9.435 16.96l-3.942 1.442c-.495.182-.977-.054-1.075-.525a.93.93 0 0 1 .045-.51l1.47-3.976L18.066 1.257c.967-.966 2.41-1.09 3.223-.276zM8.904 2.19a1 1 0 1 1 0 2h-4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4a1 1 0 0 1 2 0v4a4 4 0 0 1-4 4h-12a4 4 0 0 1-4-4v-12a4 4 0 0 1 4-4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-0.5 -0.5 24 24"
}

export const jamYahoo: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16.077 2.96c-.489.132-4.957 3.597-5.252 4.448c-.064.293.007 3.141.072 3.568c.294.066 2.42.009 2.81.074l-.047.88c-.382-.03-3.083-.023-4.624-.023c-.783 0-3.3.087-4.074.065l.146-.838c.424-.032 2.18.078 2.565-.332c.191-.204.131-2.91.066-3.368c-.162-.49-4.078-5.397-5.102-6.2H0V0h8.895v.085c.008 0 .022.001.03.003l-.03.208v.937H6.213c1.195 1.749 2.91 3.86 3.64 4.873l3.583-3.246h-2.13l-.3-1.232h7.801l-.058.087l.028.002l-.557.808l-.018.003l-.225.332h-1.439c-.186.04-.35.077-.461.1m2.545 7.726l-.688-.034l-.769-.094l.007 1.317l.606.052l.653.048l.191-1.29zm1.337-6.297c-.232-.008-2.345-.208-2.62-.262l.032 5.564l1.196.097z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -6 24 24"
}

export const jamYahooCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M13.055 8.483c-.245.066-2.484 1.802-2.631 2.228c-.033.148.003 1.574.036 1.788c.147.033 1.212.005 1.408.037l-.024.441c-.191-.015-1.545-.011-2.317-.011c-.392 0-1.654.043-2.041.032l.073-.42c.213-.015 1.093.04 1.285-.166c.096-.102.066-1.458.034-1.688c-.082-.245-2.044-2.703-2.557-3.106H5V7h4.457v.043l.015.001l-.015.105v.469H8.113c.599.876 1.457 1.933 1.824 2.441l1.795-1.626h-1.067l-.15-.618h3.908l-.03.044l.015.001l-.28.405l-.008.001l-.113.167h-.721c-.093.02-.175.039-.231.05m1.275 3.87l-.345-.016l-.385-.047l.004.66l.303.026l.327.024zM15 9.2a28 28 0 0 1-1.313-.131l.017 2.788l.599.048z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamYahooSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M13.055 8.483c-.245.066-2.484 1.802-2.631 2.228c-.033.148.003 1.574.036 1.788c.147.033 1.212.005 1.408.037l-.024.441c-.191-.015-1.545-.011-2.317-.011c-.392 0-1.654.043-2.041.032l.073-.42c.213-.015 1.093.04 1.285-.166c.096-.102.066-1.458.034-1.688c-.082-.245-2.044-2.703-2.557-3.106H5V7h4.457v.043l.015.001l-.015.105v.469H8.113c.599.876 1.457 1.933 1.824 2.441l1.795-1.626h-1.067l-.15-.618h3.908l-.03.044l.015.001l-.28.405l-.008.001l-.113.167h-.721c-.093.02-.175.039-.231.05m1.275 3.87l-.345-.016l-.385-.047l.004.66l.303.026l.327.024zM15 9.2a28 28 0 0 1-1.313-.131l.017 2.788l.599.048z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamYelp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5.893 14.08L3.13 17.444a.903.903 0 0 0 .367 1.413l2.701 1.063a.903.903 0 0 0 1.233-.816l.117-4.407c.023-.889-1.09-1.304-1.655-.617m-.459-3.345L1.336 9.264a.903.903 0 0 0-1.207.82l-.093 2.902a.903.903 0 0 0 1.183.886l4.19-1.372c.845-.276.861-1.465.025-1.765m4.696.472l4.198-1.157a.903.903 0 0 0 .514-1.366l-1.595-2.426a.903.903 0 0 0-1.477-.043L9.134 9.749c-.531.713.14 1.694.996 1.458M7.09 1.12A1.07 1.07 0 0 0 5.74.04L2.416.946a1.07 1.07 0 0 0-.592 1.65l3.813 6.606q.045.082.105.153c.565.663 1.625.418 1.886-.36c.047-.139.06-.287.048-.434l-.585-7.44zm7.266 13.106l-4.215-1.294c-.85-.26-1.548.701-1.038 1.429l2.5 3.564a.903.903 0 0 0 1.46.025l1.749-2.317a.903.903 0 0 0-.456-1.407\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-4.5 -2 24 24"
}

export const jamYelpCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"m9.2 12.095l-1.382 1.682a.45.45 0 0 0 .183.707l1.351.531a.45.45 0 0 0 .616-.408l.059-2.203a.467.467 0 0 0-.828-.309zm-.23-1.672l-2.05-.736a.45.45 0 0 0-.603.41l-.046 1.451c-.01.313.294.54.591.443l2.095-.685a.467.467 0 0 0 .013-.883m2.348.236l2.099-.579a.45.45 0 0 0 .257-.683l-.797-1.213a.45.45 0 0 0-.74-.021L10.82 9.93a.467.467 0 0 0 .498.729m-1.52-5.043a.535.535 0 0 0-.676-.541l-1.661.453a.535.535 0 0 0-.296.826L9.07 9.656a.5.5 0 0 0 .053.077a.555.555 0 0 0 .943-.18a.6.6 0 0 0 .024-.217zm3.633 6.552l-2.107-.647a.467.467 0 0 0-.52.715l1.25 1.782c.177.25.546.257.73.012l.875-1.158a.45.45 0 0 0-.228-.704\"/><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamYelpSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"m9.2 12.095l-1.382 1.682a.45.45 0 0 0 .183.707l1.351.531a.45.45 0 0 0 .616-.408l.059-2.203a.467.467 0 0 0-.828-.309zm-.23-1.672l-2.05-.736a.45.45 0 0 0-.603.41l-.046 1.451c-.01.313.294.54.591.443l2.095-.685a.467.467 0 0 0 .013-.883m2.348.236l2.099-.579a.45.45 0 0 0 .257-.683l-.797-1.213a.45.45 0 0 0-.74-.021L10.82 9.93a.467.467 0 0 0 .498.729m-1.52-5.043a.535.535 0 0 0-.676-.541l-1.661.453a.535.535 0 0 0-.296.826L9.07 9.656a.5.5 0 0 0 .053.077a.555.555 0 0 0 .943-.18a.6.6 0 0 0 .024-.217zm3.633 6.552l-2.107-.647a.467.467 0 0 0-.52.715l1.25 1.782c.177.25.546.257.73.012l.875-1.158a.45.45 0 0 0-.228-.704\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamYoutube: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15.812.017H4.145C1.855.017 0 1.852 0 4.116v5.768c0 2.264 1.856 4.1 4.145 4.1h11.667c2.29 0 4.145-1.836 4.145-4.1V4.116c0-2.264-1.856-4.1-4.145-4.1zM13.009 7.28L7.552 9.855a.22.22 0 0 1-.314-.196V4.35a.22.22 0 0 1 .318-.193l5.458 2.735a.216.216 0 0 1-.005.389z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -5 24 24"
}

export const jamYoutubeCircle: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M12.923 6.526H7.077C5.93 6.526 5 7.446 5 8.58v2.89c0 1.135.93 2.054 2.077 2.054h5.846c1.147 0 2.077-.92 2.077-2.054V8.58c0-1.135-.93-2.054-2.077-2.054m-1.404 3.64l-2.735 1.29a.11.11 0 0 1-.157-.099v-2.66a.11.11 0 0 1 .16-.097l2.734 1.37a.11.11 0 0 1-.002.196\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}

export const jamYoutubeSquare: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M12.923 6.526H7.077C5.93 6.526 5 7.446 5 8.58v2.89c0 1.135.93 2.054 2.077 2.054h5.846c1.147 0 2.077-.92 2.077-2.054V8.58c0-1.135-.93-2.054-2.077-2.054m-1.404 3.64l-2.735 1.29a.11.11 0 0 1-.157-.099v-2.66a.11.11 0 0 1 .16-.097l2.734 1.37a.11.11 0 0 1-.002.196\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "-2 -2 24 24"
}